import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["children", "question", "onResolve", "onSubmit"],
    _excluded2 = ["profile", "created_at", "body", "subject", "badgeText", "id", "published", "permalink"],
    _excluded3 = ["onSubmit", "onResolve", "apiHost"];

var _templateObject, _templateObject2;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e3) { throw _e3; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e4) { didErr = true; err = _e4; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/esnext.global-this.js";
import r$1, { useRef, useContext, useLayoutEffect, useState, useMemo, useEffect, useDebugValue, createElement, createContext, forwardRef, Children, useImperativeHandle, Component, useReducer, useCallback } from "react";
import require$$3 from "react-dom";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};

function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}

function getAugmentedNamespace(n2) {
  var f2 = n2.default;

  if (typeof f2 == "function") {
    var a2 = function a2() {
      return f2.apply(this, arguments);
    };

    a2.prototype = f2.prototype;
  } else a2 = {};

  Object.defineProperty(a2, "__esModule", {
    value: true
  });
  Object.keys(n2).forEach(function (k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a2, k2, d2.get ? d2 : {
      enumerable: true,
      get: function get() {
        return n2[k2];
      }
    });
  });
  return a2;
}

var styledComponents = {};
var server_browser = {};
var reactDomServerLegacy_browser_production_min = {};
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServerLegacy_browser_production_min;

function requireReactDomServerLegacy_browser_production_min() {
  if (hasRequiredReactDomServerLegacy_browser_production_min) return reactDomServerLegacy_browser_production_min;
  hasRequiredReactDomServerLegacy_browser_production_min = 1;
  var aa = r$1;

  function l2(a2) {
    for (var b2 = "https://reactjs.org/docs/error-decoder.html?invariant=" + a2, c2 = 1; c2 < arguments.length; c2++) {
      b2 += "&args[]=" + encodeURIComponent(arguments[c2]);
    }

    return "Minified React error #" + a2 + "; visit " + b2 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }

  var p2 = Object.prototype.hasOwnProperty,
      fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      ha = {},
      ia = {};

  function ja(a2) {
    if (p2.call(ia, a2)) return true;
    if (p2.call(ha, a2)) return false;
    if (fa.test(a2)) return ia[a2] = true;
    ha[a2] = true;
    return false;
  }

  function r2(a2, b2, c2, d2, f2, e2, g2) {
    this.acceptsBooleans = 2 === b2 || 3 === b2 || 4 === b2;
    this.attributeName = d2;
    this.attributeNamespace = f2;
    this.mustUseProperty = c2;
    this.propertyName = a2;
    this.type = b2;
    this.sanitizeURL = e2;
    this.removeEmptyString = g2;
  }

  var t2 = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a2) {
    t2[a2] = new r2(a2, 0, false, a2, null, false, false);
  });
  [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a2) {
    var b2 = a2[0];
    t2[b2] = new r2(b2, 1, false, a2[1], null, false, false);
  });
  ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a2) {
    t2[a2] = new r2(a2, 2, false, a2.toLowerCase(), null, false, false);
  });
  ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a2) {
    t2[a2] = new r2(a2, 2, false, a2, null, false, false);
  });
  "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a2) {
    t2[a2] = new r2(a2, 3, false, a2.toLowerCase(), null, false, false);
  });
  ["checked", "multiple", "muted", "selected"].forEach(function (a2) {
    t2[a2] = new r2(a2, 3, true, a2, null, false, false);
  });
  ["capture", "download"].forEach(function (a2) {
    t2[a2] = new r2(a2, 4, false, a2, null, false, false);
  });
  ["cols", "rows", "size", "span"].forEach(function (a2) {
    t2[a2] = new r2(a2, 6, false, a2, null, false, false);
  });
  ["rowSpan", "start"].forEach(function (a2) {
    t2[a2] = new r2(a2, 5, false, a2.toLowerCase(), null, false, false);
  });
  var ka = /[\-:]([a-z])/g;

  function la(a2) {
    return a2[1].toUpperCase();
  }

  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a2) {
    var b2 = a2.replace(ka, la);
    t2[b2] = new r2(b2, 1, false, a2, null, false, false);
  });
  "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a2) {
    var b2 = a2.replace(ka, la);
    t2[b2] = new r2(b2, 1, false, a2, "http://www.w3.org/1999/xlink", false, false);
  });
  ["xml:base", "xml:lang", "xml:space"].forEach(function (a2) {
    var b2 = a2.replace(ka, la);
    t2[b2] = new r2(b2, 1, false, a2, "http://www.w3.org/XML/1998/namespace", false, false);
  });
  ["tabIndex", "crossOrigin"].forEach(function (a2) {
    t2[a2] = new r2(a2, 1, false, a2.toLowerCase(), null, false, false);
  });
  t2.xlinkHref = new r2("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
  ["src", "href", "action", "formAction"].forEach(function (a2) {
    t2[a2] = new r2(a2, 1, false, a2.toLowerCase(), null, true, true);
  });
  var u2 = {
    animationIterationCount: true,
    aspectRatio: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridArea: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
  },
      ma = ["Webkit", "ms", "Moz", "O"];
  Object.keys(u2).forEach(function (a2) {
    ma.forEach(function (b2) {
      b2 = b2 + a2.charAt(0).toUpperCase() + a2.substring(1);
      u2[b2] = u2[a2];
    });
  });
  var na = /["'&<>]/;

  function v2(a2) {
    if ("boolean" === typeof a2 || "number" === typeof a2) return "" + a2;
    a2 = "" + a2;
    var b2 = na.exec(a2);

    if (b2) {
      var c2 = "",
          d2,
          f2 = 0;

      for (d2 = b2.index; d2 < a2.length; d2++) {
        switch (a2.charCodeAt(d2)) {
          case 34:
            b2 = "&quot;";
            break;

          case 38:
            b2 = "&amp;";
            break;

          case 39:
            b2 = "&#x27;";
            break;

          case 60:
            b2 = "&lt;";
            break;

          case 62:
            b2 = "&gt;";
            break;

          default:
            continue;
        }

        f2 !== d2 && (c2 += a2.substring(f2, d2));
        f2 = d2 + 1;
        c2 += b2;
      }

      a2 = f2 !== d2 ? c2 + a2.substring(f2, d2) : c2;
    }

    return a2;
  }

  var oa = /([A-Z])/g,
      pa = /^ms-/,
      qa = Array.isArray;

  function w2(a2, b2) {
    return {
      insertionMode: a2,
      selectedValue: b2
    };
  }

  function ra(a2, b2, c2) {
    switch (b2) {
      case "select":
        return w2(1, null != c2.value ? c2.value : c2.defaultValue);

      case "svg":
        return w2(2, null);

      case "math":
        return w2(3, null);

      case "foreignObject":
        return w2(1, null);

      case "table":
        return w2(4, null);

      case "thead":
      case "tbody":
      case "tfoot":
        return w2(5, null);

      case "colgroup":
        return w2(7, null);

      case "tr":
        return w2(6, null);
    }

    return 4 <= a2.insertionMode || 0 === a2.insertionMode ? w2(1, null) : a2;
  }

  var sa = /* @__PURE__ */new Map();

  function ta(a2, b2, c2) {
    if ("object" !== typeof c2) throw Error(l2(62));
    b2 = true;

    for (var d2 in c2) {
      if (p2.call(c2, d2)) {
        var f2 = c2[d2];

        if (null != f2 && "boolean" !== typeof f2 && "" !== f2) {
          if (0 === d2.indexOf("--")) {
            var e2 = v2(d2);
            f2 = v2(("" + f2).trim());
          } else {
            e2 = d2;
            var g2 = sa.get(e2);
            void 0 !== g2 ? e2 = g2 : (g2 = v2(e2.replace(oa, "-$1").toLowerCase().replace(pa, "-ms-")), sa.set(e2, g2), e2 = g2);
            f2 = "number" === typeof f2 ? 0 === f2 || p2.call(u2, d2) ? "" + f2 : f2 + "px" : v2(("" + f2).trim());
          }

          b2 ? (b2 = false, a2.push(' style="', e2, ":", f2)) : a2.push(";", e2, ":", f2);
        }
      }
    }

    b2 || a2.push('"');
  }

  function x2(a2, b2, c2, d2) {
    switch (c2) {
      case "style":
        ta(a2, b2, d2);
        return;

      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }

    if (!(2 < c2.length) || "o" !== c2[0] && "O" !== c2[0] || "n" !== c2[1] && "N" !== c2[1]) {
      if (b2 = t2.hasOwnProperty(c2) ? t2[c2] : null, null !== b2) {
        switch (typeof d2) {
          case "function":
          case "symbol":
            return;

          case "boolean":
            if (!b2.acceptsBooleans) return;
        }

        c2 = b2.attributeName;

        switch (b2.type) {
          case 3:
            d2 && a2.push(" ", c2, '=""');
            break;

          case 4:
            true === d2 ? a2.push(" ", c2, '=""') : false !== d2 && a2.push(" ", c2, '="', v2(d2), '"');
            break;

          case 5:
            isNaN(d2) || a2.push(" ", c2, '="', v2(d2), '"');
            break;

          case 6:
            !isNaN(d2) && 1 <= d2 && a2.push(" ", c2, '="', v2(d2), '"');
            break;

          default:
            b2.sanitizeURL && (d2 = "" + d2), a2.push(" ", c2, '="', v2(d2), '"');
        }
      } else if (ja(c2)) {
        switch (typeof d2) {
          case "function":
          case "symbol":
            return;

          case "boolean":
            if (b2 = c2.toLowerCase().slice(0, 5), "data-" !== b2 && "aria-" !== b2) return;
        }

        a2.push(" ", c2, '="', v2(d2), '"');
      }
    }
  }

  function y2(a2, b2, c2) {
    if (null != b2) {
      if (null != c2) throw Error(l2(60));
      if ("object" !== typeof b2 || !("__html" in b2)) throw Error(l2(61));
      b2 = b2.__html;
      null !== b2 && void 0 !== b2 && a2.push("" + b2);
    }
  }

  function ua(a2) {
    var b2 = "";
    aa.Children.forEach(a2, function (a3) {
      null != a3 && (b2 += a3);
    });
    return b2;
  }

  function va(a2, b2, c2, d2) {
    a2.push(A2(c2));
    var f2 = c2 = null,
        e2;

    for (e2 in b2) {
      if (p2.call(b2, e2)) {
        var g2 = b2[e2];
        if (null != g2) switch (e2) {
          case "children":
            c2 = g2;
            break;

          case "dangerouslySetInnerHTML":
            f2 = g2;
            break;

          default:
            x2(a2, d2, e2, g2);
        }
      }
    }

    a2.push(">");
    y2(a2, f2, c2);
    return "string" === typeof c2 ? (a2.push(v2(c2)), null) : c2;
  }

  var wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
      xa = /* @__PURE__ */new Map();

  function A2(a2) {
    var b2 = xa.get(a2);

    if (void 0 === b2) {
      if (!wa.test(a2)) throw Error(l2(65, a2));
      b2 = "<" + a2;
      xa.set(a2, b2);
    }

    return b2;
  }

  function ya(a2, b2, c2, d2, f2) {
    switch (b2) {
      case "select":
        a2.push(A2("select"));
        var e2 = null,
            g2 = null;

        for (n2 in c2) {
          if (p2.call(c2, n2)) {
            var h2 = c2[n2];
            if (null != h2) switch (n2) {
              case "children":
                e2 = h2;
                break;

              case "dangerouslySetInnerHTML":
                g2 = h2;
                break;

              case "defaultValue":
              case "value":
                break;

              default:
                x2(a2, d2, n2, h2);
            }
          }
        }

        a2.push(">");
        y2(a2, g2, e2);
        return e2;

      case "option":
        g2 = f2.selectedValue;
        a2.push(A2("option"));
        var k2 = h2 = null,
            m2 = null;
        var n2 = null;

        for (e2 in c2) {
          if (p2.call(c2, e2)) {
            var q2 = c2[e2];
            if (null != q2) switch (e2) {
              case "children":
                h2 = q2;
                break;

              case "selected":
                m2 = q2;
                break;

              case "dangerouslySetInnerHTML":
                n2 = q2;
                break;

              case "value":
                k2 = q2;

              default:
                x2(a2, d2, e2, q2);
            }
          }
        }

        if (null != g2) {
          if (c2 = null !== k2 ? "" + k2 : ua(h2), qa(g2)) for (d2 = 0; d2 < g2.length; d2++) {
            if ("" + g2[d2] === c2) {
              a2.push(' selected=""');
              break;
            }
          } else "" + g2 === c2 && a2.push(' selected=""');
        } else m2 && a2.push(' selected=""');
        a2.push(">");
        y2(a2, n2, h2);
        return h2;

      case "textarea":
        a2.push(A2("textarea"));
        n2 = g2 = e2 = null;

        for (h2 in c2) {
          if (p2.call(c2, h2) && (k2 = c2[h2], null != k2)) switch (h2) {
            case "children":
              n2 = k2;
              break;

            case "value":
              e2 = k2;
              break;

            case "defaultValue":
              g2 = k2;
              break;

            case "dangerouslySetInnerHTML":
              throw Error(l2(91));

            default:
              x2(a2, d2, h2, k2);
          }
        }

        null === e2 && null !== g2 && (e2 = g2);
        a2.push(">");

        if (null != n2) {
          if (null != e2) throw Error(l2(92));
          if (qa(n2) && 1 < n2.length) throw Error(l2(93));
          e2 = "" + n2;
        }

        "string" === typeof e2 && "\n" === e2[0] && a2.push("\n");
        null !== e2 && a2.push(v2("" + e2));
        return null;

      case "input":
        a2.push(A2("input"));
        k2 = n2 = h2 = e2 = null;

        for (g2 in c2) {
          if (p2.call(c2, g2) && (m2 = c2[g2], null != m2)) switch (g2) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(l2(399, "input"));

            case "defaultChecked":
              k2 = m2;
              break;

            case "defaultValue":
              h2 = m2;
              break;

            case "checked":
              n2 = m2;
              break;

            case "value":
              e2 = m2;
              break;

            default:
              x2(a2, d2, g2, m2);
          }
        }

        null !== n2 ? x2(a2, d2, "checked", n2) : null !== k2 && x2(a2, d2, "checked", k2);
        null !== e2 ? x2(a2, d2, "value", e2) : null !== h2 && x2(a2, d2, "value", h2);
        a2.push("/>");
        return null;

      case "menuitem":
        a2.push(A2("menuitem"));

        for (var C2 in c2) {
          if (p2.call(c2, C2) && (e2 = c2[C2], null != e2)) switch (C2) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(l2(400));

            default:
              x2(a2, d2, C2, e2);
          }
        }

        a2.push(">");
        return null;

      case "title":
        a2.push(A2("title"));
        e2 = null;

        for (q2 in c2) {
          if (p2.call(c2, q2) && (g2 = c2[q2], null != g2)) switch (q2) {
            case "children":
              e2 = g2;
              break;

            case "dangerouslySetInnerHTML":
              throw Error(l2(434));

            default:
              x2(a2, d2, q2, g2);
          }
        }

        a2.push(">");
        return e2;

      case "listing":
      case "pre":
        a2.push(A2(b2));
        g2 = e2 = null;

        for (k2 in c2) {
          if (p2.call(c2, k2) && (h2 = c2[k2], null != h2)) switch (k2) {
            case "children":
              e2 = h2;
              break;

            case "dangerouslySetInnerHTML":
              g2 = h2;
              break;

            default:
              x2(a2, d2, k2, h2);
          }
        }

        a2.push(">");

        if (null != g2) {
          if (null != e2) throw Error(l2(60));
          if ("object" !== typeof g2 || !("__html" in g2)) throw Error(l2(61));
          c2 = g2.__html;
          null !== c2 && void 0 !== c2 && ("string" === typeof c2 && 0 < c2.length && "\n" === c2[0] ? a2.push("\n", c2) : a2.push("" + c2));
        }

        "string" === typeof e2 && "\n" === e2[0] && a2.push("\n");
        return e2;

      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        a2.push(A2(b2));

        for (var D2 in c2) {
          if (p2.call(c2, D2) && (e2 = c2[D2], null != e2)) switch (D2) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(l2(399, b2));

            default:
              x2(a2, d2, D2, e2);
          }
        }

        a2.push("/>");
        return null;

      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return va(a2, c2, b2, d2);

      case "html":
        return 0 === f2.insertionMode && a2.push("<!DOCTYPE html>"), va(a2, c2, b2, d2);

      default:
        if (-1 === b2.indexOf("-") && "string" !== typeof c2.is) return va(a2, c2, b2, d2);
        a2.push(A2(b2));
        g2 = e2 = null;

        for (m2 in c2) {
          if (p2.call(c2, m2) && (h2 = c2[m2], null != h2)) switch (m2) {
            case "children":
              e2 = h2;
              break;

            case "dangerouslySetInnerHTML":
              g2 = h2;
              break;

            case "style":
              ta(a2, d2, h2);
              break;

            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;

            default:
              ja(m2) && "function" !== typeof h2 && "symbol" !== typeof h2 && a2.push(" ", m2, '="', v2(h2), '"');
          }
        }

        a2.push(">");
        y2(a2, g2, e2);
        return e2;
    }
  }

  function za(a2, b2, c2) {
    a2.push('<!--$?--><template id="');
    if (null === c2) throw Error(l2(395));
    a2.push(c2);
    return a2.push('"></template>');
  }

  function Aa(a2, b2, c2, d2) {
    switch (c2.insertionMode) {
      case 0:
      case 1:
        return a2.push('<div hidden id="'), a2.push(b2.segmentPrefix), b2 = d2.toString(16), a2.push(b2), a2.push('">');

      case 2:
        return a2.push('<svg aria-hidden="true" style="display:none" id="'), a2.push(b2.segmentPrefix), b2 = d2.toString(16), a2.push(b2), a2.push('">');

      case 3:
        return a2.push('<math aria-hidden="true" style="display:none" id="'), a2.push(b2.segmentPrefix), b2 = d2.toString(16), a2.push(b2), a2.push('">');

      case 4:
        return a2.push('<table hidden id="'), a2.push(b2.segmentPrefix), b2 = d2.toString(16), a2.push(b2), a2.push('">');

      case 5:
        return a2.push('<table hidden><tbody id="'), a2.push(b2.segmentPrefix), b2 = d2.toString(16), a2.push(b2), a2.push('">');

      case 6:
        return a2.push('<table hidden><tr id="'), a2.push(b2.segmentPrefix), b2 = d2.toString(16), a2.push(b2), a2.push('">');

      case 7:
        return a2.push('<table hidden><colgroup id="'), a2.push(b2.segmentPrefix), b2 = d2.toString(16), a2.push(b2), a2.push('">');

      default:
        throw Error(l2(397));
    }
  }

  function Ba(a2, b2) {
    switch (b2.insertionMode) {
      case 0:
      case 1:
        return a2.push("</div>");

      case 2:
        return a2.push("</svg>");

      case 3:
        return a2.push("</math>");

      case 4:
        return a2.push("</table>");

      case 5:
        return a2.push("</tbody></table>");

      case 6:
        return a2.push("</tr></table>");

      case 7:
        return a2.push("</colgroup></table>");

      default:
        throw Error(l2(397));
    }
  }

  var Ca = /[<\u2028\u2029]/g;

  function Da(a2) {
    return JSON.stringify(a2).replace(Ca, function (a3) {
      switch (a3) {
        case "<":
          return "\\u003c";

        case "\u2028":
          return "\\u2028";

        case "\u2029":
          return "\\u2029";

        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }

  function Ea(a2, b2) {
    b2 = void 0 === b2 ? "" : b2;
    return {
      bootstrapChunks: [],
      startInlineScript: "<script>",
      placeholderPrefix: b2 + "P:",
      segmentPrefix: b2 + "S:",
      boundaryPrefix: b2 + "B:",
      idPrefix: b2,
      nextSuspenseID: 0,
      sentCompleteSegmentFunction: false,
      sentCompleteBoundaryFunction: false,
      sentClientRenderFunction: false,
      generateStaticMarkup: a2
    };
  }

  function Fa(a2, b2, c2, d2) {
    if (c2.generateStaticMarkup) return a2.push(v2(b2)), false;
    "" === b2 ? a2 = d2 : (d2 && a2.push("<!-- -->"), a2.push(v2(b2)), a2 = true);
    return a2;
  }

  var B2 = Object.assign,
      Ga = Symbol.for("react.element"),
      Ha = Symbol.for("react.portal"),
      Ia = Symbol.for("react.fragment"),
      Ja = Symbol.for("react.strict_mode"),
      Ka = Symbol.for("react.profiler"),
      La = Symbol.for("react.provider"),
      Ma = Symbol.for("react.context"),
      Na = Symbol.for("react.forward_ref"),
      Oa = Symbol.for("react.suspense"),
      Pa = Symbol.for("react.suspense_list"),
      Qa = Symbol.for("react.memo"),
      Ra = Symbol.for("react.lazy"),
      Sa = Symbol.for("react.scope"),
      Ta = Symbol.for("react.debug_trace_mode"),
      Ua = Symbol.for("react.legacy_hidden"),
      Va = Symbol.for("react.default_value"),
      Wa = Symbol.iterator;

  function Xa(a2) {
    if (null == a2) return null;
    if ("function" === typeof a2) return a2.displayName || a2.name || null;
    if ("string" === typeof a2) return a2;

    switch (a2) {
      case Ia:
        return "Fragment";

      case Ha:
        return "Portal";

      case Ka:
        return "Profiler";

      case Ja:
        return "StrictMode";

      case Oa:
        return "Suspense";

      case Pa:
        return "SuspenseList";
    }

    if ("object" === typeof a2) switch (a2.$$typeof) {
      case Ma:
        return (a2.displayName || "Context") + ".Consumer";

      case La:
        return (a2._context.displayName || "Context") + ".Provider";

      case Na:
        var b2 = a2.render;
        a2 = a2.displayName;
        a2 || (a2 = b2.displayName || b2.name || "", a2 = "" !== a2 ? "ForwardRef(" + a2 + ")" : "ForwardRef");
        return a2;

      case Qa:
        return b2 = a2.displayName || null, null !== b2 ? b2 : Xa(a2.type) || "Memo";

      case Ra:
        b2 = a2._payload;
        a2 = a2._init;

        try {
          return Xa(a2(b2));
        } catch (c2) {}

    }
    return null;
  }

  var Ya = {};

  function Za(a2, b2) {
    a2 = a2.contextTypes;
    if (!a2) return Ya;
    var c2 = {},
        d2;

    for (d2 in a2) {
      c2[d2] = b2[d2];
    }

    return c2;
  }

  var E2 = null;

  function F2(a2, b2) {
    if (a2 !== b2) {
      a2.context._currentValue2 = a2.parentValue;
      a2 = a2.parent;
      var c2 = b2.parent;

      if (null === a2) {
        if (null !== c2) throw Error(l2(401));
      } else {
        if (null === c2) throw Error(l2(401));
        F2(a2, c2);
      }

      b2.context._currentValue2 = b2.value;
    }
  }

  function $a(a2) {
    a2.context._currentValue2 = a2.parentValue;
    a2 = a2.parent;
    null !== a2 && $a(a2);
  }

  function ab(a2) {
    var b2 = a2.parent;
    null !== b2 && ab(b2);
    a2.context._currentValue2 = a2.value;
  }

  function bb(a2, b2) {
    a2.context._currentValue2 = a2.parentValue;
    a2 = a2.parent;
    if (null === a2) throw Error(l2(402));
    a2.depth === b2.depth ? F2(a2, b2) : bb(a2, b2);
  }

  function cb(a2, b2) {
    var c2 = b2.parent;
    if (null === c2) throw Error(l2(402));
    a2.depth === c2.depth ? F2(a2, c2) : cb(a2, c2);
    b2.context._currentValue2 = b2.value;
  }

  function G2(a2) {
    var b2 = E2;
    b2 !== a2 && (null === b2 ? ab(a2) : null === a2 ? $a(b2) : b2.depth === a2.depth ? F2(b2, a2) : b2.depth > a2.depth ? bb(b2, a2) : cb(b2, a2), E2 = a2);
  }

  var db = {
    isMounted: function isMounted() {
      return false;
    },
    enqueueSetState: function enqueueSetState(a2, b2) {
      a2 = a2._reactInternals;
      null !== a2.queue && a2.queue.push(b2);
    },
    enqueueReplaceState: function enqueueReplaceState(a2, b2) {
      a2 = a2._reactInternals;
      a2.replace = true;
      a2.queue = [b2];
    },
    enqueueForceUpdate: function enqueueForceUpdate() {}
  };

  function eb(a2, b2, c2, d2) {
    var f2 = void 0 !== a2.state ? a2.state : null;
    a2.updater = db;
    a2.props = c2;
    a2.state = f2;
    var e2 = {
      queue: [],
      replace: false
    };
    a2._reactInternals = e2;
    var g2 = b2.contextType;
    a2.context = "object" === typeof g2 && null !== g2 ? g2._currentValue2 : d2;
    g2 = b2.getDerivedStateFromProps;
    "function" === typeof g2 && (g2 = g2(c2, f2), f2 = null === g2 || void 0 === g2 ? f2 : B2({}, f2, g2), a2.state = f2);
    if ("function" !== typeof b2.getDerivedStateFromProps && "function" !== typeof a2.getSnapshotBeforeUpdate && ("function" === typeof a2.UNSAFE_componentWillMount || "function" === typeof a2.componentWillMount)) if (b2 = a2.state, "function" === typeof a2.componentWillMount && a2.componentWillMount(), "function" === typeof a2.UNSAFE_componentWillMount && a2.UNSAFE_componentWillMount(), b2 !== a2.state && db.enqueueReplaceState(a2, a2.state, null), null !== e2.queue && 0 < e2.queue.length) {
      if (b2 = e2.queue, g2 = e2.replace, e2.queue = null, e2.replace = false, g2 && 1 === b2.length) a2.state = b2[0];else {
        e2 = g2 ? b2[0] : a2.state;
        f2 = true;

        for (g2 = g2 ? 1 : 0; g2 < b2.length; g2++) {
          var h2 = b2[g2];
          h2 = "function" === typeof h2 ? h2.call(a2, e2, c2, d2) : h2;
          null != h2 && (f2 ? (f2 = false, e2 = B2({}, e2, h2)) : B2(e2, h2));
        }

        a2.state = e2;
      }
    } else e2.queue = null;
  }

  var fb = {
    id: 1,
    overflow: ""
  };

  function gb(a2, b2, c2) {
    var d2 = a2.id;
    a2 = a2.overflow;
    var f2 = 32 - H2(d2) - 1;
    d2 &= ~(1 << f2);
    c2 += 1;
    var e2 = 32 - H2(b2) + f2;

    if (30 < e2) {
      var g2 = f2 - f2 % 5;
      e2 = (d2 & (1 << g2) - 1).toString(32);
      d2 >>= g2;
      f2 -= g2;
      return {
        id: 1 << 32 - H2(b2) + f2 | c2 << f2 | d2,
        overflow: e2 + a2
      };
    }

    return {
      id: 1 << e2 | c2 << f2 | d2,
      overflow: a2
    };
  }

  var H2 = Math.clz32 ? Math.clz32 : hb,
      ib = Math.log,
      jb = Math.LN2;

  function hb(a2) {
    a2 >>>= 0;
    return 0 === a2 ? 32 : 31 - (ib(a2) / jb | 0) | 0;
  }

  function kb(a2, b2) {
    return a2 === b2 && (0 !== a2 || 1 / a2 === 1 / b2) || a2 !== a2 && b2 !== b2;
  }

  var lb = "function" === typeof Object.is ? Object.is : kb,
      I2 = null,
      ob = null,
      J2 = null,
      K2 = null,
      L2 = false,
      M2 = false,
      N2 = 0,
      O2 = null,
      P2 = 0;

  function Q2() {
    if (null === I2) throw Error(l2(321));
    return I2;
  }

  function pb() {
    if (0 < P2) throw Error(l2(312));
    return {
      memoizedState: null,
      queue: null,
      next: null
    };
  }

  function qb() {
    null === K2 ? null === J2 ? (L2 = false, J2 = K2 = pb()) : (L2 = true, K2 = J2) : null === K2.next ? (L2 = false, K2 = K2.next = pb()) : (L2 = true, K2 = K2.next);
    return K2;
  }

  function rb() {
    ob = I2 = null;
    M2 = false;
    J2 = null;
    P2 = 0;
    K2 = O2 = null;
  }

  function sb(a2, b2) {
    return "function" === typeof b2 ? b2(a2) : b2;
  }

  function tb(a2, b2, c2) {
    I2 = Q2();
    K2 = qb();

    if (L2) {
      var d2 = K2.queue;
      b2 = d2.dispatch;

      if (null !== O2 && (c2 = O2.get(d2), void 0 !== c2)) {
        O2.delete(d2);
        d2 = K2.memoizedState;

        do {
          d2 = a2(d2, c2.action), c2 = c2.next;
        } while (null !== c2);

        K2.memoizedState = d2;
        return [d2, b2];
      }

      return [K2.memoizedState, b2];
    }

    a2 = a2 === sb ? "function" === typeof b2 ? b2() : b2 : void 0 !== c2 ? c2(b2) : b2;
    K2.memoizedState = a2;
    a2 = K2.queue = {
      last: null,
      dispatch: null
    };
    a2 = a2.dispatch = ub.bind(null, I2, a2);
    return [K2.memoizedState, a2];
  }

  function vb(a2, b2) {
    I2 = Q2();
    K2 = qb();
    b2 = void 0 === b2 ? null : b2;

    if (null !== K2) {
      var c2 = K2.memoizedState;

      if (null !== c2 && null !== b2) {
        var d2 = c2[1];

        a: if (null === d2) d2 = false;else {
          for (var f2 = 0; f2 < d2.length && f2 < b2.length; f2++) {
            if (!lb(b2[f2], d2[f2])) {
              d2 = false;
              break a;
            }
          }

          d2 = true;
        }

        if (d2) return c2[0];
      }
    }

    a2 = a2();
    K2.memoizedState = [a2, b2];
    return a2;
  }

  function ub(a2, b2, c2) {
    if (25 <= P2) throw Error(l2(301));
    if (a2 === I2) if (M2 = true, a2 = {
      action: c2,
      next: null
    }, null === O2 && (O2 = /* @__PURE__ */new Map()), c2 = O2.get(b2), void 0 === c2) O2.set(b2, a2);else {
      for (b2 = c2; null !== b2.next;) {
        b2 = b2.next;
      }

      b2.next = a2;
    }
  }

  function wb() {
    throw Error(l2(394));
  }

  function R2() {}

  var xb = {
    readContext: function readContext(a2) {
      return a2._currentValue2;
    },
    useContext: function useContext(a2) {
      Q2();
      return a2._currentValue2;
    },
    useMemo: vb,
    useReducer: tb,
    useRef: function useRef(a2) {
      I2 = Q2();
      K2 = qb();
      var b2 = K2.memoizedState;
      return null === b2 ? (a2 = {
        current: a2
      }, K2.memoizedState = a2) : b2;
    },
    useState: function useState(a2) {
      return tb(sb, a2);
    },
    useInsertionEffect: R2,
    useLayoutEffect: function useLayoutEffect() {},
    useCallback: function useCallback(a2, b2) {
      return vb(function () {
        return a2;
      }, b2);
    },
    useImperativeHandle: R2,
    useEffect: R2,
    useDebugValue: R2,
    useDeferredValue: function useDeferredValue(a2) {
      Q2();
      return a2;
    },
    useTransition: function useTransition() {
      Q2();
      return [false, wb];
    },
    useId: function useId() {
      var a2 = ob.treeContext;
      var b2 = a2.overflow;
      a2 = a2.id;
      a2 = (a2 & ~(1 << 32 - H2(a2) - 1)).toString(32) + b2;
      var c2 = S2;
      if (null === c2) throw Error(l2(404));
      b2 = N2++;
      a2 = ":" + c2.idPrefix + "R" + a2;
      0 < b2 && (a2 += "H" + b2.toString(32));
      return a2 + ":";
    },
    useMutableSource: function useMutableSource(a2, b2) {
      Q2();
      return b2(a2._source);
    },
    useSyncExternalStore: function useSyncExternalStore(a2, b2, c2) {
      if (void 0 === c2) throw Error(l2(407));
      return c2();
    }
  },
      S2 = null,
      yb = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;

  function zb(a2) {
    console.error(a2);
    return null;
  }

  function T2() {}

  function Ab(a2, b2, c2, d2, f2, e2, g2, h2, k2) {
    var m2 = [],
        n2 = /* @__PURE__ */new Set();
    b2 = {
      destination: null,
      responseState: b2,
      progressiveChunkSize: void 0 === d2 ? 12800 : d2,
      status: 0,
      fatalError: null,
      nextSegmentId: 0,
      allPendingTasks: 0,
      pendingRootTasks: 0,
      completedRootSegment: null,
      abortableTasks: n2,
      pingedTasks: m2,
      clientRenderedBoundaries: [],
      completedBoundaries: [],
      partialBoundaries: [],
      onError: void 0 === f2 ? zb : f2,
      onAllReady: void 0 === e2 ? T2 : e2,
      onShellReady: void 0 === g2 ? T2 : g2,
      onShellError: void 0 === h2 ? T2 : h2,
      onFatalError: void 0 === k2 ? T2 : k2
    };
    c2 = U2(b2, 0, null, c2, false, false);
    c2.parentFlushed = true;
    a2 = Bb(b2, a2, null, c2, n2, Ya, null, fb);
    m2.push(a2);
    return b2;
  }

  function Bb(a2, b2, c2, d2, f2, e2, g2, h2) {
    a2.allPendingTasks++;
    null === c2 ? a2.pendingRootTasks++ : c2.pendingTasks++;
    var k2 = {
      node: b2,
      ping: function ping() {
        var b3 = a2.pingedTasks;
        b3.push(k2);
        1 === b3.length && Cb(a2);
      },
      blockedBoundary: c2,
      blockedSegment: d2,
      abortSet: f2,
      legacyContext: e2,
      context: g2,
      treeContext: h2
    };
    f2.add(k2);
    return k2;
  }

  function U2(a2, b2, c2, d2, f2, e2) {
    return {
      status: 0,
      id: -1,
      index: b2,
      parentFlushed: false,
      chunks: [],
      children: [],
      formatContext: d2,
      boundary: c2,
      lastPushedText: f2,
      textEmbedded: e2
    };
  }

  function V2(a2, b2) {
    a2 = a2.onError(b2);
    if (null != a2 && "string" !== typeof a2) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a2 + '" instead');
    return a2;
  }

  function W2(a2, b2) {
    var c2 = a2.onShellError;
    c2(b2);
    c2 = a2.onFatalError;
    c2(b2);
    null !== a2.destination ? (a2.status = 2, a2.destination.destroy(b2)) : (a2.status = 1, a2.fatalError = b2);
  }

  function Db(a2, b2, c2, d2, f2) {
    I2 = {};
    ob = b2;
    N2 = 0;

    for (a2 = c2(d2, f2); M2;) {
      M2 = false, N2 = 0, P2 += 1, K2 = null, a2 = c2(d2, f2);
    }

    rb();
    return a2;
  }

  function Eb(a2, b2, c2, d2) {
    var f2 = c2.render(),
        e2 = d2.childContextTypes;

    if (null !== e2 && void 0 !== e2) {
      var g2 = b2.legacyContext;
      if ("function" !== typeof c2.getChildContext) d2 = g2;else {
        c2 = c2.getChildContext();

        for (var h2 in c2) {
          if (!(h2 in e2)) throw Error(l2(108, Xa(d2) || "Unknown", h2));
        }

        d2 = B2({}, g2, c2);
      }
      b2.legacyContext = d2;
      X2(a2, b2, f2);
      b2.legacyContext = g2;
    } else X2(a2, b2, f2);
  }

  function Fb(a2, b2) {
    if (a2 && a2.defaultProps) {
      b2 = B2({}, b2);
      a2 = a2.defaultProps;

      for (var c2 in a2) {
        void 0 === b2[c2] && (b2[c2] = a2[c2]);
      }

      return b2;
    }

    return b2;
  }

  function Gb(a2, b2, c2, d2, f2) {
    if ("function" === typeof c2) {
      if (c2.prototype && c2.prototype.isReactComponent) {
        f2 = Za(c2, b2.legacyContext);
        var e2 = c2.contextType;
        e2 = new c2(d2, "object" === typeof e2 && null !== e2 ? e2._currentValue2 : f2);
        eb(e2, c2, d2, f2);
        Eb(a2, b2, e2, c2);
      } else {
        e2 = Za(c2, b2.legacyContext);
        f2 = Db(a2, b2, c2, d2, e2);
        var g2 = 0 !== N2;
        if ("object" === typeof f2 && null !== f2 && "function" === typeof f2.render && void 0 === f2.$$typeof) eb(f2, c2, d2, e2), Eb(a2, b2, f2, c2);else if (g2) {
          d2 = b2.treeContext;
          b2.treeContext = gb(d2, 1, 0);

          try {
            X2(a2, b2, f2);
          } finally {
            b2.treeContext = d2;
          }
        } else X2(a2, b2, f2);
      }
    } else if ("string" === typeof c2) {
      f2 = b2.blockedSegment;
      e2 = ya(f2.chunks, c2, d2, a2.responseState, f2.formatContext);
      f2.lastPushedText = false;
      g2 = f2.formatContext;
      f2.formatContext = ra(g2, c2, d2);
      Hb(a2, b2, e2);
      f2.formatContext = g2;

      switch (c2) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;

        default:
          f2.chunks.push("</", c2, ">");
      }

      f2.lastPushedText = false;
    } else {
      switch (c2) {
        case Ua:
        case Ta:
        case Ja:
        case Ka:
        case Ia:
          X2(a2, b2, d2.children);
          return;

        case Pa:
          X2(a2, b2, d2.children);
          return;

        case Sa:
          throw Error(l2(343));

        case Oa:
          a: {
            c2 = b2.blockedBoundary;
            f2 = b2.blockedSegment;
            e2 = d2.fallback;
            d2 = d2.children;
            g2 = /* @__PURE__ */new Set();
            var h2 = {
              id: null,
              rootSegmentID: -1,
              parentFlushed: false,
              pendingTasks: 0,
              forceClientRender: false,
              completedSegments: [],
              byteSize: 0,
              fallbackAbortableTasks: g2,
              errorDigest: null
            },
                k2 = U2(a2, f2.chunks.length, h2, f2.formatContext, false, false);
            f2.children.push(k2);
            f2.lastPushedText = false;
            var m2 = U2(a2, 0, null, f2.formatContext, false, false);
            m2.parentFlushed = true;
            b2.blockedBoundary = h2;
            b2.blockedSegment = m2;

            try {
              if (Hb(a2, b2, d2), a2.responseState.generateStaticMarkup || m2.lastPushedText && m2.textEmbedded && m2.chunks.push("<!-- -->"), m2.status = 1, Y2(h2, m2), 0 === h2.pendingTasks) break a;
            } catch (n2) {
              m2.status = 4, h2.forceClientRender = true, h2.errorDigest = V2(a2, n2);
            } finally {
              b2.blockedBoundary = c2, b2.blockedSegment = f2;
            }

            b2 = Bb(a2, e2, c2, k2, g2, b2.legacyContext, b2.context, b2.treeContext);
            a2.pingedTasks.push(b2);
          }

          return;
      }

      if ("object" === typeof c2 && null !== c2) switch (c2.$$typeof) {
        case Na:
          d2 = Db(a2, b2, c2.render, d2, f2);

          if (0 !== N2) {
            c2 = b2.treeContext;
            b2.treeContext = gb(c2, 1, 0);

            try {
              X2(a2, b2, d2);
            } finally {
              b2.treeContext = c2;
            }
          } else X2(a2, b2, d2);

          return;

        case Qa:
          c2 = c2.type;
          d2 = Fb(c2, d2);
          Gb(a2, b2, c2, d2, f2);
          return;

        case La:
          f2 = d2.children;
          c2 = c2._context;
          d2 = d2.value;
          e2 = c2._currentValue2;
          c2._currentValue2 = d2;
          g2 = E2;
          E2 = d2 = {
            parent: g2,
            depth: null === g2 ? 0 : g2.depth + 1,
            context: c2,
            parentValue: e2,
            value: d2
          };
          b2.context = d2;
          X2(a2, b2, f2);
          a2 = E2;
          if (null === a2) throw Error(l2(403));
          d2 = a2.parentValue;
          a2.context._currentValue2 = d2 === Va ? a2.context._defaultValue : d2;
          a2 = E2 = a2.parent;
          b2.context = a2;
          return;

        case Ma:
          d2 = d2.children;
          d2 = d2(c2._currentValue2);
          X2(a2, b2, d2);
          return;

        case Ra:
          f2 = c2._init;
          c2 = f2(c2._payload);
          d2 = Fb(c2, d2);
          Gb(a2, b2, c2, d2, void 0);
          return;
      }
      throw Error(l2(130, null == c2 ? c2 : typeof c2, ""));
    }
  }

  function X2(a2, b2, c2) {
    b2.node = c2;

    if ("object" === typeof c2 && null !== c2) {
      switch (c2.$$typeof) {
        case Ga:
          Gb(a2, b2, c2.type, c2.props, c2.ref);
          return;

        case Ha:
          throw Error(l2(257));

        case Ra:
          var d2 = c2._init;
          c2 = d2(c2._payload);
          X2(a2, b2, c2);
          return;
      }

      if (qa(c2)) {
        Ib(a2, b2, c2);
        return;
      }

      null === c2 || "object" !== typeof c2 ? d2 = null : (d2 = Wa && c2[Wa] || c2["@@iterator"], d2 = "function" === typeof d2 ? d2 : null);

      if (d2 && (d2 = d2.call(c2))) {
        c2 = d2.next();

        if (!c2.done) {
          var f2 = [];

          do {
            f2.push(c2.value), c2 = d2.next();
          } while (!c2.done);

          Ib(a2, b2, f2);
        }

        return;
      }

      a2 = Object.prototype.toString.call(c2);
      throw Error(l2(31, "[object Object]" === a2 ? "object with keys {" + Object.keys(c2).join(", ") + "}" : a2));
    }

    "string" === typeof c2 ? (d2 = b2.blockedSegment, d2.lastPushedText = Fa(b2.blockedSegment.chunks, c2, a2.responseState, d2.lastPushedText)) : "number" === typeof c2 && (d2 = b2.blockedSegment, d2.lastPushedText = Fa(b2.blockedSegment.chunks, "" + c2, a2.responseState, d2.lastPushedText));
  }

  function Ib(a2, b2, c2) {
    for (var d2 = c2.length, f2 = 0; f2 < d2; f2++) {
      var e2 = b2.treeContext;
      b2.treeContext = gb(e2, d2, f2);

      try {
        Hb(a2, b2, c2[f2]);
      } finally {
        b2.treeContext = e2;
      }
    }
  }

  function Hb(a2, b2, c2) {
    var d2 = b2.blockedSegment.formatContext,
        f2 = b2.legacyContext,
        e2 = b2.context;

    try {
      return X2(a2, b2, c2);
    } catch (k2) {
      if (rb(), "object" === typeof k2 && null !== k2 && "function" === typeof k2.then) {
        c2 = k2;
        var g2 = b2.blockedSegment,
            h2 = U2(a2, g2.chunks.length, null, g2.formatContext, g2.lastPushedText, true);
        g2.children.push(h2);
        g2.lastPushedText = false;
        a2 = Bb(a2, b2.node, b2.blockedBoundary, h2, b2.abortSet, b2.legacyContext, b2.context, b2.treeContext).ping;
        c2.then(a2, a2);
        b2.blockedSegment.formatContext = d2;
        b2.legacyContext = f2;
        b2.context = e2;
        G2(e2);
      } else throw b2.blockedSegment.formatContext = d2, b2.legacyContext = f2, b2.context = e2, G2(e2), k2;
    }
  }

  function Jb(a2) {
    var b2 = a2.blockedBoundary;
    a2 = a2.blockedSegment;
    a2.status = 3;
    Kb(this, b2, a2);
  }

  function Lb(a2, b2, c2) {
    var d2 = a2.blockedBoundary;
    a2.blockedSegment.status = 3;
    null === d2 ? (b2.allPendingTasks--, 2 !== b2.status && (b2.status = 2, null !== b2.destination && b2.destination.push(null))) : (d2.pendingTasks--, d2.forceClientRender || (d2.forceClientRender = true, a2 = void 0 === c2 ? Error(l2(432)) : c2, d2.errorDigest = b2.onError(a2), d2.parentFlushed && b2.clientRenderedBoundaries.push(d2)), d2.fallbackAbortableTasks.forEach(function (a3) {
      return Lb(a3, b2, c2);
    }), d2.fallbackAbortableTasks.clear(), b2.allPendingTasks--, 0 === b2.allPendingTasks && (d2 = b2.onAllReady, d2()));
  }

  function Y2(a2, b2) {
    if (0 === b2.chunks.length && 1 === b2.children.length && null === b2.children[0].boundary) {
      var c2 = b2.children[0];
      c2.id = b2.id;
      c2.parentFlushed = true;
      1 === c2.status && Y2(a2, c2);
    } else a2.completedSegments.push(b2);
  }

  function Kb(a2, b2, c2) {
    if (null === b2) {
      if (c2.parentFlushed) {
        if (null !== a2.completedRootSegment) throw Error(l2(389));
        a2.completedRootSegment = c2;
      }

      a2.pendingRootTasks--;
      0 === a2.pendingRootTasks && (a2.onShellError = T2, b2 = a2.onShellReady, b2());
    } else b2.pendingTasks--, b2.forceClientRender || (0 === b2.pendingTasks ? (c2.parentFlushed && 1 === c2.status && Y2(b2, c2), b2.parentFlushed && a2.completedBoundaries.push(b2), b2.fallbackAbortableTasks.forEach(Jb, a2), b2.fallbackAbortableTasks.clear()) : c2.parentFlushed && 1 === c2.status && (Y2(b2, c2), 1 === b2.completedSegments.length && b2.parentFlushed && a2.partialBoundaries.push(b2)));

    a2.allPendingTasks--;
    0 === a2.allPendingTasks && (a2 = a2.onAllReady, a2());
  }

  function Cb(a2) {
    if (2 !== a2.status) {
      var b2 = E2,
          c2 = yb.current;
      yb.current = xb;
      var d2 = S2;
      S2 = a2.responseState;

      try {
        var f2 = a2.pingedTasks,
            e2;

        for (e2 = 0; e2 < f2.length; e2++) {
          var g2 = f2[e2];
          var h2 = a2,
              k2 = g2.blockedSegment;

          if (0 === k2.status) {
            G2(g2.context);

            try {
              X2(h2, g2, g2.node), h2.responseState.generateStaticMarkup || k2.lastPushedText && k2.textEmbedded && k2.chunks.push("<!-- -->"), g2.abortSet.delete(g2), k2.status = 1, Kb(h2, g2.blockedBoundary, k2);
            } catch (z2) {
              if (rb(), "object" === typeof z2 && null !== z2 && "function" === typeof z2.then) {
                var m2 = g2.ping;
                z2.then(m2, m2);
              } else {
                g2.abortSet.delete(g2);
                k2.status = 4;
                var n2 = g2.blockedBoundary,
                    q2 = z2,
                    C2 = V2(h2, q2);
                null === n2 ? W2(h2, q2) : (n2.pendingTasks--, n2.forceClientRender || (n2.forceClientRender = true, n2.errorDigest = C2, n2.parentFlushed && h2.clientRenderedBoundaries.push(n2)));
                h2.allPendingTasks--;

                if (0 === h2.allPendingTasks) {
                  var D2 = h2.onAllReady;
                  D2();
                }
              }
            } finally {}
          }
        }

        f2.splice(0, e2);
        null !== a2.destination && Mb(a2, a2.destination);
      } catch (z2) {
        V2(a2, z2), W2(a2, z2);
      } finally {
        S2 = d2, yb.current = c2, c2 === xb && G2(b2);
      }
    }
  }

  function Z2(a2, b2, c2) {
    c2.parentFlushed = true;

    switch (c2.status) {
      case 0:
        var d2 = c2.id = a2.nextSegmentId++;
        c2.lastPushedText = false;
        c2.textEmbedded = false;
        a2 = a2.responseState;
        b2.push('<template id="');
        b2.push(a2.placeholderPrefix);
        a2 = d2.toString(16);
        b2.push(a2);
        return b2.push('"></template>');

      case 1:
        c2.status = 2;
        var f2 = true;
        d2 = c2.chunks;
        var e2 = 0;
        c2 = c2.children;

        for (var g2 = 0; g2 < c2.length; g2++) {
          for (f2 = c2[g2]; e2 < f2.index; e2++) {
            b2.push(d2[e2]);
          }

          f2 = Nb(a2, b2, f2);
        }

        for (; e2 < d2.length - 1; e2++) {
          b2.push(d2[e2]);
        }

        e2 < d2.length && (f2 = b2.push(d2[e2]));
        return f2;

      default:
        throw Error(l2(390));
    }
  }

  function Nb(a2, b2, c2) {
    var d2 = c2.boundary;
    if (null === d2) return Z2(a2, b2, c2);
    d2.parentFlushed = true;
    if (d2.forceClientRender) return a2.responseState.generateStaticMarkup || (d2 = d2.errorDigest, b2.push("<!--$!-->"), b2.push("<template"), d2 && (b2.push(' data-dgst="'), d2 = v2(d2), b2.push(d2), b2.push('"')), b2.push("></template>")), Z2(a2, b2, c2), a2 = a2.responseState.generateStaticMarkup ? true : b2.push("<!--/$-->"), a2;

    if (0 < d2.pendingTasks) {
      d2.rootSegmentID = a2.nextSegmentId++;
      0 < d2.completedSegments.length && a2.partialBoundaries.push(d2);
      var f2 = a2.responseState;
      var e2 = f2.nextSuspenseID++;
      f2 = f2.boundaryPrefix + e2.toString(16);
      d2 = d2.id = f2;
      za(b2, a2.responseState, d2);
      Z2(a2, b2, c2);
      return b2.push("<!--/$-->");
    }

    if (d2.byteSize > a2.progressiveChunkSize) return d2.rootSegmentID = a2.nextSegmentId++, a2.completedBoundaries.push(d2), za(b2, a2.responseState, d2.id), Z2(a2, b2, c2), b2.push("<!--/$-->");
    a2.responseState.generateStaticMarkup || b2.push("<!--$-->");
    c2 = d2.completedSegments;
    if (1 !== c2.length) throw Error(l2(391));
    Nb(a2, b2, c2[0]);
    a2 = a2.responseState.generateStaticMarkup ? true : b2.push("<!--/$-->");
    return a2;
  }

  function Ob(a2, b2, c2) {
    Aa(b2, a2.responseState, c2.formatContext, c2.id);
    Nb(a2, b2, c2);
    return Ba(b2, c2.formatContext);
  }

  function Pb(a2, b2, c2) {
    for (var d2 = c2.completedSegments, f2 = 0; f2 < d2.length; f2++) {
      Qb(a2, b2, c2, d2[f2]);
    }

    d2.length = 0;
    a2 = a2.responseState;
    d2 = c2.id;
    c2 = c2.rootSegmentID;
    b2.push(a2.startInlineScript);
    a2.sentCompleteBoundaryFunction ? b2.push('$RC("') : (a2.sentCompleteBoundaryFunction = true, b2.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d2) throw Error(l2(395));
    c2 = c2.toString(16);
    b2.push(d2);
    b2.push('","');
    b2.push(a2.segmentPrefix);
    b2.push(c2);
    return b2.push('")<\/script>');
  }

  function Qb(a2, b2, c2, d2) {
    if (2 === d2.status) return true;
    var f2 = d2.id;

    if (-1 === f2) {
      if (-1 === (d2.id = c2.rootSegmentID)) throw Error(l2(392));
      return Ob(a2, b2, d2);
    }

    Ob(a2, b2, d2);
    a2 = a2.responseState;
    b2.push(a2.startInlineScript);
    a2.sentCompleteSegmentFunction ? b2.push('$RS("') : (a2.sentCompleteSegmentFunction = true, b2.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b2.push(a2.segmentPrefix);
    f2 = f2.toString(16);
    b2.push(f2);
    b2.push('","');
    b2.push(a2.placeholderPrefix);
    b2.push(f2);
    return b2.push('")<\/script>');
  }

  function Mb(a2, b2) {
    try {
      var c2 = a2.completedRootSegment;

      if (null !== c2 && 0 === a2.pendingRootTasks) {
        Nb(a2, b2, c2);
        a2.completedRootSegment = null;
        var d2 = a2.responseState.bootstrapChunks;

        for (c2 = 0; c2 < d2.length - 1; c2++) {
          b2.push(d2[c2]);
        }

        c2 < d2.length && b2.push(d2[c2]);
      }

      var f2 = a2.clientRenderedBoundaries,
          e2;

      for (e2 = 0; e2 < f2.length; e2++) {
        var g2 = f2[e2];
        d2 = b2;
        var h2 = a2.responseState,
            k2 = g2.id,
            m2 = g2.errorDigest,
            n2 = g2.errorMessage,
            q2 = g2.errorComponentStack;
        d2.push(h2.startInlineScript);
        h2.sentClientRenderFunction ? d2.push('$RX("') : (h2.sentClientRenderFunction = true, d2.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
        if (null === k2) throw Error(l2(395));
        d2.push(k2);
        d2.push('"');

        if (m2 || n2 || q2) {
          d2.push(",");
          var C2 = Da(m2 || "");
          d2.push(C2);
        }

        if (n2 || q2) {
          d2.push(",");
          var D2 = Da(n2 || "");
          d2.push(D2);
        }

        if (q2) {
          d2.push(",");
          var z2 = Da(q2);
          d2.push(z2);
        }

        if (!d2.push(")<\/script>")) {
          a2.destination = null;
          e2++;
          f2.splice(0, e2);
          return;
        }
      }

      f2.splice(0, e2);
      var ba = a2.completedBoundaries;

      for (e2 = 0; e2 < ba.length; e2++) {
        if (!Pb(a2, b2, ba[e2])) {
          a2.destination = null;
          e2++;
          ba.splice(0, e2);
          return;
        }
      }

      ba.splice(0, e2);
      var ca = a2.partialBoundaries;

      for (e2 = 0; e2 < ca.length; e2++) {
        var mb = ca[e2];

        a: {
          f2 = a2;
          g2 = b2;
          var da = mb.completedSegments;

          for (h2 = 0; h2 < da.length; h2++) {
            if (!Qb(f2, g2, mb, da[h2])) {
              h2++;
              da.splice(0, h2);
              var nb = false;
              break a;
            }
          }

          da.splice(0, h2);
          nb = true;
        }

        if (!nb) {
          a2.destination = null;
          e2++;
          ca.splice(0, e2);
          return;
        }
      }

      ca.splice(0, e2);
      var ea = a2.completedBoundaries;

      for (e2 = 0; e2 < ea.length; e2++) {
        if (!Pb(a2, b2, ea[e2])) {
          a2.destination = null;
          e2++;
          ea.splice(0, e2);
          return;
        }
      }

      ea.splice(0, e2);
    } finally {
      0 === a2.allPendingTasks && 0 === a2.pingedTasks.length && 0 === a2.clientRenderedBoundaries.length && 0 === a2.completedBoundaries.length && b2.push(null);
    }
  }

  function Rb(a2, b2) {
    try {
      var c2 = a2.abortableTasks;
      c2.forEach(function (c3) {
        return Lb(c3, a2, b2);
      });
      c2.clear();
      null !== a2.destination && Mb(a2, a2.destination);
    } catch (d2) {
      V2(a2, d2), W2(a2, d2);
    }
  }

  function Sb() {}

  function Tb(a2, b2, c2, d2) {
    var f2 = false,
        e2 = null,
        g2 = "",
        h2 = {
      push: function push(a3) {
        null !== a3 && (g2 += a3);
        return true;
      },
      destroy: function destroy(a3) {
        f2 = true;
        e2 = a3;
      }
    },
        k2 = false;
    a2 = Ab(a2, Ea(c2, b2 ? b2.identifierPrefix : void 0), {
      insertionMode: 1,
      selectedValue: null
    }, Infinity, Sb, void 0, function () {
      k2 = true;
    }, void 0, void 0);
    Cb(a2);
    Rb(a2, d2);
    if (1 === a2.status) a2.status = 2, h2.destroy(a2.fatalError);else if (2 !== a2.status && null === a2.destination) {
      a2.destination = h2;

      try {
        Mb(a2, h2);
      } catch (m2) {
        V2(a2, m2), W2(a2, m2);
      }
    }
    if (f2) throw e2;
    if (!k2) throw Error(l2(426));
    return g2;
  }

  reactDomServerLegacy_browser_production_min.renderToNodeStream = function () {
    throw Error(l2(207));
  };

  reactDomServerLegacy_browser_production_min.renderToStaticMarkup = function (a2, b2) {
    return Tb(a2, b2, true, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  };

  reactDomServerLegacy_browser_production_min.renderToStaticNodeStream = function () {
    throw Error(l2(208));
  };

  reactDomServerLegacy_browser_production_min.renderToString = function (a2, b2) {
    return Tb(a2, b2, false, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  };

  reactDomServerLegacy_browser_production_min.version = "18.2.0";
  return reactDomServerLegacy_browser_production_min;
}

var reactDomServer_browser_production_min = {};
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServer_browser_production_min;

function requireReactDomServer_browser_production_min() {
  if (hasRequiredReactDomServer_browser_production_min) return reactDomServer_browser_production_min;
  hasRequiredReactDomServer_browser_production_min = 1;
  var aa = r$1;

  function k2(a2) {
    for (var b2 = "https://reactjs.org/docs/error-decoder.html?invariant=" + a2, c2 = 1; c2 < arguments.length; c2++) {
      b2 += "&args[]=" + encodeURIComponent(arguments[c2]);
    }

    return "Minified React error #" + a2 + "; visit " + b2 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }

  var l2 = null,
      n2 = 0;

  function p2(a2, b2) {
    if (0 !== b2.length) if (512 < b2.length) 0 < n2 && (a2.enqueue(new Uint8Array(l2.buffer, 0, n2)), l2 = new Uint8Array(512), n2 = 0), a2.enqueue(b2);else {
      var c2 = l2.length - n2;
      c2 < b2.length && (0 === c2 ? a2.enqueue(l2) : (l2.set(b2.subarray(0, c2), n2), a2.enqueue(l2), b2 = b2.subarray(c2)), l2 = new Uint8Array(512), n2 = 0);
      l2.set(b2, n2);
      n2 += b2.length;
    }
  }

  function t2(a2, b2) {
    p2(a2, b2);
    return true;
  }

  function ba(a2) {
    l2 && 0 < n2 && (a2.enqueue(new Uint8Array(l2.buffer, 0, n2)), l2 = null, n2 = 0);
  }

  var ca = new TextEncoder();

  function u2(a2) {
    return ca.encode(a2);
  }

  function w2(a2) {
    return ca.encode(a2);
  }

  function da(a2, b2) {
    "function" === typeof a2.error ? a2.error(b2) : a2.close();
  }

  var x2 = Object.prototype.hasOwnProperty,
      ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      fa = {},
      ha = {};

  function ia(a2) {
    if (x2.call(ha, a2)) return true;
    if (x2.call(fa, a2)) return false;
    if (ea.test(a2)) return ha[a2] = true;
    fa[a2] = true;
    return false;
  }

  function y2(a2, b2, c2, d2, f2, e2, g2) {
    this.acceptsBooleans = 2 === b2 || 3 === b2 || 4 === b2;
    this.attributeName = d2;
    this.attributeNamespace = f2;
    this.mustUseProperty = c2;
    this.propertyName = a2;
    this.type = b2;
    this.sanitizeURL = e2;
    this.removeEmptyString = g2;
  }

  var z2 = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a2) {
    z2[a2] = new y2(a2, 0, false, a2, null, false, false);
  });
  [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a2) {
    var b2 = a2[0];
    z2[b2] = new y2(b2, 1, false, a2[1], null, false, false);
  });
  ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a2) {
    z2[a2] = new y2(a2, 2, false, a2.toLowerCase(), null, false, false);
  });
  ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a2) {
    z2[a2] = new y2(a2, 2, false, a2, null, false, false);
  });
  "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a2) {
    z2[a2] = new y2(a2, 3, false, a2.toLowerCase(), null, false, false);
  });
  ["checked", "multiple", "muted", "selected"].forEach(function (a2) {
    z2[a2] = new y2(a2, 3, true, a2, null, false, false);
  });
  ["capture", "download"].forEach(function (a2) {
    z2[a2] = new y2(a2, 4, false, a2, null, false, false);
  });
  ["cols", "rows", "size", "span"].forEach(function (a2) {
    z2[a2] = new y2(a2, 6, false, a2, null, false, false);
  });
  ["rowSpan", "start"].forEach(function (a2) {
    z2[a2] = new y2(a2, 5, false, a2.toLowerCase(), null, false, false);
  });
  var ja = /[\-:]([a-z])/g;

  function ka(a2) {
    return a2[1].toUpperCase();
  }

  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a2) {
    var b2 = a2.replace(ja, ka);
    z2[b2] = new y2(b2, 1, false, a2, null, false, false);
  });
  "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a2) {
    var b2 = a2.replace(ja, ka);
    z2[b2] = new y2(b2, 1, false, a2, "http://www.w3.org/1999/xlink", false, false);
  });
  ["xml:base", "xml:lang", "xml:space"].forEach(function (a2) {
    var b2 = a2.replace(ja, ka);
    z2[b2] = new y2(b2, 1, false, a2, "http://www.w3.org/XML/1998/namespace", false, false);
  });
  ["tabIndex", "crossOrigin"].forEach(function (a2) {
    z2[a2] = new y2(a2, 1, false, a2.toLowerCase(), null, false, false);
  });
  z2.xlinkHref = new y2("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
  ["src", "href", "action", "formAction"].forEach(function (a2) {
    z2[a2] = new y2(a2, 1, false, a2.toLowerCase(), null, true, true);
  });
  var B2 = {
    animationIterationCount: true,
    aspectRatio: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridArea: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
  },
      la = ["Webkit", "ms", "Moz", "O"];
  Object.keys(B2).forEach(function (a2) {
    la.forEach(function (b2) {
      b2 = b2 + a2.charAt(0).toUpperCase() + a2.substring(1);
      B2[b2] = B2[a2];
    });
  });
  var oa = /["'&<>]/;

  function C2(a2) {
    if ("boolean" === typeof a2 || "number" === typeof a2) return "" + a2;
    a2 = "" + a2;
    var b2 = oa.exec(a2);

    if (b2) {
      var c2 = "",
          d2,
          f2 = 0;

      for (d2 = b2.index; d2 < a2.length; d2++) {
        switch (a2.charCodeAt(d2)) {
          case 34:
            b2 = "&quot;";
            break;

          case 38:
            b2 = "&amp;";
            break;

          case 39:
            b2 = "&#x27;";
            break;

          case 60:
            b2 = "&lt;";
            break;

          case 62:
            b2 = "&gt;";
            break;

          default:
            continue;
        }

        f2 !== d2 && (c2 += a2.substring(f2, d2));
        f2 = d2 + 1;
        c2 += b2;
      }

      a2 = f2 !== d2 ? c2 + a2.substring(f2, d2) : c2;
    }

    return a2;
  }

  var pa = /([A-Z])/g,
      qa = /^ms-/,
      ra = Array.isArray,
      sa = w2("<script>"),
      ta = w2("<\/script>"),
      ua = w2('<script src="'),
      va = w2('<script type="module" src="'),
      wa = w2('" async=""><\/script>'),
      xa = /(<\/|<)(s)(cript)/gi;

  function ya(a2, b2, c2, d2) {
    return "" + b2 + ("s" === c2 ? "\\u0073" : "\\u0053") + d2;
  }

  function za(a2, b2, c2, d2, f2) {
    a2 = void 0 === a2 ? "" : a2;
    b2 = void 0 === b2 ? sa : w2('<script nonce="' + C2(b2) + '">');
    var e2 = [];
    void 0 !== c2 && e2.push(b2, u2(("" + c2).replace(xa, ya)), ta);
    if (void 0 !== d2) for (c2 = 0; c2 < d2.length; c2++) {
      e2.push(ua, u2(C2(d2[c2])), wa);
    }
    if (void 0 !== f2) for (d2 = 0; d2 < f2.length; d2++) {
      e2.push(va, u2(C2(f2[d2])), wa);
    }
    return {
      bootstrapChunks: e2,
      startInlineScript: b2,
      placeholderPrefix: w2(a2 + "P:"),
      segmentPrefix: w2(a2 + "S:"),
      boundaryPrefix: a2 + "B:",
      idPrefix: a2,
      nextSuspenseID: 0,
      sentCompleteSegmentFunction: false,
      sentCompleteBoundaryFunction: false,
      sentClientRenderFunction: false
    };
  }

  function D2(a2, b2) {
    return {
      insertionMode: a2,
      selectedValue: b2
    };
  }

  function Aa(a2) {
    return D2("http://www.w3.org/2000/svg" === a2 ? 2 : "http://www.w3.org/1998/Math/MathML" === a2 ? 3 : 0, null);
  }

  function Ba(a2, b2, c2) {
    switch (b2) {
      case "select":
        return D2(1, null != c2.value ? c2.value : c2.defaultValue);

      case "svg":
        return D2(2, null);

      case "math":
        return D2(3, null);

      case "foreignObject":
        return D2(1, null);

      case "table":
        return D2(4, null);

      case "thead":
      case "tbody":
      case "tfoot":
        return D2(5, null);

      case "colgroup":
        return D2(7, null);

      case "tr":
        return D2(6, null);
    }

    return 4 <= a2.insertionMode || 0 === a2.insertionMode ? D2(1, null) : a2;
  }

  var Ca = w2("<!-- -->");

  function Da(a2, b2, c2, d2) {
    if ("" === b2) return d2;
    d2 && a2.push(Ca);
    a2.push(u2(C2(b2)));
    return true;
  }

  var Ea = /* @__PURE__ */new Map(),
      Fa = w2(' style="'),
      Ga = w2(":"),
      Ha = w2(";");

  function Ia(a2, b2, c2) {
    if ("object" !== typeof c2) throw Error(k2(62));
    b2 = true;

    for (var d2 in c2) {
      if (x2.call(c2, d2)) {
        var f2 = c2[d2];

        if (null != f2 && "boolean" !== typeof f2 && "" !== f2) {
          if (0 === d2.indexOf("--")) {
            var e2 = u2(C2(d2));
            f2 = u2(C2(("" + f2).trim()));
          } else {
            e2 = d2;
            var g2 = Ea.get(e2);
            void 0 !== g2 ? e2 = g2 : (g2 = w2(C2(e2.replace(pa, "-$1").toLowerCase().replace(qa, "-ms-"))), Ea.set(e2, g2), e2 = g2);
            f2 = "number" === typeof f2 ? 0 === f2 || x2.call(B2, d2) ? u2("" + f2) : u2(f2 + "px") : u2(C2(("" + f2).trim()));
          }

          b2 ? (b2 = false, a2.push(Fa, e2, Ga, f2)) : a2.push(Ha, e2, Ga, f2);
        }
      }
    }

    b2 || a2.push(E2);
  }

  var H2 = w2(" "),
      I2 = w2('="'),
      E2 = w2('"'),
      Ja = w2('=""');

  function J2(a2, b2, c2, d2) {
    switch (c2) {
      case "style":
        Ia(a2, b2, d2);
        return;

      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }

    if (!(2 < c2.length) || "o" !== c2[0] && "O" !== c2[0] || "n" !== c2[1] && "N" !== c2[1]) {
      if (b2 = z2.hasOwnProperty(c2) ? z2[c2] : null, null !== b2) {
        switch (typeof d2) {
          case "function":
          case "symbol":
            return;

          case "boolean":
            if (!b2.acceptsBooleans) return;
        }

        c2 = u2(b2.attributeName);

        switch (b2.type) {
          case 3:
            d2 && a2.push(H2, c2, Ja);
            break;

          case 4:
            true === d2 ? a2.push(H2, c2, Ja) : false !== d2 && a2.push(H2, c2, I2, u2(C2(d2)), E2);
            break;

          case 5:
            isNaN(d2) || a2.push(H2, c2, I2, u2(C2(d2)), E2);
            break;

          case 6:
            !isNaN(d2) && 1 <= d2 && a2.push(H2, c2, I2, u2(C2(d2)), E2);
            break;

          default:
            b2.sanitizeURL && (d2 = "" + d2), a2.push(H2, c2, I2, u2(C2(d2)), E2);
        }
      } else if (ia(c2)) {
        switch (typeof d2) {
          case "function":
          case "symbol":
            return;

          case "boolean":
            if (b2 = c2.toLowerCase().slice(0, 5), "data-" !== b2 && "aria-" !== b2) return;
        }

        a2.push(H2, u2(c2), I2, u2(C2(d2)), E2);
      }
    }
  }

  var K2 = w2(">"),
      Ka = w2("/>");

  function L2(a2, b2, c2) {
    if (null != b2) {
      if (null != c2) throw Error(k2(60));
      if ("object" !== typeof b2 || !("__html" in b2)) throw Error(k2(61));
      b2 = b2.__html;
      null !== b2 && void 0 !== b2 && a2.push(u2("" + b2));
    }
  }

  function La(a2) {
    var b2 = "";
    aa.Children.forEach(a2, function (a3) {
      null != a3 && (b2 += a3);
    });
    return b2;
  }

  var Ma = w2(' selected=""');

  function Na(a2, b2, c2, d2) {
    a2.push(M2(c2));
    var f2 = c2 = null,
        e2;

    for (e2 in b2) {
      if (x2.call(b2, e2)) {
        var g2 = b2[e2];
        if (null != g2) switch (e2) {
          case "children":
            c2 = g2;
            break;

          case "dangerouslySetInnerHTML":
            f2 = g2;
            break;

          default:
            J2(a2, d2, e2, g2);
        }
      }
    }

    a2.push(K2);
    L2(a2, f2, c2);
    return "string" === typeof c2 ? (a2.push(u2(C2(c2))), null) : c2;
  }

  var Oa = w2("\n"),
      Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
      Qa = /* @__PURE__ */new Map();

  function M2(a2) {
    var b2 = Qa.get(a2);

    if (void 0 === b2) {
      if (!Pa.test(a2)) throw Error(k2(65, a2));
      b2 = w2("<" + a2);
      Qa.set(a2, b2);
    }

    return b2;
  }

  var Ra = w2("<!DOCTYPE html>");

  function Sa(a2, b2, c2, d2, f2) {
    switch (b2) {
      case "select":
        a2.push(M2("select"));
        var e2 = null,
            g2 = null;

        for (r2 in c2) {
          if (x2.call(c2, r2)) {
            var h2 = c2[r2];
            if (null != h2) switch (r2) {
              case "children":
                e2 = h2;
                break;

              case "dangerouslySetInnerHTML":
                g2 = h2;
                break;

              case "defaultValue":
              case "value":
                break;

              default:
                J2(a2, d2, r2, h2);
            }
          }
        }

        a2.push(K2);
        L2(a2, g2, e2);
        return e2;

      case "option":
        g2 = f2.selectedValue;
        a2.push(M2("option"));
        var m2 = h2 = null,
            q2 = null;
        var r2 = null;

        for (e2 in c2) {
          if (x2.call(c2, e2)) {
            var v2 = c2[e2];
            if (null != v2) switch (e2) {
              case "children":
                h2 = v2;
                break;

              case "selected":
                q2 = v2;
                break;

              case "dangerouslySetInnerHTML":
                r2 = v2;
                break;

              case "value":
                m2 = v2;

              default:
                J2(a2, d2, e2, v2);
            }
          }
        }

        if (null != g2) {
          if (c2 = null !== m2 ? "" + m2 : La(h2), ra(g2)) for (d2 = 0; d2 < g2.length; d2++) {
            if ("" + g2[d2] === c2) {
              a2.push(Ma);
              break;
            }
          } else "" + g2 === c2 && a2.push(Ma);
        } else q2 && a2.push(Ma);
        a2.push(K2);
        L2(a2, r2, h2);
        return h2;

      case "textarea":
        a2.push(M2("textarea"));
        r2 = g2 = e2 = null;

        for (h2 in c2) {
          if (x2.call(c2, h2) && (m2 = c2[h2], null != m2)) switch (h2) {
            case "children":
              r2 = m2;
              break;

            case "value":
              e2 = m2;
              break;

            case "defaultValue":
              g2 = m2;
              break;

            case "dangerouslySetInnerHTML":
              throw Error(k2(91));

            default:
              J2(a2, d2, h2, m2);
          }
        }

        null === e2 && null !== g2 && (e2 = g2);
        a2.push(K2);

        if (null != r2) {
          if (null != e2) throw Error(k2(92));
          if (ra(r2) && 1 < r2.length) throw Error(k2(93));
          e2 = "" + r2;
        }

        "string" === typeof e2 && "\n" === e2[0] && a2.push(Oa);
        null !== e2 && a2.push(u2(C2("" + e2)));
        return null;

      case "input":
        a2.push(M2("input"));
        m2 = r2 = h2 = e2 = null;

        for (g2 in c2) {
          if (x2.call(c2, g2) && (q2 = c2[g2], null != q2)) switch (g2) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(k2(399, "input"));

            case "defaultChecked":
              m2 = q2;
              break;

            case "defaultValue":
              h2 = q2;
              break;

            case "checked":
              r2 = q2;
              break;

            case "value":
              e2 = q2;
              break;

            default:
              J2(a2, d2, g2, q2);
          }
        }

        null !== r2 ? J2(a2, d2, "checked", r2) : null !== m2 && J2(a2, d2, "checked", m2);
        null !== e2 ? J2(a2, d2, "value", e2) : null !== h2 && J2(a2, d2, "value", h2);
        a2.push(Ka);
        return null;

      case "menuitem":
        a2.push(M2("menuitem"));

        for (var A2 in c2) {
          if (x2.call(c2, A2) && (e2 = c2[A2], null != e2)) switch (A2) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(k2(400));

            default:
              J2(a2, d2, A2, e2);
          }
        }

        a2.push(K2);
        return null;

      case "title":
        a2.push(M2("title"));
        e2 = null;

        for (v2 in c2) {
          if (x2.call(c2, v2) && (g2 = c2[v2], null != g2)) switch (v2) {
            case "children":
              e2 = g2;
              break;

            case "dangerouslySetInnerHTML":
              throw Error(k2(434));

            default:
              J2(a2, d2, v2, g2);
          }
        }

        a2.push(K2);
        return e2;

      case "listing":
      case "pre":
        a2.push(M2(b2));
        g2 = e2 = null;

        for (m2 in c2) {
          if (x2.call(c2, m2) && (h2 = c2[m2], null != h2)) switch (m2) {
            case "children":
              e2 = h2;
              break;

            case "dangerouslySetInnerHTML":
              g2 = h2;
              break;

            default:
              J2(a2, d2, m2, h2);
          }
        }

        a2.push(K2);

        if (null != g2) {
          if (null != e2) throw Error(k2(60));
          if ("object" !== typeof g2 || !("__html" in g2)) throw Error(k2(61));
          c2 = g2.__html;
          null !== c2 && void 0 !== c2 && ("string" === typeof c2 && 0 < c2.length && "\n" === c2[0] ? a2.push(Oa, u2(c2)) : a2.push(u2("" + c2)));
        }

        "string" === typeof e2 && "\n" === e2[0] && a2.push(Oa);
        return e2;

      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        a2.push(M2(b2));

        for (var F2 in c2) {
          if (x2.call(c2, F2) && (e2 = c2[F2], null != e2)) switch (F2) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(k2(399, b2));

            default:
              J2(a2, d2, F2, e2);
          }
        }

        a2.push(Ka);
        return null;

      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Na(a2, c2, b2, d2);

      case "html":
        return 0 === f2.insertionMode && a2.push(Ra), Na(a2, c2, b2, d2);

      default:
        if (-1 === b2.indexOf("-") && "string" !== typeof c2.is) return Na(a2, c2, b2, d2);
        a2.push(M2(b2));
        g2 = e2 = null;

        for (q2 in c2) {
          if (x2.call(c2, q2) && (h2 = c2[q2], null != h2)) switch (q2) {
            case "children":
              e2 = h2;
              break;

            case "dangerouslySetInnerHTML":
              g2 = h2;
              break;

            case "style":
              Ia(a2, d2, h2);
              break;

            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;

            default:
              ia(q2) && "function" !== typeof h2 && "symbol" !== typeof h2 && a2.push(H2, u2(q2), I2, u2(C2(h2)), E2);
          }
        }

        a2.push(K2);
        L2(a2, g2, e2);
        return e2;
    }
  }

  var Ta = w2("</"),
      Ua = w2(">"),
      Va = w2('<template id="'),
      Wa = w2('"></template>'),
      Xa = w2("<!--$-->"),
      Ya = w2('<!--$?--><template id="'),
      Za = w2('"></template>'),
      $a = w2("<!--$!-->"),
      ab = w2("<!--/$-->"),
      bb = w2("<template"),
      cb = w2('"'),
      db = w2(' data-dgst="');
  w2(' data-msg="');
  w2(' data-stck="');
  var eb = w2("></template>");

  function fb(a2, b2, c2) {
    p2(a2, Ya);
    if (null === c2) throw Error(k2(395));
    p2(a2, c2);
    return t2(a2, Za);
  }

  var gb = w2('<div hidden id="'),
      hb = w2('">'),
      ib = w2("</div>"),
      jb = w2('<svg aria-hidden="true" style="display:none" id="'),
      kb = w2('">'),
      lb = w2("</svg>"),
      mb = w2('<math aria-hidden="true" style="display:none" id="'),
      nb = w2('">'),
      ob = w2("</math>"),
      pb = w2('<table hidden id="'),
      qb = w2('">'),
      rb = w2("</table>"),
      sb = w2('<table hidden><tbody id="'),
      tb = w2('">'),
      ub = w2("</tbody></table>"),
      vb = w2('<table hidden><tr id="'),
      wb = w2('">'),
      xb = w2("</tr></table>"),
      yb = w2('<table hidden><colgroup id="'),
      zb = w2('">'),
      Ab = w2("</colgroup></table>");

  function Bb(a2, b2, c2, d2) {
    switch (c2.insertionMode) {
      case 0:
      case 1:
        return p2(a2, gb), p2(a2, b2.segmentPrefix), p2(a2, u2(d2.toString(16))), t2(a2, hb);

      case 2:
        return p2(a2, jb), p2(a2, b2.segmentPrefix), p2(a2, u2(d2.toString(16))), t2(a2, kb);

      case 3:
        return p2(a2, mb), p2(a2, b2.segmentPrefix), p2(a2, u2(d2.toString(16))), t2(a2, nb);

      case 4:
        return p2(a2, pb), p2(a2, b2.segmentPrefix), p2(a2, u2(d2.toString(16))), t2(a2, qb);

      case 5:
        return p2(a2, sb), p2(a2, b2.segmentPrefix), p2(a2, u2(d2.toString(16))), t2(a2, tb);

      case 6:
        return p2(a2, vb), p2(a2, b2.segmentPrefix), p2(a2, u2(d2.toString(16))), t2(a2, wb);

      case 7:
        return p2(a2, yb), p2(a2, b2.segmentPrefix), p2(a2, u2(d2.toString(16))), t2(a2, zb);

      default:
        throw Error(k2(397));
    }
  }

  function Cb(a2, b2) {
    switch (b2.insertionMode) {
      case 0:
      case 1:
        return t2(a2, ib);

      case 2:
        return t2(a2, lb);

      case 3:
        return t2(a2, ob);

      case 4:
        return t2(a2, rb);

      case 5:
        return t2(a2, ub);

      case 6:
        return t2(a2, xb);

      case 7:
        return t2(a2, Ab);

      default:
        throw Error(k2(397));
    }
  }

  var Db = w2('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'),
      Eb = w2('$RS("'),
      Gb = w2('","'),
      Hb = w2('")<\/script>'),
      Ib = w2('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'),
      Jb = w2('$RC("'),
      Kb = w2('","'),
      Lb = w2('")<\/script>'),
      Mb = w2('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'),
      Nb = w2('$RX("'),
      Ob = w2('"'),
      Pb = w2(")<\/script>"),
      Qb = w2(","),
      Rb = /[<\u2028\u2029]/g;

  function Sb(a2) {
    return JSON.stringify(a2).replace(Rb, function (a3) {
      switch (a3) {
        case "<":
          return "\\u003c";

        case "\u2028":
          return "\\u2028";

        case "\u2029":
          return "\\u2029";

        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }

  var N2 = Object.assign,
      Tb = Symbol.for("react.element"),
      Ub = Symbol.for("react.portal"),
      Vb = Symbol.for("react.fragment"),
      Wb = Symbol.for("react.strict_mode"),
      Xb = Symbol.for("react.profiler"),
      Yb = Symbol.for("react.provider"),
      Zb = Symbol.for("react.context"),
      $b = Symbol.for("react.forward_ref"),
      ac = Symbol.for("react.suspense"),
      bc = Symbol.for("react.suspense_list"),
      cc = Symbol.for("react.memo"),
      dc = Symbol.for("react.lazy"),
      ec = Symbol.for("react.scope"),
      fc = Symbol.for("react.debug_trace_mode"),
      gc = Symbol.for("react.legacy_hidden"),
      hc = Symbol.for("react.default_value"),
      ic = Symbol.iterator;

  function jc(a2) {
    if (null == a2) return null;
    if ("function" === typeof a2) return a2.displayName || a2.name || null;
    if ("string" === typeof a2) return a2;

    switch (a2) {
      case Vb:
        return "Fragment";

      case Ub:
        return "Portal";

      case Xb:
        return "Profiler";

      case Wb:
        return "StrictMode";

      case ac:
        return "Suspense";

      case bc:
        return "SuspenseList";
    }

    if ("object" === typeof a2) switch (a2.$$typeof) {
      case Zb:
        return (a2.displayName || "Context") + ".Consumer";

      case Yb:
        return (a2._context.displayName || "Context") + ".Provider";

      case $b:
        var b2 = a2.render;
        a2 = a2.displayName;
        a2 || (a2 = b2.displayName || b2.name || "", a2 = "" !== a2 ? "ForwardRef(" + a2 + ")" : "ForwardRef");
        return a2;

      case cc:
        return b2 = a2.displayName || null, null !== b2 ? b2 : jc(a2.type) || "Memo";

      case dc:
        b2 = a2._payload;
        a2 = a2._init;

        try {
          return jc(a2(b2));
        } catch (c2) {}

    }
    return null;
  }

  var kc = {};

  function lc(a2, b2) {
    a2 = a2.contextTypes;
    if (!a2) return kc;
    var c2 = {},
        d2;

    for (d2 in a2) {
      c2[d2] = b2[d2];
    }

    return c2;
  }

  var O2 = null;

  function P2(a2, b2) {
    if (a2 !== b2) {
      a2.context._currentValue = a2.parentValue;
      a2 = a2.parent;
      var c2 = b2.parent;

      if (null === a2) {
        if (null !== c2) throw Error(k2(401));
      } else {
        if (null === c2) throw Error(k2(401));
        P2(a2, c2);
      }

      b2.context._currentValue = b2.value;
    }
  }

  function mc(a2) {
    a2.context._currentValue = a2.parentValue;
    a2 = a2.parent;
    null !== a2 && mc(a2);
  }

  function nc(a2) {
    var b2 = a2.parent;
    null !== b2 && nc(b2);
    a2.context._currentValue = a2.value;
  }

  function oc(a2, b2) {
    a2.context._currentValue = a2.parentValue;
    a2 = a2.parent;
    if (null === a2) throw Error(k2(402));
    a2.depth === b2.depth ? P2(a2, b2) : oc(a2, b2);
  }

  function pc(a2, b2) {
    var c2 = b2.parent;
    if (null === c2) throw Error(k2(402));
    a2.depth === c2.depth ? P2(a2, c2) : pc(a2, c2);
    b2.context._currentValue = b2.value;
  }

  function Q2(a2) {
    var b2 = O2;
    b2 !== a2 && (null === b2 ? nc(a2) : null === a2 ? mc(b2) : b2.depth === a2.depth ? P2(b2, a2) : b2.depth > a2.depth ? oc(b2, a2) : pc(b2, a2), O2 = a2);
  }

  var qc = {
    isMounted: function isMounted() {
      return false;
    },
    enqueueSetState: function enqueueSetState(a2, b2) {
      a2 = a2._reactInternals;
      null !== a2.queue && a2.queue.push(b2);
    },
    enqueueReplaceState: function enqueueReplaceState(a2, b2) {
      a2 = a2._reactInternals;
      a2.replace = true;
      a2.queue = [b2];
    },
    enqueueForceUpdate: function enqueueForceUpdate() {}
  };

  function rc(a2, b2, c2, d2) {
    var f2 = void 0 !== a2.state ? a2.state : null;
    a2.updater = qc;
    a2.props = c2;
    a2.state = f2;
    var e2 = {
      queue: [],
      replace: false
    };
    a2._reactInternals = e2;
    var g2 = b2.contextType;
    a2.context = "object" === typeof g2 && null !== g2 ? g2._currentValue : d2;
    g2 = b2.getDerivedStateFromProps;
    "function" === typeof g2 && (g2 = g2(c2, f2), f2 = null === g2 || void 0 === g2 ? f2 : N2({}, f2, g2), a2.state = f2);
    if ("function" !== typeof b2.getDerivedStateFromProps && "function" !== typeof a2.getSnapshotBeforeUpdate && ("function" === typeof a2.UNSAFE_componentWillMount || "function" === typeof a2.componentWillMount)) if (b2 = a2.state, "function" === typeof a2.componentWillMount && a2.componentWillMount(), "function" === typeof a2.UNSAFE_componentWillMount && a2.UNSAFE_componentWillMount(), b2 !== a2.state && qc.enqueueReplaceState(a2, a2.state, null), null !== e2.queue && 0 < e2.queue.length) {
      if (b2 = e2.queue, g2 = e2.replace, e2.queue = null, e2.replace = false, g2 && 1 === b2.length) a2.state = b2[0];else {
        e2 = g2 ? b2[0] : a2.state;
        f2 = true;

        for (g2 = g2 ? 1 : 0; g2 < b2.length; g2++) {
          var h2 = b2[g2];
          h2 = "function" === typeof h2 ? h2.call(a2, e2, c2, d2) : h2;
          null != h2 && (f2 ? (f2 = false, e2 = N2({}, e2, h2)) : N2(e2, h2));
        }

        a2.state = e2;
      }
    } else e2.queue = null;
  }

  var sc = {
    id: 1,
    overflow: ""
  };

  function tc(a2, b2, c2) {
    var d2 = a2.id;
    a2 = a2.overflow;
    var f2 = 32 - uc(d2) - 1;
    d2 &= ~(1 << f2);
    c2 += 1;
    var e2 = 32 - uc(b2) + f2;

    if (30 < e2) {
      var g2 = f2 - f2 % 5;
      e2 = (d2 & (1 << g2) - 1).toString(32);
      d2 >>= g2;
      f2 -= g2;
      return {
        id: 1 << 32 - uc(b2) + f2 | c2 << f2 | d2,
        overflow: e2 + a2
      };
    }

    return {
      id: 1 << e2 | c2 << f2 | d2,
      overflow: a2
    };
  }

  var uc = Math.clz32 ? Math.clz32 : vc,
      wc = Math.log,
      xc = Math.LN2;

  function vc(a2) {
    a2 >>>= 0;
    return 0 === a2 ? 32 : 31 - (wc(a2) / xc | 0) | 0;
  }

  function yc(a2, b2) {
    return a2 === b2 && (0 !== a2 || 1 / a2 === 1 / b2) || a2 !== a2 && b2 !== b2;
  }

  var zc = "function" === typeof Object.is ? Object.is : yc,
      R2 = null,
      Ac = null,
      Bc = null,
      S2 = null,
      T2 = false,
      Cc = false,
      U2 = 0,
      V2 = null,
      Dc = 0;

  function W2() {
    if (null === R2) throw Error(k2(321));
    return R2;
  }

  function Ec() {
    if (0 < Dc) throw Error(k2(312));
    return {
      memoizedState: null,
      queue: null,
      next: null
    };
  }

  function Fc() {
    null === S2 ? null === Bc ? (T2 = false, Bc = S2 = Ec()) : (T2 = true, S2 = Bc) : null === S2.next ? (T2 = false, S2 = S2.next = Ec()) : (T2 = true, S2 = S2.next);
    return S2;
  }

  function Gc() {
    Ac = R2 = null;
    Cc = false;
    Bc = null;
    Dc = 0;
    S2 = V2 = null;
  }

  function Hc(a2, b2) {
    return "function" === typeof b2 ? b2(a2) : b2;
  }

  function Ic(a2, b2, c2) {
    R2 = W2();
    S2 = Fc();

    if (T2) {
      var d2 = S2.queue;
      b2 = d2.dispatch;

      if (null !== V2 && (c2 = V2.get(d2), void 0 !== c2)) {
        V2.delete(d2);
        d2 = S2.memoizedState;

        do {
          d2 = a2(d2, c2.action), c2 = c2.next;
        } while (null !== c2);

        S2.memoizedState = d2;
        return [d2, b2];
      }

      return [S2.memoizedState, b2];
    }

    a2 = a2 === Hc ? "function" === typeof b2 ? b2() : b2 : void 0 !== c2 ? c2(b2) : b2;
    S2.memoizedState = a2;
    a2 = S2.queue = {
      last: null,
      dispatch: null
    };
    a2 = a2.dispatch = Jc.bind(null, R2, a2);
    return [S2.memoizedState, a2];
  }

  function Kc(a2, b2) {
    R2 = W2();
    S2 = Fc();
    b2 = void 0 === b2 ? null : b2;

    if (null !== S2) {
      var c2 = S2.memoizedState;

      if (null !== c2 && null !== b2) {
        var d2 = c2[1];

        a: if (null === d2) d2 = false;else {
          for (var f2 = 0; f2 < d2.length && f2 < b2.length; f2++) {
            if (!zc(b2[f2], d2[f2])) {
              d2 = false;
              break a;
            }
          }

          d2 = true;
        }

        if (d2) return c2[0];
      }
    }

    a2 = a2();
    S2.memoizedState = [a2, b2];
    return a2;
  }

  function Jc(a2, b2, c2) {
    if (25 <= Dc) throw Error(k2(301));
    if (a2 === R2) if (Cc = true, a2 = {
      action: c2,
      next: null
    }, null === V2 && (V2 = /* @__PURE__ */new Map()), c2 = V2.get(b2), void 0 === c2) V2.set(b2, a2);else {
      for (b2 = c2; null !== b2.next;) {
        b2 = b2.next;
      }

      b2.next = a2;
    }
  }

  function Lc() {
    throw Error(k2(394));
  }

  function Mc() {}

  var Oc = {
    readContext: function readContext(a2) {
      return a2._currentValue;
    },
    useContext: function useContext(a2) {
      W2();
      return a2._currentValue;
    },
    useMemo: Kc,
    useReducer: Ic,
    useRef: function useRef(a2) {
      R2 = W2();
      S2 = Fc();
      var b2 = S2.memoizedState;
      return null === b2 ? (a2 = {
        current: a2
      }, S2.memoizedState = a2) : b2;
    },
    useState: function useState(a2) {
      return Ic(Hc, a2);
    },
    useInsertionEffect: Mc,
    useLayoutEffect: function useLayoutEffect() {},
    useCallback: function useCallback(a2, b2) {
      return Kc(function () {
        return a2;
      }, b2);
    },
    useImperativeHandle: Mc,
    useEffect: Mc,
    useDebugValue: Mc,
    useDeferredValue: function useDeferredValue(a2) {
      W2();
      return a2;
    },
    useTransition: function useTransition() {
      W2();
      return [false, Lc];
    },
    useId: function useId() {
      var a2 = Ac.treeContext;
      var b2 = a2.overflow;
      a2 = a2.id;
      a2 = (a2 & ~(1 << 32 - uc(a2) - 1)).toString(32) + b2;
      var c2 = Nc;
      if (null === c2) throw Error(k2(404));
      b2 = U2++;
      a2 = ":" + c2.idPrefix + "R" + a2;
      0 < b2 && (a2 += "H" + b2.toString(32));
      return a2 + ":";
    },
    useMutableSource: function useMutableSource(a2, b2) {
      W2();
      return b2(a2._source);
    },
    useSyncExternalStore: function useSyncExternalStore(a2, b2, c2) {
      if (void 0 === c2) throw Error(k2(407));
      return c2();
    }
  },
      Nc = null,
      Pc = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;

  function Qc(a2) {
    console.error(a2);
    return null;
  }

  function X2() {}

  function Rc(a2, b2, c2, d2, f2, e2, g2, h2, m2) {
    var q2 = [],
        r2 = /* @__PURE__ */new Set();
    b2 = {
      destination: null,
      responseState: b2,
      progressiveChunkSize: void 0 === d2 ? 12800 : d2,
      status: 0,
      fatalError: null,
      nextSegmentId: 0,
      allPendingTasks: 0,
      pendingRootTasks: 0,
      completedRootSegment: null,
      abortableTasks: r2,
      pingedTasks: q2,
      clientRenderedBoundaries: [],
      completedBoundaries: [],
      partialBoundaries: [],
      onError: void 0 === f2 ? Qc : f2,
      onAllReady: void 0 === e2 ? X2 : e2,
      onShellReady: void 0 === g2 ? X2 : g2,
      onShellError: void 0 === h2 ? X2 : h2,
      onFatalError: void 0 === m2 ? X2 : m2
    };
    c2 = Sc(b2, 0, null, c2, false, false);
    c2.parentFlushed = true;
    a2 = Tc(b2, a2, null, c2, r2, kc, null, sc);
    q2.push(a2);
    return b2;
  }

  function Tc(a2, b2, c2, d2, f2, e2, g2, h2) {
    a2.allPendingTasks++;
    null === c2 ? a2.pendingRootTasks++ : c2.pendingTasks++;
    var m2 = {
      node: b2,
      ping: function ping() {
        var b3 = a2.pingedTasks;
        b3.push(m2);
        1 === b3.length && Uc(a2);
      },
      blockedBoundary: c2,
      blockedSegment: d2,
      abortSet: f2,
      legacyContext: e2,
      context: g2,
      treeContext: h2
    };
    f2.add(m2);
    return m2;
  }

  function Sc(a2, b2, c2, d2, f2, e2) {
    return {
      status: 0,
      id: -1,
      index: b2,
      parentFlushed: false,
      chunks: [],
      children: [],
      formatContext: d2,
      boundary: c2,
      lastPushedText: f2,
      textEmbedded: e2
    };
  }

  function Y2(a2, b2) {
    a2 = a2.onError(b2);
    if (null != a2 && "string" !== typeof a2) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a2 + '" instead');
    return a2;
  }

  function Vc(a2, b2) {
    var c2 = a2.onShellError;
    c2(b2);
    c2 = a2.onFatalError;
    c2(b2);
    null !== a2.destination ? (a2.status = 2, da(a2.destination, b2)) : (a2.status = 1, a2.fatalError = b2);
  }

  function Wc(a2, b2, c2, d2, f2) {
    R2 = {};
    Ac = b2;
    U2 = 0;

    for (a2 = c2(d2, f2); Cc;) {
      Cc = false, U2 = 0, Dc += 1, S2 = null, a2 = c2(d2, f2);
    }

    Gc();
    return a2;
  }

  function Xc(a2, b2, c2, d2) {
    var f2 = c2.render(),
        e2 = d2.childContextTypes;

    if (null !== e2 && void 0 !== e2) {
      var g2 = b2.legacyContext;
      if ("function" !== typeof c2.getChildContext) d2 = g2;else {
        c2 = c2.getChildContext();

        for (var h2 in c2) {
          if (!(h2 in e2)) throw Error(k2(108, jc(d2) || "Unknown", h2));
        }

        d2 = N2({}, g2, c2);
      }
      b2.legacyContext = d2;
      Z2(a2, b2, f2);
      b2.legacyContext = g2;
    } else Z2(a2, b2, f2);
  }

  function Yc(a2, b2) {
    if (a2 && a2.defaultProps) {
      b2 = N2({}, b2);
      a2 = a2.defaultProps;

      for (var c2 in a2) {
        void 0 === b2[c2] && (b2[c2] = a2[c2]);
      }

      return b2;
    }

    return b2;
  }

  function Zc(a2, b2, c2, d2, f2) {
    if ("function" === typeof c2) {
      if (c2.prototype && c2.prototype.isReactComponent) {
        f2 = lc(c2, b2.legacyContext);
        var e2 = c2.contextType;
        e2 = new c2(d2, "object" === typeof e2 && null !== e2 ? e2._currentValue : f2);
        rc(e2, c2, d2, f2);
        Xc(a2, b2, e2, c2);
      } else {
        e2 = lc(c2, b2.legacyContext);
        f2 = Wc(a2, b2, c2, d2, e2);
        var g2 = 0 !== U2;
        if ("object" === typeof f2 && null !== f2 && "function" === typeof f2.render && void 0 === f2.$$typeof) rc(f2, c2, d2, e2), Xc(a2, b2, f2, c2);else if (g2) {
          d2 = b2.treeContext;
          b2.treeContext = tc(d2, 1, 0);

          try {
            Z2(a2, b2, f2);
          } finally {
            b2.treeContext = d2;
          }
        } else Z2(a2, b2, f2);
      }
    } else if ("string" === typeof c2) {
      f2 = b2.blockedSegment;
      e2 = Sa(f2.chunks, c2, d2, a2.responseState, f2.formatContext);
      f2.lastPushedText = false;
      g2 = f2.formatContext;
      f2.formatContext = Ba(g2, c2, d2);
      $c(a2, b2, e2);
      f2.formatContext = g2;

      switch (c2) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;

        default:
          f2.chunks.push(Ta, u2(c2), Ua);
      }

      f2.lastPushedText = false;
    } else {
      switch (c2) {
        case gc:
        case fc:
        case Wb:
        case Xb:
        case Vb:
          Z2(a2, b2, d2.children);
          return;

        case bc:
          Z2(a2, b2, d2.children);
          return;

        case ec:
          throw Error(k2(343));

        case ac:
          a: {
            c2 = b2.blockedBoundary;
            f2 = b2.blockedSegment;
            e2 = d2.fallback;
            d2 = d2.children;
            g2 = /* @__PURE__ */new Set();
            var h2 = {
              id: null,
              rootSegmentID: -1,
              parentFlushed: false,
              pendingTasks: 0,
              forceClientRender: false,
              completedSegments: [],
              byteSize: 0,
              fallbackAbortableTasks: g2,
              errorDigest: null
            },
                m2 = Sc(a2, f2.chunks.length, h2, f2.formatContext, false, false);
            f2.children.push(m2);
            f2.lastPushedText = false;
            var q2 = Sc(a2, 0, null, f2.formatContext, false, false);
            q2.parentFlushed = true;
            b2.blockedBoundary = h2;
            b2.blockedSegment = q2;

            try {
              if ($c(a2, b2, d2), q2.lastPushedText && q2.textEmbedded && q2.chunks.push(Ca), q2.status = 1, ad(h2, q2), 0 === h2.pendingTasks) break a;
            } catch (r2) {
              q2.status = 4, h2.forceClientRender = true, h2.errorDigest = Y2(a2, r2);
            } finally {
              b2.blockedBoundary = c2, b2.blockedSegment = f2;
            }

            b2 = Tc(a2, e2, c2, m2, g2, b2.legacyContext, b2.context, b2.treeContext);
            a2.pingedTasks.push(b2);
          }

          return;
      }

      if ("object" === typeof c2 && null !== c2) switch (c2.$$typeof) {
        case $b:
          d2 = Wc(a2, b2, c2.render, d2, f2);

          if (0 !== U2) {
            c2 = b2.treeContext;
            b2.treeContext = tc(c2, 1, 0);

            try {
              Z2(a2, b2, d2);
            } finally {
              b2.treeContext = c2;
            }
          } else Z2(a2, b2, d2);

          return;

        case cc:
          c2 = c2.type;
          d2 = Yc(c2, d2);
          Zc(a2, b2, c2, d2, f2);
          return;

        case Yb:
          f2 = d2.children;
          c2 = c2._context;
          d2 = d2.value;
          e2 = c2._currentValue;
          c2._currentValue = d2;
          g2 = O2;
          O2 = d2 = {
            parent: g2,
            depth: null === g2 ? 0 : g2.depth + 1,
            context: c2,
            parentValue: e2,
            value: d2
          };
          b2.context = d2;
          Z2(a2, b2, f2);
          a2 = O2;
          if (null === a2) throw Error(k2(403));
          d2 = a2.parentValue;
          a2.context._currentValue = d2 === hc ? a2.context._defaultValue : d2;
          a2 = O2 = a2.parent;
          b2.context = a2;
          return;

        case Zb:
          d2 = d2.children;
          d2 = d2(c2._currentValue);
          Z2(a2, b2, d2);
          return;

        case dc:
          f2 = c2._init;
          c2 = f2(c2._payload);
          d2 = Yc(c2, d2);
          Zc(a2, b2, c2, d2, void 0);
          return;
      }
      throw Error(k2(130, null == c2 ? c2 : typeof c2, ""));
    }
  }

  function Z2(a2, b2, c2) {
    b2.node = c2;

    if ("object" === typeof c2 && null !== c2) {
      switch (c2.$$typeof) {
        case Tb:
          Zc(a2, b2, c2.type, c2.props, c2.ref);
          return;

        case Ub:
          throw Error(k2(257));

        case dc:
          var d2 = c2._init;
          c2 = d2(c2._payload);
          Z2(a2, b2, c2);
          return;
      }

      if (ra(c2)) {
        bd(a2, b2, c2);
        return;
      }

      null === c2 || "object" !== typeof c2 ? d2 = null : (d2 = ic && c2[ic] || c2["@@iterator"], d2 = "function" === typeof d2 ? d2 : null);

      if (d2 && (d2 = d2.call(c2))) {
        c2 = d2.next();

        if (!c2.done) {
          var f2 = [];

          do {
            f2.push(c2.value), c2 = d2.next();
          } while (!c2.done);

          bd(a2, b2, f2);
        }

        return;
      }

      a2 = Object.prototype.toString.call(c2);
      throw Error(k2(31, "[object Object]" === a2 ? "object with keys {" + Object.keys(c2).join(", ") + "}" : a2));
    }

    "string" === typeof c2 ? (d2 = b2.blockedSegment, d2.lastPushedText = Da(b2.blockedSegment.chunks, c2, a2.responseState, d2.lastPushedText)) : "number" === typeof c2 && (d2 = b2.blockedSegment, d2.lastPushedText = Da(b2.blockedSegment.chunks, "" + c2, a2.responseState, d2.lastPushedText));
  }

  function bd(a2, b2, c2) {
    for (var d2 = c2.length, f2 = 0; f2 < d2; f2++) {
      var e2 = b2.treeContext;
      b2.treeContext = tc(e2, d2, f2);

      try {
        $c(a2, b2, c2[f2]);
      } finally {
        b2.treeContext = e2;
      }
    }
  }

  function $c(a2, b2, c2) {
    var d2 = b2.blockedSegment.formatContext,
        f2 = b2.legacyContext,
        e2 = b2.context;

    try {
      return Z2(a2, b2, c2);
    } catch (m2) {
      if (Gc(), "object" === typeof m2 && null !== m2 && "function" === typeof m2.then) {
        c2 = m2;
        var g2 = b2.blockedSegment,
            h2 = Sc(a2, g2.chunks.length, null, g2.formatContext, g2.lastPushedText, true);
        g2.children.push(h2);
        g2.lastPushedText = false;
        a2 = Tc(a2, b2.node, b2.blockedBoundary, h2, b2.abortSet, b2.legacyContext, b2.context, b2.treeContext).ping;
        c2.then(a2, a2);
        b2.blockedSegment.formatContext = d2;
        b2.legacyContext = f2;
        b2.context = e2;
        Q2(e2);
      } else throw b2.blockedSegment.formatContext = d2, b2.legacyContext = f2, b2.context = e2, Q2(e2), m2;
    }
  }

  function cd(a2) {
    var b2 = a2.blockedBoundary;
    a2 = a2.blockedSegment;
    a2.status = 3;
    dd(this, b2, a2);
  }

  function ed(a2, b2, c2) {
    var d2 = a2.blockedBoundary;
    a2.blockedSegment.status = 3;
    null === d2 ? (b2.allPendingTasks--, 2 !== b2.status && (b2.status = 2, null !== b2.destination && b2.destination.close())) : (d2.pendingTasks--, d2.forceClientRender || (d2.forceClientRender = true, a2 = void 0 === c2 ? Error(k2(432)) : c2, d2.errorDigest = b2.onError(a2), d2.parentFlushed && b2.clientRenderedBoundaries.push(d2)), d2.fallbackAbortableTasks.forEach(function (a3) {
      return ed(a3, b2, c2);
    }), d2.fallbackAbortableTasks.clear(), b2.allPendingTasks--, 0 === b2.allPendingTasks && (d2 = b2.onAllReady, d2()));
  }

  function ad(a2, b2) {
    if (0 === b2.chunks.length && 1 === b2.children.length && null === b2.children[0].boundary) {
      var c2 = b2.children[0];
      c2.id = b2.id;
      c2.parentFlushed = true;
      1 === c2.status && ad(a2, c2);
    } else a2.completedSegments.push(b2);
  }

  function dd(a2, b2, c2) {
    if (null === b2) {
      if (c2.parentFlushed) {
        if (null !== a2.completedRootSegment) throw Error(k2(389));
        a2.completedRootSegment = c2;
      }

      a2.pendingRootTasks--;
      0 === a2.pendingRootTasks && (a2.onShellError = X2, b2 = a2.onShellReady, b2());
    } else b2.pendingTasks--, b2.forceClientRender || (0 === b2.pendingTasks ? (c2.parentFlushed && 1 === c2.status && ad(b2, c2), b2.parentFlushed && a2.completedBoundaries.push(b2), b2.fallbackAbortableTasks.forEach(cd, a2), b2.fallbackAbortableTasks.clear()) : c2.parentFlushed && 1 === c2.status && (ad(b2, c2), 1 === b2.completedSegments.length && b2.parentFlushed && a2.partialBoundaries.push(b2)));

    a2.allPendingTasks--;
    0 === a2.allPendingTasks && (a2 = a2.onAllReady, a2());
  }

  function Uc(a2) {
    if (2 !== a2.status) {
      var b2 = O2,
          c2 = Pc.current;
      Pc.current = Oc;
      var d2 = Nc;
      Nc = a2.responseState;

      try {
        var f2 = a2.pingedTasks,
            e2;

        for (e2 = 0; e2 < f2.length; e2++) {
          var g2 = f2[e2];
          var h2 = a2,
              m2 = g2.blockedSegment;

          if (0 === m2.status) {
            Q2(g2.context);

            try {
              Z2(h2, g2, g2.node), m2.lastPushedText && m2.textEmbedded && m2.chunks.push(Ca), g2.abortSet.delete(g2), m2.status = 1, dd(h2, g2.blockedBoundary, m2);
            } catch (G2) {
              if (Gc(), "object" === typeof G2 && null !== G2 && "function" === typeof G2.then) {
                var q2 = g2.ping;
                G2.then(q2, q2);
              } else {
                g2.abortSet.delete(g2);
                m2.status = 4;
                var r2 = g2.blockedBoundary,
                    v2 = G2,
                    A2 = Y2(h2, v2);
                null === r2 ? Vc(h2, v2) : (r2.pendingTasks--, r2.forceClientRender || (r2.forceClientRender = true, r2.errorDigest = A2, r2.parentFlushed && h2.clientRenderedBoundaries.push(r2)));
                h2.allPendingTasks--;

                if (0 === h2.allPendingTasks) {
                  var F2 = h2.onAllReady;
                  F2();
                }
              }
            } finally {}
          }
        }

        f2.splice(0, e2);
        null !== a2.destination && fd(a2, a2.destination);
      } catch (G2) {
        Y2(a2, G2), Vc(a2, G2);
      } finally {
        Nc = d2, Pc.current = c2, c2 === Oc && Q2(b2);
      }
    }
  }

  function gd(a2, b2, c2) {
    c2.parentFlushed = true;

    switch (c2.status) {
      case 0:
        var d2 = c2.id = a2.nextSegmentId++;
        c2.lastPushedText = false;
        c2.textEmbedded = false;
        a2 = a2.responseState;
        p2(b2, Va);
        p2(b2, a2.placeholderPrefix);
        a2 = u2(d2.toString(16));
        p2(b2, a2);
        return t2(b2, Wa);

      case 1:
        c2.status = 2;
        var f2 = true;
        d2 = c2.chunks;
        var e2 = 0;
        c2 = c2.children;

        for (var g2 = 0; g2 < c2.length; g2++) {
          for (f2 = c2[g2]; e2 < f2.index; e2++) {
            p2(b2, d2[e2]);
          }

          f2 = hd(a2, b2, f2);
        }

        for (; e2 < d2.length - 1; e2++) {
          p2(b2, d2[e2]);
        }

        e2 < d2.length && (f2 = t2(b2, d2[e2]));
        return f2;

      default:
        throw Error(k2(390));
    }
  }

  function hd(a2, b2, c2) {
    var d2 = c2.boundary;
    if (null === d2) return gd(a2, b2, c2);
    d2.parentFlushed = true;
    if (d2.forceClientRender) d2 = d2.errorDigest, t2(b2, $a), p2(b2, bb), d2 && (p2(b2, db), p2(b2, u2(C2(d2))), p2(b2, cb)), t2(b2, eb), gd(a2, b2, c2);else if (0 < d2.pendingTasks) {
      d2.rootSegmentID = a2.nextSegmentId++;
      0 < d2.completedSegments.length && a2.partialBoundaries.push(d2);
      var f2 = a2.responseState;
      var e2 = f2.nextSuspenseID++;
      f2 = w2(f2.boundaryPrefix + e2.toString(16));
      d2 = d2.id = f2;
      fb(b2, a2.responseState, d2);
      gd(a2, b2, c2);
    } else if (d2.byteSize > a2.progressiveChunkSize) d2.rootSegmentID = a2.nextSegmentId++, a2.completedBoundaries.push(d2), fb(b2, a2.responseState, d2.id), gd(a2, b2, c2);else {
      t2(b2, Xa);
      c2 = d2.completedSegments;
      if (1 !== c2.length) throw Error(k2(391));
      hd(a2, b2, c2[0]);
    }
    return t2(b2, ab);
  }

  function id(a2, b2, c2) {
    Bb(b2, a2.responseState, c2.formatContext, c2.id);
    hd(a2, b2, c2);
    return Cb(b2, c2.formatContext);
  }

  function jd(a2, b2, c2) {
    for (var d2 = c2.completedSegments, f2 = 0; f2 < d2.length; f2++) {
      kd(a2, b2, c2, d2[f2]);
    }

    d2.length = 0;
    a2 = a2.responseState;
    d2 = c2.id;
    c2 = c2.rootSegmentID;
    p2(b2, a2.startInlineScript);
    a2.sentCompleteBoundaryFunction ? p2(b2, Jb) : (a2.sentCompleteBoundaryFunction = true, p2(b2, Ib));
    if (null === d2) throw Error(k2(395));
    c2 = u2(c2.toString(16));
    p2(b2, d2);
    p2(b2, Kb);
    p2(b2, a2.segmentPrefix);
    p2(b2, c2);
    return t2(b2, Lb);
  }

  function kd(a2, b2, c2, d2) {
    if (2 === d2.status) return true;
    var f2 = d2.id;

    if (-1 === f2) {
      if (-1 === (d2.id = c2.rootSegmentID)) throw Error(k2(392));
      return id(a2, b2, d2);
    }

    id(a2, b2, d2);
    a2 = a2.responseState;
    p2(b2, a2.startInlineScript);
    a2.sentCompleteSegmentFunction ? p2(b2, Eb) : (a2.sentCompleteSegmentFunction = true, p2(b2, Db));
    p2(b2, a2.segmentPrefix);
    f2 = u2(f2.toString(16));
    p2(b2, f2);
    p2(b2, Gb);
    p2(b2, a2.placeholderPrefix);
    p2(b2, f2);
    return t2(b2, Hb);
  }

  function fd(a2, b2) {
    l2 = new Uint8Array(512);
    n2 = 0;

    try {
      var c2 = a2.completedRootSegment;

      if (null !== c2 && 0 === a2.pendingRootTasks) {
        hd(a2, b2, c2);
        a2.completedRootSegment = null;
        var d2 = a2.responseState.bootstrapChunks;

        for (c2 = 0; c2 < d2.length - 1; c2++) {
          p2(b2, d2[c2]);
        }

        c2 < d2.length && t2(b2, d2[c2]);
      }

      var f2 = a2.clientRenderedBoundaries,
          e2;

      for (e2 = 0; e2 < f2.length; e2++) {
        var g2 = f2[e2];
        d2 = b2;
        var h2 = a2.responseState,
            m2 = g2.id,
            q2 = g2.errorDigest,
            r2 = g2.errorMessage,
            v2 = g2.errorComponentStack;
        p2(d2, h2.startInlineScript);
        h2.sentClientRenderFunction ? p2(d2, Nb) : (h2.sentClientRenderFunction = true, p2(d2, Mb));
        if (null === m2) throw Error(k2(395));
        p2(d2, m2);
        p2(d2, Ob);
        if (q2 || r2 || v2) p2(d2, Qb), p2(d2, u2(Sb(q2 || "")));
        if (r2 || v2) p2(d2, Qb), p2(d2, u2(Sb(r2 || "")));
        v2 && (p2(d2, Qb), p2(d2, u2(Sb(v2))));
        if (!t2(d2, Pb)) ;
      }

      f2.splice(0, e2);
      var A2 = a2.completedBoundaries;

      for (e2 = 0; e2 < A2.length; e2++) {
        if (!jd(a2, b2, A2[e2])) ;
      }

      A2.splice(0, e2);
      ba(b2);
      l2 = new Uint8Array(512);
      n2 = 0;
      var F2 = a2.partialBoundaries;

      for (e2 = 0; e2 < F2.length; e2++) {
        var G2 = F2[e2];

        a: {
          f2 = a2;
          g2 = b2;
          var ma = G2.completedSegments;

          for (h2 = 0; h2 < ma.length; h2++) {
            if (!kd(f2, g2, G2, ma[h2])) {
              h2++;
              ma.splice(0, h2);
              var Fb = false;
              break a;
            }
          }

          ma.splice(0, h2);
          Fb = true;
        }

        if (!Fb) {
          a2.destination = null;
          e2++;
          F2.splice(0, e2);
          return;
        }
      }

      F2.splice(0, e2);
      var na = a2.completedBoundaries;

      for (e2 = 0; e2 < na.length; e2++) {
        if (!jd(a2, b2, na[e2])) ;
      }

      na.splice(0, e2);
    } finally {
      ba(b2), 0 === a2.allPendingTasks && 0 === a2.pingedTasks.length && 0 === a2.clientRenderedBoundaries.length && 0 === a2.completedBoundaries.length && b2.close();
    }
  }

  function ld(a2, b2) {
    try {
      var c2 = a2.abortableTasks;
      c2.forEach(function (c3) {
        return ed(c3, a2, b2);
      });
      c2.clear();
      null !== a2.destination && fd(a2, a2.destination);
    } catch (d2) {
      Y2(a2, d2), Vc(a2, d2);
    }
  }

  reactDomServer_browser_production_min.renderToReadableStream = function (a2, b2) {
    return new Promise(function (c2, d2) {
      var f2,
          e2,
          g2 = new Promise(function (a3, b3) {
        e2 = a3;
        f2 = b3;
      }),
          h2 = Rc(a2, za(b2 ? b2.identifierPrefix : void 0, b2 ? b2.nonce : void 0, b2 ? b2.bootstrapScriptContent : void 0, b2 ? b2.bootstrapScripts : void 0, b2 ? b2.bootstrapModules : void 0), Aa(b2 ? b2.namespaceURI : void 0), b2 ? b2.progressiveChunkSize : void 0, b2 ? b2.onError : void 0, e2, function () {
        var a3 = new ReadableStream({
          type: "bytes",
          pull: function pull(a4) {
            if (1 === h2.status) h2.status = 2, da(a4, h2.fatalError);else if (2 !== h2.status && null === h2.destination) {
              h2.destination = a4;

              try {
                fd(h2, a4);
              } catch (A2) {
                Y2(h2, A2), Vc(h2, A2);
              }
            }
          },
          cancel: function cancel() {
            ld(h2);
          }
        }, {
          highWaterMark: 0
        });
        a3.allReady = g2;
        c2(a3);
      }, function (a3) {
        g2.catch(function () {});
        d2(a3);
      }, f2);

      if (b2 && b2.signal) {
        var m2 = b2.signal,
            q2 = function q2() {
          ld(h2, m2.reason);
          m2.removeEventListener("abort", q2);
        };

        m2.addEventListener("abort", q2);
      }

      Uc(h2);
    });
  };

  reactDomServer_browser_production_min.version = "18.2.0";
  return reactDomServer_browser_production_min;
}

var reactDomServerLegacy_browser_development = {};
/**
 * @license React
 * react-dom-server-legacy.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServerLegacy_browser_development;

function requireReactDomServerLegacy_browser_development() {
  if (hasRequiredReactDomServerLegacy_browser_development) return reactDomServerLegacy_browser_development;
  hasRequiredReactDomServerLegacy_browser_development = 1;

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var React = r$1;
      var ReactVersion = "18.2.0";
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

      function warn(format) {
        {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            printWarning("warn", format, args);
          }
        }
      }

      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning("error", format, args);
          }
        }
      }

      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();

          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }

          var argsWithFormat = args.map(function (item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      function scheduleWork(callback) {
        callback();
      }

      function beginWriting(destination) {}

      function writeChunk(destination, chunk) {
        writeChunkAndReturn(destination, chunk);
      }

      function writeChunkAndReturn(destination, chunk) {
        return destination.push(chunk);
      }

      function completeWriting(destination) {}

      function close(destination) {
        destination.push(null);
      }

      function stringToChunk(content) {
        return content;
      }

      function stringToPrecomputedChunk(content) {
        return content;
      }

      function closeWithError(destination, error2) {
        destination.destroy(error2);
      }

      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }

      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e2) {
            return true;
          }
        }
      }

      function testStringCoercion(value) {
        return "" + value;
      }

      function checkAttributeStringCoercion(value, attributeName) {
        {
          if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkCSSPropertyStringCoercion(value, propName) {
        {
          if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkHtmlStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      var hasOwnProperty2 = Object.prototype.hasOwnProperty;
      var RESERVED = 0;
      var STRING = 1;
      var BOOLEANISH_STRING = 2;
      var BOOLEAN = 3;
      var OVERLOADED_BOOLEAN = 4;
      var NUMERIC = 5;
      var POSITIVE_NUMERIC = 6;
      var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
      var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
      var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
      var illegalAttributeNameCache = {};
      var validatedAttributeNameCache = {};

      function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty2.call(validatedAttributeNameCache, attributeName)) {
          return true;
        }

        if (hasOwnProperty2.call(illegalAttributeNameCache, attributeName)) {
          return false;
        }

        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
          validatedAttributeNameCache[attributeName] = true;
          return true;
        }

        illegalAttributeNameCache[attributeName] = true;
        {
          error("Invalid attribute name: `%s`", attributeName);
        }
        return false;
      }

      function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) {
          return false;
        }

        switch (typeof value) {
          case "function":
          case "symbol":
            return true;

          case "boolean":
            {
              if (isCustomComponentTag) {
                return false;
              }

              if (propertyInfo !== null) {
                return !propertyInfo.acceptsBooleans;
              } else {
                var prefix2 = name.toLowerCase().slice(0, 5);
                return prefix2 !== "data-" && prefix2 !== "aria-";
              }
            }

          default:
            return false;
        }
      }

      function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
      }

      function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL2, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL2;
        this.removeEmptyString = removeEmptyString;
      }

      var properties = {};
      var reservedProps = ["children", "dangerouslySetInnerHTML", "defaultValue", "defaultChecked", "innerHTML", "suppressContentEditableWarning", "suppressHydrationWarning", "style"];
      reservedProps.forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
      });
      [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (_ref) {
        var name = _ref[0],
            attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
      });
      ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
      });
      ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
      });
      ["allowFullScreen", "async", "autoFocus", "autoPlay", "controls", "default", "defer", "disabled", "disablePictureInPicture", "disableRemotePlayback", "formNoValidate", "hidden", "loop", "noModule", "noValidate", "open", "playsInline", "readOnly", "required", "reversed", "scoped", "seamless", "itemScope"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
      });
      ["checked", "multiple", "muted", "selected"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
      });
      ["capture", "download"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
      });
      ["cols", "rows", "size", "span"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
      });
      ["rowSpan", "start"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
      });
      var CAMELIZE = /[\-\:]([a-z])/g;

      var capitalize = function capitalize(token) {
        return token[1].toUpperCase();
      };

      ["accent-height", "alignment-baseline", "arabic-form", "baseline-shift", "cap-height", "clip-path", "clip-rule", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "dominant-baseline", "enable-background", "fill-opacity", "fill-rule", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "glyph-name", "glyph-orientation-horizontal", "glyph-orientation-vertical", "horiz-adv-x", "horiz-origin-x", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "overline-position", "overline-thickness", "paint-order", "panose-1", "pointer-events", "rendering-intent", "shape-rendering", "stop-color", "stop-opacity", "strikethrough-position", "strikethrough-thickness", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-rendering", "underline-position", "underline-thickness", "unicode-bidi", "unicode-range", "units-per-em", "v-alphabetic", "v-hanging", "v-ideographic", "v-mathematical", "vector-effect", "vert-adv-y", "vert-origin-x", "vert-origin-y", "word-spacing", "writing-mode", "xmlns:xlink", "x-height"].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
      });
      ["xlink:actuate", "xlink:arcrole", "xlink:role", "xlink:show", "xlink:title", "xlink:type"].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
      });
      ["xml:base", "xml:lang", "xml:space"].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
      });
      ["tabIndex", "crossOrigin"].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
      });
      var xlinkHref = "xlinkHref";
      properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
      ["src", "href", "action", "formAction"].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
      });
      var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
      };

      function prefixKey(prefix2, key) {
        return prefix2 + key.charAt(0).toUpperCase() + key.substring(1);
      }

      var prefixes = ["Webkit", "ms", "Moz", "O"];
      Object.keys(isUnitlessNumber).forEach(function (prop) {
        prefixes.forEach(function (prefix2) {
          isUnitlessNumber[prefixKey(prefix2, prop)] = isUnitlessNumber[prop];
        });
      });
      var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
      };

      function checkControlledValueProps(tagName, props) {
        {
          if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
            error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
          }

          if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
            error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
          }
        }
      }

      function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) {
          return typeof props.is === "string";
        }

        switch (tagName) {
          case "annotation-xml":
          case "color-profile":
          case "font-face":
          case "font-face-src":
          case "font-face-uri":
          case "font-face-format":
          case "font-face-name":
          case "missing-glyph":
            return false;

          default:
            return true;
        }
      }

      var ariaProperties = {
        "aria-current": 0,
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        "aria-hidden": 0,
        "aria-invalid": 0,
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
      };
      var warnedProperties = {};
      var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
      var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");

      function validateProperty(tagName, name) {
        {
          if (hasOwnProperty2.call(warnedProperties, name) && warnedProperties[name]) {
            return true;
          }

          if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null;

            if (correctName == null) {
              error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
              warnedProperties[name] = true;
              return true;
            }

            if (name !== correctName) {
              error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
              warnedProperties[name] = true;
              return true;
            }
          }

          if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null;

            if (standardName == null) {
              warnedProperties[name] = true;
              return false;
            }

            if (name !== standardName) {
              error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
              warnedProperties[name] = true;
              return true;
            }
          }
        }
        return true;
      }

      function warnInvalidARIAProps(type, props) {
        {
          var invalidProps = [];

          for (var key in props) {
            var isValid = validateProperty(type, key);

            if (!isValid) {
              invalidProps.push(key);
            }
          }

          var unknownPropString = invalidProps.map(function (prop) {
            return "`" + prop + "`";
          }).join(", ");

          if (invalidProps.length === 1) {
            error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
          } else if (invalidProps.length > 1) {
            error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
          }
        }
      }

      function validateProperties(type, props) {
        if (isCustomComponent(type, props)) {
          return;
        }

        warnInvalidARIAProps(type, props);
      }

      var didWarnValueNull = false;

      function validateProperties$1(type, props) {
        {
          if (type !== "input" && type !== "textarea" && type !== "select") {
            return;
          }

          if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;

            if (type === "select" && props.multiple) {
              error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            } else {
              error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
            }
          }
        }
      }

      var possibleStandardNames = {
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
      };

      var validateProperty$1 = function validateProperty$1() {};

      {
        var warnedProperties$1 = {};
        var EVENT_NAME_REGEX = /^on./;
        var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
        var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
        var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");

        validateProperty$1 = function validateProperty$1(tagName, name, value, eventRegistry) {
          if (hasOwnProperty2.call(warnedProperties$1, name) && warnedProperties$1[name]) {
            return true;
          }

          var lowerCasedName = name.toLowerCase();

          if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
          }

          if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies,
                possibleRegistrationNames = eventRegistry.possibleRegistrationNames;

            if (registrationNameDependencies.hasOwnProperty(name)) {
              return true;
            }

            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

            if (registrationName != null) {
              error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
              warnedProperties$1[name] = true;
              return true;
            }

            if (EVENT_NAME_REGEX.test(name)) {
              error("Unknown event handler property `%s`. It will be ignored.", name);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (EVENT_NAME_REGEX.test(name)) {
            if (INVALID_EVENT_NAME_REGEX.test(name)) {
              error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            }

            warnedProperties$1[name] = true;
            return true;
          }

          if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
            return true;
          }

          if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
          }

          if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
          }

          if (lowerCasedName === "is" && value !== null && value !== void 0 && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
          }

          if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
          }

          var propertyInfo = getPropertyInfo(name);
          var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED;

          if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];

            if (standardName !== name) {
              error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (!isReserved && name !== lowerCasedName) {
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
          }

          if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) {
              error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            } else {
              error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            }

            warnedProperties$1[name] = true;
            return true;
          }

          if (isReserved) {
            return true;
          }

          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
          }

          if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
          }

          return true;
        };
      }

      var warnUnknownProperties = function warnUnknownProperties(type, props, eventRegistry) {
        {
          var unknownProps = [];

          for (var key in props) {
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);

            if (!isValid) {
              unknownProps.push(key);
            }
          }

          var unknownPropString = unknownProps.map(function (prop) {
            return "`" + prop + "`";
          }).join(", ");

          if (unknownProps.length === 1) {
            error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
          } else if (unknownProps.length > 1) {
            error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
          }
        }
      };

      function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) {
          return;
        }

        warnUnknownProperties(type, props, eventRegistry);
      }

      var warnValidStyle = function warnValidStyle() {};

      {
        var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
        var msPattern = /^-ms-/;
        var hyphenPattern = /-(.)/g;
        var badStyleValueWithSemicolonPattern = /;\s*$/;
        var warnedStyleNames = {};
        var warnedStyleValues = {};
        var warnedForNaNValue = false;
        var warnedForInfinityValue = false;

        var camelize = function camelize(string) {
          return string.replace(hyphenPattern, function (_2, character) {
            return character.toUpperCase();
          });
        };

        var warnHyphenatedStyleName = function warnHyphenatedStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }

          warnedStyleNames[name] = true;
          error("Unsupported style property %s. Did you mean %s?", name, camelize(name.replace(msPattern, "ms-")));
        };

        var warnBadVendoredStyleName = function warnBadVendoredStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }

          warnedStyleNames[name] = true;
          error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
        };

        var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value) {
          if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
            return;
          }

          warnedStyleValues[value] = true;
          error("Style property values shouldn't contain a semicolon. Try \"%s: %s\" instead.", name, value.replace(badStyleValueWithSemicolonPattern, ""));
        };

        var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value) {
          if (warnedForNaNValue) {
            return;
          }

          warnedForNaNValue = true;
          error("`NaN` is an invalid value for the `%s` css style property.", name);
        };

        var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value) {
          if (warnedForInfinityValue) {
            return;
          }

          warnedForInfinityValue = true;
          error("`Infinity` is an invalid value for the `%s` css style property.", name);
        };

        warnValidStyle = function warnValidStyle(name, value) {
          if (name.indexOf("-") > -1) {
            warnHyphenatedStyleName(name);
          } else if (badVendoredStyleNamePattern.test(name)) {
            warnBadVendoredStyleName(name);
          } else if (badStyleValueWithSemicolonPattern.test(value)) {
            warnStyleValueWithSemicolon(name, value);
          }

          if (typeof value === "number") {
            if (isNaN(value)) {
              warnStyleValueIsNaN(name, value);
            } else if (!isFinite(value)) {
              warnStyleValueIsInfinity(name, value);
            }
          }
        };
      }
      var warnValidStyle$1 = warnValidStyle;
      var matchHtmlRegExp = /["'&<>]/;

      function escapeHtml(string) {
        {
          checkHtmlStringCoercion(string);
        }
        var str = "" + string;
        var match = matchHtmlRegExp.exec(str);

        if (!match) {
          return str;
        }

        var escape;
        var html = "";
        var index;
        var lastIndex = 0;

        for (index = match.index; index < str.length; index++) {
          switch (str.charCodeAt(index)) {
            case 34:
              escape = "&quot;";
              break;

            case 38:
              escape = "&amp;";
              break;

            case 39:
              escape = "&#x27;";
              break;

            case 60:
              escape = "&lt;";
              break;

            case 62:
              escape = "&gt;";
              break;

            default:
              continue;
          }

          if (lastIndex !== index) {
            html += str.substring(lastIndex, index);
          }

          lastIndex = index + 1;
          html += escape;
        }

        return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
      }

      function escapeTextForBrowser(text) {
        if (typeof text === "boolean" || typeof text === "number") {
          return "" + text;
        }

        return escapeHtml(text);
      }

      var uppercasePattern = /([A-Z])/g;
      var msPattern$1 = /^ms-/;

      function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-");
      }

      var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
      var didWarn = false;

      function sanitizeURL(url) {
        {
          if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
          }
        }
      }

      var isArrayImpl = Array.isArray;

      function isArray2(a2) {
        return isArrayImpl(a2);
      }

      var startInlineScript = stringToPrecomputedChunk("<script>");
      var endInlineScript = stringToPrecomputedChunk("<\/script>");
      var startScriptSrc = stringToPrecomputedChunk('<script src="');
      var startModuleSrc = stringToPrecomputedChunk('<script type="module" src="');
      var endAsyncScript = stringToPrecomputedChunk('" async=""><\/script>');

      function escapeBootstrapScriptContent(scriptText) {
        {
          checkHtmlStringCoercion(scriptText);
        }
        return ("" + scriptText).replace(scriptRegex, scriptReplacer);
      }

      var scriptRegex = /(<\/|<)(s)(cript)/gi;

      var scriptReplacer = function scriptReplacer(match, prefix2, s2, suffix) {
        return "" + prefix2 + (s2 === "s" ? "\\u0073" : "\\u0053") + suffix;
      };

      function createResponseState(identifierPrefix, nonce, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
        var idPrefix = identifierPrefix === void 0 ? "" : identifierPrefix;
        var inlineScriptWithNonce = nonce === void 0 ? startInlineScript : stringToPrecomputedChunk('<script nonce="' + escapeTextForBrowser(nonce) + '">');
        var bootstrapChunks = [];

        if (bootstrapScriptContent !== void 0) {
          bootstrapChunks.push(inlineScriptWithNonce, stringToChunk(escapeBootstrapScriptContent(bootstrapScriptContent)), endInlineScript);
        }

        if (bootstrapScripts !== void 0) {
          for (var i2 = 0; i2 < bootstrapScripts.length; i2++) {
            bootstrapChunks.push(startScriptSrc, stringToChunk(escapeTextForBrowser(bootstrapScripts[i2])), endAsyncScript);
          }
        }

        if (bootstrapModules !== void 0) {
          for (var _i = 0; _i < bootstrapModules.length; _i++) {
            bootstrapChunks.push(startModuleSrc, stringToChunk(escapeTextForBrowser(bootstrapModules[_i])), endAsyncScript);
          }
        }

        return {
          bootstrapChunks: bootstrapChunks,
          startInlineScript: inlineScriptWithNonce,
          placeholderPrefix: stringToPrecomputedChunk(idPrefix + "P:"),
          segmentPrefix: stringToPrecomputedChunk(idPrefix + "S:"),
          boundaryPrefix: idPrefix + "B:",
          idPrefix: idPrefix,
          nextSuspenseID: 0,
          sentCompleteSegmentFunction: false,
          sentCompleteBoundaryFunction: false,
          sentClientRenderFunction: false
        };
      }

      var ROOT_HTML_MODE = 0;
      var HTML_MODE = 1;
      var SVG_MODE = 2;
      var MATHML_MODE = 3;
      var HTML_TABLE_MODE = 4;
      var HTML_TABLE_BODY_MODE = 5;
      var HTML_TABLE_ROW_MODE = 6;
      var HTML_COLGROUP_MODE = 7;

      function createFormatContext(insertionMode, selectedValue) {
        return {
          insertionMode: insertionMode,
          selectedValue: selectedValue
        };
      }

      function getChildFormatContext(parentContext, type, props) {
        switch (type) {
          case "select":
            return createFormatContext(HTML_MODE, props.value != null ? props.value : props.defaultValue);

          case "svg":
            return createFormatContext(SVG_MODE, null);

          case "math":
            return createFormatContext(MATHML_MODE, null);

          case "foreignObject":
            return createFormatContext(HTML_MODE, null);

          case "table":
            return createFormatContext(HTML_TABLE_MODE, null);

          case "thead":
          case "tbody":
          case "tfoot":
            return createFormatContext(HTML_TABLE_BODY_MODE, null);

          case "colgroup":
            return createFormatContext(HTML_COLGROUP_MODE, null);

          case "tr":
            return createFormatContext(HTML_TABLE_ROW_MODE, null);
        }

        if (parentContext.insertionMode >= HTML_TABLE_MODE) {
          return createFormatContext(HTML_MODE, null);
        }

        if (parentContext.insertionMode === ROOT_HTML_MODE) {
          return createFormatContext(HTML_MODE, null);
        }

        return parentContext;
      }

      var UNINITIALIZED_SUSPENSE_BOUNDARY_ID = null;

      function assignSuspenseBoundaryID(responseState) {
        var generatedID = responseState.nextSuspenseID++;
        return stringToPrecomputedChunk(responseState.boundaryPrefix + generatedID.toString(16));
      }

      function makeId(responseState, treeId, localId) {
        var idPrefix = responseState.idPrefix;
        var id = ":" + idPrefix + "R" + treeId;

        if (localId > 0) {
          id += "H" + localId.toString(32);
        }

        return id + ":";
      }

      function encodeHTMLTextNode(text) {
        return escapeTextForBrowser(text);
      }

      var textSeparator = stringToPrecomputedChunk("<!-- -->");

      function pushTextInstance(target, text, responseState, textEmbedded) {
        if (text === "") {
          return textEmbedded;
        }

        if (textEmbedded) {
          target.push(textSeparator);
        }

        target.push(stringToChunk(encodeHTMLTextNode(text)));
        return true;
      }

      function pushSegmentFinale(target, responseState, lastPushedText, textEmbedded) {
        if (lastPushedText && textEmbedded) {
          target.push(textSeparator);
        }
      }

      var styleNameCache = /* @__PURE__ */new Map();

      function processStyleName(styleName) {
        var chunk = styleNameCache.get(styleName);

        if (chunk !== void 0) {
          return chunk;
        }

        var result = stringToPrecomputedChunk(escapeTextForBrowser(hyphenateStyleName(styleName)));
        styleNameCache.set(styleName, result);
        return result;
      }

      var styleAttributeStart = stringToPrecomputedChunk(' style="');
      var styleAssign = stringToPrecomputedChunk(":");
      var styleSeparator = stringToPrecomputedChunk(";");

      function pushStyle(target, responseState, style) {
        if (typeof style !== "object") {
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        }

        var isFirst = true;

        for (var styleName in style) {
          if (!hasOwnProperty2.call(style, styleName)) {
            continue;
          }

          var styleValue = style[styleName];

          if (styleValue == null || typeof styleValue === "boolean" || styleValue === "") {
            continue;
          }

          var nameChunk = void 0;
          var valueChunk = void 0;
          var isCustomProperty = styleName.indexOf("--") === 0;

          if (isCustomProperty) {
            nameChunk = stringToChunk(escapeTextForBrowser(styleName));
            {
              checkCSSPropertyStringCoercion(styleValue, styleName);
            }
            valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
          } else {
            {
              warnValidStyle$1(styleName, styleValue);
            }
            nameChunk = processStyleName(styleName);

            if (typeof styleValue === "number") {
              if (styleValue !== 0 && !hasOwnProperty2.call(isUnitlessNumber, styleName)) {
                valueChunk = stringToChunk(styleValue + "px");
              } else {
                valueChunk = stringToChunk("" + styleValue);
              }
            } else {
              {
                checkCSSPropertyStringCoercion(styleValue, styleName);
              }
              valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
            }
          }

          if (isFirst) {
            isFirst = false;
            target.push(styleAttributeStart, nameChunk, styleAssign, valueChunk);
          } else {
            target.push(styleSeparator, nameChunk, styleAssign, valueChunk);
          }
        }

        if (!isFirst) {
          target.push(attributeEnd);
        }
      }

      var attributeSeparator = stringToPrecomputedChunk(" ");
      var attributeAssign = stringToPrecomputedChunk('="');
      var attributeEnd = stringToPrecomputedChunk('"');
      var attributeEmptyString = stringToPrecomputedChunk('=""');

      function pushAttribute(target, responseState, name, value) {
        switch (name) {
          case "style":
            {
              pushStyle(target, responseState, value);
              return;
            }

          case "defaultValue":
          case "defaultChecked":
          case "innerHTML":
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            return;
        }

        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) {
          return;
        }

        var propertyInfo = getPropertyInfo(name);

        if (propertyInfo !== null) {
          switch (typeof value) {
            case "function":
            case "symbol":
              return;

            case "boolean":
              {
                if (!propertyInfo.acceptsBooleans) {
                  return;
                }
              }
          }

          var attributeName = propertyInfo.attributeName;
          var attributeNameChunk = stringToChunk(attributeName);

          switch (propertyInfo.type) {
            case BOOLEAN:
              if (value) {
                target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
              }

              return;

            case OVERLOADED_BOOLEAN:
              if (value === true) {
                target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
              } else if (value === false) ;else {
                target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
              }

              return;

            case NUMERIC:
              if (!isNaN(value)) {
                target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
              }

              break;

            case POSITIVE_NUMERIC:
              if (!isNaN(value) && value >= 1) {
                target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
              }

              break;

            default:
              if (propertyInfo.sanitizeURL) {
                {
                  checkAttributeStringCoercion(value, attributeName);
                }
                value = "" + value;
                sanitizeURL(value);
              }

              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
          }
        } else if (isAttributeNameSafe(name)) {
          switch (typeof value) {
            case "function":
            case "symbol":
              return;

            case "boolean":
              {
                var prefix2 = name.toLowerCase().slice(0, 5);

                if (prefix2 !== "data-" && prefix2 !== "aria-") {
                  return;
                }
              }
          }

          target.push(attributeSeparator, stringToChunk(name), attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
        }
      }

      var endOfStartTag = stringToPrecomputedChunk(">");
      var endOfStartTagSelfClosing = stringToPrecomputedChunk("/>");

      function pushInnerHTML(target, innerHTML, children) {
        if (innerHTML != null) {
          if (children != null) {
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          }

          if (typeof innerHTML !== "object" || !("__html" in innerHTML)) {
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
          }

          var html = innerHTML.__html;

          if (html !== null && html !== void 0) {
            {
              checkHtmlStringCoercion(html);
            }
            target.push(stringToChunk("" + html));
          }
        }
      }

      var didWarnDefaultInputValue = false;
      var didWarnDefaultChecked = false;
      var didWarnDefaultSelectValue = false;
      var didWarnDefaultTextareaValue = false;
      var didWarnInvalidOptionChildren = false;
      var didWarnInvalidOptionInnerHTML = false;
      var didWarnSelectedSetOnOption = false;

      function checkSelectProp(props, propName) {
        {
          var value = props[propName];

          if (value != null) {
            var array = isArray2(value);

            if (props.multiple && !array) {
              error("The `%s` prop supplied to <select> must be an array if `multiple` is true.", propName);
            } else if (!props.multiple && array) {
              error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", propName);
            }
          }
        }
      }

      function pushStartSelect(target, props, responseState) {
        {
          checkControlledValueProps("select", props);
          checkSelectProp(props, "value");
          checkSelectProp(props, "defaultValue");

          if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnDefaultSelectValue) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnDefaultSelectValue = true;
          }
        }
        target.push(startChunkForTag("select"));
        var children = null;
        var innerHTML = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;

              case "defaultValue":
              case "value":
                break;

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
      }

      function flattenOptionChildren(children) {
        var content = "";
        React.Children.forEach(children, function (child) {
          if (child == null) {
            return;
          }

          content += child;
          {
            if (!didWarnInvalidOptionChildren && typeof child !== "string" && typeof child !== "number") {
              didWarnInvalidOptionChildren = true;
              error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
            }
          }
        });
        return content;
      }

      var selectedMarkerAttribute = stringToPrecomputedChunk(' selected=""');

      function pushStartOption(target, props, responseState, formatContext) {
        var selectedValue = formatContext.selectedValue;
        target.push(startChunkForTag("option"));
        var children = null;
        var value = null;
        var selected = null;
        var innerHTML = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "selected":
                selected = propValue;
                {
                  if (!didWarnSelectedSetOnOption) {
                    error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
                    didWarnSelectedSetOnOption = true;
                  }
                }
                break;

              case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;

              case "value":
                value = propValue;

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        if (selectedValue != null) {
          var stringValue;

          if (value !== null) {
            {
              checkAttributeStringCoercion(value, "value");
            }
            stringValue = "" + value;
          } else {
            {
              if (innerHTML !== null) {
                if (!didWarnInvalidOptionInnerHTML) {
                  didWarnInvalidOptionInnerHTML = true;
                  error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
              }
            }
            stringValue = flattenOptionChildren(children);
          }

          if (isArray2(selectedValue)) {
            for (var i2 = 0; i2 < selectedValue.length; i2++) {
              {
                checkAttributeStringCoercion(selectedValue[i2], "value");
              }
              var v2 = "" + selectedValue[i2];

              if (v2 === stringValue) {
                target.push(selectedMarkerAttribute);
                break;
              }
            }
          } else {
            {
              checkAttributeStringCoercion(selectedValue, "select.value");
            }

            if ("" + selectedValue === stringValue) {
              target.push(selectedMarkerAttribute);
            }
          }
        } else if (selected) {
          target.push(selectedMarkerAttribute);
        }

        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
      }

      function pushInput(target, props, responseState) {
        {
          checkControlledValueProps("input", props);

          if (props.checked !== void 0 && props.defaultChecked !== void 0 && !didWarnDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
            didWarnDefaultChecked = true;
          }

          if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnDefaultInputValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
            didWarnDefaultInputValue = true;
          }
        }
        target.push(startChunkForTag("input"));
        var value = null;
        var defaultValue = null;
        var checked = null;
        var defaultChecked = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");

              case "defaultChecked":
                defaultChecked = propValue;
                break;

              case "defaultValue":
                defaultValue = propValue;
                break;

              case "checked":
                checked = propValue;
                break;

              case "value":
                value = propValue;
                break;

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        if (checked !== null) {
          pushAttribute(target, responseState, "checked", checked);
        } else if (defaultChecked !== null) {
          pushAttribute(target, responseState, "checked", defaultChecked);
        }

        if (value !== null) {
          pushAttribute(target, responseState, "value", value);
        } else if (defaultValue !== null) {
          pushAttribute(target, responseState, "value", defaultValue);
        }

        target.push(endOfStartTagSelfClosing);
        return null;
      }

      function pushStartTextArea(target, props, responseState) {
        {
          checkControlledValueProps("textarea", props);

          if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnDefaultTextareaValue) {
            error("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnDefaultTextareaValue = true;
          }
        }
        target.push(startChunkForTag("textarea"));
        var value = null;
        var defaultValue = null;
        var children = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "value":
                value = propValue;
                break;

              case "defaultValue":
                defaultValue = propValue;
                break;

              case "dangerouslySetInnerHTML":
                throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        if (value === null && defaultValue !== null) {
          value = defaultValue;
        }

        target.push(endOfStartTag);

        if (children != null) {
          {
            error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          }

          if (value != null) {
            throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
          }

          if (isArray2(children)) {
            if (children.length > 1) {
              throw new Error("<textarea> can only have at most one child.");
            }

            {
              checkHtmlStringCoercion(children[0]);
            }
            value = "" + children[0];
          }

          {
            checkHtmlStringCoercion(children);
          }
          value = "" + children;
        }

        if (typeof value === "string" && value[0] === "\n") {
          target.push(leadingNewline);
        }

        if (value !== null) {
          {
            checkAttributeStringCoercion(value, "value");
          }
          target.push(stringToChunk(encodeHTMLTextNode("" + value)));
        }

        return null;
      }

      function pushSelfClosing(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw new Error(tag + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTagSelfClosing);
        return null;
      }

      function pushStartMenuItem(target, props, responseState) {
        target.push(startChunkForTag("menuitem"));

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTag);
        return null;
      }

      function pushStartTitle(target, props, responseState) {
        target.push(startChunkForTag("title"));
        var children = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "dangerouslySetInnerHTML":
                throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTag);
        {
          var child = Array.isArray(children) && children.length < 2 ? children[0] || null : children;

          if (Array.isArray(children) && children.length > 1) {
            error("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
          } else if (child != null && child.$$typeof != null) {
            error("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
          } else if (child != null && typeof child !== "string" && typeof child !== "number") {
            error("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
          }
        }
        return children;
      }

      function pushStartGenericElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);

        if (typeof children === "string") {
          target.push(stringToChunk(encodeHTMLTextNode(children)));
          return null;
        }

        return children;
      }

      function pushStartCustomElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;

              case "style":
                pushStyle(target, responseState, propValue);
                break;

              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
                break;

              default:
                if (isAttributeNameSafe(propKey) && typeof propValue !== "function" && typeof propValue !== "symbol") {
                  target.push(attributeSeparator, stringToChunk(propKey), attributeAssign, stringToChunk(escapeTextForBrowser(propValue)), attributeEnd);
                }

                break;
            }
          }
        }

        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
      }

      var leadingNewline = stringToPrecomputedChunk("\n");

      function pushStartPreformattedElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTag);

        if (innerHTML != null) {
          if (children != null) {
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          }

          if (typeof innerHTML !== "object" || !("__html" in innerHTML)) {
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
          }

          var html = innerHTML.__html;

          if (html !== null && html !== void 0) {
            if (typeof html === "string" && html.length > 0 && html[0] === "\n") {
              target.push(leadingNewline, stringToChunk(html));
            } else {
              {
                checkHtmlStringCoercion(html);
              }
              target.push(stringToChunk("" + html));
            }
          }
        }

        if (typeof children === "string" && children[0] === "\n") {
          target.push(leadingNewline);
        }

        return children;
      }

      var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
      var validatedTagCache = /* @__PURE__ */new Map();

      function startChunkForTag(tag) {
        var tagStartChunk = validatedTagCache.get(tag);

        if (tagStartChunk === void 0) {
          if (!VALID_TAG_REGEX.test(tag)) {
            throw new Error("Invalid tag: " + tag);
          }

          tagStartChunk = stringToPrecomputedChunk("<" + tag);
          validatedTagCache.set(tag, tagStartChunk);
        }

        return tagStartChunk;
      }

      var DOCTYPE = stringToPrecomputedChunk("<!DOCTYPE html>");

      function pushStartInstance(target, type, props, responseState, formatContext) {
        {
          validateProperties(type, props);
          validateProperties$1(type, props);
          validateProperties$2(type, props, null);

          if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
            error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
          }

          if (formatContext.insertionMode !== SVG_MODE && formatContext.insertionMode !== MATHML_MODE) {
            if (type.indexOf("-") === -1 && typeof props.is !== "string" && type.toLowerCase() !== type) {
              error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            }
          }
        }

        switch (type) {
          case "select":
            return pushStartSelect(target, props, responseState);

          case "option":
            return pushStartOption(target, props, responseState, formatContext);

          case "textarea":
            return pushStartTextArea(target, props, responseState);

          case "input":
            return pushInput(target, props, responseState);

          case "menuitem":
            return pushStartMenuItem(target, props, responseState);

          case "title":
            return pushStartTitle(target, props, responseState);

          case "listing":
          case "pre":
            {
              return pushStartPreformattedElement(target, props, type, responseState);
            }

          case "area":
          case "base":
          case "br":
          case "col":
          case "embed":
          case "hr":
          case "img":
          case "keygen":
          case "link":
          case "meta":
          case "param":
          case "source":
          case "track":
          case "wbr":
            {
              return pushSelfClosing(target, props, type, responseState);
            }

          case "annotation-xml":
          case "color-profile":
          case "font-face":
          case "font-face-src":
          case "font-face-uri":
          case "font-face-format":
          case "font-face-name":
          case "missing-glyph":
            {
              return pushStartGenericElement(target, props, type, responseState);
            }

          case "html":
            {
              if (formatContext.insertionMode === ROOT_HTML_MODE) {
                target.push(DOCTYPE);
              }

              return pushStartGenericElement(target, props, type, responseState);
            }

          default:
            {
              if (type.indexOf("-") === -1 && typeof props.is !== "string") {
                return pushStartGenericElement(target, props, type, responseState);
              } else {
                return pushStartCustomElement(target, props, type, responseState);
              }
            }
        }
      }

      var endTag1 = stringToPrecomputedChunk("</");
      var endTag2 = stringToPrecomputedChunk(">");

      function pushEndInstance(target, type, props) {
        switch (type) {
          case "area":
          case "base":
          case "br":
          case "col":
          case "embed":
          case "hr":
          case "img":
          case "input":
          case "keygen":
          case "link":
          case "meta":
          case "param":
          case "source":
          case "track":
          case "wbr":
            {
              break;
            }

          default:
            {
              target.push(endTag1, stringToChunk(type), endTag2);
            }
        }
      }

      function writeCompletedRoot(destination, responseState) {
        var bootstrapChunks = responseState.bootstrapChunks;
        var i2 = 0;

        for (; i2 < bootstrapChunks.length - 1; i2++) {
          writeChunk(destination, bootstrapChunks[i2]);
        }

        if (i2 < bootstrapChunks.length) {
          return writeChunkAndReturn(destination, bootstrapChunks[i2]);
        }

        return true;
      }

      var placeholder1 = stringToPrecomputedChunk('<template id="');
      var placeholder2 = stringToPrecomputedChunk('"></template>');

      function writePlaceholder(destination, responseState, id) {
        writeChunk(destination, placeholder1);
        writeChunk(destination, responseState.placeholderPrefix);
        var formattedID = stringToChunk(id.toString(16));
        writeChunk(destination, formattedID);
        return writeChunkAndReturn(destination, placeholder2);
      }

      var startCompletedSuspenseBoundary = stringToPrecomputedChunk("<!--$-->");
      var startPendingSuspenseBoundary1 = stringToPrecomputedChunk('<!--$?--><template id="');
      var startPendingSuspenseBoundary2 = stringToPrecomputedChunk('"></template>');
      var startClientRenderedSuspenseBoundary = stringToPrecomputedChunk("<!--$!-->");
      var endSuspenseBoundary = stringToPrecomputedChunk("<!--/$-->");
      var clientRenderedSuspenseBoundaryError1 = stringToPrecomputedChunk("<template");
      var clientRenderedSuspenseBoundaryErrorAttrInterstitial = stringToPrecomputedChunk('"');
      var clientRenderedSuspenseBoundaryError1A = stringToPrecomputedChunk(' data-dgst="');
      var clientRenderedSuspenseBoundaryError1B = stringToPrecomputedChunk(' data-msg="');
      var clientRenderedSuspenseBoundaryError1C = stringToPrecomputedChunk(' data-stck="');
      var clientRenderedSuspenseBoundaryError2 = stringToPrecomputedChunk("></template>");

      function writeStartCompletedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, startCompletedSuspenseBoundary);
      }

      function writeStartPendingSuspenseBoundary(destination, responseState, id) {
        writeChunk(destination, startPendingSuspenseBoundary1);

        if (id === null) {
          throw new Error("An ID must have been assigned before we can complete the boundary.");
        }

        writeChunk(destination, id);
        return writeChunkAndReturn(destination, startPendingSuspenseBoundary2);
      }

      function writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMesssage, errorComponentStack) {
        var result;
        result = writeChunkAndReturn(destination, startClientRenderedSuspenseBoundary);
        writeChunk(destination, clientRenderedSuspenseBoundaryError1);

        if (errorDigest) {
          writeChunk(destination, clientRenderedSuspenseBoundaryError1A);
          writeChunk(destination, stringToChunk(escapeTextForBrowser(errorDigest)));
          writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
        }

        {
          if (errorMesssage) {
            writeChunk(destination, clientRenderedSuspenseBoundaryError1B);
            writeChunk(destination, stringToChunk(escapeTextForBrowser(errorMesssage)));
            writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
          }

          if (errorComponentStack) {
            writeChunk(destination, clientRenderedSuspenseBoundaryError1C);
            writeChunk(destination, stringToChunk(escapeTextForBrowser(errorComponentStack)));
            writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
          }
        }
        result = writeChunkAndReturn(destination, clientRenderedSuspenseBoundaryError2);
        return result;
      }

      function writeEndCompletedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
      }

      function writeEndPendingSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
      }

      function writeEndClientRenderedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
      }

      var startSegmentHTML = stringToPrecomputedChunk('<div hidden id="');
      var startSegmentHTML2 = stringToPrecomputedChunk('">');
      var endSegmentHTML = stringToPrecomputedChunk("</div>");
      var startSegmentSVG = stringToPrecomputedChunk('<svg aria-hidden="true" style="display:none" id="');
      var startSegmentSVG2 = stringToPrecomputedChunk('">');
      var endSegmentSVG = stringToPrecomputedChunk("</svg>");
      var startSegmentMathML = stringToPrecomputedChunk('<math aria-hidden="true" style="display:none" id="');
      var startSegmentMathML2 = stringToPrecomputedChunk('">');
      var endSegmentMathML = stringToPrecomputedChunk("</math>");
      var startSegmentTable = stringToPrecomputedChunk('<table hidden id="');
      var startSegmentTable2 = stringToPrecomputedChunk('">');
      var endSegmentTable = stringToPrecomputedChunk("</table>");
      var startSegmentTableBody = stringToPrecomputedChunk('<table hidden><tbody id="');
      var startSegmentTableBody2 = stringToPrecomputedChunk('">');
      var endSegmentTableBody = stringToPrecomputedChunk("</tbody></table>");
      var startSegmentTableRow = stringToPrecomputedChunk('<table hidden><tr id="');
      var startSegmentTableRow2 = stringToPrecomputedChunk('">');
      var endSegmentTableRow = stringToPrecomputedChunk("</tr></table>");
      var startSegmentColGroup = stringToPrecomputedChunk('<table hidden><colgroup id="');
      var startSegmentColGroup2 = stringToPrecomputedChunk('">');
      var endSegmentColGroup = stringToPrecomputedChunk("</colgroup></table>");

      function writeStartSegment(destination, responseState, formatContext, id) {
        switch (formatContext.insertionMode) {
          case ROOT_HTML_MODE:
          case HTML_MODE:
            {
              writeChunk(destination, startSegmentHTML);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentHTML2);
            }

          case SVG_MODE:
            {
              writeChunk(destination, startSegmentSVG);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentSVG2);
            }

          case MATHML_MODE:
            {
              writeChunk(destination, startSegmentMathML);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentMathML2);
            }

          case HTML_TABLE_MODE:
            {
              writeChunk(destination, startSegmentTable);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentTable2);
            }

          case HTML_TABLE_BODY_MODE:
            {
              writeChunk(destination, startSegmentTableBody);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentTableBody2);
            }

          case HTML_TABLE_ROW_MODE:
            {
              writeChunk(destination, startSegmentTableRow);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentTableRow2);
            }

          case HTML_COLGROUP_MODE:
            {
              writeChunk(destination, startSegmentColGroup);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentColGroup2);
            }

          default:
            {
              throw new Error("Unknown insertion mode. This is a bug in React.");
            }
        }
      }

      function writeEndSegment(destination, formatContext) {
        switch (formatContext.insertionMode) {
          case ROOT_HTML_MODE:
          case HTML_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentHTML);
            }

          case SVG_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentSVG);
            }

          case MATHML_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentMathML);
            }

          case HTML_TABLE_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentTable);
            }

          case HTML_TABLE_BODY_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentTableBody);
            }

          case HTML_TABLE_ROW_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentTableRow);
            }

          case HTML_COLGROUP_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentColGroup);
            }

          default:
            {
              throw new Error("Unknown insertion mode. This is a bug in React.");
            }
        }
      }

      var completeSegmentFunction = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}";
      var completeBoundaryFunction = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}';
      var clientRenderFunction = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}';
      var completeSegmentScript1Full = stringToPrecomputedChunk(completeSegmentFunction + ';$RS("');
      var completeSegmentScript1Partial = stringToPrecomputedChunk('$RS("');
      var completeSegmentScript2 = stringToPrecomputedChunk('","');
      var completeSegmentScript3 = stringToPrecomputedChunk('")<\/script>');

      function writeCompletedSegmentInstruction(destination, responseState, contentSegmentID) {
        writeChunk(destination, responseState.startInlineScript);

        if (!responseState.sentCompleteSegmentFunction) {
          responseState.sentCompleteSegmentFunction = true;
          writeChunk(destination, completeSegmentScript1Full);
        } else {
          writeChunk(destination, completeSegmentScript1Partial);
        }

        writeChunk(destination, responseState.segmentPrefix);
        var formattedID = stringToChunk(contentSegmentID.toString(16));
        writeChunk(destination, formattedID);
        writeChunk(destination, completeSegmentScript2);
        writeChunk(destination, responseState.placeholderPrefix);
        writeChunk(destination, formattedID);
        return writeChunkAndReturn(destination, completeSegmentScript3);
      }

      var completeBoundaryScript1Full = stringToPrecomputedChunk(completeBoundaryFunction + ';$RC("');
      var completeBoundaryScript1Partial = stringToPrecomputedChunk('$RC("');
      var completeBoundaryScript2 = stringToPrecomputedChunk('","');
      var completeBoundaryScript3 = stringToPrecomputedChunk('")<\/script>');

      function writeCompletedBoundaryInstruction(destination, responseState, boundaryID, contentSegmentID) {
        writeChunk(destination, responseState.startInlineScript);

        if (!responseState.sentCompleteBoundaryFunction) {
          responseState.sentCompleteBoundaryFunction = true;
          writeChunk(destination, completeBoundaryScript1Full);
        } else {
          writeChunk(destination, completeBoundaryScript1Partial);
        }

        if (boundaryID === null) {
          throw new Error("An ID must have been assigned before we can complete the boundary.");
        }

        var formattedContentID = stringToChunk(contentSegmentID.toString(16));
        writeChunk(destination, boundaryID);
        writeChunk(destination, completeBoundaryScript2);
        writeChunk(destination, responseState.segmentPrefix);
        writeChunk(destination, formattedContentID);
        return writeChunkAndReturn(destination, completeBoundaryScript3);
      }

      var clientRenderScript1Full = stringToPrecomputedChunk(clientRenderFunction + ';$RX("');
      var clientRenderScript1Partial = stringToPrecomputedChunk('$RX("');
      var clientRenderScript1A = stringToPrecomputedChunk('"');
      var clientRenderScript2 = stringToPrecomputedChunk(")<\/script>");
      var clientRenderErrorScriptArgInterstitial = stringToPrecomputedChunk(",");

      function writeClientRenderBoundaryInstruction(destination, responseState, boundaryID, errorDigest, errorMessage, errorComponentStack) {
        writeChunk(destination, responseState.startInlineScript);

        if (!responseState.sentClientRenderFunction) {
          responseState.sentClientRenderFunction = true;
          writeChunk(destination, clientRenderScript1Full);
        } else {
          writeChunk(destination, clientRenderScript1Partial);
        }

        if (boundaryID === null) {
          throw new Error("An ID must have been assigned before we can complete the boundary.");
        }

        writeChunk(destination, boundaryID);
        writeChunk(destination, clientRenderScript1A);

        if (errorDigest || errorMessage || errorComponentStack) {
          writeChunk(destination, clientRenderErrorScriptArgInterstitial);
          writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorDigest || "")));
        }

        if (errorMessage || errorComponentStack) {
          writeChunk(destination, clientRenderErrorScriptArgInterstitial);
          writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorMessage || "")));
        }

        if (errorComponentStack) {
          writeChunk(destination, clientRenderErrorScriptArgInterstitial);
          writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorComponentStack)));
        }

        return writeChunkAndReturn(destination, clientRenderScript2);
      }

      var regexForJSStringsInScripts = /[<\u2028\u2029]/g;

      function escapeJSStringsForInstructionScripts(input) {
        var escaped = JSON.stringify(input);
        return escaped.replace(regexForJSStringsInScripts, function (match) {
          switch (match) {
            case "<":
              return "\\u003c";

            case "\u2028":
              return "\\u2028";

            case "\u2029":
              return "\\u2029";

            default:
              {
                throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
              }
          }
        });
      }

      function createResponseState$1(generateStaticMarkup, identifierPrefix) {
        var responseState = createResponseState(identifierPrefix, void 0);
        return {
          bootstrapChunks: responseState.bootstrapChunks,
          startInlineScript: responseState.startInlineScript,
          placeholderPrefix: responseState.placeholderPrefix,
          segmentPrefix: responseState.segmentPrefix,
          boundaryPrefix: responseState.boundaryPrefix,
          idPrefix: responseState.idPrefix,
          nextSuspenseID: responseState.nextSuspenseID,
          sentCompleteSegmentFunction: responseState.sentCompleteSegmentFunction,
          sentCompleteBoundaryFunction: responseState.sentCompleteBoundaryFunction,
          sentClientRenderFunction: responseState.sentClientRenderFunction,
          generateStaticMarkup: generateStaticMarkup
        };
      }

      function createRootFormatContext() {
        return {
          insertionMode: HTML_MODE,
          selectedValue: null
        };
      }

      function pushTextInstance$1(target, text, responseState, textEmbedded) {
        if (responseState.generateStaticMarkup) {
          target.push(stringToChunk(escapeTextForBrowser(text)));
          return false;
        } else {
          return pushTextInstance(target, text, responseState, textEmbedded);
        }
      }

      function pushSegmentFinale$1(target, responseState, lastPushedText, textEmbedded) {
        if (responseState.generateStaticMarkup) {
          return;
        } else {
          return pushSegmentFinale(target, responseState, lastPushedText, textEmbedded);
        }
      }

      function writeStartCompletedSuspenseBoundary$1(destination, responseState) {
        if (responseState.generateStaticMarkup) {
          return true;
        }

        return writeStartCompletedSuspenseBoundary(destination);
      }

      function writeStartClientRenderedSuspenseBoundary$1(destination, responseState, errorDigest, errorMessage, errorComponentStack) {
        if (responseState.generateStaticMarkup) {
          return true;
        }

        return writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMessage, errorComponentStack);
      }

      function writeEndCompletedSuspenseBoundary$1(destination, responseState) {
        if (responseState.generateStaticMarkup) {
          return true;
        }

        return writeEndCompletedSuspenseBoundary(destination);
      }

      function writeEndClientRenderedSuspenseBoundary$1(destination, responseState) {
        if (responseState.generateStaticMarkup) {
          return true;
        }

        return writeEndClientRenderedSuspenseBoundary(destination);
      }

      var assign = Object.assign;
      var REACT_ELEMENT_TYPE2 = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_SCOPE_TYPE = Symbol.for("react.scope");
      var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
      var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
      var REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED = Symbol.for("react.default_value");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }

        return null;
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;

        if (displayName) {
          return displayName;
        }

        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }

      function getContextName(type) {
        return type.displayName || "Context";
      }

      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }

        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }

        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }

        if (typeof type === "string") {
          return type;
        }

        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";

          case REACT_PORTAL_TYPE:
            return "Portal";

          case REACT_PROFILER_TYPE:
            return "Profiler";

          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";

          case REACT_SUSPENSE_TYPE:
            return "Suspense";

          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }

        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");

            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;

              if (outerName !== null) {
                return outerName;
              }

              return getComponentNameFromType(type.type) || "Memo";

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentNameFromType(init(payload));
                } catch (x2) {
                  return null;
                }
              }
          }
        }

        return null;
      }

      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }

          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x2) {
              var match = x2.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }

          return "\n" + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          if (construct) {
            var Fake = function Fake() {
              throw Error();
            };

            Object.defineProperty(Fake.prototype, "props", {
              set: function set() {
                throw Error();
              }
            });

            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x2) {
                control = x2;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x2) {
                control = x2;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x2) {
              control = x2;
            }

            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s2 = sampleLines.length - 1;
            var c2 = controlLines.length - 1;

            while (s2 >= 1 && c2 >= 0 && sampleLines[s2] !== controlLines[c2]) {
              c2--;
            }

            for (; s2 >= 1 && c2 >= 0; s2--, c2--) {
              if (sampleLines[s2] !== controlLines[c2]) {
                if (s2 !== 1 || c2 !== 1) {
                  do {
                    s2--;
                    c2--;

                    if (c2 < 0 || sampleLines[s2] !== controlLines[c2]) {
                      var _frame = "\n" + sampleLines[s2].replace(" at new ", " at ");

                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }

                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s2 >= 1 && c2 >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }

        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeClassComponentFrame(ctor, source, ownerFn) {
        {
          return describeNativeComponentFrame(ctor, true);
        }
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component2) {
        var prototype = Component2.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }

        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }

        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x2) {}
              }
          }
        }

        return "";
      }

      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has2 = Function.call.bind(hasOwnProperty2);

          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$1 = void 0;

              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var warnedAboutMissingGetChildContext;
      {
        warnedAboutMissingGetChildContext = {};
      }
      var emptyContextObject = {};
      {
        Object.freeze(emptyContextObject);
      }

      function getMaskedContext(type, unmaskedContext) {
        {
          var contextTypes = type.contextTypes;

          if (!contextTypes) {
            return emptyContextObject;
          }

          var context = {};

          for (var key in contextTypes) {
            context[key] = unmaskedContext[key];
          }

          {
            var name = getComponentNameFromType(type) || "Unknown";
            checkPropTypes(contextTypes, context, "context", name);
          }
          return context;
        }
      }

      function processChildContext(instance, type, parentContext, childContextTypes) {
        {
          if (typeof instance.getChildContext !== "function") {
            {
              var componentName = getComponentNameFromType(type) || "Unknown";

              if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
              }
            }
            return parentContext;
          }

          var childContext = instance.getChildContext();

          for (var contextKey in childContext) {
            if (!(contextKey in childContextTypes)) {
              throw new Error((getComponentNameFromType(type) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
            }
          }

          {
            var name = getComponentNameFromType(type) || "Unknown";
            checkPropTypes(childContextTypes, childContext, "child context", name);
          }
          return assign({}, parentContext, childContext);
        }
      }

      var rendererSigil;
      {
        rendererSigil = {};
      }
      var rootContextSnapshot = null;
      var currentActiveSnapshot = null;

      function popNode(prev) {
        {
          prev.context._currentValue2 = prev.parentValue;
        }
      }

      function pushNode(next) {
        {
          next.context._currentValue2 = next.value;
        }
      }

      function popToNearestCommonAncestor(prev, next) {
        if (prev === next) ;else {
          popNode(prev);
          var parentPrev = prev.parent;
          var parentNext = next.parent;

          if (parentPrev === null) {
            if (parentNext !== null) {
              throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
            }
          } else {
            if (parentNext === null) {
              throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
            }

            popToNearestCommonAncestor(parentPrev, parentNext);
          }

          pushNode(next);
        }
      }

      function popAllPrevious(prev) {
        popNode(prev);
        var parentPrev = prev.parent;

        if (parentPrev !== null) {
          popAllPrevious(parentPrev);
        }
      }

      function pushAllNext(next) {
        var parentNext = next.parent;

        if (parentNext !== null) {
          pushAllNext(parentNext);
        }

        pushNode(next);
      }

      function popPreviousToCommonLevel(prev, next) {
        popNode(prev);
        var parentPrev = prev.parent;

        if (parentPrev === null) {
          throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
        }

        if (parentPrev.depth === next.depth) {
          popToNearestCommonAncestor(parentPrev, next);
        } else {
          popPreviousToCommonLevel(parentPrev, next);
        }
      }

      function popNextToCommonLevel(prev, next) {
        var parentNext = next.parent;

        if (parentNext === null) {
          throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
        }

        if (prev.depth === parentNext.depth) {
          popToNearestCommonAncestor(prev, parentNext);
        } else {
          popNextToCommonLevel(prev, parentNext);
        }

        pushNode(next);
      }

      function switchContext(newSnapshot) {
        var prev = currentActiveSnapshot;
        var next = newSnapshot;

        if (prev !== next) {
          if (prev === null) {
            pushAllNext(next);
          } else if (next === null) {
            popAllPrevious(prev);
          } else if (prev.depth === next.depth) {
            popToNearestCommonAncestor(prev, next);
          } else if (prev.depth > next.depth) {
            popPreviousToCommonLevel(prev, next);
          } else {
            popNextToCommonLevel(prev, next);
          }

          currentActiveSnapshot = next;
        }
      }

      function pushProvider(context, nextValue) {
        var prevValue;
        {
          prevValue = context._currentValue2;
          context._currentValue2 = nextValue;
          {
            if (context._currentRenderer2 !== void 0 && context._currentRenderer2 !== null && context._currentRenderer2 !== rendererSigil) {
              error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
            }

            context._currentRenderer2 = rendererSigil;
          }
        }
        var prevNode = currentActiveSnapshot;
        var newNode = {
          parent: prevNode,
          depth: prevNode === null ? 0 : prevNode.depth + 1,
          context: context,
          parentValue: prevValue,
          value: nextValue
        };
        currentActiveSnapshot = newNode;
        return newNode;
      }

      function popProvider(context) {
        var prevSnapshot = currentActiveSnapshot;

        if (prevSnapshot === null) {
          throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
        }

        {
          if (prevSnapshot.context !== context) {
            error("The parent context is not the expected context. This is probably a bug in React.");
          }
        }
        {
          var _value = prevSnapshot.parentValue;

          if (_value === REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED) {
            prevSnapshot.context._currentValue2 = prevSnapshot.context._defaultValue;
          } else {
            prevSnapshot.context._currentValue2 = _value;
          }

          {
            if (context._currentRenderer2 !== void 0 && context._currentRenderer2 !== null && context._currentRenderer2 !== rendererSigil) {
              error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
            }

            context._currentRenderer2 = rendererSigil;
          }
        }
        return currentActiveSnapshot = prevSnapshot.parent;
      }

      function getActiveContext() {
        return currentActiveSnapshot;
      }

      function readContext(context) {
        var value = context._currentValue2;
        return value;
      }

      function get2(key) {
        return key._reactInternals;
      }

      function set(key, value) {
        key._reactInternals = value;
      }

      var didWarnAboutNoopUpdateForComponent = {};
      var didWarnAboutDeprecatedWillMount = {};
      var didWarnAboutUninitializedState;
      var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
      var didWarnAboutLegacyLifecyclesAndDerivedState;
      var didWarnAboutUndefinedDerivedState;
      var warnOnUndefinedDerivedState;
      var warnOnInvalidCallback;
      var didWarnAboutDirectlyAssigningPropsToState;
      var didWarnAboutContextTypeAndContextTypes;
      var didWarnAboutInvalidateContextType;
      {
        didWarnAboutUninitializedState = /* @__PURE__ */new Set();
        didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = /* @__PURE__ */new Set();
        didWarnAboutLegacyLifecyclesAndDerivedState = /* @__PURE__ */new Set();
        didWarnAboutDirectlyAssigningPropsToState = /* @__PURE__ */new Set();
        didWarnAboutUndefinedDerivedState = /* @__PURE__ */new Set();
        didWarnAboutContextTypeAndContextTypes = /* @__PURE__ */new Set();
        didWarnAboutInvalidateContextType = /* @__PURE__ */new Set();
        var didWarnOnInvalidCallback = /* @__PURE__ */new Set();

        warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
          if (callback === null || typeof callback === "function") {
            return;
          }

          var key = callerName + "_" + callback;

          if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
          }
        };

        warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(type, partialState) {
          if (partialState === void 0) {
            var componentName = getComponentNameFromType(type) || "Component";

            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
              didWarnAboutUndefinedDerivedState.add(componentName);
              error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
          }
        };
      }

      function warnNoop(publicInstance, callerName) {
        {
          var _constructor = publicInstance.constructor;
          var componentName = _constructor && getComponentNameFromType(_constructor) || "ReactClass";
          var warningKey = componentName + "." + callerName;

          if (didWarnAboutNoopUpdateForComponent[warningKey]) {
            return;
          }

          error("%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.\n\nPlease check the code for the %s component.", callerName, callerName, componentName);
          didWarnAboutNoopUpdateForComponent[warningKey] = true;
        }
      }

      var classComponentUpdater = {
        isMounted: function isMounted(inst) {
          return false;
        },
        enqueueSetState: function enqueueSetState(inst, payload, callback) {
          var internals = get2(inst);

          if (internals.queue === null) {
            warnNoop(inst, "setState");
          } else {
            internals.queue.push(payload);
            {
              if (callback !== void 0 && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
              }
            }
          }
        },
        enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
          var internals = get2(inst);
          internals.replace = true;
          internals.queue = [payload];
          {
            if (callback !== void 0 && callback !== null) {
              warnOnInvalidCallback(callback, "setState");
            }
          }
        },
        enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
          var internals = get2(inst);

          if (internals.queue === null) {
            warnNoop(inst, "forceUpdate");
          } else {
            {
              if (callback !== void 0 && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
              }
            }
          }
        }
      };

      function applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, prevState, nextProps) {
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        {
          warnOnUndefinedDerivedState(ctor, partialState);
        }
        var newState = partialState === null || partialState === void 0 ? prevState : assign({}, prevState, partialState);
        return newState;
      }

      function constructClassInstance(ctor, props, maskedLegacyContext) {
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        {
          if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== void 0 && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === void 0;

            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
              didWarnAboutInvalidateContextType.add(ctor);
              var addendum = "";

              if (contextType === void 0) {
                addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
              } else if (typeof contextType !== "object") {
                addendum = " However, it is set to a " + typeof contextType + ".";
              } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                addendum = " Did you accidentally pass the Context.Provider instead?";
              } else if (contextType._context !== void 0) {
                addendum = " Did you accidentally pass the Context.Consumer instead?";
              } else {
                addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
              }

              error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
          }
        }

        if (typeof contextType === "object" && contextType !== null) {
          context = readContext(contextType);
        } else {
          context = maskedLegacyContext;
        }

        var instance = new ctor(props, context);
        {
          if (typeof ctor.getDerivedStateFromProps === "function" && (instance.state === null || instance.state === void 0)) {
            var componentName = getComponentNameFromType(ctor) || "Component";

            if (!didWarnAboutUninitializedState.has(componentName)) {
              didWarnAboutUninitializedState.add(componentName);
              error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
          }

          if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;

            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) {
              foundWillMountName = "componentWillMount";
            } else if (typeof instance.UNSAFE_componentWillMount === "function") {
              foundWillMountName = "UNSAFE_componentWillMount";
            }

            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              foundWillReceivePropsName = "componentWillReceiveProps";
            } else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") {
              foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            }

            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              foundWillUpdateName = "componentWillUpdate";
            } else if (typeof instance.UNSAFE_componentWillUpdate === "function") {
              foundWillUpdateName = "UNSAFE_componentWillUpdate";
            }

            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
              var _componentName = getComponentNameFromType(ctor) || "Component";

              var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";

              if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
              }
            }
          }
        }
        return instance;
      }

      function checkClassInstance(instance, ctor, newProps) {
        {
          var name = getComponentNameFromType(ctor) || "Component";
          var renderPresent = instance.render;

          if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") {
              error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            } else {
              error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
            }
          }

          if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
            error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
          }

          if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
          }

          if (instance.propTypes) {
            error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
          }

          if (instance.contextType) {
            error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
          }

          {
            if (instance.contextTypes) {
              error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
            }

            if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
              didWarnAboutContextTypeAndContextTypes.add(ctor);
              error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
            }
          }

          if (typeof instance.componentShouldUpdate === "function") {
            error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
          }

          if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") {
            error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
          }

          if (typeof instance.componentDidUnmount === "function") {
            error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
          }

          if (typeof instance.componentDidReceiveProps === "function") {
            error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
          }

          if (typeof instance.componentWillRecieveProps === "function") {
            error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
          }

          if (typeof instance.UNSAFE_componentWillRecieveProps === "function") {
            error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
          }

          var hasMutatedProps = instance.props !== newProps;

          if (instance.props !== void 0 && hasMutatedProps) {
            error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
          }

          if (instance.defaultProps) {
            error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
          }

          if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
          }

          if (typeof instance.getDerivedStateFromProps === "function") {
            error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
          }

          if (typeof instance.getDerivedStateFromError === "function") {
            error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
          }

          if (typeof ctor.getSnapshotBeforeUpdate === "function") {
            error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
          }

          var _state = instance.state;

          if (_state && (typeof _state !== "object" || isArray2(_state))) {
            error("%s.state: must be set to an object or null", name);
          }

          if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") {
            error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
          }
        }
      }

      function callComponentWillMount(type, instance) {
        var oldState = instance.state;

        if (typeof instance.componentWillMount === "function") {
          {
            if (instance.componentWillMount.__suppressDeprecationWarning !== true) {
              var componentName = getComponentNameFromType(type) || "Unknown";

              if (!didWarnAboutDeprecatedWillMount[componentName]) {
                warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.\n\nPlease update the following components: %s", componentName);
                didWarnAboutDeprecatedWillMount[componentName] = true;
              }
            }
          }
          instance.componentWillMount();
        }

        if (typeof instance.UNSAFE_componentWillMount === "function") {
          instance.UNSAFE_componentWillMount();
        }

        if (oldState !== instance.state) {
          {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromType(type) || "Component");
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      }

      function processUpdateQueue(internalInstance, inst, props, maskedLegacyContext) {
        if (internalInstance.queue !== null && internalInstance.queue.length > 0) {
          var oldQueue = internalInstance.queue;
          var oldReplace = internalInstance.replace;
          internalInstance.queue = null;
          internalInstance.replace = false;

          if (oldReplace && oldQueue.length === 1) {
            inst.state = oldQueue[0];
          } else {
            var nextState = oldReplace ? oldQueue[0] : inst.state;
            var dontMutate = true;

            for (var i2 = oldReplace ? 1 : 0; i2 < oldQueue.length; i2++) {
              var partial = oldQueue[i2];
              var partialState = typeof partial === "function" ? partial.call(inst, nextState, props, maskedLegacyContext) : partial;

              if (partialState != null) {
                if (dontMutate) {
                  dontMutate = false;
                  nextState = assign({}, nextState, partialState);
                } else {
                  assign(nextState, partialState);
                }
              }
            }

            inst.state = nextState;
          }
        } else {
          internalInstance.queue = null;
        }
      }

      function mountClassInstance(instance, ctor, newProps, maskedLegacyContext) {
        {
          checkClassInstance(instance, ctor, newProps);
        }
        var initialState = instance.state !== void 0 ? instance.state : null;
        instance.updater = classComponentUpdater;
        instance.props = newProps;
        instance.state = initialState;
        var internalInstance = {
          queue: [],
          replace: false
        };
        set(instance, internalInstance);
        var contextType = ctor.contextType;

        if (typeof contextType === "object" && contextType !== null) {
          instance.context = readContext(contextType);
        } else {
          instance.context = maskedLegacyContext;
        }

        {
          if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";

            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
              didWarnAboutDirectlyAssigningPropsToState.add(componentName);
              error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
          }
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;

        if (typeof getDerivedStateFromProps === "function") {
          instance.state = applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, initialState, newProps);
        }

        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
          callComponentWillMount(ctor, instance);
          processUpdateQueue(internalInstance, instance, newProps, maskedLegacyContext);
        }
      }

      var emptyTreeContext = {
        id: 1,
        overflow: ""
      };

      function getTreeId(context) {
        var overflow = context.overflow;
        var idWithLeadingBit = context.id;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
      }

      function pushTreeContext(baseContext, totalChildren, index) {
        var baseIdWithLeadingBit = baseContext.id;
        var baseOverflow = baseContext.overflow;
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength;

        if (length > 30) {
          var numberOfOverflowBits = baseLength - baseLength % 5;
          var newOverflowBits = (1 << numberOfOverflowBits) - 1;
          var newOverflow = (baseId & newOverflowBits).toString(32);
          var restOfBaseId = baseId >> numberOfOverflowBits;
          var restOfBaseLength = baseLength - numberOfOverflowBits;
          var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
          var restOfNewBits = slot << restOfBaseLength;
          var id = restOfNewBits | restOfBaseId;
          var overflow = newOverflow + baseOverflow;
          return {
            id: 1 << restOfLength | id,
            overflow: overflow
          };
        } else {
          var newBits = slot << baseLength;

          var _id = newBits | baseId;

          var _overflow = baseOverflow;
          return {
            id: 1 << length | _id,
            overflow: _overflow
          };
        }
      }

      function getBitLength(number) {
        return 32 - clz32(number);
      }

      function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
      }

      var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback;
      var log = Math.log;
      var LN2 = Math.LN2;

      function clz32Fallback(x2) {
        var asUint = x2 >>> 0;

        if (asUint === 0) {
          return 32;
        }

        return 31 - (log(asUint) / LN2 | 0) | 0;
      }

      function is(x2, y2) {
        return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
      }

      var objectIs = typeof Object.is === "function" ? Object.is : is;
      var currentlyRenderingComponent = null;
      var currentlyRenderingTask = null;
      var firstWorkInProgressHook = null;
      var workInProgressHook = null;
      var isReRender = false;
      var didScheduleRenderPhaseUpdate = false;
      var localIdCounter = 0;
      var renderPhaseUpdates = null;
      var numberOfReRenders = 0;
      var RE_RENDER_LIMIT = 25;
      var isInHookUserCodeInDev = false;
      var currentHookNameInDev;

      function resolveCurrentlyRenderingComponent() {
        if (currentlyRenderingComponent === null) {
          throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        }

        {
          if (isInHookUserCodeInDev) {
            error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
          }
        }
        return currentlyRenderingComponent;
      }

      function areHookInputsEqual(nextDeps, prevDeps) {
        if (prevDeps === null) {
          {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
          }
          return false;
        }

        {
          if (nextDeps.length !== prevDeps.length) {
            error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + nextDeps.join(", ") + "]", "[" + prevDeps.join(", ") + "]");
          }
        }

        for (var i2 = 0; i2 < prevDeps.length && i2 < nextDeps.length; i2++) {
          if (objectIs(nextDeps[i2], prevDeps[i2])) {
            continue;
          }

          return false;
        }

        return true;
      }

      function createHook() {
        if (numberOfReRenders > 0) {
          throw new Error("Rendered more hooks than during the previous render");
        }

        return {
          memoizedState: null,
          queue: null,
          next: null
        };
      }

      function createWorkInProgressHook() {
        if (workInProgressHook === null) {
          if (firstWorkInProgressHook === null) {
            isReRender = false;
            firstWorkInProgressHook = workInProgressHook = createHook();
          } else {
            isReRender = true;
            workInProgressHook = firstWorkInProgressHook;
          }
        } else {
          if (workInProgressHook.next === null) {
            isReRender = false;
            workInProgressHook = workInProgressHook.next = createHook();
          } else {
            isReRender = true;
            workInProgressHook = workInProgressHook.next;
          }
        }

        return workInProgressHook;
      }

      function prepareToUseHooks(task, componentIdentity) {
        currentlyRenderingComponent = componentIdentity;
        currentlyRenderingTask = task;
        {
          isInHookUserCodeInDev = false;
        }
        localIdCounter = 0;
      }

      function finishHooks(Component2, props, children, refOrContext) {
        while (didScheduleRenderPhaseUpdate) {
          didScheduleRenderPhaseUpdate = false;
          localIdCounter = 0;
          numberOfReRenders += 1;
          workInProgressHook = null;
          children = Component2(props, refOrContext);
        }

        resetHooksState();
        return children;
      }

      function checkDidRenderIdHook() {
        var didRenderIdHook = localIdCounter !== 0;
        return didRenderIdHook;
      }

      function resetHooksState() {
        {
          isInHookUserCodeInDev = false;
        }
        currentlyRenderingComponent = null;
        currentlyRenderingTask = null;
        didScheduleRenderPhaseUpdate = false;
        firstWorkInProgressHook = null;
        numberOfReRenders = 0;
        renderPhaseUpdates = null;
        workInProgressHook = null;
      }

      function readContext$1(context) {
        {
          if (isInHookUserCodeInDev) {
            error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          }
        }
        return readContext(context);
      }

      function useContext2(context) {
        {
          currentHookNameInDev = "useContext";
        }
        resolveCurrentlyRenderingComponent();
        return readContext(context);
      }

      function basicStateReducer(state, action) {
        return typeof action === "function" ? action(state) : action;
      }

      function useState2(initialState) {
        {
          currentHookNameInDev = "useState";
        }
        return useReducer2(basicStateReducer, initialState);
      }

      function useReducer2(reducer, initialArg, init) {
        {
          if (reducer !== basicStateReducer) {
            currentHookNameInDev = "useReducer";
          }
        }
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();

        if (isReRender) {
          var queue = workInProgressHook.queue;
          var dispatch = queue.dispatch;

          if (renderPhaseUpdates !== null) {
            var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);

            if (firstRenderPhaseUpdate !== void 0) {
              renderPhaseUpdates.delete(queue);
              var newState = workInProgressHook.memoizedState;
              var update = firstRenderPhaseUpdate;

              do {
                var action = update.action;
                {
                  isInHookUserCodeInDev = true;
                }
                newState = reducer(newState, action);
                {
                  isInHookUserCodeInDev = false;
                }
                update = update.next;
              } while (update !== null);

              workInProgressHook.memoizedState = newState;
              return [newState, dispatch];
            }
          }

          return [workInProgressHook.memoizedState, dispatch];
        } else {
          {
            isInHookUserCodeInDev = true;
          }
          var initialState;

          if (reducer === basicStateReducer) {
            initialState = typeof initialArg === "function" ? initialArg() : initialArg;
          } else {
            initialState = init !== void 0 ? init(initialArg) : initialArg;
          }

          {
            isInHookUserCodeInDev = false;
          }
          workInProgressHook.memoizedState = initialState;

          var _queue = workInProgressHook.queue = {
            last: null,
            dispatch: null
          };

          var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);

          return [workInProgressHook.memoizedState, _dispatch];
        }
      }

      function useMemo2(nextCreate, deps) {
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        var nextDeps = deps === void 0 ? null : deps;

        if (workInProgressHook !== null) {
          var prevState = workInProgressHook.memoizedState;

          if (prevState !== null) {
            if (nextDeps !== null) {
              var prevDeps = prevState[1];

              if (areHookInputsEqual(nextDeps, prevDeps)) {
                return prevState[0];
              }
            }
          }
        }

        {
          isInHookUserCodeInDev = true;
        }
        var nextValue = nextCreate();
        {
          isInHookUserCodeInDev = false;
        }
        workInProgressHook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }

      function useRef2(initialValue) {
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        var previousRef = workInProgressHook.memoizedState;

        if (previousRef === null) {
          var ref = {
            current: initialValue
          };
          {
            Object.seal(ref);
          }
          workInProgressHook.memoizedState = ref;
          return ref;
        } else {
          return previousRef;
        }
      }

      function useLayoutEffect2(create, inputs) {
        {
          currentHookNameInDev = "useLayoutEffect";
          error("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
        }
      }

      function dispatchAction(componentIdentity, queue, action) {
        if (numberOfReRenders >= RE_RENDER_LIMIT) {
          throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
        }

        if (componentIdentity === currentlyRenderingComponent) {
          didScheduleRenderPhaseUpdate = true;
          var update = {
            action: action,
            next: null
          };

          if (renderPhaseUpdates === null) {
            renderPhaseUpdates = /* @__PURE__ */new Map();
          }

          var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);

          if (firstRenderPhaseUpdate === void 0) {
            renderPhaseUpdates.set(queue, update);
          } else {
            var lastRenderPhaseUpdate = firstRenderPhaseUpdate;

            while (lastRenderPhaseUpdate.next !== null) {
              lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            }

            lastRenderPhaseUpdate.next = update;
          }
        }
      }

      function useCallback2(callback, deps) {
        return useMemo2(function () {
          return callback;
        }, deps);
      }

      function useMutableSource(source, getSnapshot, subscribe) {
        resolveCurrentlyRenderingComponent();
        return getSnapshot(source._source);
      }

      function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        if (getServerSnapshot === void 0) {
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        }

        return getServerSnapshot();
      }

      function useDeferredValue(value) {
        resolveCurrentlyRenderingComponent();
        return value;
      }

      function unsupportedStartTransition() {
        throw new Error("startTransition cannot be called during server rendering.");
      }

      function useTransition() {
        resolveCurrentlyRenderingComponent();
        return [false, unsupportedStartTransition];
      }

      function useId() {
        var task = currentlyRenderingTask;
        var treeId = getTreeId(task.treeContext);
        var responseState = currentResponseState;

        if (responseState === null) {
          throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
        }

        var localId = localIdCounter++;
        return makeId(responseState, treeId, localId);
      }

      function noop() {}

      var Dispatcher = {
        readContext: readContext$1,
        useContext: useContext2,
        useMemo: useMemo2,
        useReducer: useReducer2,
        useRef: useRef2,
        useState: useState2,
        useInsertionEffect: noop,
        useLayoutEffect: useLayoutEffect2,
        useCallback: useCallback2,
        useImperativeHandle: noop,
        useEffect: noop,
        useDebugValue: noop,
        useDeferredValue: useDeferredValue,
        useTransition: useTransition,
        useId: useId,
        useMutableSource: useMutableSource,
        useSyncExternalStore: useSyncExternalStore
      };
      var currentResponseState = null;

      function setCurrentResponseState(responseState) {
        currentResponseState = responseState;
      }

      function getStackByComponentStackNode(componentStack) {
        try {
          var info = "";
          var node = componentStack;

          do {
            switch (node.tag) {
              case 0:
                info += describeBuiltInComponentFrame(node.type, null, null);
                break;

              case 1:
                info += describeFunctionComponentFrame(node.type, null, null);
                break;

              case 2:
                info += describeClassComponentFrame(node.type, null, null);
                break;
            }

            node = node.parent;
          } while (node);

          return info;
        } catch (x2) {
          return "\nError generating stack: " + x2.message + "\n" + x2.stack;
        }
      }

      var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      var PENDING = 0;
      var COMPLETED = 1;
      var FLUSHED = 2;
      var ABORTED = 3;
      var ERRORED = 4;
      var OPEN = 0;
      var CLOSING = 1;
      var CLOSED = 2;
      var DEFAULT_PROGRESSIVE_CHUNK_SIZE = 12800;

      function defaultErrorHandler(error2) {
        console["error"](error2);
        return null;
      }

      function noop$1() {}

      function createRequest(children, responseState, rootFormatContext, progressiveChunkSize, onError2, onAllReady, onShellReady, onShellError, onFatalError) {
        var pingedTasks = [];
        var abortSet = /* @__PURE__ */new Set();
        var request = {
          destination: null,
          responseState: responseState,
          progressiveChunkSize: progressiveChunkSize === void 0 ? DEFAULT_PROGRESSIVE_CHUNK_SIZE : progressiveChunkSize,
          status: OPEN,
          fatalError: null,
          nextSegmentId: 0,
          allPendingTasks: 0,
          pendingRootTasks: 0,
          completedRootSegment: null,
          abortableTasks: abortSet,
          pingedTasks: pingedTasks,
          clientRenderedBoundaries: [],
          completedBoundaries: [],
          partialBoundaries: [],
          onError: onError2 === void 0 ? defaultErrorHandler : onError2,
          onAllReady: onAllReady === void 0 ? noop$1 : onAllReady,
          onShellReady: onShellReady === void 0 ? noop$1 : onShellReady,
          onShellError: onShellError === void 0 ? noop$1 : onShellError,
          onFatalError: onFatalError === void 0 ? noop$1 : onFatalError
        };
        var rootSegment = createPendingSegment(request, 0, null, rootFormatContext, false, false);
        rootSegment.parentFlushed = true;
        var rootTask = createTask(request, children, null, rootSegment, abortSet, emptyContextObject, rootContextSnapshot, emptyTreeContext);
        pingedTasks.push(rootTask);
        return request;
      }

      function pingTask(request, task) {
        var pingedTasks = request.pingedTasks;
        pingedTasks.push(task);

        if (pingedTasks.length === 1) {
          scheduleWork(function () {
            return performWork(request);
          });
        }
      }

      function createSuspenseBoundary(request, fallbackAbortableTasks) {
        return {
          id: UNINITIALIZED_SUSPENSE_BOUNDARY_ID,
          rootSegmentID: -1,
          parentFlushed: false,
          pendingTasks: 0,
          forceClientRender: false,
          completedSegments: [],
          byteSize: 0,
          fallbackAbortableTasks: fallbackAbortableTasks,
          errorDigest: null
        };
      }

      function createTask(request, node, blockedBoundary, blockedSegment, abortSet, legacyContext, context, treeContext) {
        request.allPendingTasks++;

        if (blockedBoundary === null) {
          request.pendingRootTasks++;
        } else {
          blockedBoundary.pendingTasks++;
        }

        var task = {
          node: node,
          ping: function ping() {
            return pingTask(request, task);
          },
          blockedBoundary: blockedBoundary,
          blockedSegment: blockedSegment,
          abortSet: abortSet,
          legacyContext: legacyContext,
          context: context,
          treeContext: treeContext
        };
        {
          task.componentStack = null;
        }
        abortSet.add(task);
        return task;
      }

      function createPendingSegment(request, index, boundary, formatContext, lastPushedText, textEmbedded) {
        return {
          status: PENDING,
          id: -1,
          index: index,
          parentFlushed: false,
          chunks: [],
          children: [],
          formatContext: formatContext,
          boundary: boundary,
          lastPushedText: lastPushedText,
          textEmbedded: textEmbedded
        };
      }

      var currentTaskInDEV = null;

      function getCurrentStackInDEV() {
        {
          if (currentTaskInDEV === null || currentTaskInDEV.componentStack === null) {
            return "";
          }

          return getStackByComponentStackNode(currentTaskInDEV.componentStack);
        }
      }

      function pushBuiltInComponentStackInDEV(task, type) {
        {
          task.componentStack = {
            tag: 0,
            parent: task.componentStack,
            type: type
          };
        }
      }

      function pushFunctionComponentStackInDEV(task, type) {
        {
          task.componentStack = {
            tag: 1,
            parent: task.componentStack,
            type: type
          };
        }
      }

      function pushClassComponentStackInDEV(task, type) {
        {
          task.componentStack = {
            tag: 2,
            parent: task.componentStack,
            type: type
          };
        }
      }

      function popComponentStackInDEV(task) {
        {
          if (task.componentStack === null) {
            error("Unexpectedly popped too many stack frames. This is a bug in React.");
          } else {
            task.componentStack = task.componentStack.parent;
          }
        }
      }

      var lastBoundaryErrorComponentStackDev = null;

      function captureBoundaryErrorDetailsDev(boundary, error2) {
        {
          var errorMessage;

          if (typeof error2 === "string") {
            errorMessage = error2;
          } else if (error2 && typeof error2.message === "string") {
            errorMessage = error2.message;
          } else {
            errorMessage = String(error2);
          }

          var errorComponentStack = lastBoundaryErrorComponentStackDev || getCurrentStackInDEV();
          lastBoundaryErrorComponentStackDev = null;
          boundary.errorMessage = errorMessage;
          boundary.errorComponentStack = errorComponentStack;
        }
      }

      function logRecoverableError(request, error2) {
        var errorDigest = request.onError(error2);

        if (errorDigest != null && typeof errorDigest !== "string") {
          throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
        }

        return errorDigest;
      }

      function fatalError(request, error2) {
        var onShellError = request.onShellError;
        onShellError(error2);
        var onFatalError = request.onFatalError;
        onFatalError(error2);

        if (request.destination !== null) {
          request.status = CLOSED;
          closeWithError(request.destination, error2);
        } else {
          request.status = CLOSING;
          request.fatalError = error2;
        }
      }

      function renderSuspenseBoundary(request, task, props) {
        pushBuiltInComponentStackInDEV(task, "Suspense");
        var parentBoundary = task.blockedBoundary;
        var parentSegment = task.blockedSegment;
        var fallback = props.fallback;
        var content = props.children;
        var fallbackAbortSet = /* @__PURE__ */new Set();
        var newBoundary = createSuspenseBoundary(request, fallbackAbortSet);
        var insertionIndex = parentSegment.chunks.length;
        var boundarySegment = createPendingSegment(request, insertionIndex, newBoundary, parentSegment.formatContext, false, false);
        parentSegment.children.push(boundarySegment);
        parentSegment.lastPushedText = false;
        var contentRootSegment = createPendingSegment(request, 0, null, parentSegment.formatContext, false, false);
        contentRootSegment.parentFlushed = true;
        task.blockedBoundary = newBoundary;
        task.blockedSegment = contentRootSegment;

        try {
          renderNode(request, task, content);
          pushSegmentFinale$1(contentRootSegment.chunks, request.responseState, contentRootSegment.lastPushedText, contentRootSegment.textEmbedded);
          contentRootSegment.status = COMPLETED;
          queueCompletedSegment(newBoundary, contentRootSegment);

          if (newBoundary.pendingTasks === 0) {
            popComponentStackInDEV(task);
            return;
          }
        } catch (error2) {
          contentRootSegment.status = ERRORED;
          newBoundary.forceClientRender = true;
          newBoundary.errorDigest = logRecoverableError(request, error2);
          {
            captureBoundaryErrorDetailsDev(newBoundary, error2);
          }
        } finally {
          task.blockedBoundary = parentBoundary;
          task.blockedSegment = parentSegment;
        }

        var suspendedFallbackTask = createTask(request, fallback, parentBoundary, boundarySegment, fallbackAbortSet, task.legacyContext, task.context, task.treeContext);
        {
          suspendedFallbackTask.componentStack = task.componentStack;
        }
        request.pingedTasks.push(suspendedFallbackTask);
        popComponentStackInDEV(task);
      }

      function renderHostElement(request, task, type, props) {
        pushBuiltInComponentStackInDEV(task, type);
        var segment = task.blockedSegment;
        var children = pushStartInstance(segment.chunks, type, props, request.responseState, segment.formatContext);
        segment.lastPushedText = false;
        var prevContext = segment.formatContext;
        segment.formatContext = getChildFormatContext(prevContext, type, props);
        renderNode(request, task, children);
        segment.formatContext = prevContext;
        pushEndInstance(segment.chunks, type);
        segment.lastPushedText = false;
        popComponentStackInDEV(task);
      }

      function shouldConstruct$1(Component2) {
        return Component2.prototype && Component2.prototype.isReactComponent;
      }

      function renderWithHooks(request, task, Component2, props, secondArg) {
        var componentIdentity = {};
        prepareToUseHooks(task, componentIdentity);
        var result = Component2(props, secondArg);
        return finishHooks(Component2, props, result, secondArg);
      }

      function finishClassComponent(request, task, instance, Component2, props) {
        var nextChildren = instance.render();
        {
          if (instance.props !== props) {
            if (!didWarnAboutReassigningProps) {
              error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromType(Component2) || "a component");
            }

            didWarnAboutReassigningProps = true;
          }
        }
        {
          var childContextTypes = Component2.childContextTypes;

          if (childContextTypes !== null && childContextTypes !== void 0) {
            var previousContext = task.legacyContext;
            var mergedContext = processChildContext(instance, Component2, previousContext, childContextTypes);
            task.legacyContext = mergedContext;
            renderNodeDestructive(request, task, nextChildren);
            task.legacyContext = previousContext;
            return;
          }
        }
        renderNodeDestructive(request, task, nextChildren);
      }

      function renderClassComponent(request, task, Component2, props) {
        pushClassComponentStackInDEV(task, Component2);
        var maskedContext = getMaskedContext(Component2, task.legacyContext);
        var instance = constructClassInstance(Component2, props, maskedContext);
        mountClassInstance(instance, Component2, props, maskedContext);
        finishClassComponent(request, task, instance, Component2, props);
        popComponentStackInDEV(task);
      }

      var didWarnAboutBadClass = {};
      var didWarnAboutModulePatternComponent = {};
      var didWarnAboutContextTypeOnFunctionComponent = {};
      var didWarnAboutGetDerivedStateOnFunctionComponent = {};
      var didWarnAboutReassigningProps = false;
      var didWarnAboutGenerators = false;
      var didWarnAboutMaps = false;
      var hasWarnedAboutUsingContextAsConsumer = false;

      function renderIndeterminateComponent(request, task, Component2, props) {
        var legacyContext;
        {
          legacyContext = getMaskedContext(Component2, task.legacyContext);
        }
        pushFunctionComponentStackInDEV(task, Component2);
        {
          if (Component2.prototype && typeof Component2.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component2) || "Unknown";

            if (!didWarnAboutBadClass[componentName]) {
              error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
              didWarnAboutBadClass[componentName] = true;
            }
          }
        }
        var value = renderWithHooks(request, task, Component2, props, legacyContext);
        var hasId = checkDidRenderIdHook();
        {
          if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0) {
            var _componentName = getComponentNameFromType(Component2) || "Unknown";

            if (!didWarnAboutModulePatternComponent[_componentName]) {
              error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
              didWarnAboutModulePatternComponent[_componentName] = true;
            }
          }
        }

        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0) {
          {
            var _componentName2 = getComponentNameFromType(Component2) || "Unknown";

            if (!didWarnAboutModulePatternComponent[_componentName2]) {
              error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
              didWarnAboutModulePatternComponent[_componentName2] = true;
            }
          }
          mountClassInstance(value, Component2, props, legacyContext);
          finishClassComponent(request, task, value, Component2, props);
        } else {
          {
            validateFunctionComponentInDev(Component2);
          }

          if (hasId) {
            var prevTreeContext = task.treeContext;
            var totalChildren = 1;
            var index = 0;
            task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);

            try {
              renderNodeDestructive(request, task, value);
            } finally {
              task.treeContext = prevTreeContext;
            }
          } else {
            renderNodeDestructive(request, task, value);
          }
        }

        popComponentStackInDEV(task);
      }

      function validateFunctionComponentInDev(Component2) {
        {
          if (Component2) {
            if (Component2.childContextTypes) {
              error("%s(...): childContextTypes cannot be defined on a function component.", Component2.displayName || Component2.name || "Component");
            }
          }

          if (typeof Component2.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component2) || "Unknown";

            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
              error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
              didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
          }

          if (typeof Component2.contextType === "object" && Component2.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component2) || "Unknown";

            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
              error("%s: Function components do not support contextType.", _componentName4);
              didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
          }
        }
      }

      function resolveDefaultProps(Component2, baseProps) {
        if (Component2 && Component2.defaultProps) {
          var props = assign({}, baseProps);
          var defaultProps = Component2.defaultProps;

          for (var propName in defaultProps) {
            if (props[propName] === void 0) {
              props[propName] = defaultProps[propName];
            }
          }

          return props;
        }

        return baseProps;
      }

      function renderForwardRef(request, task, type, props, ref) {
        pushFunctionComponentStackInDEV(task, type.render);
        var children = renderWithHooks(request, task, type.render, props, ref);
        var hasId = checkDidRenderIdHook();

        if (hasId) {
          var prevTreeContext = task.treeContext;
          var totalChildren = 1;
          var index = 0;
          task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);

          try {
            renderNodeDestructive(request, task, children);
          } finally {
            task.treeContext = prevTreeContext;
          }
        } else {
          renderNodeDestructive(request, task, children);
        }

        popComponentStackInDEV(task);
      }

      function renderMemo(request, task, type, props, ref) {
        var innerType = type.type;
        var resolvedProps = resolveDefaultProps(innerType, props);
        renderElement(request, task, innerType, resolvedProps, ref);
      }

      function renderContextConsumer(request, task, context, props) {
        {
          if (context._context === void 0) {
            if (context !== context.Consumer) {
              if (!hasWarnedAboutUsingContextAsConsumer) {
                hasWarnedAboutUsingContextAsConsumer = true;
                error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
              }
            }
          } else {
            context = context._context;
          }
        }
        var render = props.children;
        {
          if (typeof render !== "function") {
            error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
          }
        }
        var newValue = readContext(context);
        var newChildren = render(newValue);
        renderNodeDestructive(request, task, newChildren);
      }

      function renderContextProvider(request, task, type, props) {
        var context = type._context;
        var value = props.value;
        var children = props.children;
        var prevSnapshot;
        {
          prevSnapshot = task.context;
        }
        task.context = pushProvider(context, value);
        renderNodeDestructive(request, task, children);
        task.context = popProvider(context);
        {
          if (prevSnapshot !== task.context) {
            error("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
          }
        }
      }

      function renderLazyComponent(request, task, lazyComponent, props, ref) {
        pushBuiltInComponentStackInDEV(task, "Lazy");
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component2 = init(payload);
        var resolvedProps = resolveDefaultProps(Component2, props);
        renderElement(request, task, Component2, resolvedProps, ref);
        popComponentStackInDEV(task);
      }

      function renderElement(request, task, type, props, ref) {
        if (typeof type === "function") {
          if (shouldConstruct$1(type)) {
            renderClassComponent(request, task, type, props);
            return;
          } else {
            renderIndeterminateComponent(request, task, type, props);
            return;
          }
        }

        if (typeof type === "string") {
          renderHostElement(request, task, type, props);
          return;
        }

        switch (type) {
          case REACT_LEGACY_HIDDEN_TYPE:
          case REACT_DEBUG_TRACING_MODE_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_FRAGMENT_TYPE:
            {
              renderNodeDestructive(request, task, props.children);
              return;
            }

          case REACT_SUSPENSE_LIST_TYPE:
            {
              pushBuiltInComponentStackInDEV(task, "SuspenseList");
              renderNodeDestructive(request, task, props.children);
              popComponentStackInDEV(task);
              return;
            }

          case REACT_SCOPE_TYPE:
            {
              throw new Error("ReactDOMServer does not yet support scope components.");
            }

          case REACT_SUSPENSE_TYPE:
            {
              {
                renderSuspenseBoundary(request, task, props);
              }
              return;
            }
        }

        if (typeof type === "object" && type !== null) {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              {
                renderForwardRef(request, task, type, props, ref);
                return;
              }

            case REACT_MEMO_TYPE:
              {
                renderMemo(request, task, type, props, ref);
                return;
              }

            case REACT_PROVIDER_TYPE:
              {
                renderContextProvider(request, task, type, props);
                return;
              }

            case REACT_CONTEXT_TYPE:
              {
                renderContextConsumer(request, task, type, props);
                return;
              }

            case REACT_LAZY_TYPE:
              {
                renderLazyComponent(request, task, type, props);
                return;
              }
          }
        }

        var info = "";
        {
          if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
            info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
          }
        }
        throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
      }

      function validateIterable(iterable, iteratorFn) {
        {
          if (typeof Symbol === "function" && iterable[Symbol.toStringTag] === "Generator") {
            if (!didWarnAboutGenerators) {
              error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
            }

            didWarnAboutGenerators = true;
          }

          if (iterable.entries === iteratorFn) {
            if (!didWarnAboutMaps) {
              error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
            }

            didWarnAboutMaps = true;
          }
        }
      }

      function renderNodeDestructive(request, task, node) {
        {
          try {
            return renderNodeDestructiveImpl(request, task, node);
          } catch (x2) {
            if (typeof x2 === "object" && x2 !== null && typeof x2.then === "function") ;else {
              lastBoundaryErrorComponentStackDev = lastBoundaryErrorComponentStackDev !== null ? lastBoundaryErrorComponentStackDev : getCurrentStackInDEV();
            }
            throw x2;
          }
        }
      }

      function renderNodeDestructiveImpl(request, task, node) {
        task.node = node;

        if (typeof node === "object" && node !== null) {
          switch (node.$$typeof) {
            case REACT_ELEMENT_TYPE2:
              {
                var element = node;
                var type = element.type;
                var props = element.props;
                var ref = element.ref;
                renderElement(request, task, type, props, ref);
                return;
              }

            case REACT_PORTAL_TYPE:
              throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");

            case REACT_LAZY_TYPE:
              {
                var lazyNode = node;
                var payload = lazyNode._payload;
                var init = lazyNode._init;
                var resolvedNode;
                {
                  try {
                    resolvedNode = init(payload);
                  } catch (x2) {
                    if (typeof x2 === "object" && x2 !== null && typeof x2.then === "function") {
                      pushBuiltInComponentStackInDEV(task, "Lazy");
                    }

                    throw x2;
                  }
                }
                renderNodeDestructive(request, task, resolvedNode);
                return;
              }
          }

          if (isArray2(node)) {
            renderChildrenArray(request, task, node);
            return;
          }

          var iteratorFn = getIteratorFn(node);

          if (iteratorFn) {
            {
              validateIterable(node, iteratorFn);
            }
            var iterator = iteratorFn.call(node);

            if (iterator) {
              var step = iterator.next();

              if (!step.done) {
                var children = [];

                do {
                  children.push(step.value);
                  step = iterator.next();
                } while (!step.done);

                renderChildrenArray(request, task, children);
                return;
              }

              return;
            }
          }

          var childString = Object.prototype.toString.call(node);
          throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(node).join(", ") + "}" : childString) + "). If you meant to render a collection of children, use an array instead.");
        }

        if (typeof node === "string") {
          var segment = task.blockedSegment;
          segment.lastPushedText = pushTextInstance$1(task.blockedSegment.chunks, node, request.responseState, segment.lastPushedText);
          return;
        }

        if (typeof node === "number") {
          var _segment = task.blockedSegment;
          _segment.lastPushedText = pushTextInstance$1(task.blockedSegment.chunks, "" + node, request.responseState, _segment.lastPushedText);
          return;
        }

        {
          if (typeof node === "function") {
            error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
          }
        }
      }

      function renderChildrenArray(request, task, children) {
        var totalChildren = children.length;

        for (var i2 = 0; i2 < totalChildren; i2++) {
          var prevTreeContext = task.treeContext;
          task.treeContext = pushTreeContext(prevTreeContext, totalChildren, i2);

          try {
            renderNode(request, task, children[i2]);
          } finally {
            task.treeContext = prevTreeContext;
          }
        }
      }

      function spawnNewSuspendedTask(request, task, x2) {
        var segment = task.blockedSegment;
        var insertionIndex = segment.chunks.length;
        var newSegment = createPendingSegment(request, insertionIndex, null, segment.formatContext, segment.lastPushedText, true);
        segment.children.push(newSegment);
        segment.lastPushedText = false;
        var newTask = createTask(request, task.node, task.blockedBoundary, newSegment, task.abortSet, task.legacyContext, task.context, task.treeContext);
        {
          if (task.componentStack !== null) {
            newTask.componentStack = task.componentStack.parent;
          }
        }
        var ping = newTask.ping;
        x2.then(ping, ping);
      }

      function renderNode(request, task, node) {
        var previousFormatContext = task.blockedSegment.formatContext;
        var previousLegacyContext = task.legacyContext;
        var previousContext = task.context;
        var previousComponentStack = null;
        {
          previousComponentStack = task.componentStack;
        }

        try {
          return renderNodeDestructive(request, task, node);
        } catch (x2) {
          resetHooksState();

          if (typeof x2 === "object" && x2 !== null && typeof x2.then === "function") {
            spawnNewSuspendedTask(request, task, x2);
            task.blockedSegment.formatContext = previousFormatContext;
            task.legacyContext = previousLegacyContext;
            task.context = previousContext;
            switchContext(previousContext);
            {
              task.componentStack = previousComponentStack;
            }
            return;
          } else {
            task.blockedSegment.formatContext = previousFormatContext;
            task.legacyContext = previousLegacyContext;
            task.context = previousContext;
            switchContext(previousContext);
            {
              task.componentStack = previousComponentStack;
            }
            throw x2;
          }
        }
      }

      function erroredTask(request, boundary, segment, error2) {
        var errorDigest = logRecoverableError(request, error2);

        if (boundary === null) {
          fatalError(request, error2);
        } else {
          boundary.pendingTasks--;

          if (!boundary.forceClientRender) {
            boundary.forceClientRender = true;
            boundary.errorDigest = errorDigest;
            {
              captureBoundaryErrorDetailsDev(boundary, error2);
            }

            if (boundary.parentFlushed) {
              request.clientRenderedBoundaries.push(boundary);
            }
          }
        }

        request.allPendingTasks--;

        if (request.allPendingTasks === 0) {
          var onAllReady = request.onAllReady;
          onAllReady();
        }
      }

      function abortTaskSoft(task) {
        var request = this;
        var boundary = task.blockedBoundary;
        var segment = task.blockedSegment;
        segment.status = ABORTED;
        finishedTask(request, boundary, segment);
      }

      function abortTask(task, request, reason) {
        var boundary = task.blockedBoundary;
        var segment = task.blockedSegment;
        segment.status = ABORTED;

        if (boundary === null) {
          request.allPendingTasks--;

          if (request.status !== CLOSED) {
            request.status = CLOSED;

            if (request.destination !== null) {
              close(request.destination);
            }
          }
        } else {
          boundary.pendingTasks--;

          if (!boundary.forceClientRender) {
            boundary.forceClientRender = true;

            var _error = reason === void 0 ? new Error("The render was aborted by the server without a reason.") : reason;

            boundary.errorDigest = request.onError(_error);
            {
              var errorPrefix = "The server did not finish this Suspense boundary: ";

              if (_error && typeof _error.message === "string") {
                _error = errorPrefix + _error.message;
              } else {
                _error = errorPrefix + String(_error);
              }

              var previousTaskInDev = currentTaskInDEV;
              currentTaskInDEV = task;

              try {
                captureBoundaryErrorDetailsDev(boundary, _error);
              } finally {
                currentTaskInDEV = previousTaskInDev;
              }
            }

            if (boundary.parentFlushed) {
              request.clientRenderedBoundaries.push(boundary);
            }
          }

          boundary.fallbackAbortableTasks.forEach(function (fallbackTask) {
            return abortTask(fallbackTask, request, reason);
          });
          boundary.fallbackAbortableTasks.clear();
          request.allPendingTasks--;

          if (request.allPendingTasks === 0) {
            var onAllReady = request.onAllReady;
            onAllReady();
          }
        }
      }

      function queueCompletedSegment(boundary, segment) {
        if (segment.chunks.length === 0 && segment.children.length === 1 && segment.children[0].boundary === null) {
          var childSegment = segment.children[0];
          childSegment.id = segment.id;
          childSegment.parentFlushed = true;

          if (childSegment.status === COMPLETED) {
            queueCompletedSegment(boundary, childSegment);
          }
        } else {
          var completedSegments = boundary.completedSegments;
          completedSegments.push(segment);
        }
      }

      function finishedTask(request, boundary, segment) {
        if (boundary === null) {
          if (segment.parentFlushed) {
            if (request.completedRootSegment !== null) {
              throw new Error("There can only be one root segment. This is a bug in React.");
            }

            request.completedRootSegment = segment;
          }

          request.pendingRootTasks--;

          if (request.pendingRootTasks === 0) {
            request.onShellError = noop$1;
            var onShellReady = request.onShellReady;
            onShellReady();
          }
        } else {
          boundary.pendingTasks--;
          if (boundary.forceClientRender) ;else if (boundary.pendingTasks === 0) {
            if (segment.parentFlushed) {
              if (segment.status === COMPLETED) {
                queueCompletedSegment(boundary, segment);
              }
            }

            if (boundary.parentFlushed) {
              request.completedBoundaries.push(boundary);
            }

            boundary.fallbackAbortableTasks.forEach(abortTaskSoft, request);
            boundary.fallbackAbortableTasks.clear();
          } else {
            if (segment.parentFlushed) {
              if (segment.status === COMPLETED) {
                queueCompletedSegment(boundary, segment);
                var completedSegments = boundary.completedSegments;

                if (completedSegments.length === 1) {
                  if (boundary.parentFlushed) {
                    request.partialBoundaries.push(boundary);
                  }
                }
              }
            }
          }
        }

        request.allPendingTasks--;

        if (request.allPendingTasks === 0) {
          var onAllReady = request.onAllReady;
          onAllReady();
        }
      }

      function retryTask(request, task) {
        var segment = task.blockedSegment;

        if (segment.status !== PENDING) {
          return;
        }

        switchContext(task.context);
        var prevTaskInDEV = null;
        {
          prevTaskInDEV = currentTaskInDEV;
          currentTaskInDEV = task;
        }

        try {
          renderNodeDestructive(request, task, task.node);
          pushSegmentFinale$1(segment.chunks, request.responseState, segment.lastPushedText, segment.textEmbedded);
          task.abortSet.delete(task);
          segment.status = COMPLETED;
          finishedTask(request, task.blockedBoundary, segment);
        } catch (x2) {
          resetHooksState();

          if (typeof x2 === "object" && x2 !== null && typeof x2.then === "function") {
            var ping = task.ping;
            x2.then(ping, ping);
          } else {
            task.abortSet.delete(task);
            segment.status = ERRORED;
            erroredTask(request, task.blockedBoundary, segment, x2);
          }
        } finally {
          {
            currentTaskInDEV = prevTaskInDEV;
          }
        }
      }

      function performWork(request) {
        if (request.status === CLOSED) {
          return;
        }

        var prevContext = getActiveContext();
        var prevDispatcher = ReactCurrentDispatcher$1.current;
        ReactCurrentDispatcher$1.current = Dispatcher;
        var prevGetCurrentStackImpl;
        {
          prevGetCurrentStackImpl = ReactDebugCurrentFrame$1.getCurrentStack;
          ReactDebugCurrentFrame$1.getCurrentStack = getCurrentStackInDEV;
        }
        var prevResponseState = currentResponseState;
        setCurrentResponseState(request.responseState);

        try {
          var pingedTasks = request.pingedTasks;
          var i2;

          for (i2 = 0; i2 < pingedTasks.length; i2++) {
            var task = pingedTasks[i2];
            retryTask(request, task);
          }

          pingedTasks.splice(0, i2);

          if (request.destination !== null) {
            flushCompletedQueues(request, request.destination);
          }
        } catch (error2) {
          logRecoverableError(request, error2);
          fatalError(request, error2);
        } finally {
          setCurrentResponseState(prevResponseState);
          ReactCurrentDispatcher$1.current = prevDispatcher;
          {
            ReactDebugCurrentFrame$1.getCurrentStack = prevGetCurrentStackImpl;
          }

          if (prevDispatcher === Dispatcher) {
            switchContext(prevContext);
          }
        }
      }

      function flushSubtree(request, destination, segment) {
        segment.parentFlushed = true;

        switch (segment.status) {
          case PENDING:
            {
              var segmentID = segment.id = request.nextSegmentId++;
              segment.lastPushedText = false;
              segment.textEmbedded = false;
              return writePlaceholder(destination, request.responseState, segmentID);
            }

          case COMPLETED:
            {
              segment.status = FLUSHED;
              var r2 = true;
              var chunks = segment.chunks;
              var chunkIdx = 0;
              var children = segment.children;

              for (var childIdx = 0; childIdx < children.length; childIdx++) {
                var nextChild = children[childIdx];

                for (; chunkIdx < nextChild.index; chunkIdx++) {
                  writeChunk(destination, chunks[chunkIdx]);
                }

                r2 = flushSegment(request, destination, nextChild);
              }

              for (; chunkIdx < chunks.length - 1; chunkIdx++) {
                writeChunk(destination, chunks[chunkIdx]);
              }

              if (chunkIdx < chunks.length) {
                r2 = writeChunkAndReturn(destination, chunks[chunkIdx]);
              }

              return r2;
            }

          default:
            {
              throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
            }
        }
      }

      function flushSegment(request, destination, segment) {
        var boundary = segment.boundary;

        if (boundary === null) {
          return flushSubtree(request, destination, segment);
        }

        boundary.parentFlushed = true;

        if (boundary.forceClientRender) {
          writeStartClientRenderedSuspenseBoundary$1(destination, request.responseState, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
          flushSubtree(request, destination, segment);
          return writeEndClientRenderedSuspenseBoundary$1(destination, request.responseState);
        } else if (boundary.pendingTasks > 0) {
          boundary.rootSegmentID = request.nextSegmentId++;

          if (boundary.completedSegments.length > 0) {
            request.partialBoundaries.push(boundary);
          }

          var id = boundary.id = assignSuspenseBoundaryID(request.responseState);
          writeStartPendingSuspenseBoundary(destination, request.responseState, id);
          flushSubtree(request, destination, segment);
          return writeEndPendingSuspenseBoundary(destination, request.responseState);
        } else if (boundary.byteSize > request.progressiveChunkSize) {
          boundary.rootSegmentID = request.nextSegmentId++;
          request.completedBoundaries.push(boundary);
          writeStartPendingSuspenseBoundary(destination, request.responseState, boundary.id);
          flushSubtree(request, destination, segment);
          return writeEndPendingSuspenseBoundary(destination, request.responseState);
        } else {
          writeStartCompletedSuspenseBoundary$1(destination, request.responseState);
          var completedSegments = boundary.completedSegments;

          if (completedSegments.length !== 1) {
            throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
          }

          var contentSegment = completedSegments[0];
          flushSegment(request, destination, contentSegment);
          return writeEndCompletedSuspenseBoundary$1(destination, request.responseState);
        }
      }

      function flushClientRenderedBoundary(request, destination, boundary) {
        return writeClientRenderBoundaryInstruction(destination, request.responseState, boundary.id, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
      }

      function flushSegmentContainer(request, destination, segment) {
        writeStartSegment(destination, request.responseState, segment.formatContext, segment.id);
        flushSegment(request, destination, segment);
        return writeEndSegment(destination, segment.formatContext);
      }

      function flushCompletedBoundary(request, destination, boundary) {
        var completedSegments = boundary.completedSegments;
        var i2 = 0;

        for (; i2 < completedSegments.length; i2++) {
          var segment = completedSegments[i2];
          flushPartiallyCompletedSegment(request, destination, boundary, segment);
        }

        completedSegments.length = 0;
        return writeCompletedBoundaryInstruction(destination, request.responseState, boundary.id, boundary.rootSegmentID);
      }

      function flushPartialBoundary(request, destination, boundary) {
        var completedSegments = boundary.completedSegments;
        var i2 = 0;

        for (; i2 < completedSegments.length; i2++) {
          var segment = completedSegments[i2];

          if (!flushPartiallyCompletedSegment(request, destination, boundary, segment)) {
            i2++;
            completedSegments.splice(0, i2);
            return false;
          }
        }

        completedSegments.splice(0, i2);
        return true;
      }

      function flushPartiallyCompletedSegment(request, destination, boundary, segment) {
        if (segment.status === FLUSHED) {
          return true;
        }

        var segmentID = segment.id;

        if (segmentID === -1) {
          var rootSegmentID = segment.id = boundary.rootSegmentID;

          if (rootSegmentID === -1) {
            throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
          }

          return flushSegmentContainer(request, destination, segment);
        } else {
          flushSegmentContainer(request, destination, segment);
          return writeCompletedSegmentInstruction(destination, request.responseState, segmentID);
        }
      }

      function flushCompletedQueues(request, destination) {
        try {
          var completedRootSegment = request.completedRootSegment;

          if (completedRootSegment !== null && request.pendingRootTasks === 0) {
            flushSegment(request, destination, completedRootSegment);
            request.completedRootSegment = null;
            writeCompletedRoot(destination, request.responseState);
          }

          var clientRenderedBoundaries = request.clientRenderedBoundaries;
          var i2;

          for (i2 = 0; i2 < clientRenderedBoundaries.length; i2++) {
            var boundary = clientRenderedBoundaries[i2];

            if (!flushClientRenderedBoundary(request, destination, boundary)) {
              request.destination = null;
              i2++;
              clientRenderedBoundaries.splice(0, i2);
              return;
            }
          }

          clientRenderedBoundaries.splice(0, i2);
          var completedBoundaries = request.completedBoundaries;

          for (i2 = 0; i2 < completedBoundaries.length; i2++) {
            var _boundary = completedBoundaries[i2];

            if (!flushCompletedBoundary(request, destination, _boundary)) {
              request.destination = null;
              i2++;
              completedBoundaries.splice(0, i2);
              return;
            }
          }

          completedBoundaries.splice(0, i2);
          completeWriting(destination);
          beginWriting(destination);
          var partialBoundaries = request.partialBoundaries;

          for (i2 = 0; i2 < partialBoundaries.length; i2++) {
            var _boundary2 = partialBoundaries[i2];

            if (!flushPartialBoundary(request, destination, _boundary2)) {
              request.destination = null;
              i2++;
              partialBoundaries.splice(0, i2);
              return;
            }
          }

          partialBoundaries.splice(0, i2);
          var largeBoundaries = request.completedBoundaries;

          for (i2 = 0; i2 < largeBoundaries.length; i2++) {
            var _boundary3 = largeBoundaries[i2];

            if (!flushCompletedBoundary(request, destination, _boundary3)) {
              request.destination = null;
              i2++;
              largeBoundaries.splice(0, i2);
              return;
            }
          }

          largeBoundaries.splice(0, i2);
        } finally {
          if (request.allPendingTasks === 0 && request.pingedTasks.length === 0 && request.clientRenderedBoundaries.length === 0 && request.completedBoundaries.length === 0) {
            {
              if (request.abortableTasks.size !== 0) {
                error("There was still abortable task at the root when we closed. This is a bug in React.");
              }
            }
            close(destination);
          }
        }
      }

      function startWork(request) {
        scheduleWork(function () {
          return performWork(request);
        });
      }

      function startFlowing(request, destination) {
        if (request.status === CLOSING) {
          request.status = CLOSED;
          closeWithError(destination, request.fatalError);
          return;
        }

        if (request.status === CLOSED) {
          return;
        }

        if (request.destination !== null) {
          return;
        }

        request.destination = destination;

        try {
          flushCompletedQueues(request, destination);
        } catch (error2) {
          logRecoverableError(request, error2);
          fatalError(request, error2);
        }
      }

      function abort(request, reason) {
        try {
          var abortableTasks = request.abortableTasks;
          abortableTasks.forEach(function (task) {
            return abortTask(task, request, reason);
          });
          abortableTasks.clear();

          if (request.destination !== null) {
            flushCompletedQueues(request, request.destination);
          }
        } catch (error2) {
          logRecoverableError(request, error2);
          fatalError(request, error2);
        }
      }

      function onError() {}

      function renderToStringImpl(children, options, generateStaticMarkup, abortReason) {
        var didFatal = false;
        var fatalError2 = null;
        var result = "";
        var destination = {
          push: function push(chunk) {
            if (chunk !== null) {
              result += chunk;
            }

            return true;
          },
          destroy: function destroy(error2) {
            didFatal = true;
            fatalError2 = error2;
          }
        };
        var readyToStream = false;

        function onShellReady() {
          readyToStream = true;
        }

        var request = createRequest(children, createResponseState$1(generateStaticMarkup, options ? options.identifierPrefix : void 0), createRootFormatContext(), Infinity, onError, void 0, onShellReady, void 0, void 0);
        startWork(request);
        abort(request, abortReason);
        startFlowing(request, destination);

        if (didFatal) {
          throw fatalError2;
        }

        if (!readyToStream) {
          throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
        }

        return result;
      }

      function renderToString(children, options) {
        return renderToStringImpl(children, options, false, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
      }

      function renderToStaticMarkup(children, options) {
        return renderToStringImpl(children, options, true, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
      }

      function renderToNodeStream() {
        throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
      }

      function renderToStaticNodeStream() {
        throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
      }

      reactDomServerLegacy_browser_development.renderToNodeStream = renderToNodeStream;
      reactDomServerLegacy_browser_development.renderToStaticMarkup = renderToStaticMarkup;
      reactDomServerLegacy_browser_development.renderToStaticNodeStream = renderToStaticNodeStream;
      reactDomServerLegacy_browser_development.renderToString = renderToString;
      reactDomServerLegacy_browser_development.version = ReactVersion;
    })();
  }

  return reactDomServerLegacy_browser_development;
}

var reactDomServer_browser_development = {};
/**
 * @license React
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServer_browser_development;

function requireReactDomServer_browser_development() {
  if (hasRequiredReactDomServer_browser_development) return reactDomServer_browser_development;
  hasRequiredReactDomServer_browser_development = 1;

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var React = r$1;
      var ReactVersion = "18.2.0";
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

      function warn(format) {
        {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            printWarning("warn", format, args);
          }
        }
      }

      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning("error", format, args);
          }
        }
      }

      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();

          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }

          var argsWithFormat = args.map(function (item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      function scheduleWork(callback) {
        callback();
      }

      var VIEW_SIZE = 512;
      var currentView = null;
      var writtenBytes = 0;

      function beginWriting(destination) {
        currentView = new Uint8Array(VIEW_SIZE);
        writtenBytes = 0;
      }

      function writeChunk(destination, chunk) {
        if (chunk.length === 0) {
          return;
        }

        if (chunk.length > VIEW_SIZE) {
          if (writtenBytes > 0) {
            destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes));
            currentView = new Uint8Array(VIEW_SIZE);
            writtenBytes = 0;
          }

          destination.enqueue(chunk);
          return;
        }

        var bytesToWrite = chunk;
        var allowableBytes = currentView.length - writtenBytes;

        if (allowableBytes < bytesToWrite.length) {
          if (allowableBytes === 0) {
            destination.enqueue(currentView);
          } else {
            currentView.set(bytesToWrite.subarray(0, allowableBytes), writtenBytes);
            destination.enqueue(currentView);
            bytesToWrite = bytesToWrite.subarray(allowableBytes);
          }

          currentView = new Uint8Array(VIEW_SIZE);
          writtenBytes = 0;
        }

        currentView.set(bytesToWrite, writtenBytes);
        writtenBytes += bytesToWrite.length;
      }

      function writeChunkAndReturn(destination, chunk) {
        writeChunk(destination, chunk);
        return true;
      }

      function completeWriting(destination) {
        if (currentView && writtenBytes > 0) {
          destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes));
          currentView = null;
          writtenBytes = 0;
        }
      }

      function close(destination) {
        destination.close();
      }

      var textEncoder = new TextEncoder();

      function stringToChunk(content) {
        return textEncoder.encode(content);
      }

      function stringToPrecomputedChunk(content) {
        return textEncoder.encode(content);
      }

      function closeWithError(destination, error2) {
        if (typeof destination.error === "function") {
          destination.error(error2);
        } else {
          destination.close();
        }
      }

      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }

      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e2) {
            return true;
          }
        }
      }

      function testStringCoercion(value) {
        return "" + value;
      }

      function checkAttributeStringCoercion(value, attributeName) {
        {
          if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkCSSPropertyStringCoercion(value, propName) {
        {
          if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkHtmlStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      var hasOwnProperty2 = Object.prototype.hasOwnProperty;
      var RESERVED = 0;
      var STRING = 1;
      var BOOLEANISH_STRING = 2;
      var BOOLEAN = 3;
      var OVERLOADED_BOOLEAN = 4;
      var NUMERIC = 5;
      var POSITIVE_NUMERIC = 6;
      var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
      var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
      var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
      var illegalAttributeNameCache = {};
      var validatedAttributeNameCache = {};

      function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty2.call(validatedAttributeNameCache, attributeName)) {
          return true;
        }

        if (hasOwnProperty2.call(illegalAttributeNameCache, attributeName)) {
          return false;
        }

        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
          validatedAttributeNameCache[attributeName] = true;
          return true;
        }

        illegalAttributeNameCache[attributeName] = true;
        {
          error("Invalid attribute name: `%s`", attributeName);
        }
        return false;
      }

      function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) {
          return false;
        }

        switch (typeof value) {
          case "function":
          case "symbol":
            return true;

          case "boolean":
            {
              if (isCustomComponentTag) {
                return false;
              }

              if (propertyInfo !== null) {
                return !propertyInfo.acceptsBooleans;
              } else {
                var prefix2 = name.toLowerCase().slice(0, 5);
                return prefix2 !== "data-" && prefix2 !== "aria-";
              }
            }

          default:
            return false;
        }
      }

      function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
      }

      function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL2, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL2;
        this.removeEmptyString = removeEmptyString;
      }

      var properties = {};
      var reservedProps = ["children", "dangerouslySetInnerHTML", "defaultValue", "defaultChecked", "innerHTML", "suppressContentEditableWarning", "suppressHydrationWarning", "style"];
      reservedProps.forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
      });
      [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (_ref) {
        var name = _ref[0],
            attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
      });
      ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
      });
      ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
      });
      ["allowFullScreen", "async", "autoFocus", "autoPlay", "controls", "default", "defer", "disabled", "disablePictureInPicture", "disableRemotePlayback", "formNoValidate", "hidden", "loop", "noModule", "noValidate", "open", "playsInline", "readOnly", "required", "reversed", "scoped", "seamless", "itemScope"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
      });
      ["checked", "multiple", "muted", "selected"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
      });
      ["capture", "download"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
      });
      ["cols", "rows", "size", "span"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
      });
      ["rowSpan", "start"].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
      });
      var CAMELIZE = /[\-\:]([a-z])/g;

      var capitalize = function capitalize(token) {
        return token[1].toUpperCase();
      };

      ["accent-height", "alignment-baseline", "arabic-form", "baseline-shift", "cap-height", "clip-path", "clip-rule", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "dominant-baseline", "enable-background", "fill-opacity", "fill-rule", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "glyph-name", "glyph-orientation-horizontal", "glyph-orientation-vertical", "horiz-adv-x", "horiz-origin-x", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "overline-position", "overline-thickness", "paint-order", "panose-1", "pointer-events", "rendering-intent", "shape-rendering", "stop-color", "stop-opacity", "strikethrough-position", "strikethrough-thickness", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-rendering", "underline-position", "underline-thickness", "unicode-bidi", "unicode-range", "units-per-em", "v-alphabetic", "v-hanging", "v-ideographic", "v-mathematical", "vector-effect", "vert-adv-y", "vert-origin-x", "vert-origin-y", "word-spacing", "writing-mode", "xmlns:xlink", "x-height"].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
      });
      ["xlink:actuate", "xlink:arcrole", "xlink:role", "xlink:show", "xlink:title", "xlink:type"].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
      });
      ["xml:base", "xml:lang", "xml:space"].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
      });
      ["tabIndex", "crossOrigin"].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
      });
      var xlinkHref = "xlinkHref";
      properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
      ["src", "href", "action", "formAction"].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
      });
      var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
      };

      function prefixKey(prefix2, key) {
        return prefix2 + key.charAt(0).toUpperCase() + key.substring(1);
      }

      var prefixes = ["Webkit", "ms", "Moz", "O"];
      Object.keys(isUnitlessNumber).forEach(function (prop) {
        prefixes.forEach(function (prefix2) {
          isUnitlessNumber[prefixKey(prefix2, prop)] = isUnitlessNumber[prop];
        });
      });
      var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
      };

      function checkControlledValueProps(tagName, props) {
        {
          if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
            error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
          }

          if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
            error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
          }
        }
      }

      function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) {
          return typeof props.is === "string";
        }

        switch (tagName) {
          case "annotation-xml":
          case "color-profile":
          case "font-face":
          case "font-face-src":
          case "font-face-uri":
          case "font-face-format":
          case "font-face-name":
          case "missing-glyph":
            return false;

          default:
            return true;
        }
      }

      var ariaProperties = {
        "aria-current": 0,
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        "aria-hidden": 0,
        "aria-invalid": 0,
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
      };
      var warnedProperties = {};
      var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
      var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");

      function validateProperty(tagName, name) {
        {
          if (hasOwnProperty2.call(warnedProperties, name) && warnedProperties[name]) {
            return true;
          }

          if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null;

            if (correctName == null) {
              error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
              warnedProperties[name] = true;
              return true;
            }

            if (name !== correctName) {
              error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
              warnedProperties[name] = true;
              return true;
            }
          }

          if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null;

            if (standardName == null) {
              warnedProperties[name] = true;
              return false;
            }

            if (name !== standardName) {
              error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
              warnedProperties[name] = true;
              return true;
            }
          }
        }
        return true;
      }

      function warnInvalidARIAProps(type, props) {
        {
          var invalidProps = [];

          for (var key in props) {
            var isValid = validateProperty(type, key);

            if (!isValid) {
              invalidProps.push(key);
            }
          }

          var unknownPropString = invalidProps.map(function (prop) {
            return "`" + prop + "`";
          }).join(", ");

          if (invalidProps.length === 1) {
            error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
          } else if (invalidProps.length > 1) {
            error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
          }
        }
      }

      function validateProperties(type, props) {
        if (isCustomComponent(type, props)) {
          return;
        }

        warnInvalidARIAProps(type, props);
      }

      var didWarnValueNull = false;

      function validateProperties$1(type, props) {
        {
          if (type !== "input" && type !== "textarea" && type !== "select") {
            return;
          }

          if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;

            if (type === "select" && props.multiple) {
              error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            } else {
              error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
            }
          }
        }
      }

      var possibleStandardNames = {
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
      };

      var validateProperty$1 = function validateProperty$1() {};

      {
        var warnedProperties$1 = {};
        var EVENT_NAME_REGEX = /^on./;
        var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
        var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
        var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");

        validateProperty$1 = function validateProperty$1(tagName, name, value, eventRegistry) {
          if (hasOwnProperty2.call(warnedProperties$1, name) && warnedProperties$1[name]) {
            return true;
          }

          var lowerCasedName = name.toLowerCase();

          if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
          }

          if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies,
                possibleRegistrationNames = eventRegistry.possibleRegistrationNames;

            if (registrationNameDependencies.hasOwnProperty(name)) {
              return true;
            }

            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

            if (registrationName != null) {
              error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
              warnedProperties$1[name] = true;
              return true;
            }

            if (EVENT_NAME_REGEX.test(name)) {
              error("Unknown event handler property `%s`. It will be ignored.", name);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (EVENT_NAME_REGEX.test(name)) {
            if (INVALID_EVENT_NAME_REGEX.test(name)) {
              error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            }

            warnedProperties$1[name] = true;
            return true;
          }

          if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
            return true;
          }

          if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
          }

          if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
          }

          if (lowerCasedName === "is" && value !== null && value !== void 0 && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
          }

          if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
          }

          var propertyInfo = getPropertyInfo(name);
          var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED;

          if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];

            if (standardName !== name) {
              error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (!isReserved && name !== lowerCasedName) {
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
          }

          if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) {
              error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            } else {
              error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            }

            warnedProperties$1[name] = true;
            return true;
          }

          if (isReserved) {
            return true;
          }

          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
          }

          if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
          }

          return true;
        };
      }

      var warnUnknownProperties = function warnUnknownProperties(type, props, eventRegistry) {
        {
          var unknownProps = [];

          for (var key in props) {
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);

            if (!isValid) {
              unknownProps.push(key);
            }
          }

          var unknownPropString = unknownProps.map(function (prop) {
            return "`" + prop + "`";
          }).join(", ");

          if (unknownProps.length === 1) {
            error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
          } else if (unknownProps.length > 1) {
            error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
          }
        }
      };

      function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) {
          return;
        }

        warnUnknownProperties(type, props, eventRegistry);
      }

      var warnValidStyle = function warnValidStyle() {};

      {
        var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
        var msPattern = /^-ms-/;
        var hyphenPattern = /-(.)/g;
        var badStyleValueWithSemicolonPattern = /;\s*$/;
        var warnedStyleNames = {};
        var warnedStyleValues = {};
        var warnedForNaNValue = false;
        var warnedForInfinityValue = false;

        var camelize = function camelize(string) {
          return string.replace(hyphenPattern, function (_2, character) {
            return character.toUpperCase();
          });
        };

        var warnHyphenatedStyleName = function warnHyphenatedStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }

          warnedStyleNames[name] = true;
          error("Unsupported style property %s. Did you mean %s?", name, camelize(name.replace(msPattern, "ms-")));
        };

        var warnBadVendoredStyleName = function warnBadVendoredStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }

          warnedStyleNames[name] = true;
          error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
        };

        var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value) {
          if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
            return;
          }

          warnedStyleValues[value] = true;
          error("Style property values shouldn't contain a semicolon. Try \"%s: %s\" instead.", name, value.replace(badStyleValueWithSemicolonPattern, ""));
        };

        var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value) {
          if (warnedForNaNValue) {
            return;
          }

          warnedForNaNValue = true;
          error("`NaN` is an invalid value for the `%s` css style property.", name);
        };

        var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value) {
          if (warnedForInfinityValue) {
            return;
          }

          warnedForInfinityValue = true;
          error("`Infinity` is an invalid value for the `%s` css style property.", name);
        };

        warnValidStyle = function warnValidStyle(name, value) {
          if (name.indexOf("-") > -1) {
            warnHyphenatedStyleName(name);
          } else if (badVendoredStyleNamePattern.test(name)) {
            warnBadVendoredStyleName(name);
          } else if (badStyleValueWithSemicolonPattern.test(value)) {
            warnStyleValueWithSemicolon(name, value);
          }

          if (typeof value === "number") {
            if (isNaN(value)) {
              warnStyleValueIsNaN(name, value);
            } else if (!isFinite(value)) {
              warnStyleValueIsInfinity(name, value);
            }
          }
        };
      }
      var warnValidStyle$1 = warnValidStyle;
      var matchHtmlRegExp = /["'&<>]/;

      function escapeHtml(string) {
        {
          checkHtmlStringCoercion(string);
        }
        var str = "" + string;
        var match = matchHtmlRegExp.exec(str);

        if (!match) {
          return str;
        }

        var escape;
        var html = "";
        var index;
        var lastIndex = 0;

        for (index = match.index; index < str.length; index++) {
          switch (str.charCodeAt(index)) {
            case 34:
              escape = "&quot;";
              break;

            case 38:
              escape = "&amp;";
              break;

            case 39:
              escape = "&#x27;";
              break;

            case 60:
              escape = "&lt;";
              break;

            case 62:
              escape = "&gt;";
              break;

            default:
              continue;
          }

          if (lastIndex !== index) {
            html += str.substring(lastIndex, index);
          }

          lastIndex = index + 1;
          html += escape;
        }

        return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
      }

      function escapeTextForBrowser(text) {
        if (typeof text === "boolean" || typeof text === "number") {
          return "" + text;
        }

        return escapeHtml(text);
      }

      var uppercasePattern = /([A-Z])/g;
      var msPattern$1 = /^ms-/;

      function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-");
      }

      var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
      var didWarn = false;

      function sanitizeURL(url) {
        {
          if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
          }
        }
      }

      var isArrayImpl = Array.isArray;

      function isArray2(a2) {
        return isArrayImpl(a2);
      }

      var startInlineScript = stringToPrecomputedChunk("<script>");
      var endInlineScript = stringToPrecomputedChunk("<\/script>");
      var startScriptSrc = stringToPrecomputedChunk('<script src="');
      var startModuleSrc = stringToPrecomputedChunk('<script type="module" src="');
      var endAsyncScript = stringToPrecomputedChunk('" async=""><\/script>');

      function escapeBootstrapScriptContent(scriptText) {
        {
          checkHtmlStringCoercion(scriptText);
        }
        return ("" + scriptText).replace(scriptRegex, scriptReplacer);
      }

      var scriptRegex = /(<\/|<)(s)(cript)/gi;

      var scriptReplacer = function scriptReplacer(match, prefix2, s2, suffix) {
        return "" + prefix2 + (s2 === "s" ? "\\u0073" : "\\u0053") + suffix;
      };

      function createResponseState(identifierPrefix, nonce, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
        var idPrefix = identifierPrefix === void 0 ? "" : identifierPrefix;
        var inlineScriptWithNonce = nonce === void 0 ? startInlineScript : stringToPrecomputedChunk('<script nonce="' + escapeTextForBrowser(nonce) + '">');
        var bootstrapChunks = [];

        if (bootstrapScriptContent !== void 0) {
          bootstrapChunks.push(inlineScriptWithNonce, stringToChunk(escapeBootstrapScriptContent(bootstrapScriptContent)), endInlineScript);
        }

        if (bootstrapScripts !== void 0) {
          for (var i2 = 0; i2 < bootstrapScripts.length; i2++) {
            bootstrapChunks.push(startScriptSrc, stringToChunk(escapeTextForBrowser(bootstrapScripts[i2])), endAsyncScript);
          }
        }

        if (bootstrapModules !== void 0) {
          for (var _i = 0; _i < bootstrapModules.length; _i++) {
            bootstrapChunks.push(startModuleSrc, stringToChunk(escapeTextForBrowser(bootstrapModules[_i])), endAsyncScript);
          }
        }

        return {
          bootstrapChunks: bootstrapChunks,
          startInlineScript: inlineScriptWithNonce,
          placeholderPrefix: stringToPrecomputedChunk(idPrefix + "P:"),
          segmentPrefix: stringToPrecomputedChunk(idPrefix + "S:"),
          boundaryPrefix: idPrefix + "B:",
          idPrefix: idPrefix,
          nextSuspenseID: 0,
          sentCompleteSegmentFunction: false,
          sentCompleteBoundaryFunction: false,
          sentClientRenderFunction: false
        };
      }

      var ROOT_HTML_MODE = 0;
      var HTML_MODE = 1;
      var SVG_MODE = 2;
      var MATHML_MODE = 3;
      var HTML_TABLE_MODE = 4;
      var HTML_TABLE_BODY_MODE = 5;
      var HTML_TABLE_ROW_MODE = 6;
      var HTML_COLGROUP_MODE = 7;

      function createFormatContext(insertionMode, selectedValue) {
        return {
          insertionMode: insertionMode,
          selectedValue: selectedValue
        };
      }

      function createRootFormatContext(namespaceURI) {
        var insertionMode = namespaceURI === "http://www.w3.org/2000/svg" ? SVG_MODE : namespaceURI === "http://www.w3.org/1998/Math/MathML" ? MATHML_MODE : ROOT_HTML_MODE;
        return createFormatContext(insertionMode, null);
      }

      function getChildFormatContext(parentContext, type, props) {
        switch (type) {
          case "select":
            return createFormatContext(HTML_MODE, props.value != null ? props.value : props.defaultValue);

          case "svg":
            return createFormatContext(SVG_MODE, null);

          case "math":
            return createFormatContext(MATHML_MODE, null);

          case "foreignObject":
            return createFormatContext(HTML_MODE, null);

          case "table":
            return createFormatContext(HTML_TABLE_MODE, null);

          case "thead":
          case "tbody":
          case "tfoot":
            return createFormatContext(HTML_TABLE_BODY_MODE, null);

          case "colgroup":
            return createFormatContext(HTML_COLGROUP_MODE, null);

          case "tr":
            return createFormatContext(HTML_TABLE_ROW_MODE, null);
        }

        if (parentContext.insertionMode >= HTML_TABLE_MODE) {
          return createFormatContext(HTML_MODE, null);
        }

        if (parentContext.insertionMode === ROOT_HTML_MODE) {
          return createFormatContext(HTML_MODE, null);
        }

        return parentContext;
      }

      var UNINITIALIZED_SUSPENSE_BOUNDARY_ID = null;

      function assignSuspenseBoundaryID(responseState) {
        var generatedID = responseState.nextSuspenseID++;
        return stringToPrecomputedChunk(responseState.boundaryPrefix + generatedID.toString(16));
      }

      function makeId(responseState, treeId, localId) {
        var idPrefix = responseState.idPrefix;
        var id = ":" + idPrefix + "R" + treeId;

        if (localId > 0) {
          id += "H" + localId.toString(32);
        }

        return id + ":";
      }

      function encodeHTMLTextNode(text) {
        return escapeTextForBrowser(text);
      }

      var textSeparator = stringToPrecomputedChunk("<!-- -->");

      function pushTextInstance(target, text, responseState, textEmbedded) {
        if (text === "") {
          return textEmbedded;
        }

        if (textEmbedded) {
          target.push(textSeparator);
        }

        target.push(stringToChunk(encodeHTMLTextNode(text)));
        return true;
      }

      function pushSegmentFinale(target, responseState, lastPushedText, textEmbedded) {
        if (lastPushedText && textEmbedded) {
          target.push(textSeparator);
        }
      }

      var styleNameCache = /* @__PURE__ */new Map();

      function processStyleName(styleName) {
        var chunk = styleNameCache.get(styleName);

        if (chunk !== void 0) {
          return chunk;
        }

        var result = stringToPrecomputedChunk(escapeTextForBrowser(hyphenateStyleName(styleName)));
        styleNameCache.set(styleName, result);
        return result;
      }

      var styleAttributeStart = stringToPrecomputedChunk(' style="');
      var styleAssign = stringToPrecomputedChunk(":");
      var styleSeparator = stringToPrecomputedChunk(";");

      function pushStyle(target, responseState, style) {
        if (typeof style !== "object") {
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        }

        var isFirst = true;

        for (var styleName in style) {
          if (!hasOwnProperty2.call(style, styleName)) {
            continue;
          }

          var styleValue = style[styleName];

          if (styleValue == null || typeof styleValue === "boolean" || styleValue === "") {
            continue;
          }

          var nameChunk = void 0;
          var valueChunk = void 0;
          var isCustomProperty = styleName.indexOf("--") === 0;

          if (isCustomProperty) {
            nameChunk = stringToChunk(escapeTextForBrowser(styleName));
            {
              checkCSSPropertyStringCoercion(styleValue, styleName);
            }
            valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
          } else {
            {
              warnValidStyle$1(styleName, styleValue);
            }
            nameChunk = processStyleName(styleName);

            if (typeof styleValue === "number") {
              if (styleValue !== 0 && !hasOwnProperty2.call(isUnitlessNumber, styleName)) {
                valueChunk = stringToChunk(styleValue + "px");
              } else {
                valueChunk = stringToChunk("" + styleValue);
              }
            } else {
              {
                checkCSSPropertyStringCoercion(styleValue, styleName);
              }
              valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
            }
          }

          if (isFirst) {
            isFirst = false;
            target.push(styleAttributeStart, nameChunk, styleAssign, valueChunk);
          } else {
            target.push(styleSeparator, nameChunk, styleAssign, valueChunk);
          }
        }

        if (!isFirst) {
          target.push(attributeEnd);
        }
      }

      var attributeSeparator = stringToPrecomputedChunk(" ");
      var attributeAssign = stringToPrecomputedChunk('="');
      var attributeEnd = stringToPrecomputedChunk('"');
      var attributeEmptyString = stringToPrecomputedChunk('=""');

      function pushAttribute(target, responseState, name, value) {
        switch (name) {
          case "style":
            {
              pushStyle(target, responseState, value);
              return;
            }

          case "defaultValue":
          case "defaultChecked":
          case "innerHTML":
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            return;
        }

        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) {
          return;
        }

        var propertyInfo = getPropertyInfo(name);

        if (propertyInfo !== null) {
          switch (typeof value) {
            case "function":
            case "symbol":
              return;

            case "boolean":
              {
                if (!propertyInfo.acceptsBooleans) {
                  return;
                }
              }
          }

          var attributeName = propertyInfo.attributeName;
          var attributeNameChunk = stringToChunk(attributeName);

          switch (propertyInfo.type) {
            case BOOLEAN:
              if (value) {
                target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
              }

              return;

            case OVERLOADED_BOOLEAN:
              if (value === true) {
                target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
              } else if (value === false) ;else {
                target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
              }

              return;

            case NUMERIC:
              if (!isNaN(value)) {
                target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
              }

              break;

            case POSITIVE_NUMERIC:
              if (!isNaN(value) && value >= 1) {
                target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
              }

              break;

            default:
              if (propertyInfo.sanitizeURL) {
                {
                  checkAttributeStringCoercion(value, attributeName);
                }
                value = "" + value;
                sanitizeURL(value);
              }

              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
          }
        } else if (isAttributeNameSafe(name)) {
          switch (typeof value) {
            case "function":
            case "symbol":
              return;

            case "boolean":
              {
                var prefix2 = name.toLowerCase().slice(0, 5);

                if (prefix2 !== "data-" && prefix2 !== "aria-") {
                  return;
                }
              }
          }

          target.push(attributeSeparator, stringToChunk(name), attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
        }
      }

      var endOfStartTag = stringToPrecomputedChunk(">");
      var endOfStartTagSelfClosing = stringToPrecomputedChunk("/>");

      function pushInnerHTML(target, innerHTML, children) {
        if (innerHTML != null) {
          if (children != null) {
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          }

          if (typeof innerHTML !== "object" || !("__html" in innerHTML)) {
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
          }

          var html = innerHTML.__html;

          if (html !== null && html !== void 0) {
            {
              checkHtmlStringCoercion(html);
            }
            target.push(stringToChunk("" + html));
          }
        }
      }

      var didWarnDefaultInputValue = false;
      var didWarnDefaultChecked = false;
      var didWarnDefaultSelectValue = false;
      var didWarnDefaultTextareaValue = false;
      var didWarnInvalidOptionChildren = false;
      var didWarnInvalidOptionInnerHTML = false;
      var didWarnSelectedSetOnOption = false;

      function checkSelectProp(props, propName) {
        {
          var value = props[propName];

          if (value != null) {
            var array = isArray2(value);

            if (props.multiple && !array) {
              error("The `%s` prop supplied to <select> must be an array if `multiple` is true.", propName);
            } else if (!props.multiple && array) {
              error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", propName);
            }
          }
        }
      }

      function pushStartSelect(target, props, responseState) {
        {
          checkControlledValueProps("select", props);
          checkSelectProp(props, "value");
          checkSelectProp(props, "defaultValue");

          if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnDefaultSelectValue) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnDefaultSelectValue = true;
          }
        }
        target.push(startChunkForTag("select"));
        var children = null;
        var innerHTML = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;

              case "defaultValue":
              case "value":
                break;

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
      }

      function flattenOptionChildren(children) {
        var content = "";
        React.Children.forEach(children, function (child) {
          if (child == null) {
            return;
          }

          content += child;
          {
            if (!didWarnInvalidOptionChildren && typeof child !== "string" && typeof child !== "number") {
              didWarnInvalidOptionChildren = true;
              error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
            }
          }
        });
        return content;
      }

      var selectedMarkerAttribute = stringToPrecomputedChunk(' selected=""');

      function pushStartOption(target, props, responseState, formatContext) {
        var selectedValue = formatContext.selectedValue;
        target.push(startChunkForTag("option"));
        var children = null;
        var value = null;
        var selected = null;
        var innerHTML = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "selected":
                selected = propValue;
                {
                  if (!didWarnSelectedSetOnOption) {
                    error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
                    didWarnSelectedSetOnOption = true;
                  }
                }
                break;

              case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;

              case "value":
                value = propValue;

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        if (selectedValue != null) {
          var stringValue;

          if (value !== null) {
            {
              checkAttributeStringCoercion(value, "value");
            }
            stringValue = "" + value;
          } else {
            {
              if (innerHTML !== null) {
                if (!didWarnInvalidOptionInnerHTML) {
                  didWarnInvalidOptionInnerHTML = true;
                  error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
              }
            }
            stringValue = flattenOptionChildren(children);
          }

          if (isArray2(selectedValue)) {
            for (var i2 = 0; i2 < selectedValue.length; i2++) {
              {
                checkAttributeStringCoercion(selectedValue[i2], "value");
              }
              var v2 = "" + selectedValue[i2];

              if (v2 === stringValue) {
                target.push(selectedMarkerAttribute);
                break;
              }
            }
          } else {
            {
              checkAttributeStringCoercion(selectedValue, "select.value");
            }

            if ("" + selectedValue === stringValue) {
              target.push(selectedMarkerAttribute);
            }
          }
        } else if (selected) {
          target.push(selectedMarkerAttribute);
        }

        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
      }

      function pushInput(target, props, responseState) {
        {
          checkControlledValueProps("input", props);

          if (props.checked !== void 0 && props.defaultChecked !== void 0 && !didWarnDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
            didWarnDefaultChecked = true;
          }

          if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnDefaultInputValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
            didWarnDefaultInputValue = true;
          }
        }
        target.push(startChunkForTag("input"));
        var value = null;
        var defaultValue = null;
        var checked = null;
        var defaultChecked = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");

              case "defaultChecked":
                defaultChecked = propValue;
                break;

              case "defaultValue":
                defaultValue = propValue;
                break;

              case "checked":
                checked = propValue;
                break;

              case "value":
                value = propValue;
                break;

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        if (checked !== null) {
          pushAttribute(target, responseState, "checked", checked);
        } else if (defaultChecked !== null) {
          pushAttribute(target, responseState, "checked", defaultChecked);
        }

        if (value !== null) {
          pushAttribute(target, responseState, "value", value);
        } else if (defaultValue !== null) {
          pushAttribute(target, responseState, "value", defaultValue);
        }

        target.push(endOfStartTagSelfClosing);
        return null;
      }

      function pushStartTextArea(target, props, responseState) {
        {
          checkControlledValueProps("textarea", props);

          if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnDefaultTextareaValue) {
            error("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnDefaultTextareaValue = true;
          }
        }
        target.push(startChunkForTag("textarea"));
        var value = null;
        var defaultValue = null;
        var children = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "value":
                value = propValue;
                break;

              case "defaultValue":
                defaultValue = propValue;
                break;

              case "dangerouslySetInnerHTML":
                throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        if (value === null && defaultValue !== null) {
          value = defaultValue;
        }

        target.push(endOfStartTag);

        if (children != null) {
          {
            error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          }

          if (value != null) {
            throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
          }

          if (isArray2(children)) {
            if (children.length > 1) {
              throw new Error("<textarea> can only have at most one child.");
            }

            {
              checkHtmlStringCoercion(children[0]);
            }
            value = "" + children[0];
          }

          {
            checkHtmlStringCoercion(children);
          }
          value = "" + children;
        }

        if (typeof value === "string" && value[0] === "\n") {
          target.push(leadingNewline);
        }

        if (value !== null) {
          {
            checkAttributeStringCoercion(value, "value");
          }
          target.push(stringToChunk(encodeHTMLTextNode("" + value)));
        }

        return null;
      }

      function pushSelfClosing(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw new Error(tag + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTagSelfClosing);
        return null;
      }

      function pushStartMenuItem(target, props, responseState) {
        target.push(startChunkForTag("menuitem"));

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTag);
        return null;
      }

      function pushStartTitle(target, props, responseState) {
        target.push(startChunkForTag("title"));
        var children = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "dangerouslySetInnerHTML":
                throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTag);
        {
          var child = Array.isArray(children) && children.length < 2 ? children[0] || null : children;

          if (Array.isArray(children) && children.length > 1) {
            error("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
          } else if (child != null && child.$$typeof != null) {
            error("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
          } else if (child != null && typeof child !== "string" && typeof child !== "number") {
            error("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
          }
        }
        return children;
      }

      function pushStartGenericElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);

        if (typeof children === "string") {
          target.push(stringToChunk(encodeHTMLTextNode(children)));
          return null;
        }

        return children;
      }

      function pushStartCustomElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;

              case "style":
                pushStyle(target, responseState, propValue);
                break;

              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
                break;

              default:
                if (isAttributeNameSafe(propKey) && typeof propValue !== "function" && typeof propValue !== "symbol") {
                  target.push(attributeSeparator, stringToChunk(propKey), attributeAssign, stringToChunk(escapeTextForBrowser(propValue)), attributeEnd);
                }

                break;
            }
          }
        }

        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
      }

      var leadingNewline = stringToPrecomputedChunk("\n");

      function pushStartPreformattedElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;

        for (var propKey in props) {
          if (hasOwnProperty2.call(props, propKey)) {
            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            switch (propKey) {
              case "children":
                children = propValue;
                break;

              case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;

              default:
                pushAttribute(target, responseState, propKey, propValue);
                break;
            }
          }
        }

        target.push(endOfStartTag);

        if (innerHTML != null) {
          if (children != null) {
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          }

          if (typeof innerHTML !== "object" || !("__html" in innerHTML)) {
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
          }

          var html = innerHTML.__html;

          if (html !== null && html !== void 0) {
            if (typeof html === "string" && html.length > 0 && html[0] === "\n") {
              target.push(leadingNewline, stringToChunk(html));
            } else {
              {
                checkHtmlStringCoercion(html);
              }
              target.push(stringToChunk("" + html));
            }
          }
        }

        if (typeof children === "string" && children[0] === "\n") {
          target.push(leadingNewline);
        }

        return children;
      }

      var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
      var validatedTagCache = /* @__PURE__ */new Map();

      function startChunkForTag(tag) {
        var tagStartChunk = validatedTagCache.get(tag);

        if (tagStartChunk === void 0) {
          if (!VALID_TAG_REGEX.test(tag)) {
            throw new Error("Invalid tag: " + tag);
          }

          tagStartChunk = stringToPrecomputedChunk("<" + tag);
          validatedTagCache.set(tag, tagStartChunk);
        }

        return tagStartChunk;
      }

      var DOCTYPE = stringToPrecomputedChunk("<!DOCTYPE html>");

      function pushStartInstance(target, type, props, responseState, formatContext) {
        {
          validateProperties(type, props);
          validateProperties$1(type, props);
          validateProperties$2(type, props, null);

          if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
            error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
          }

          if (formatContext.insertionMode !== SVG_MODE && formatContext.insertionMode !== MATHML_MODE) {
            if (type.indexOf("-") === -1 && typeof props.is !== "string" && type.toLowerCase() !== type) {
              error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            }
          }
        }

        switch (type) {
          case "select":
            return pushStartSelect(target, props, responseState);

          case "option":
            return pushStartOption(target, props, responseState, formatContext);

          case "textarea":
            return pushStartTextArea(target, props, responseState);

          case "input":
            return pushInput(target, props, responseState);

          case "menuitem":
            return pushStartMenuItem(target, props, responseState);

          case "title":
            return pushStartTitle(target, props, responseState);

          case "listing":
          case "pre":
            {
              return pushStartPreformattedElement(target, props, type, responseState);
            }

          case "area":
          case "base":
          case "br":
          case "col":
          case "embed":
          case "hr":
          case "img":
          case "keygen":
          case "link":
          case "meta":
          case "param":
          case "source":
          case "track":
          case "wbr":
            {
              return pushSelfClosing(target, props, type, responseState);
            }

          case "annotation-xml":
          case "color-profile":
          case "font-face":
          case "font-face-src":
          case "font-face-uri":
          case "font-face-format":
          case "font-face-name":
          case "missing-glyph":
            {
              return pushStartGenericElement(target, props, type, responseState);
            }

          case "html":
            {
              if (formatContext.insertionMode === ROOT_HTML_MODE) {
                target.push(DOCTYPE);
              }

              return pushStartGenericElement(target, props, type, responseState);
            }

          default:
            {
              if (type.indexOf("-") === -1 && typeof props.is !== "string") {
                return pushStartGenericElement(target, props, type, responseState);
              } else {
                return pushStartCustomElement(target, props, type, responseState);
              }
            }
        }
      }

      var endTag1 = stringToPrecomputedChunk("</");
      var endTag2 = stringToPrecomputedChunk(">");

      function pushEndInstance(target, type, props) {
        switch (type) {
          case "area":
          case "base":
          case "br":
          case "col":
          case "embed":
          case "hr":
          case "img":
          case "input":
          case "keygen":
          case "link":
          case "meta":
          case "param":
          case "source":
          case "track":
          case "wbr":
            {
              break;
            }

          default:
            {
              target.push(endTag1, stringToChunk(type), endTag2);
            }
        }
      }

      function writeCompletedRoot(destination, responseState) {
        var bootstrapChunks = responseState.bootstrapChunks;
        var i2 = 0;

        for (; i2 < bootstrapChunks.length - 1; i2++) {
          writeChunk(destination, bootstrapChunks[i2]);
        }

        if (i2 < bootstrapChunks.length) {
          return writeChunkAndReturn(destination, bootstrapChunks[i2]);
        }

        return true;
      }

      var placeholder1 = stringToPrecomputedChunk('<template id="');
      var placeholder2 = stringToPrecomputedChunk('"></template>');

      function writePlaceholder(destination, responseState, id) {
        writeChunk(destination, placeholder1);
        writeChunk(destination, responseState.placeholderPrefix);
        var formattedID = stringToChunk(id.toString(16));
        writeChunk(destination, formattedID);
        return writeChunkAndReturn(destination, placeholder2);
      }

      var startCompletedSuspenseBoundary = stringToPrecomputedChunk("<!--$-->");
      var startPendingSuspenseBoundary1 = stringToPrecomputedChunk('<!--$?--><template id="');
      var startPendingSuspenseBoundary2 = stringToPrecomputedChunk('"></template>');
      var startClientRenderedSuspenseBoundary = stringToPrecomputedChunk("<!--$!-->");
      var endSuspenseBoundary = stringToPrecomputedChunk("<!--/$-->");
      var clientRenderedSuspenseBoundaryError1 = stringToPrecomputedChunk("<template");
      var clientRenderedSuspenseBoundaryErrorAttrInterstitial = stringToPrecomputedChunk('"');
      var clientRenderedSuspenseBoundaryError1A = stringToPrecomputedChunk(' data-dgst="');
      var clientRenderedSuspenseBoundaryError1B = stringToPrecomputedChunk(' data-msg="');
      var clientRenderedSuspenseBoundaryError1C = stringToPrecomputedChunk(' data-stck="');
      var clientRenderedSuspenseBoundaryError2 = stringToPrecomputedChunk("></template>");

      function writeStartCompletedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, startCompletedSuspenseBoundary);
      }

      function writeStartPendingSuspenseBoundary(destination, responseState, id) {
        writeChunk(destination, startPendingSuspenseBoundary1);

        if (id === null) {
          throw new Error("An ID must have been assigned before we can complete the boundary.");
        }

        writeChunk(destination, id);
        return writeChunkAndReturn(destination, startPendingSuspenseBoundary2);
      }

      function writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMesssage, errorComponentStack) {
        var result;
        result = writeChunkAndReturn(destination, startClientRenderedSuspenseBoundary);
        writeChunk(destination, clientRenderedSuspenseBoundaryError1);

        if (errorDigest) {
          writeChunk(destination, clientRenderedSuspenseBoundaryError1A);
          writeChunk(destination, stringToChunk(escapeTextForBrowser(errorDigest)));
          writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
        }

        {
          if (errorMesssage) {
            writeChunk(destination, clientRenderedSuspenseBoundaryError1B);
            writeChunk(destination, stringToChunk(escapeTextForBrowser(errorMesssage)));
            writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
          }

          if (errorComponentStack) {
            writeChunk(destination, clientRenderedSuspenseBoundaryError1C);
            writeChunk(destination, stringToChunk(escapeTextForBrowser(errorComponentStack)));
            writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
          }
        }
        result = writeChunkAndReturn(destination, clientRenderedSuspenseBoundaryError2);
        return result;
      }

      function writeEndCompletedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
      }

      function writeEndPendingSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
      }

      function writeEndClientRenderedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
      }

      var startSegmentHTML = stringToPrecomputedChunk('<div hidden id="');
      var startSegmentHTML2 = stringToPrecomputedChunk('">');
      var endSegmentHTML = stringToPrecomputedChunk("</div>");
      var startSegmentSVG = stringToPrecomputedChunk('<svg aria-hidden="true" style="display:none" id="');
      var startSegmentSVG2 = stringToPrecomputedChunk('">');
      var endSegmentSVG = stringToPrecomputedChunk("</svg>");
      var startSegmentMathML = stringToPrecomputedChunk('<math aria-hidden="true" style="display:none" id="');
      var startSegmentMathML2 = stringToPrecomputedChunk('">');
      var endSegmentMathML = stringToPrecomputedChunk("</math>");
      var startSegmentTable = stringToPrecomputedChunk('<table hidden id="');
      var startSegmentTable2 = stringToPrecomputedChunk('">');
      var endSegmentTable = stringToPrecomputedChunk("</table>");
      var startSegmentTableBody = stringToPrecomputedChunk('<table hidden><tbody id="');
      var startSegmentTableBody2 = stringToPrecomputedChunk('">');
      var endSegmentTableBody = stringToPrecomputedChunk("</tbody></table>");
      var startSegmentTableRow = stringToPrecomputedChunk('<table hidden><tr id="');
      var startSegmentTableRow2 = stringToPrecomputedChunk('">');
      var endSegmentTableRow = stringToPrecomputedChunk("</tr></table>");
      var startSegmentColGroup = stringToPrecomputedChunk('<table hidden><colgroup id="');
      var startSegmentColGroup2 = stringToPrecomputedChunk('">');
      var endSegmentColGroup = stringToPrecomputedChunk("</colgroup></table>");

      function writeStartSegment(destination, responseState, formatContext, id) {
        switch (formatContext.insertionMode) {
          case ROOT_HTML_MODE:
          case HTML_MODE:
            {
              writeChunk(destination, startSegmentHTML);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentHTML2);
            }

          case SVG_MODE:
            {
              writeChunk(destination, startSegmentSVG);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentSVG2);
            }

          case MATHML_MODE:
            {
              writeChunk(destination, startSegmentMathML);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentMathML2);
            }

          case HTML_TABLE_MODE:
            {
              writeChunk(destination, startSegmentTable);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentTable2);
            }

          case HTML_TABLE_BODY_MODE:
            {
              writeChunk(destination, startSegmentTableBody);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentTableBody2);
            }

          case HTML_TABLE_ROW_MODE:
            {
              writeChunk(destination, startSegmentTableRow);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentTableRow2);
            }

          case HTML_COLGROUP_MODE:
            {
              writeChunk(destination, startSegmentColGroup);
              writeChunk(destination, responseState.segmentPrefix);
              writeChunk(destination, stringToChunk(id.toString(16)));
              return writeChunkAndReturn(destination, startSegmentColGroup2);
            }

          default:
            {
              throw new Error("Unknown insertion mode. This is a bug in React.");
            }
        }
      }

      function writeEndSegment(destination, formatContext) {
        switch (formatContext.insertionMode) {
          case ROOT_HTML_MODE:
          case HTML_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentHTML);
            }

          case SVG_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentSVG);
            }

          case MATHML_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentMathML);
            }

          case HTML_TABLE_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentTable);
            }

          case HTML_TABLE_BODY_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentTableBody);
            }

          case HTML_TABLE_ROW_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentTableRow);
            }

          case HTML_COLGROUP_MODE:
            {
              return writeChunkAndReturn(destination, endSegmentColGroup);
            }

          default:
            {
              throw new Error("Unknown insertion mode. This is a bug in React.");
            }
        }
      }

      var completeSegmentFunction = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}";
      var completeBoundaryFunction = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}';
      var clientRenderFunction = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}';
      var completeSegmentScript1Full = stringToPrecomputedChunk(completeSegmentFunction + ';$RS("');
      var completeSegmentScript1Partial = stringToPrecomputedChunk('$RS("');
      var completeSegmentScript2 = stringToPrecomputedChunk('","');
      var completeSegmentScript3 = stringToPrecomputedChunk('")<\/script>');

      function writeCompletedSegmentInstruction(destination, responseState, contentSegmentID) {
        writeChunk(destination, responseState.startInlineScript);

        if (!responseState.sentCompleteSegmentFunction) {
          responseState.sentCompleteSegmentFunction = true;
          writeChunk(destination, completeSegmentScript1Full);
        } else {
          writeChunk(destination, completeSegmentScript1Partial);
        }

        writeChunk(destination, responseState.segmentPrefix);
        var formattedID = stringToChunk(contentSegmentID.toString(16));
        writeChunk(destination, formattedID);
        writeChunk(destination, completeSegmentScript2);
        writeChunk(destination, responseState.placeholderPrefix);
        writeChunk(destination, formattedID);
        return writeChunkAndReturn(destination, completeSegmentScript3);
      }

      var completeBoundaryScript1Full = stringToPrecomputedChunk(completeBoundaryFunction + ';$RC("');
      var completeBoundaryScript1Partial = stringToPrecomputedChunk('$RC("');
      var completeBoundaryScript2 = stringToPrecomputedChunk('","');
      var completeBoundaryScript3 = stringToPrecomputedChunk('")<\/script>');

      function writeCompletedBoundaryInstruction(destination, responseState, boundaryID, contentSegmentID) {
        writeChunk(destination, responseState.startInlineScript);

        if (!responseState.sentCompleteBoundaryFunction) {
          responseState.sentCompleteBoundaryFunction = true;
          writeChunk(destination, completeBoundaryScript1Full);
        } else {
          writeChunk(destination, completeBoundaryScript1Partial);
        }

        if (boundaryID === null) {
          throw new Error("An ID must have been assigned before we can complete the boundary.");
        }

        var formattedContentID = stringToChunk(contentSegmentID.toString(16));
        writeChunk(destination, boundaryID);
        writeChunk(destination, completeBoundaryScript2);
        writeChunk(destination, responseState.segmentPrefix);
        writeChunk(destination, formattedContentID);
        return writeChunkAndReturn(destination, completeBoundaryScript3);
      }

      var clientRenderScript1Full = stringToPrecomputedChunk(clientRenderFunction + ';$RX("');
      var clientRenderScript1Partial = stringToPrecomputedChunk('$RX("');
      var clientRenderScript1A = stringToPrecomputedChunk('"');
      var clientRenderScript2 = stringToPrecomputedChunk(")<\/script>");
      var clientRenderErrorScriptArgInterstitial = stringToPrecomputedChunk(",");

      function writeClientRenderBoundaryInstruction(destination, responseState, boundaryID, errorDigest, errorMessage, errorComponentStack) {
        writeChunk(destination, responseState.startInlineScript);

        if (!responseState.sentClientRenderFunction) {
          responseState.sentClientRenderFunction = true;
          writeChunk(destination, clientRenderScript1Full);
        } else {
          writeChunk(destination, clientRenderScript1Partial);
        }

        if (boundaryID === null) {
          throw new Error("An ID must have been assigned before we can complete the boundary.");
        }

        writeChunk(destination, boundaryID);
        writeChunk(destination, clientRenderScript1A);

        if (errorDigest || errorMessage || errorComponentStack) {
          writeChunk(destination, clientRenderErrorScriptArgInterstitial);
          writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorDigest || "")));
        }

        if (errorMessage || errorComponentStack) {
          writeChunk(destination, clientRenderErrorScriptArgInterstitial);
          writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorMessage || "")));
        }

        if (errorComponentStack) {
          writeChunk(destination, clientRenderErrorScriptArgInterstitial);
          writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorComponentStack)));
        }

        return writeChunkAndReturn(destination, clientRenderScript2);
      }

      var regexForJSStringsInScripts = /[<\u2028\u2029]/g;

      function escapeJSStringsForInstructionScripts(input) {
        var escaped = JSON.stringify(input);
        return escaped.replace(regexForJSStringsInScripts, function (match) {
          switch (match) {
            case "<":
              return "\\u003c";

            case "\u2028":
              return "\\u2028";

            case "\u2029":
              return "\\u2029";

            default:
              {
                throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
              }
          }
        });
      }

      var assign = Object.assign;
      var REACT_ELEMENT_TYPE2 = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_SCOPE_TYPE = Symbol.for("react.scope");
      var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
      var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
      var REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED = Symbol.for("react.default_value");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }

        return null;
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;

        if (displayName) {
          return displayName;
        }

        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }

      function getContextName(type) {
        return type.displayName || "Context";
      }

      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }

        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }

        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }

        if (typeof type === "string") {
          return type;
        }

        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";

          case REACT_PORTAL_TYPE:
            return "Portal";

          case REACT_PROFILER_TYPE:
            return "Profiler";

          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";

          case REACT_SUSPENSE_TYPE:
            return "Suspense";

          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }

        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");

            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;

              if (outerName !== null) {
                return outerName;
              }

              return getComponentNameFromType(type.type) || "Memo";

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentNameFromType(init(payload));
                } catch (x2) {
                  return null;
                }
              }
          }
        }

        return null;
      }

      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }

          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x2) {
              var match = x2.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }

          return "\n" + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          if (construct) {
            var Fake = function Fake() {
              throw Error();
            };

            Object.defineProperty(Fake.prototype, "props", {
              set: function set() {
                throw Error();
              }
            });

            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x2) {
                control = x2;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x2) {
                control = x2;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x2) {
              control = x2;
            }

            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s2 = sampleLines.length - 1;
            var c2 = controlLines.length - 1;

            while (s2 >= 1 && c2 >= 0 && sampleLines[s2] !== controlLines[c2]) {
              c2--;
            }

            for (; s2 >= 1 && c2 >= 0; s2--, c2--) {
              if (sampleLines[s2] !== controlLines[c2]) {
                if (s2 !== 1 || c2 !== 1) {
                  do {
                    s2--;
                    c2--;

                    if (c2 < 0 || sampleLines[s2] !== controlLines[c2]) {
                      var _frame = "\n" + sampleLines[s2].replace(" at new ", " at ");

                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }

                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s2 >= 1 && c2 >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }

        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeClassComponentFrame(ctor, source, ownerFn) {
        {
          return describeNativeComponentFrame(ctor, true);
        }
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component2) {
        var prototype = Component2.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }

        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }

        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x2) {}
              }
          }
        }

        return "";
      }

      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has2 = Function.call.bind(hasOwnProperty2);

          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$1 = void 0;

              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var warnedAboutMissingGetChildContext;
      {
        warnedAboutMissingGetChildContext = {};
      }
      var emptyContextObject = {};
      {
        Object.freeze(emptyContextObject);
      }

      function getMaskedContext(type, unmaskedContext) {
        {
          var contextTypes = type.contextTypes;

          if (!contextTypes) {
            return emptyContextObject;
          }

          var context = {};

          for (var key in contextTypes) {
            context[key] = unmaskedContext[key];
          }

          {
            var name = getComponentNameFromType(type) || "Unknown";
            checkPropTypes(contextTypes, context, "context", name);
          }
          return context;
        }
      }

      function processChildContext(instance, type, parentContext, childContextTypes) {
        {
          if (typeof instance.getChildContext !== "function") {
            {
              var componentName = getComponentNameFromType(type) || "Unknown";

              if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
              }
            }
            return parentContext;
          }

          var childContext = instance.getChildContext();

          for (var contextKey in childContext) {
            if (!(contextKey in childContextTypes)) {
              throw new Error((getComponentNameFromType(type) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
            }
          }

          {
            var name = getComponentNameFromType(type) || "Unknown";
            checkPropTypes(childContextTypes, childContext, "child context", name);
          }
          return assign({}, parentContext, childContext);
        }
      }

      var rendererSigil;
      {
        rendererSigil = {};
      }
      var rootContextSnapshot = null;
      var currentActiveSnapshot = null;

      function popNode(prev) {
        {
          prev.context._currentValue = prev.parentValue;
        }
      }

      function pushNode(next) {
        {
          next.context._currentValue = next.value;
        }
      }

      function popToNearestCommonAncestor(prev, next) {
        if (prev === next) ;else {
          popNode(prev);
          var parentPrev = prev.parent;
          var parentNext = next.parent;

          if (parentPrev === null) {
            if (parentNext !== null) {
              throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
            }
          } else {
            if (parentNext === null) {
              throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
            }

            popToNearestCommonAncestor(parentPrev, parentNext);
          }

          pushNode(next);
        }
      }

      function popAllPrevious(prev) {
        popNode(prev);
        var parentPrev = prev.parent;

        if (parentPrev !== null) {
          popAllPrevious(parentPrev);
        }
      }

      function pushAllNext(next) {
        var parentNext = next.parent;

        if (parentNext !== null) {
          pushAllNext(parentNext);
        }

        pushNode(next);
      }

      function popPreviousToCommonLevel(prev, next) {
        popNode(prev);
        var parentPrev = prev.parent;

        if (parentPrev === null) {
          throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
        }

        if (parentPrev.depth === next.depth) {
          popToNearestCommonAncestor(parentPrev, next);
        } else {
          popPreviousToCommonLevel(parentPrev, next);
        }
      }

      function popNextToCommonLevel(prev, next) {
        var parentNext = next.parent;

        if (parentNext === null) {
          throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
        }

        if (prev.depth === parentNext.depth) {
          popToNearestCommonAncestor(prev, parentNext);
        } else {
          popNextToCommonLevel(prev, parentNext);
        }

        pushNode(next);
      }

      function switchContext(newSnapshot) {
        var prev = currentActiveSnapshot;
        var next = newSnapshot;

        if (prev !== next) {
          if (prev === null) {
            pushAllNext(next);
          } else if (next === null) {
            popAllPrevious(prev);
          } else if (prev.depth === next.depth) {
            popToNearestCommonAncestor(prev, next);
          } else if (prev.depth > next.depth) {
            popPreviousToCommonLevel(prev, next);
          } else {
            popNextToCommonLevel(prev, next);
          }

          currentActiveSnapshot = next;
        }
      }

      function pushProvider(context, nextValue) {
        var prevValue;
        {
          prevValue = context._currentValue;
          context._currentValue = nextValue;
          {
            if (context._currentRenderer !== void 0 && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
              error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
            }

            context._currentRenderer = rendererSigil;
          }
        }
        var prevNode = currentActiveSnapshot;
        var newNode = {
          parent: prevNode,
          depth: prevNode === null ? 0 : prevNode.depth + 1,
          context: context,
          parentValue: prevValue,
          value: nextValue
        };
        currentActiveSnapshot = newNode;
        return newNode;
      }

      function popProvider(context) {
        var prevSnapshot = currentActiveSnapshot;

        if (prevSnapshot === null) {
          throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
        }

        {
          if (prevSnapshot.context !== context) {
            error("The parent context is not the expected context. This is probably a bug in React.");
          }
        }
        {
          var value = prevSnapshot.parentValue;

          if (value === REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED) {
            prevSnapshot.context._currentValue = prevSnapshot.context._defaultValue;
          } else {
            prevSnapshot.context._currentValue = value;
          }

          {
            if (context._currentRenderer !== void 0 && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
              error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
            }

            context._currentRenderer = rendererSigil;
          }
        }
        return currentActiveSnapshot = prevSnapshot.parent;
      }

      function getActiveContext() {
        return currentActiveSnapshot;
      }

      function readContext(context) {
        var value = context._currentValue;
        return value;
      }

      function get2(key) {
        return key._reactInternals;
      }

      function set(key, value) {
        key._reactInternals = value;
      }

      var didWarnAboutNoopUpdateForComponent = {};
      var didWarnAboutDeprecatedWillMount = {};
      var didWarnAboutUninitializedState;
      var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
      var didWarnAboutLegacyLifecyclesAndDerivedState;
      var didWarnAboutUndefinedDerivedState;
      var warnOnUndefinedDerivedState;
      var warnOnInvalidCallback;
      var didWarnAboutDirectlyAssigningPropsToState;
      var didWarnAboutContextTypeAndContextTypes;
      var didWarnAboutInvalidateContextType;
      {
        didWarnAboutUninitializedState = /* @__PURE__ */new Set();
        didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = /* @__PURE__ */new Set();
        didWarnAboutLegacyLifecyclesAndDerivedState = /* @__PURE__ */new Set();
        didWarnAboutDirectlyAssigningPropsToState = /* @__PURE__ */new Set();
        didWarnAboutUndefinedDerivedState = /* @__PURE__ */new Set();
        didWarnAboutContextTypeAndContextTypes = /* @__PURE__ */new Set();
        didWarnAboutInvalidateContextType = /* @__PURE__ */new Set();
        var didWarnOnInvalidCallback = /* @__PURE__ */new Set();

        warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
          if (callback === null || typeof callback === "function") {
            return;
          }

          var key = callerName + "_" + callback;

          if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
          }
        };

        warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(type, partialState) {
          if (partialState === void 0) {
            var componentName = getComponentNameFromType(type) || "Component";

            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
              didWarnAboutUndefinedDerivedState.add(componentName);
              error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
          }
        };
      }

      function warnNoop(publicInstance, callerName) {
        {
          var _constructor = publicInstance.constructor;
          var componentName = _constructor && getComponentNameFromType(_constructor) || "ReactClass";
          var warningKey = componentName + "." + callerName;

          if (didWarnAboutNoopUpdateForComponent[warningKey]) {
            return;
          }

          error("%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.\n\nPlease check the code for the %s component.", callerName, callerName, componentName);
          didWarnAboutNoopUpdateForComponent[warningKey] = true;
        }
      }

      var classComponentUpdater = {
        isMounted: function isMounted(inst) {
          return false;
        },
        enqueueSetState: function enqueueSetState(inst, payload, callback) {
          var internals = get2(inst);

          if (internals.queue === null) {
            warnNoop(inst, "setState");
          } else {
            internals.queue.push(payload);
            {
              if (callback !== void 0 && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
              }
            }
          }
        },
        enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
          var internals = get2(inst);
          internals.replace = true;
          internals.queue = [payload];
          {
            if (callback !== void 0 && callback !== null) {
              warnOnInvalidCallback(callback, "setState");
            }
          }
        },
        enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
          var internals = get2(inst);

          if (internals.queue === null) {
            warnNoop(inst, "forceUpdate");
          } else {
            {
              if (callback !== void 0 && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
              }
            }
          }
        }
      };

      function applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, prevState, nextProps) {
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        {
          warnOnUndefinedDerivedState(ctor, partialState);
        }
        var newState = partialState === null || partialState === void 0 ? prevState : assign({}, prevState, partialState);
        return newState;
      }

      function constructClassInstance(ctor, props, maskedLegacyContext) {
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        {
          if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== void 0 && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === void 0;

            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
              didWarnAboutInvalidateContextType.add(ctor);
              var addendum = "";

              if (contextType === void 0) {
                addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
              } else if (typeof contextType !== "object") {
                addendum = " However, it is set to a " + typeof contextType + ".";
              } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                addendum = " Did you accidentally pass the Context.Provider instead?";
              } else if (contextType._context !== void 0) {
                addendum = " Did you accidentally pass the Context.Consumer instead?";
              } else {
                addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
              }

              error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
          }
        }

        if (typeof contextType === "object" && contextType !== null) {
          context = readContext(contextType);
        } else {
          context = maskedLegacyContext;
        }

        var instance = new ctor(props, context);
        {
          if (typeof ctor.getDerivedStateFromProps === "function" && (instance.state === null || instance.state === void 0)) {
            var componentName = getComponentNameFromType(ctor) || "Component";

            if (!didWarnAboutUninitializedState.has(componentName)) {
              didWarnAboutUninitializedState.add(componentName);
              error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
          }

          if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;

            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) {
              foundWillMountName = "componentWillMount";
            } else if (typeof instance.UNSAFE_componentWillMount === "function") {
              foundWillMountName = "UNSAFE_componentWillMount";
            }

            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              foundWillReceivePropsName = "componentWillReceiveProps";
            } else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") {
              foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            }

            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              foundWillUpdateName = "componentWillUpdate";
            } else if (typeof instance.UNSAFE_componentWillUpdate === "function") {
              foundWillUpdateName = "UNSAFE_componentWillUpdate";
            }

            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
              var _componentName = getComponentNameFromType(ctor) || "Component";

              var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";

              if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
              }
            }
          }
        }
        return instance;
      }

      function checkClassInstance(instance, ctor, newProps) {
        {
          var name = getComponentNameFromType(ctor) || "Component";
          var renderPresent = instance.render;

          if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") {
              error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            } else {
              error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
            }
          }

          if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
            error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
          }

          if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
          }

          if (instance.propTypes) {
            error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
          }

          if (instance.contextType) {
            error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
          }

          {
            if (instance.contextTypes) {
              error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
            }

            if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
              didWarnAboutContextTypeAndContextTypes.add(ctor);
              error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
            }
          }

          if (typeof instance.componentShouldUpdate === "function") {
            error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
          }

          if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") {
            error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
          }

          if (typeof instance.componentDidUnmount === "function") {
            error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
          }

          if (typeof instance.componentDidReceiveProps === "function") {
            error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
          }

          if (typeof instance.componentWillRecieveProps === "function") {
            error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
          }

          if (typeof instance.UNSAFE_componentWillRecieveProps === "function") {
            error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
          }

          var hasMutatedProps = instance.props !== newProps;

          if (instance.props !== void 0 && hasMutatedProps) {
            error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
          }

          if (instance.defaultProps) {
            error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
          }

          if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
          }

          if (typeof instance.getDerivedStateFromProps === "function") {
            error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
          }

          if (typeof instance.getDerivedStateFromError === "function") {
            error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
          }

          if (typeof ctor.getSnapshotBeforeUpdate === "function") {
            error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
          }

          var _state = instance.state;

          if (_state && (typeof _state !== "object" || isArray2(_state))) {
            error("%s.state: must be set to an object or null", name);
          }

          if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") {
            error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
          }
        }
      }

      function callComponentWillMount(type, instance) {
        var oldState = instance.state;

        if (typeof instance.componentWillMount === "function") {
          {
            if (instance.componentWillMount.__suppressDeprecationWarning !== true) {
              var componentName = getComponentNameFromType(type) || "Unknown";

              if (!didWarnAboutDeprecatedWillMount[componentName]) {
                warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.\n\nPlease update the following components: %s", componentName);
                didWarnAboutDeprecatedWillMount[componentName] = true;
              }
            }
          }
          instance.componentWillMount();
        }

        if (typeof instance.UNSAFE_componentWillMount === "function") {
          instance.UNSAFE_componentWillMount();
        }

        if (oldState !== instance.state) {
          {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromType(type) || "Component");
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      }

      function processUpdateQueue(internalInstance, inst, props, maskedLegacyContext) {
        if (internalInstance.queue !== null && internalInstance.queue.length > 0) {
          var oldQueue = internalInstance.queue;
          var oldReplace = internalInstance.replace;
          internalInstance.queue = null;
          internalInstance.replace = false;

          if (oldReplace && oldQueue.length === 1) {
            inst.state = oldQueue[0];
          } else {
            var nextState = oldReplace ? oldQueue[0] : inst.state;
            var dontMutate = true;

            for (var i2 = oldReplace ? 1 : 0; i2 < oldQueue.length; i2++) {
              var partial = oldQueue[i2];
              var partialState = typeof partial === "function" ? partial.call(inst, nextState, props, maskedLegacyContext) : partial;

              if (partialState != null) {
                if (dontMutate) {
                  dontMutate = false;
                  nextState = assign({}, nextState, partialState);
                } else {
                  assign(nextState, partialState);
                }
              }
            }

            inst.state = nextState;
          }
        } else {
          internalInstance.queue = null;
        }
      }

      function mountClassInstance(instance, ctor, newProps, maskedLegacyContext) {
        {
          checkClassInstance(instance, ctor, newProps);
        }
        var initialState = instance.state !== void 0 ? instance.state : null;
        instance.updater = classComponentUpdater;
        instance.props = newProps;
        instance.state = initialState;
        var internalInstance = {
          queue: [],
          replace: false
        };
        set(instance, internalInstance);
        var contextType = ctor.contextType;

        if (typeof contextType === "object" && contextType !== null) {
          instance.context = readContext(contextType);
        } else {
          instance.context = maskedLegacyContext;
        }

        {
          if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";

            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
              didWarnAboutDirectlyAssigningPropsToState.add(componentName);
              error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
          }
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;

        if (typeof getDerivedStateFromProps === "function") {
          instance.state = applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, initialState, newProps);
        }

        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
          callComponentWillMount(ctor, instance);
          processUpdateQueue(internalInstance, instance, newProps, maskedLegacyContext);
        }
      }

      var emptyTreeContext = {
        id: 1,
        overflow: ""
      };

      function getTreeId(context) {
        var overflow = context.overflow;
        var idWithLeadingBit = context.id;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
      }

      function pushTreeContext(baseContext, totalChildren, index) {
        var baseIdWithLeadingBit = baseContext.id;
        var baseOverflow = baseContext.overflow;
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength;

        if (length > 30) {
          var numberOfOverflowBits = baseLength - baseLength % 5;
          var newOverflowBits = (1 << numberOfOverflowBits) - 1;
          var newOverflow = (baseId & newOverflowBits).toString(32);
          var restOfBaseId = baseId >> numberOfOverflowBits;
          var restOfBaseLength = baseLength - numberOfOverflowBits;
          var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
          var restOfNewBits = slot << restOfBaseLength;
          var id = restOfNewBits | restOfBaseId;
          var overflow = newOverflow + baseOverflow;
          return {
            id: 1 << restOfLength | id,
            overflow: overflow
          };
        } else {
          var newBits = slot << baseLength;

          var _id = newBits | baseId;

          var _overflow = baseOverflow;
          return {
            id: 1 << length | _id,
            overflow: _overflow
          };
        }
      }

      function getBitLength(number) {
        return 32 - clz32(number);
      }

      function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
      }

      var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback;
      var log = Math.log;
      var LN2 = Math.LN2;

      function clz32Fallback(x2) {
        var asUint = x2 >>> 0;

        if (asUint === 0) {
          return 32;
        }

        return 31 - (log(asUint) / LN2 | 0) | 0;
      }

      function is(x2, y2) {
        return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
      }

      var objectIs = typeof Object.is === "function" ? Object.is : is;
      var currentlyRenderingComponent = null;
      var currentlyRenderingTask = null;
      var firstWorkInProgressHook = null;
      var workInProgressHook = null;
      var isReRender = false;
      var didScheduleRenderPhaseUpdate = false;
      var localIdCounter = 0;
      var renderPhaseUpdates = null;
      var numberOfReRenders = 0;
      var RE_RENDER_LIMIT = 25;
      var isInHookUserCodeInDev = false;
      var currentHookNameInDev;

      function resolveCurrentlyRenderingComponent() {
        if (currentlyRenderingComponent === null) {
          throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        }

        {
          if (isInHookUserCodeInDev) {
            error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
          }
        }
        return currentlyRenderingComponent;
      }

      function areHookInputsEqual(nextDeps, prevDeps) {
        if (prevDeps === null) {
          {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
          }
          return false;
        }

        {
          if (nextDeps.length !== prevDeps.length) {
            error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + nextDeps.join(", ") + "]", "[" + prevDeps.join(", ") + "]");
          }
        }

        for (var i2 = 0; i2 < prevDeps.length && i2 < nextDeps.length; i2++) {
          if (objectIs(nextDeps[i2], prevDeps[i2])) {
            continue;
          }

          return false;
        }

        return true;
      }

      function createHook() {
        if (numberOfReRenders > 0) {
          throw new Error("Rendered more hooks than during the previous render");
        }

        return {
          memoizedState: null,
          queue: null,
          next: null
        };
      }

      function createWorkInProgressHook() {
        if (workInProgressHook === null) {
          if (firstWorkInProgressHook === null) {
            isReRender = false;
            firstWorkInProgressHook = workInProgressHook = createHook();
          } else {
            isReRender = true;
            workInProgressHook = firstWorkInProgressHook;
          }
        } else {
          if (workInProgressHook.next === null) {
            isReRender = false;
            workInProgressHook = workInProgressHook.next = createHook();
          } else {
            isReRender = true;
            workInProgressHook = workInProgressHook.next;
          }
        }

        return workInProgressHook;
      }

      function prepareToUseHooks(task, componentIdentity) {
        currentlyRenderingComponent = componentIdentity;
        currentlyRenderingTask = task;
        {
          isInHookUserCodeInDev = false;
        }
        localIdCounter = 0;
      }

      function finishHooks(Component2, props, children, refOrContext) {
        while (didScheduleRenderPhaseUpdate) {
          didScheduleRenderPhaseUpdate = false;
          localIdCounter = 0;
          numberOfReRenders += 1;
          workInProgressHook = null;
          children = Component2(props, refOrContext);
        }

        resetHooksState();
        return children;
      }

      function checkDidRenderIdHook() {
        var didRenderIdHook = localIdCounter !== 0;
        return didRenderIdHook;
      }

      function resetHooksState() {
        {
          isInHookUserCodeInDev = false;
        }
        currentlyRenderingComponent = null;
        currentlyRenderingTask = null;
        didScheduleRenderPhaseUpdate = false;
        firstWorkInProgressHook = null;
        numberOfReRenders = 0;
        renderPhaseUpdates = null;
        workInProgressHook = null;
      }

      function readContext$1(context) {
        {
          if (isInHookUserCodeInDev) {
            error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          }
        }
        return readContext(context);
      }

      function useContext2(context) {
        {
          currentHookNameInDev = "useContext";
        }
        resolveCurrentlyRenderingComponent();
        return readContext(context);
      }

      function basicStateReducer(state, action) {
        return typeof action === "function" ? action(state) : action;
      }

      function useState2(initialState) {
        {
          currentHookNameInDev = "useState";
        }
        return useReducer2(basicStateReducer, initialState);
      }

      function useReducer2(reducer, initialArg, init) {
        {
          if (reducer !== basicStateReducer) {
            currentHookNameInDev = "useReducer";
          }
        }
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();

        if (isReRender) {
          var queue = workInProgressHook.queue;
          var dispatch = queue.dispatch;

          if (renderPhaseUpdates !== null) {
            var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);

            if (firstRenderPhaseUpdate !== void 0) {
              renderPhaseUpdates.delete(queue);
              var newState = workInProgressHook.memoizedState;
              var update = firstRenderPhaseUpdate;

              do {
                var action = update.action;
                {
                  isInHookUserCodeInDev = true;
                }
                newState = reducer(newState, action);
                {
                  isInHookUserCodeInDev = false;
                }
                update = update.next;
              } while (update !== null);

              workInProgressHook.memoizedState = newState;
              return [newState, dispatch];
            }
          }

          return [workInProgressHook.memoizedState, dispatch];
        } else {
          {
            isInHookUserCodeInDev = true;
          }
          var initialState;

          if (reducer === basicStateReducer) {
            initialState = typeof initialArg === "function" ? initialArg() : initialArg;
          } else {
            initialState = init !== void 0 ? init(initialArg) : initialArg;
          }

          {
            isInHookUserCodeInDev = false;
          }
          workInProgressHook.memoizedState = initialState;

          var _queue = workInProgressHook.queue = {
            last: null,
            dispatch: null
          };

          var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);

          return [workInProgressHook.memoizedState, _dispatch];
        }
      }

      function useMemo2(nextCreate, deps) {
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        var nextDeps = deps === void 0 ? null : deps;

        if (workInProgressHook !== null) {
          var prevState = workInProgressHook.memoizedState;

          if (prevState !== null) {
            if (nextDeps !== null) {
              var prevDeps = prevState[1];

              if (areHookInputsEqual(nextDeps, prevDeps)) {
                return prevState[0];
              }
            }
          }
        }

        {
          isInHookUserCodeInDev = true;
        }
        var nextValue = nextCreate();
        {
          isInHookUserCodeInDev = false;
        }
        workInProgressHook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }

      function useRef2(initialValue) {
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        var previousRef = workInProgressHook.memoizedState;

        if (previousRef === null) {
          var ref = {
            current: initialValue
          };
          {
            Object.seal(ref);
          }
          workInProgressHook.memoizedState = ref;
          return ref;
        } else {
          return previousRef;
        }
      }

      function useLayoutEffect2(create, inputs) {
        {
          currentHookNameInDev = "useLayoutEffect";
          error("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
        }
      }

      function dispatchAction(componentIdentity, queue, action) {
        if (numberOfReRenders >= RE_RENDER_LIMIT) {
          throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
        }

        if (componentIdentity === currentlyRenderingComponent) {
          didScheduleRenderPhaseUpdate = true;
          var update = {
            action: action,
            next: null
          };

          if (renderPhaseUpdates === null) {
            renderPhaseUpdates = /* @__PURE__ */new Map();
          }

          var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);

          if (firstRenderPhaseUpdate === void 0) {
            renderPhaseUpdates.set(queue, update);
          } else {
            var lastRenderPhaseUpdate = firstRenderPhaseUpdate;

            while (lastRenderPhaseUpdate.next !== null) {
              lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            }

            lastRenderPhaseUpdate.next = update;
          }
        }
      }

      function useCallback2(callback, deps) {
        return useMemo2(function () {
          return callback;
        }, deps);
      }

      function useMutableSource(source, getSnapshot, subscribe) {
        resolveCurrentlyRenderingComponent();
        return getSnapshot(source._source);
      }

      function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        if (getServerSnapshot === void 0) {
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        }

        return getServerSnapshot();
      }

      function useDeferredValue(value) {
        resolveCurrentlyRenderingComponent();
        return value;
      }

      function unsupportedStartTransition() {
        throw new Error("startTransition cannot be called during server rendering.");
      }

      function useTransition() {
        resolveCurrentlyRenderingComponent();
        return [false, unsupportedStartTransition];
      }

      function useId() {
        var task = currentlyRenderingTask;
        var treeId = getTreeId(task.treeContext);
        var responseState = currentResponseState;

        if (responseState === null) {
          throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
        }

        var localId = localIdCounter++;
        return makeId(responseState, treeId, localId);
      }

      function noop() {}

      var Dispatcher = {
        readContext: readContext$1,
        useContext: useContext2,
        useMemo: useMemo2,
        useReducer: useReducer2,
        useRef: useRef2,
        useState: useState2,
        useInsertionEffect: noop,
        useLayoutEffect: useLayoutEffect2,
        useCallback: useCallback2,
        useImperativeHandle: noop,
        useEffect: noop,
        useDebugValue: noop,
        useDeferredValue: useDeferredValue,
        useTransition: useTransition,
        useId: useId,
        useMutableSource: useMutableSource,
        useSyncExternalStore: useSyncExternalStore
      };
      var currentResponseState = null;

      function setCurrentResponseState(responseState) {
        currentResponseState = responseState;
      }

      function getStackByComponentStackNode(componentStack) {
        try {
          var info = "";
          var node = componentStack;

          do {
            switch (node.tag) {
              case 0:
                info += describeBuiltInComponentFrame(node.type, null, null);
                break;

              case 1:
                info += describeFunctionComponentFrame(node.type, null, null);
                break;

              case 2:
                info += describeClassComponentFrame(node.type, null, null);
                break;
            }

            node = node.parent;
          } while (node);

          return info;
        } catch (x2) {
          return "\nError generating stack: " + x2.message + "\n" + x2.stack;
        }
      }

      var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      var PENDING = 0;
      var COMPLETED = 1;
      var FLUSHED = 2;
      var ABORTED = 3;
      var ERRORED = 4;
      var OPEN = 0;
      var CLOSING = 1;
      var CLOSED = 2;
      var DEFAULT_PROGRESSIVE_CHUNK_SIZE = 12800;

      function defaultErrorHandler(error2) {
        console["error"](error2);
        return null;
      }

      function noop$1() {}

      function createRequest(children, responseState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError) {
        var pingedTasks = [];
        var abortSet = /* @__PURE__ */new Set();
        var request = {
          destination: null,
          responseState: responseState,
          progressiveChunkSize: progressiveChunkSize === void 0 ? DEFAULT_PROGRESSIVE_CHUNK_SIZE : progressiveChunkSize,
          status: OPEN,
          fatalError: null,
          nextSegmentId: 0,
          allPendingTasks: 0,
          pendingRootTasks: 0,
          completedRootSegment: null,
          abortableTasks: abortSet,
          pingedTasks: pingedTasks,
          clientRenderedBoundaries: [],
          completedBoundaries: [],
          partialBoundaries: [],
          onError: onError === void 0 ? defaultErrorHandler : onError,
          onAllReady: onAllReady === void 0 ? noop$1 : onAllReady,
          onShellReady: onShellReady === void 0 ? noop$1 : onShellReady,
          onShellError: onShellError === void 0 ? noop$1 : onShellError,
          onFatalError: onFatalError === void 0 ? noop$1 : onFatalError
        };
        var rootSegment = createPendingSegment(request, 0, null, rootFormatContext, false, false);
        rootSegment.parentFlushed = true;
        var rootTask = createTask(request, children, null, rootSegment, abortSet, emptyContextObject, rootContextSnapshot, emptyTreeContext);
        pingedTasks.push(rootTask);
        return request;
      }

      function pingTask(request, task) {
        var pingedTasks = request.pingedTasks;
        pingedTasks.push(task);

        if (pingedTasks.length === 1) {
          scheduleWork(function () {
            return performWork(request);
          });
        }
      }

      function createSuspenseBoundary(request, fallbackAbortableTasks) {
        return {
          id: UNINITIALIZED_SUSPENSE_BOUNDARY_ID,
          rootSegmentID: -1,
          parentFlushed: false,
          pendingTasks: 0,
          forceClientRender: false,
          completedSegments: [],
          byteSize: 0,
          fallbackAbortableTasks: fallbackAbortableTasks,
          errorDigest: null
        };
      }

      function createTask(request, node, blockedBoundary, blockedSegment, abortSet, legacyContext, context, treeContext) {
        request.allPendingTasks++;

        if (blockedBoundary === null) {
          request.pendingRootTasks++;
        } else {
          blockedBoundary.pendingTasks++;
        }

        var task = {
          node: node,
          ping: function ping() {
            return pingTask(request, task);
          },
          blockedBoundary: blockedBoundary,
          blockedSegment: blockedSegment,
          abortSet: abortSet,
          legacyContext: legacyContext,
          context: context,
          treeContext: treeContext
        };
        {
          task.componentStack = null;
        }
        abortSet.add(task);
        return task;
      }

      function createPendingSegment(request, index, boundary, formatContext, lastPushedText, textEmbedded) {
        return {
          status: PENDING,
          id: -1,
          index: index,
          parentFlushed: false,
          chunks: [],
          children: [],
          formatContext: formatContext,
          boundary: boundary,
          lastPushedText: lastPushedText,
          textEmbedded: textEmbedded
        };
      }

      var currentTaskInDEV = null;

      function getCurrentStackInDEV() {
        {
          if (currentTaskInDEV === null || currentTaskInDEV.componentStack === null) {
            return "";
          }

          return getStackByComponentStackNode(currentTaskInDEV.componentStack);
        }
      }

      function pushBuiltInComponentStackInDEV(task, type) {
        {
          task.componentStack = {
            tag: 0,
            parent: task.componentStack,
            type: type
          };
        }
      }

      function pushFunctionComponentStackInDEV(task, type) {
        {
          task.componentStack = {
            tag: 1,
            parent: task.componentStack,
            type: type
          };
        }
      }

      function pushClassComponentStackInDEV(task, type) {
        {
          task.componentStack = {
            tag: 2,
            parent: task.componentStack,
            type: type
          };
        }
      }

      function popComponentStackInDEV(task) {
        {
          if (task.componentStack === null) {
            error("Unexpectedly popped too many stack frames. This is a bug in React.");
          } else {
            task.componentStack = task.componentStack.parent;
          }
        }
      }

      var lastBoundaryErrorComponentStackDev = null;

      function captureBoundaryErrorDetailsDev(boundary, error2) {
        {
          var errorMessage;

          if (typeof error2 === "string") {
            errorMessage = error2;
          } else if (error2 && typeof error2.message === "string") {
            errorMessage = error2.message;
          } else {
            errorMessage = String(error2);
          }

          var errorComponentStack = lastBoundaryErrorComponentStackDev || getCurrentStackInDEV();
          lastBoundaryErrorComponentStackDev = null;
          boundary.errorMessage = errorMessage;
          boundary.errorComponentStack = errorComponentStack;
        }
      }

      function logRecoverableError(request, error2) {
        var errorDigest = request.onError(error2);

        if (errorDigest != null && typeof errorDigest !== "string") {
          throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
        }

        return errorDigest;
      }

      function fatalError(request, error2) {
        var onShellError = request.onShellError;
        onShellError(error2);
        var onFatalError = request.onFatalError;
        onFatalError(error2);

        if (request.destination !== null) {
          request.status = CLOSED;
          closeWithError(request.destination, error2);
        } else {
          request.status = CLOSING;
          request.fatalError = error2;
        }
      }

      function renderSuspenseBoundary(request, task, props) {
        pushBuiltInComponentStackInDEV(task, "Suspense");
        var parentBoundary = task.blockedBoundary;
        var parentSegment = task.blockedSegment;
        var fallback = props.fallback;
        var content = props.children;
        var fallbackAbortSet = /* @__PURE__ */new Set();
        var newBoundary = createSuspenseBoundary(request, fallbackAbortSet);
        var insertionIndex = parentSegment.chunks.length;
        var boundarySegment = createPendingSegment(request, insertionIndex, newBoundary, parentSegment.formatContext, false, false);
        parentSegment.children.push(boundarySegment);
        parentSegment.lastPushedText = false;
        var contentRootSegment = createPendingSegment(request, 0, null, parentSegment.formatContext, false, false);
        contentRootSegment.parentFlushed = true;
        task.blockedBoundary = newBoundary;
        task.blockedSegment = contentRootSegment;

        try {
          renderNode(request, task, content);
          pushSegmentFinale(contentRootSegment.chunks, request.responseState, contentRootSegment.lastPushedText, contentRootSegment.textEmbedded);
          contentRootSegment.status = COMPLETED;
          queueCompletedSegment(newBoundary, contentRootSegment);

          if (newBoundary.pendingTasks === 0) {
            popComponentStackInDEV(task);
            return;
          }
        } catch (error2) {
          contentRootSegment.status = ERRORED;
          newBoundary.forceClientRender = true;
          newBoundary.errorDigest = logRecoverableError(request, error2);
          {
            captureBoundaryErrorDetailsDev(newBoundary, error2);
          }
        } finally {
          task.blockedBoundary = parentBoundary;
          task.blockedSegment = parentSegment;
        }

        var suspendedFallbackTask = createTask(request, fallback, parentBoundary, boundarySegment, fallbackAbortSet, task.legacyContext, task.context, task.treeContext);
        {
          suspendedFallbackTask.componentStack = task.componentStack;
        }
        request.pingedTasks.push(suspendedFallbackTask);
        popComponentStackInDEV(task);
      }

      function renderHostElement(request, task, type, props) {
        pushBuiltInComponentStackInDEV(task, type);
        var segment = task.blockedSegment;
        var children = pushStartInstance(segment.chunks, type, props, request.responseState, segment.formatContext);
        segment.lastPushedText = false;
        var prevContext = segment.formatContext;
        segment.formatContext = getChildFormatContext(prevContext, type, props);
        renderNode(request, task, children);
        segment.formatContext = prevContext;
        pushEndInstance(segment.chunks, type);
        segment.lastPushedText = false;
        popComponentStackInDEV(task);
      }

      function shouldConstruct$1(Component2) {
        return Component2.prototype && Component2.prototype.isReactComponent;
      }

      function renderWithHooks(request, task, Component2, props, secondArg) {
        var componentIdentity = {};
        prepareToUseHooks(task, componentIdentity);
        var result = Component2(props, secondArg);
        return finishHooks(Component2, props, result, secondArg);
      }

      function finishClassComponent(request, task, instance, Component2, props) {
        var nextChildren = instance.render();
        {
          if (instance.props !== props) {
            if (!didWarnAboutReassigningProps) {
              error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromType(Component2) || "a component");
            }

            didWarnAboutReassigningProps = true;
          }
        }
        {
          var childContextTypes = Component2.childContextTypes;

          if (childContextTypes !== null && childContextTypes !== void 0) {
            var previousContext = task.legacyContext;
            var mergedContext = processChildContext(instance, Component2, previousContext, childContextTypes);
            task.legacyContext = mergedContext;
            renderNodeDestructive(request, task, nextChildren);
            task.legacyContext = previousContext;
            return;
          }
        }
        renderNodeDestructive(request, task, nextChildren);
      }

      function renderClassComponent(request, task, Component2, props) {
        pushClassComponentStackInDEV(task, Component2);
        var maskedContext = getMaskedContext(Component2, task.legacyContext);
        var instance = constructClassInstance(Component2, props, maskedContext);
        mountClassInstance(instance, Component2, props, maskedContext);
        finishClassComponent(request, task, instance, Component2, props);
        popComponentStackInDEV(task);
      }

      var didWarnAboutBadClass = {};
      var didWarnAboutModulePatternComponent = {};
      var didWarnAboutContextTypeOnFunctionComponent = {};
      var didWarnAboutGetDerivedStateOnFunctionComponent = {};
      var didWarnAboutReassigningProps = false;
      var didWarnAboutGenerators = false;
      var didWarnAboutMaps = false;
      var hasWarnedAboutUsingContextAsConsumer = false;

      function renderIndeterminateComponent(request, task, Component2, props) {
        var legacyContext;
        {
          legacyContext = getMaskedContext(Component2, task.legacyContext);
        }
        pushFunctionComponentStackInDEV(task, Component2);
        {
          if (Component2.prototype && typeof Component2.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component2) || "Unknown";

            if (!didWarnAboutBadClass[componentName]) {
              error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
              didWarnAboutBadClass[componentName] = true;
            }
          }
        }
        var value = renderWithHooks(request, task, Component2, props, legacyContext);
        var hasId = checkDidRenderIdHook();
        {
          if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0) {
            var _componentName = getComponentNameFromType(Component2) || "Unknown";

            if (!didWarnAboutModulePatternComponent[_componentName]) {
              error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
              didWarnAboutModulePatternComponent[_componentName] = true;
            }
          }
        }

        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0) {
          {
            var _componentName2 = getComponentNameFromType(Component2) || "Unknown";

            if (!didWarnAboutModulePatternComponent[_componentName2]) {
              error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
              didWarnAboutModulePatternComponent[_componentName2] = true;
            }
          }
          mountClassInstance(value, Component2, props, legacyContext);
          finishClassComponent(request, task, value, Component2, props);
        } else {
          {
            validateFunctionComponentInDev(Component2);
          }

          if (hasId) {
            var prevTreeContext = task.treeContext;
            var totalChildren = 1;
            var index = 0;
            task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);

            try {
              renderNodeDestructive(request, task, value);
            } finally {
              task.treeContext = prevTreeContext;
            }
          } else {
            renderNodeDestructive(request, task, value);
          }
        }

        popComponentStackInDEV(task);
      }

      function validateFunctionComponentInDev(Component2) {
        {
          if (Component2) {
            if (Component2.childContextTypes) {
              error("%s(...): childContextTypes cannot be defined on a function component.", Component2.displayName || Component2.name || "Component");
            }
          }

          if (typeof Component2.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component2) || "Unknown";

            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
              error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
              didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
          }

          if (typeof Component2.contextType === "object" && Component2.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component2) || "Unknown";

            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
              error("%s: Function components do not support contextType.", _componentName4);
              didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
          }
        }
      }

      function resolveDefaultProps(Component2, baseProps) {
        if (Component2 && Component2.defaultProps) {
          var props = assign({}, baseProps);
          var defaultProps = Component2.defaultProps;

          for (var propName in defaultProps) {
            if (props[propName] === void 0) {
              props[propName] = defaultProps[propName];
            }
          }

          return props;
        }

        return baseProps;
      }

      function renderForwardRef(request, task, type, props, ref) {
        pushFunctionComponentStackInDEV(task, type.render);
        var children = renderWithHooks(request, task, type.render, props, ref);
        var hasId = checkDidRenderIdHook();

        if (hasId) {
          var prevTreeContext = task.treeContext;
          var totalChildren = 1;
          var index = 0;
          task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);

          try {
            renderNodeDestructive(request, task, children);
          } finally {
            task.treeContext = prevTreeContext;
          }
        } else {
          renderNodeDestructive(request, task, children);
        }

        popComponentStackInDEV(task);
      }

      function renderMemo(request, task, type, props, ref) {
        var innerType = type.type;
        var resolvedProps = resolveDefaultProps(innerType, props);
        renderElement(request, task, innerType, resolvedProps, ref);
      }

      function renderContextConsumer(request, task, context, props) {
        {
          if (context._context === void 0) {
            if (context !== context.Consumer) {
              if (!hasWarnedAboutUsingContextAsConsumer) {
                hasWarnedAboutUsingContextAsConsumer = true;
                error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
              }
            }
          } else {
            context = context._context;
          }
        }
        var render = props.children;
        {
          if (typeof render !== "function") {
            error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
          }
        }
        var newValue = readContext(context);
        var newChildren = render(newValue);
        renderNodeDestructive(request, task, newChildren);
      }

      function renderContextProvider(request, task, type, props) {
        var context = type._context;
        var value = props.value;
        var children = props.children;
        var prevSnapshot;
        {
          prevSnapshot = task.context;
        }
        task.context = pushProvider(context, value);
        renderNodeDestructive(request, task, children);
        task.context = popProvider(context);
        {
          if (prevSnapshot !== task.context) {
            error("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
          }
        }
      }

      function renderLazyComponent(request, task, lazyComponent, props, ref) {
        pushBuiltInComponentStackInDEV(task, "Lazy");
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component2 = init(payload);
        var resolvedProps = resolveDefaultProps(Component2, props);
        renderElement(request, task, Component2, resolvedProps, ref);
        popComponentStackInDEV(task);
      }

      function renderElement(request, task, type, props, ref) {
        if (typeof type === "function") {
          if (shouldConstruct$1(type)) {
            renderClassComponent(request, task, type, props);
            return;
          } else {
            renderIndeterminateComponent(request, task, type, props);
            return;
          }
        }

        if (typeof type === "string") {
          renderHostElement(request, task, type, props);
          return;
        }

        switch (type) {
          case REACT_LEGACY_HIDDEN_TYPE:
          case REACT_DEBUG_TRACING_MODE_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_FRAGMENT_TYPE:
            {
              renderNodeDestructive(request, task, props.children);
              return;
            }

          case REACT_SUSPENSE_LIST_TYPE:
            {
              pushBuiltInComponentStackInDEV(task, "SuspenseList");
              renderNodeDestructive(request, task, props.children);
              popComponentStackInDEV(task);
              return;
            }

          case REACT_SCOPE_TYPE:
            {
              throw new Error("ReactDOMServer does not yet support scope components.");
            }

          case REACT_SUSPENSE_TYPE:
            {
              {
                renderSuspenseBoundary(request, task, props);
              }
              return;
            }
        }

        if (typeof type === "object" && type !== null) {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              {
                renderForwardRef(request, task, type, props, ref);
                return;
              }

            case REACT_MEMO_TYPE:
              {
                renderMemo(request, task, type, props, ref);
                return;
              }

            case REACT_PROVIDER_TYPE:
              {
                renderContextProvider(request, task, type, props);
                return;
              }

            case REACT_CONTEXT_TYPE:
              {
                renderContextConsumer(request, task, type, props);
                return;
              }

            case REACT_LAZY_TYPE:
              {
                renderLazyComponent(request, task, type, props);
                return;
              }
          }
        }

        var info = "";
        {
          if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
            info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
          }
        }
        throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
      }

      function validateIterable(iterable, iteratorFn) {
        {
          if (typeof Symbol === "function" && iterable[Symbol.toStringTag] === "Generator") {
            if (!didWarnAboutGenerators) {
              error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
            }

            didWarnAboutGenerators = true;
          }

          if (iterable.entries === iteratorFn) {
            if (!didWarnAboutMaps) {
              error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
            }

            didWarnAboutMaps = true;
          }
        }
      }

      function renderNodeDestructive(request, task, node) {
        {
          try {
            return renderNodeDestructiveImpl(request, task, node);
          } catch (x2) {
            if (typeof x2 === "object" && x2 !== null && typeof x2.then === "function") ;else {
              lastBoundaryErrorComponentStackDev = lastBoundaryErrorComponentStackDev !== null ? lastBoundaryErrorComponentStackDev : getCurrentStackInDEV();
            }
            throw x2;
          }
        }
      }

      function renderNodeDestructiveImpl(request, task, node) {
        task.node = node;

        if (typeof node === "object" && node !== null) {
          switch (node.$$typeof) {
            case REACT_ELEMENT_TYPE2:
              {
                var element = node;
                var type = element.type;
                var props = element.props;
                var ref = element.ref;
                renderElement(request, task, type, props, ref);
                return;
              }

            case REACT_PORTAL_TYPE:
              throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");

            case REACT_LAZY_TYPE:
              {
                var lazyNode = node;
                var payload = lazyNode._payload;
                var init = lazyNode._init;
                var resolvedNode;
                {
                  try {
                    resolvedNode = init(payload);
                  } catch (x2) {
                    if (typeof x2 === "object" && x2 !== null && typeof x2.then === "function") {
                      pushBuiltInComponentStackInDEV(task, "Lazy");
                    }

                    throw x2;
                  }
                }
                renderNodeDestructive(request, task, resolvedNode);
                return;
              }
          }

          if (isArray2(node)) {
            renderChildrenArray(request, task, node);
            return;
          }

          var iteratorFn = getIteratorFn(node);

          if (iteratorFn) {
            {
              validateIterable(node, iteratorFn);
            }
            var iterator = iteratorFn.call(node);

            if (iterator) {
              var step = iterator.next();

              if (!step.done) {
                var children = [];

                do {
                  children.push(step.value);
                  step = iterator.next();
                } while (!step.done);

                renderChildrenArray(request, task, children);
                return;
              }

              return;
            }
          }

          var childString = Object.prototype.toString.call(node);
          throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(node).join(", ") + "}" : childString) + "). If you meant to render a collection of children, use an array instead.");
        }

        if (typeof node === "string") {
          var segment = task.blockedSegment;
          segment.lastPushedText = pushTextInstance(task.blockedSegment.chunks, node, request.responseState, segment.lastPushedText);
          return;
        }

        if (typeof node === "number") {
          var _segment = task.blockedSegment;
          _segment.lastPushedText = pushTextInstance(task.blockedSegment.chunks, "" + node, request.responseState, _segment.lastPushedText);
          return;
        }

        {
          if (typeof node === "function") {
            error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
          }
        }
      }

      function renderChildrenArray(request, task, children) {
        var totalChildren = children.length;

        for (var i2 = 0; i2 < totalChildren; i2++) {
          var prevTreeContext = task.treeContext;
          task.treeContext = pushTreeContext(prevTreeContext, totalChildren, i2);

          try {
            renderNode(request, task, children[i2]);
          } finally {
            task.treeContext = prevTreeContext;
          }
        }
      }

      function spawnNewSuspendedTask(request, task, x2) {
        var segment = task.blockedSegment;
        var insertionIndex = segment.chunks.length;
        var newSegment = createPendingSegment(request, insertionIndex, null, segment.formatContext, segment.lastPushedText, true);
        segment.children.push(newSegment);
        segment.lastPushedText = false;
        var newTask = createTask(request, task.node, task.blockedBoundary, newSegment, task.abortSet, task.legacyContext, task.context, task.treeContext);
        {
          if (task.componentStack !== null) {
            newTask.componentStack = task.componentStack.parent;
          }
        }
        var ping = newTask.ping;
        x2.then(ping, ping);
      }

      function renderNode(request, task, node) {
        var previousFormatContext = task.blockedSegment.formatContext;
        var previousLegacyContext = task.legacyContext;
        var previousContext = task.context;
        var previousComponentStack = null;
        {
          previousComponentStack = task.componentStack;
        }

        try {
          return renderNodeDestructive(request, task, node);
        } catch (x2) {
          resetHooksState();

          if (typeof x2 === "object" && x2 !== null && typeof x2.then === "function") {
            spawnNewSuspendedTask(request, task, x2);
            task.blockedSegment.formatContext = previousFormatContext;
            task.legacyContext = previousLegacyContext;
            task.context = previousContext;
            switchContext(previousContext);
            {
              task.componentStack = previousComponentStack;
            }
            return;
          } else {
            task.blockedSegment.formatContext = previousFormatContext;
            task.legacyContext = previousLegacyContext;
            task.context = previousContext;
            switchContext(previousContext);
            {
              task.componentStack = previousComponentStack;
            }
            throw x2;
          }
        }
      }

      function erroredTask(request, boundary, segment, error2) {
        var errorDigest = logRecoverableError(request, error2);

        if (boundary === null) {
          fatalError(request, error2);
        } else {
          boundary.pendingTasks--;

          if (!boundary.forceClientRender) {
            boundary.forceClientRender = true;
            boundary.errorDigest = errorDigest;
            {
              captureBoundaryErrorDetailsDev(boundary, error2);
            }

            if (boundary.parentFlushed) {
              request.clientRenderedBoundaries.push(boundary);
            }
          }
        }

        request.allPendingTasks--;

        if (request.allPendingTasks === 0) {
          var onAllReady = request.onAllReady;
          onAllReady();
        }
      }

      function abortTaskSoft(task) {
        var request = this;
        var boundary = task.blockedBoundary;
        var segment = task.blockedSegment;
        segment.status = ABORTED;
        finishedTask(request, boundary, segment);
      }

      function abortTask(task, request, reason) {
        var boundary = task.blockedBoundary;
        var segment = task.blockedSegment;
        segment.status = ABORTED;

        if (boundary === null) {
          request.allPendingTasks--;

          if (request.status !== CLOSED) {
            request.status = CLOSED;

            if (request.destination !== null) {
              close(request.destination);
            }
          }
        } else {
          boundary.pendingTasks--;

          if (!boundary.forceClientRender) {
            boundary.forceClientRender = true;

            var _error = reason === void 0 ? new Error("The render was aborted by the server without a reason.") : reason;

            boundary.errorDigest = request.onError(_error);
            {
              var errorPrefix = "The server did not finish this Suspense boundary: ";

              if (_error && typeof _error.message === "string") {
                _error = errorPrefix + _error.message;
              } else {
                _error = errorPrefix + String(_error);
              }

              var previousTaskInDev = currentTaskInDEV;
              currentTaskInDEV = task;

              try {
                captureBoundaryErrorDetailsDev(boundary, _error);
              } finally {
                currentTaskInDEV = previousTaskInDev;
              }
            }

            if (boundary.parentFlushed) {
              request.clientRenderedBoundaries.push(boundary);
            }
          }

          boundary.fallbackAbortableTasks.forEach(function (fallbackTask) {
            return abortTask(fallbackTask, request, reason);
          });
          boundary.fallbackAbortableTasks.clear();
          request.allPendingTasks--;

          if (request.allPendingTasks === 0) {
            var onAllReady = request.onAllReady;
            onAllReady();
          }
        }
      }

      function queueCompletedSegment(boundary, segment) {
        if (segment.chunks.length === 0 && segment.children.length === 1 && segment.children[0].boundary === null) {
          var childSegment = segment.children[0];
          childSegment.id = segment.id;
          childSegment.parentFlushed = true;

          if (childSegment.status === COMPLETED) {
            queueCompletedSegment(boundary, childSegment);
          }
        } else {
          var completedSegments = boundary.completedSegments;
          completedSegments.push(segment);
        }
      }

      function finishedTask(request, boundary, segment) {
        if (boundary === null) {
          if (segment.parentFlushed) {
            if (request.completedRootSegment !== null) {
              throw new Error("There can only be one root segment. This is a bug in React.");
            }

            request.completedRootSegment = segment;
          }

          request.pendingRootTasks--;

          if (request.pendingRootTasks === 0) {
            request.onShellError = noop$1;
            var onShellReady = request.onShellReady;
            onShellReady();
          }
        } else {
          boundary.pendingTasks--;
          if (boundary.forceClientRender) ;else if (boundary.pendingTasks === 0) {
            if (segment.parentFlushed) {
              if (segment.status === COMPLETED) {
                queueCompletedSegment(boundary, segment);
              }
            }

            if (boundary.parentFlushed) {
              request.completedBoundaries.push(boundary);
            }

            boundary.fallbackAbortableTasks.forEach(abortTaskSoft, request);
            boundary.fallbackAbortableTasks.clear();
          } else {
            if (segment.parentFlushed) {
              if (segment.status === COMPLETED) {
                queueCompletedSegment(boundary, segment);
                var completedSegments = boundary.completedSegments;

                if (completedSegments.length === 1) {
                  if (boundary.parentFlushed) {
                    request.partialBoundaries.push(boundary);
                  }
                }
              }
            }
          }
        }

        request.allPendingTasks--;

        if (request.allPendingTasks === 0) {
          var onAllReady = request.onAllReady;
          onAllReady();
        }
      }

      function retryTask(request, task) {
        var segment = task.blockedSegment;

        if (segment.status !== PENDING) {
          return;
        }

        switchContext(task.context);
        var prevTaskInDEV = null;
        {
          prevTaskInDEV = currentTaskInDEV;
          currentTaskInDEV = task;
        }

        try {
          renderNodeDestructive(request, task, task.node);
          pushSegmentFinale(segment.chunks, request.responseState, segment.lastPushedText, segment.textEmbedded);
          task.abortSet.delete(task);
          segment.status = COMPLETED;
          finishedTask(request, task.blockedBoundary, segment);
        } catch (x2) {
          resetHooksState();

          if (typeof x2 === "object" && x2 !== null && typeof x2.then === "function") {
            var ping = task.ping;
            x2.then(ping, ping);
          } else {
            task.abortSet.delete(task);
            segment.status = ERRORED;
            erroredTask(request, task.blockedBoundary, segment, x2);
          }
        } finally {
          {
            currentTaskInDEV = prevTaskInDEV;
          }
        }
      }

      function performWork(request) {
        if (request.status === CLOSED) {
          return;
        }

        var prevContext = getActiveContext();
        var prevDispatcher = ReactCurrentDispatcher$1.current;
        ReactCurrentDispatcher$1.current = Dispatcher;
        var prevGetCurrentStackImpl;
        {
          prevGetCurrentStackImpl = ReactDebugCurrentFrame$1.getCurrentStack;
          ReactDebugCurrentFrame$1.getCurrentStack = getCurrentStackInDEV;
        }
        var prevResponseState = currentResponseState;
        setCurrentResponseState(request.responseState);

        try {
          var pingedTasks = request.pingedTasks;
          var i2;

          for (i2 = 0; i2 < pingedTasks.length; i2++) {
            var task = pingedTasks[i2];
            retryTask(request, task);
          }

          pingedTasks.splice(0, i2);

          if (request.destination !== null) {
            flushCompletedQueues(request, request.destination);
          }
        } catch (error2) {
          logRecoverableError(request, error2);
          fatalError(request, error2);
        } finally {
          setCurrentResponseState(prevResponseState);
          ReactCurrentDispatcher$1.current = prevDispatcher;
          {
            ReactDebugCurrentFrame$1.getCurrentStack = prevGetCurrentStackImpl;
          }

          if (prevDispatcher === Dispatcher) {
            switchContext(prevContext);
          }
        }
      }

      function flushSubtree(request, destination, segment) {
        segment.parentFlushed = true;

        switch (segment.status) {
          case PENDING:
            {
              var segmentID = segment.id = request.nextSegmentId++;
              segment.lastPushedText = false;
              segment.textEmbedded = false;
              return writePlaceholder(destination, request.responseState, segmentID);
            }

          case COMPLETED:
            {
              segment.status = FLUSHED;
              var r2 = true;
              var chunks = segment.chunks;
              var chunkIdx = 0;
              var children = segment.children;

              for (var childIdx = 0; childIdx < children.length; childIdx++) {
                var nextChild = children[childIdx];

                for (; chunkIdx < nextChild.index; chunkIdx++) {
                  writeChunk(destination, chunks[chunkIdx]);
                }

                r2 = flushSegment(request, destination, nextChild);
              }

              for (; chunkIdx < chunks.length - 1; chunkIdx++) {
                writeChunk(destination, chunks[chunkIdx]);
              }

              if (chunkIdx < chunks.length) {
                r2 = writeChunkAndReturn(destination, chunks[chunkIdx]);
              }

              return r2;
            }

          default:
            {
              throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
            }
        }
      }

      function flushSegment(request, destination, segment) {
        var boundary = segment.boundary;

        if (boundary === null) {
          return flushSubtree(request, destination, segment);
        }

        boundary.parentFlushed = true;

        if (boundary.forceClientRender) {
          writeStartClientRenderedSuspenseBoundary(destination, request.responseState, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
          flushSubtree(request, destination, segment);
          return writeEndClientRenderedSuspenseBoundary(destination, request.responseState);
        } else if (boundary.pendingTasks > 0) {
          boundary.rootSegmentID = request.nextSegmentId++;

          if (boundary.completedSegments.length > 0) {
            request.partialBoundaries.push(boundary);
          }

          var id = boundary.id = assignSuspenseBoundaryID(request.responseState);
          writeStartPendingSuspenseBoundary(destination, request.responseState, id);
          flushSubtree(request, destination, segment);
          return writeEndPendingSuspenseBoundary(destination, request.responseState);
        } else if (boundary.byteSize > request.progressiveChunkSize) {
          boundary.rootSegmentID = request.nextSegmentId++;
          request.completedBoundaries.push(boundary);
          writeStartPendingSuspenseBoundary(destination, request.responseState, boundary.id);
          flushSubtree(request, destination, segment);
          return writeEndPendingSuspenseBoundary(destination, request.responseState);
        } else {
          writeStartCompletedSuspenseBoundary(destination, request.responseState);
          var completedSegments = boundary.completedSegments;

          if (completedSegments.length !== 1) {
            throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
          }

          var contentSegment = completedSegments[0];
          flushSegment(request, destination, contentSegment);
          return writeEndCompletedSuspenseBoundary(destination, request.responseState);
        }
      }

      function flushClientRenderedBoundary(request, destination, boundary) {
        return writeClientRenderBoundaryInstruction(destination, request.responseState, boundary.id, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
      }

      function flushSegmentContainer(request, destination, segment) {
        writeStartSegment(destination, request.responseState, segment.formatContext, segment.id);
        flushSegment(request, destination, segment);
        return writeEndSegment(destination, segment.formatContext);
      }

      function flushCompletedBoundary(request, destination, boundary) {
        var completedSegments = boundary.completedSegments;
        var i2 = 0;

        for (; i2 < completedSegments.length; i2++) {
          var segment = completedSegments[i2];
          flushPartiallyCompletedSegment(request, destination, boundary, segment);
        }

        completedSegments.length = 0;
        return writeCompletedBoundaryInstruction(destination, request.responseState, boundary.id, boundary.rootSegmentID);
      }

      function flushPartialBoundary(request, destination, boundary) {
        var completedSegments = boundary.completedSegments;
        var i2 = 0;

        for (; i2 < completedSegments.length; i2++) {
          var segment = completedSegments[i2];

          if (!flushPartiallyCompletedSegment(request, destination, boundary, segment)) {
            i2++;
            completedSegments.splice(0, i2);
            return false;
          }
        }

        completedSegments.splice(0, i2);
        return true;
      }

      function flushPartiallyCompletedSegment(request, destination, boundary, segment) {
        if (segment.status === FLUSHED) {
          return true;
        }

        var segmentID = segment.id;

        if (segmentID === -1) {
          var rootSegmentID = segment.id = boundary.rootSegmentID;

          if (rootSegmentID === -1) {
            throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
          }

          return flushSegmentContainer(request, destination, segment);
        } else {
          flushSegmentContainer(request, destination, segment);
          return writeCompletedSegmentInstruction(destination, request.responseState, segmentID);
        }
      }

      function flushCompletedQueues(request, destination) {
        beginWriting();

        try {
          var completedRootSegment = request.completedRootSegment;

          if (completedRootSegment !== null && request.pendingRootTasks === 0) {
            flushSegment(request, destination, completedRootSegment);
            request.completedRootSegment = null;
            writeCompletedRoot(destination, request.responseState);
          }

          var clientRenderedBoundaries = request.clientRenderedBoundaries;
          var i2;

          for (i2 = 0; i2 < clientRenderedBoundaries.length; i2++) {
            var boundary = clientRenderedBoundaries[i2];
            if (!flushClientRenderedBoundary(request, destination, boundary)) ;
          }

          clientRenderedBoundaries.splice(0, i2);
          var completedBoundaries = request.completedBoundaries;

          for (i2 = 0; i2 < completedBoundaries.length; i2++) {
            var _boundary = completedBoundaries[i2];
            if (!flushCompletedBoundary(request, destination, _boundary)) ;
          }

          completedBoundaries.splice(0, i2);
          completeWriting(destination);
          beginWriting(destination);
          var partialBoundaries = request.partialBoundaries;

          for (i2 = 0; i2 < partialBoundaries.length; i2++) {
            var _boundary2 = partialBoundaries[i2];

            if (!flushPartialBoundary(request, destination, _boundary2)) {
              request.destination = null;
              i2++;
              partialBoundaries.splice(0, i2);
              return;
            }
          }

          partialBoundaries.splice(0, i2);
          var largeBoundaries = request.completedBoundaries;

          for (i2 = 0; i2 < largeBoundaries.length; i2++) {
            var _boundary3 = largeBoundaries[i2];
            if (!flushCompletedBoundary(request, destination, _boundary3)) ;
          }

          largeBoundaries.splice(0, i2);
        } finally {
          completeWriting(destination);

          if (request.allPendingTasks === 0 && request.pingedTasks.length === 0 && request.clientRenderedBoundaries.length === 0 && request.completedBoundaries.length === 0) {
            {
              if (request.abortableTasks.size !== 0) {
                error("There was still abortable task at the root when we closed. This is a bug in React.");
              }
            }
            close(destination);
          }
        }
      }

      function startWork(request) {
        scheduleWork(function () {
          return performWork(request);
        });
      }

      function startFlowing(request, destination) {
        if (request.status === CLOSING) {
          request.status = CLOSED;
          closeWithError(destination, request.fatalError);
          return;
        }

        if (request.status === CLOSED) {
          return;
        }

        if (request.destination !== null) {
          return;
        }

        request.destination = destination;

        try {
          flushCompletedQueues(request, destination);
        } catch (error2) {
          logRecoverableError(request, error2);
          fatalError(request, error2);
        }
      }

      function abort(request, reason) {
        try {
          var abortableTasks = request.abortableTasks;
          abortableTasks.forEach(function (task) {
            return abortTask(task, request, reason);
          });
          abortableTasks.clear();

          if (request.destination !== null) {
            flushCompletedQueues(request, request.destination);
          }
        } catch (error2) {
          logRecoverableError(request, error2);
          fatalError(request, error2);
        }
      }

      function renderToReadableStream(children, options) {
        return new Promise(function (resolve, reject) {
          var onFatalError;
          var onAllReady;
          var allReady = new Promise(function (res, rej) {
            onAllReady = res;
            onFatalError = rej;
          });

          function onShellReady() {
            var stream = new ReadableStream({
              type: "bytes",
              pull: function pull(controller) {
                startFlowing(request, controller);
              },
              cancel: function cancel(reason) {
                abort(request);
              }
            }, {
              highWaterMark: 0
            });
            stream.allReady = allReady;
            resolve(stream);
          }

          function onShellError(error2) {
            allReady.catch(function () {});
            reject(error2);
          }

          var request = createRequest(children, createResponseState(options ? options.identifierPrefix : void 0, options ? options.nonce : void 0, options ? options.bootstrapScriptContent : void 0, options ? options.bootstrapScripts : void 0, options ? options.bootstrapModules : void 0), createRootFormatContext(options ? options.namespaceURI : void 0), options ? options.progressiveChunkSize : void 0, options ? options.onError : void 0, onAllReady, onShellReady, onShellError, onFatalError);

          if (options && options.signal) {
            var signal = options.signal;

            var listener = function listener() {
              abort(request, signal.reason);
              signal.removeEventListener("abort", listener);
            };

            signal.addEventListener("abort", listener);
          }

          startWork(request);
        });
      }

      reactDomServer_browser_development.renderToReadableStream = renderToReadableStream;
      reactDomServer_browser_development.version = ReactVersion;
    })();
  }

  return reactDomServer_browser_development;
}

var l$1, s$1;

if (process.env.NODE_ENV === "production") {
  l$1 = requireReactDomServerLegacy_browser_production_min();
  s$1 = requireReactDomServer_browser_production_min();
} else {
  l$1 = requireReactDomServerLegacy_browser_development();
  s$1 = requireReactDomServer_browser_development();
}

server_browser.version = l$1.version;
server_browser.renderToString = l$1.renderToString;
server_browser.renderToStaticMarkup = l$1.renderToStaticMarkup;
server_browser.renderToNodeStream = l$1.renderToNodeStream;
server_browser.renderToStaticNodeStream = l$1.renderToStaticNodeStream;
server_browser.renderToReadableStream = s$1.renderToReadableStream;
var reactIs$2 = {
  exports: {}
};
var reactIs_production_min$1 = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b2 = Symbol.for("react.element"),
      c2 = Symbol.for("react.portal"),
      d2 = Symbol.for("react.fragment"),
      e2 = Symbol.for("react.strict_mode"),
      f2 = Symbol.for("react.profiler"),
      g2 = Symbol.for("react.provider"),
      h2 = Symbol.for("react.context"),
      k2 = Symbol.for("react.server_context"),
      l2 = Symbol.for("react.forward_ref"),
      m2 = Symbol.for("react.suspense"),
      n2 = Symbol.for("react.suspense_list"),
      p2 = Symbol.for("react.memo"),
      q2 = Symbol.for("react.lazy"),
      t2 = Symbol.for("react.offscreen"),
      u2;
  u2 = Symbol.for("react.module.reference");

  function v2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var r2 = a2.$$typeof;

      switch (r2) {
        case b2:
          switch (a2 = a2.type, a2) {
            case d2:
            case f2:
            case e2:
            case m2:
            case n2:
              return a2;

            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case h2:
                case l2:
                case q2:
                case p2:
                case g2:
                  return a2;

                default:
                  return r2;
              }

          }

        case c2:
          return r2;
      }
    }
  }

  reactIs_production_min$1.ContextConsumer = h2;
  reactIs_production_min$1.ContextProvider = g2;
  reactIs_production_min$1.Element = b2;
  reactIs_production_min$1.ForwardRef = l2;
  reactIs_production_min$1.Fragment = d2;
  reactIs_production_min$1.Lazy = q2;
  reactIs_production_min$1.Memo = p2;
  reactIs_production_min$1.Portal = c2;
  reactIs_production_min$1.Profiler = f2;
  reactIs_production_min$1.StrictMode = e2;
  reactIs_production_min$1.Suspense = m2;
  reactIs_production_min$1.SuspenseList = n2;

  reactIs_production_min$1.isAsyncMode = function () {
    return false;
  };

  reactIs_production_min$1.isConcurrentMode = function () {
    return false;
  };

  reactIs_production_min$1.isContextConsumer = function (a2) {
    return v2(a2) === h2;
  };

  reactIs_production_min$1.isContextProvider = function (a2) {
    return v2(a2) === g2;
  };

  reactIs_production_min$1.isElement = function (a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === b2;
  };

  reactIs_production_min$1.isForwardRef = function (a2) {
    return v2(a2) === l2;
  };

  reactIs_production_min$1.isFragment = function (a2) {
    return v2(a2) === d2;
  };

  reactIs_production_min$1.isLazy = function (a2) {
    return v2(a2) === q2;
  };

  reactIs_production_min$1.isMemo = function (a2) {
    return v2(a2) === p2;
  };

  reactIs_production_min$1.isPortal = function (a2) {
    return v2(a2) === c2;
  };

  reactIs_production_min$1.isProfiler = function (a2) {
    return v2(a2) === f2;
  };

  reactIs_production_min$1.isStrictMode = function (a2) {
    return v2(a2) === e2;
  };

  reactIs_production_min$1.isSuspense = function (a2) {
    return v2(a2) === m2;
  };

  reactIs_production_min$1.isSuspenseList = function (a2) {
    return v2(a2) === n2;
  };

  reactIs_production_min$1.isValidElementType = function (a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === d2 || a2 === f2 || a2 === e2 || a2 === m2 || a2 === n2 || a2 === t2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === q2 || a2.$$typeof === p2 || a2.$$typeof === g2 || a2.$$typeof === h2 || a2.$$typeof === l2 || a2.$$typeof === u2 || void 0 !== a2.getModuleId) ? true : false;
  };

  reactIs_production_min$1.typeOf = v2;
  return reactIs_production_min$1;
}

var reactIs_development$1 = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var REACT_ELEMENT_TYPE2 = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }

      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }

        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }

        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }

        return false;
      }

      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE2:
              var type = object.type;

              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_SERVER_CONTEXT_TYPE:
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return void 0;
      }

      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE2;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false;

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }

      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true;
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE2;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
      }

      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element2;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment2;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.SuspenseList = SuspenseList;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isSuspenseList = isSuspenseList;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }

  return reactIs_development$1;
}

(function (module2) {
  if (process.env.NODE_ENV === "production") {
    module2.exports = requireReactIs_production_min$1();
  } else {
    module2.exports = requireReactIs_development$1();
  }
})(reactIs$2);

var ReactIs$1 = /* @__PURE__ */getDefaultExportFromCjs(reactIs$2.exports);

var shallowequal = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];
    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
};

function stylis_min(W2) {
  function M2(d2, c2, e2, h2, a2) {
    for (var m2 = 0, b2 = 0, v2 = 0, n2 = 0, q2, g2, x2 = 0, K2 = 0, k2, u2 = k2 = q2 = 0, l2 = 0, r2 = 0, I2 = 0, t2 = 0, B3 = e2.length, J2 = B3 - 1, y2, f2 = "", p2 = "", F3 = "", G3 = "", C2; l2 < B3;) {
      g2 = e2.charCodeAt(l2);
      l2 === J2 && 0 !== b2 + n2 + v2 + m2 && (0 !== b2 && (g2 = 47 === b2 ? 10 : 47), n2 = v2 = m2 = 0, B3++, J2++);

      if (0 === b2 + n2 + v2 + m2) {
        if (l2 === J2 && (0 < r2 && (f2 = f2.replace(N2, "")), 0 < f2.trim().length)) {
          switch (g2) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f2 += e2.charAt(l2);
          }

          g2 = 59;
        }

        switch (g2) {
          case 123:
            f2 = f2.trim();
            q2 = f2.charCodeAt(0);
            k2 = 1;

            for (t2 = ++l2; l2 < B3;) {
              switch (g2 = e2.charCodeAt(l2)) {
                case 123:
                  k2++;
                  break;

                case 125:
                  k2--;
                  break;

                case 47:
                  switch (g2 = e2.charCodeAt(l2 + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u2 = l2 + 1; u2 < J2; ++u2) {
                          switch (e2.charCodeAt(u2)) {
                            case 47:
                              if (42 === g2 && 42 === e2.charCodeAt(u2 - 1) && l2 + 2 !== u2) {
                                l2 = u2 + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g2) {
                                l2 = u2 + 1;
                                break a;
                              }

                          }
                        }

                        l2 = u2;
                      }

                  }

                  break;

                case 91:
                  g2++;

                case 40:
                  g2++;

                case 34:
                case 39:
                  for (; l2++ < J2 && e2.charCodeAt(l2) !== g2;) {}

              }

              if (0 === k2) break;
              l2++;
            }

            k2 = e2.substring(t2, l2);
            0 === q2 && (q2 = (f2 = f2.replace(ca, "").trim()).charCodeAt(0));

            switch (q2) {
              case 64:
                0 < r2 && (f2 = f2.replace(N2, ""));
                g2 = f2.charCodeAt(1);

                switch (g2) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r2 = c2;
                    break;

                  default:
                    r2 = O2;
                }

                k2 = M2(c2, r2, k2, g2, a2 + 1);
                t2 = k2.length;
                0 < A2 && (r2 = X2(O2, f2, I2), C2 = H2(3, k2, r2, c2, D2, z2, t2, g2, a2, h2), f2 = r2.join(""), void 0 !== C2 && 0 === (t2 = (k2 = C2.trim()).length) && (g2 = 0, k2 = ""));
                if (0 < t2) switch (g2) {
                  case 115:
                    f2 = f2.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k2 = f2 + "{" + k2 + "}";
                    break;

                  case 107:
                    f2 = f2.replace(fa, "$1 $2");
                    k2 = f2 + "{" + k2 + "}";
                    k2 = 1 === w2 || 2 === w2 && L2("@" + k2, 3) ? "@-webkit-" + k2 + "@" + k2 : "@" + k2;
                    break;

                  default:
                    k2 = f2 + k2, 112 === h2 && (k2 = (p2 += k2, ""));
                } else k2 = "";
                break;

              default:
                k2 = M2(c2, X2(c2, f2, I2), k2, h2, a2 + 1);
            }

            F3 += k2;
            k2 = I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e2.charCodeAt(++l2);
            break;

          case 125:
          case 59:
            f2 = (0 < r2 ? f2.replace(N2, "") : f2).trim();
            if (1 < (t2 = f2.length)) switch (0 === u2 && (q2 = f2.charCodeAt(0), 45 === q2 || 96 < q2 && 123 > q2) && (t2 = (f2 = f2.replace(" ", ":")).length), 0 < A2 && void 0 !== (C2 = H2(1, f2, c2, d2, D2, z2, p2.length, h2, a2, h2)) && 0 === (t2 = (f2 = C2.trim()).length) && (f2 = "\0\0"), q2 = f2.charCodeAt(0), g2 = f2.charCodeAt(1), q2) {
              case 0:
                break;

              case 64:
                if (105 === g2 || 99 === g2) {
                  G3 += f2 + e2.charAt(l2);
                  break;
                }

              default:
                58 !== f2.charCodeAt(t2 - 1) && (p2 += P2(f2, q2, g2, f2.charCodeAt(2)));
            }
            I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e2.charCodeAt(++l2);
        }
      }

      switch (g2) {
        case 13:
        case 10:
          47 === b2 ? b2 = 0 : 0 === 1 + q2 && 107 !== h2 && 0 < f2.length && (r2 = 1, f2 += "\0");
          0 < A2 * Y2 && H2(0, f2, c2, d2, D2, z2, p2.length, h2, a2, h2);
          z2 = 1;
          D2++;
          break;

        case 59:
        case 125:
          if (0 === b2 + n2 + v2 + m2) {
            z2++;
            break;
          }

        default:
          z2++;
          y2 = e2.charAt(l2);

          switch (g2) {
            case 9:
            case 32:
              if (0 === n2 + m2 + b2) switch (x2) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y2 = "";
                  break;

                default:
                  32 !== g2 && (y2 = " ");
              }
              break;

            case 0:
              y2 = "\\0";
              break;

            case 12:
              y2 = "\\f";
              break;

            case 11:
              y2 = "\\v";
              break;

            case 38:
              0 === n2 + b2 + m2 && (r2 = I2 = 1, y2 = "\f" + y2);
              break;

            case 108:
              if (0 === n2 + b2 + m2 + E2 && 0 < u2) switch (l2 - u2) {
                case 2:
                  112 === x2 && 58 === e2.charCodeAt(l2 - 3) && (E2 = x2);

                case 8:
                  111 === K2 && (E2 = K2);
              }
              break;

            case 58:
              0 === n2 + b2 + m2 && (u2 = l2);
              break;

            case 44:
              0 === b2 + v2 + n2 + m2 && (r2 = 1, y2 += "\r");
              break;

            case 34:
            case 39:
              0 === b2 && (n2 = n2 === g2 ? 0 : 0 === n2 ? g2 : n2);
              break;

            case 91:
              0 === n2 + b2 + v2 && m2++;
              break;

            case 93:
              0 === n2 + b2 + v2 && m2--;
              break;

            case 41:
              0 === n2 + b2 + m2 && v2--;
              break;

            case 40:
              if (0 === n2 + b2 + m2) {
                if (0 === q2) switch (2 * x2 + 3 * K2) {
                  case 533:
                    break;

                  default:
                    q2 = 1;
                }
                v2++;
              }

              break;

            case 64:
              0 === b2 + v2 + n2 + m2 + u2 + k2 && (k2 = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n2 + m2 + v2)) switch (b2) {
                case 0:
                  switch (2 * g2 + 3 * e2.charCodeAt(l2 + 1)) {
                    case 235:
                      b2 = 47;
                      break;

                    case 220:
                      t2 = l2, b2 = 42;
                  }

                  break;

                case 42:
                  47 === g2 && 42 === x2 && t2 + 2 !== l2 && (33 === e2.charCodeAt(t2 + 2) && (p2 += e2.substring(t2, l2 + 1)), y2 = "", b2 = 0);
              }
          }

          0 === b2 && (f2 += y2);
      }

      K2 = x2;
      x2 = g2;
      l2++;
    }

    t2 = p2.length;

    if (0 < t2) {
      r2 = c2;
      if (0 < A2 && (C2 = H2(2, p2, r2, d2, D2, z2, t2, h2, a2, h2), void 0 !== C2 && 0 === (p2 = C2).length)) return G3 + p2 + F3;
      p2 = r2.join(",") + "{" + p2 + "}";

      if (0 !== w2 * E2) {
        2 !== w2 || L2(p2, 2) || (E2 = 0);

        switch (E2) {
          case 111:
            p2 = p2.replace(ha, ":-moz-$1") + p2;
            break;

          case 112:
            p2 = p2.replace(Q2, "::-webkit-input-$1") + p2.replace(Q2, "::-moz-$1") + p2.replace(Q2, ":-ms-input-$1") + p2;
        }

        E2 = 0;
      }
    }

    return G3 + p2 + F3;
  }

  function X2(d2, c2, e2) {
    var h2 = c2.trim().split(ia);
    c2 = h2;
    var a2 = h2.length,
        m2 = d2.length;

    switch (m2) {
      case 0:
      case 1:
        var b2 = 0;

        for (d2 = 0 === m2 ? "" : d2[0] + " "; b2 < a2; ++b2) {
          c2[b2] = Z2(d2, c2[b2], e2).trim();
        }

        break;

      default:
        var v2 = b2 = 0;

        for (c2 = []; b2 < a2; ++b2) {
          for (var n2 = 0; n2 < m2; ++n2) {
            c2[v2++] = Z2(d2[n2] + " ", h2[b2], e2).trim();
          }
        }

    }

    return c2;
  }

  function Z2(d2, c2, e2) {
    var h2 = c2.charCodeAt(0);
    33 > h2 && (h2 = (c2 = c2.trim()).charCodeAt(0));

    switch (h2) {
      case 38:
        return c2.replace(F2, "$1" + d2.trim());

      case 58:
        return d2.trim() + c2.replace(F2, "$1" + d2.trim());

      default:
        if (0 < 1 * e2 && 0 < c2.indexOf("\f")) return c2.replace(F2, (58 === d2.charCodeAt(0) ? "" : "$1") + d2.trim());
    }

    return d2 + c2;
  }

  function P2(d2, c2, e2, h2) {
    var a2 = d2 + ";",
        m2 = 2 * c2 + 3 * e2 + 4 * h2;

    if (944 === m2) {
      d2 = a2.indexOf(":", 9) + 1;
      var b2 = a2.substring(d2, a2.length - 1).trim();
      b2 = a2.substring(0, d2).trim() + b2 + ";";
      return 1 === w2 || 2 === w2 && L2(b2, 1) ? "-webkit-" + b2 + b2 : b2;
    }

    if (0 === w2 || 2 === w2 && !L2(a2, 1)) return a2;

    switch (m2) {
      case 1015:
        return 97 === a2.charCodeAt(10) ? "-webkit-" + a2 + a2 : a2;

      case 951:
        return 116 === a2.charCodeAt(3) ? "-webkit-" + a2 + a2 : a2;

      case 963:
        return 110 === a2.charCodeAt(5) ? "-webkit-" + a2 + a2 : a2;

      case 1009:
        if (100 !== a2.charCodeAt(4)) break;

      case 969:
      case 942:
        return "-webkit-" + a2 + a2;

      case 978:
        return "-webkit-" + a2 + "-moz-" + a2 + a2;

      case 1019:
      case 983:
        return "-webkit-" + a2 + "-moz-" + a2 + "-ms-" + a2 + a2;

      case 883:
        if (45 === a2.charCodeAt(8)) return "-webkit-" + a2 + a2;
        if (0 < a2.indexOf("image-set(", 11)) return a2.replace(ja, "$1-webkit-$2") + a2;
        break;

      case 932:
        if (45 === a2.charCodeAt(4)) switch (a2.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a2.replace("-grow", "") + "-webkit-" + a2 + "-ms-" + a2.replace("grow", "positive") + a2;

          case 115:
            return "-webkit-" + a2 + "-ms-" + a2.replace("shrink", "negative") + a2;

          case 98:
            return "-webkit-" + a2 + "-ms-" + a2.replace("basis", "preferred-size") + a2;
        }
        return "-webkit-" + a2 + "-ms-" + a2 + a2;

      case 964:
        return "-webkit-" + a2 + "-ms-flex-" + a2 + a2;

      case 1023:
        if (99 !== a2.charCodeAt(8)) break;
        b2 = a2.substring(a2.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b2 + "-webkit-" + a2 + "-ms-flex-pack" + b2 + a2;

      case 1005:
        return ka.test(a2) ? a2.replace(aa, ":-webkit-") + a2.replace(aa, ":-moz-") + a2 : a2;

      case 1e3:
        b2 = a2.substring(13).trim();
        c2 = b2.indexOf("-") + 1;

        switch (b2.charCodeAt(0) + b2.charCodeAt(c2)) {
          case 226:
            b2 = a2.replace(G2, "tb");
            break;

          case 232:
            b2 = a2.replace(G2, "tb-rl");
            break;

          case 220:
            b2 = a2.replace(G2, "lr");
            break;

          default:
            return a2;
        }

        return "-webkit-" + a2 + "-ms-" + b2 + a2;

      case 1017:
        if (-1 === a2.indexOf("sticky", 9)) break;

      case 975:
        c2 = (a2 = d2).length - 10;
        b2 = (33 === a2.charCodeAt(c2) ? a2.substring(0, c2) : a2).substring(d2.indexOf(":", 7) + 1).trim();

        switch (m2 = b2.charCodeAt(0) + (b2.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b2.charCodeAt(8)) break;

          case 115:
            a2 = a2.replace(b2, "-webkit-" + b2) + ";" + a2;
            break;

          case 207:
          case 102:
            a2 = a2.replace(b2, "-webkit-" + (102 < m2 ? "inline-" : "") + "box") + ";" + a2.replace(b2, "-webkit-" + b2) + ";" + a2.replace(b2, "-ms-" + b2 + "box") + ";" + a2;
        }

        return a2 + ";";

      case 938:
        if (45 === a2.charCodeAt(5)) switch (a2.charCodeAt(6)) {
          case 105:
            return b2 = a2.replace("-items", ""), "-webkit-" + a2 + "-webkit-box-" + b2 + "-ms-flex-" + b2 + a2;

          case 115:
            return "-webkit-" + a2 + "-ms-flex-item-" + a2.replace(ba, "") + a2;

          default:
            return "-webkit-" + a2 + "-ms-flex-line-pack" + a2.replace("align-content", "").replace(ba, "") + a2;
        }
        break;

      case 973:
      case 989:
        if (45 !== a2.charCodeAt(3) || 122 === a2.charCodeAt(4)) break;

      case 931:
      case 953:
        if (true === la.test(d2)) return 115 === (b2 = d2.substring(d2.indexOf(":") + 1)).charCodeAt(0) ? P2(d2.replace("stretch", "fill-available"), c2, e2, h2).replace(":fill-available", ":stretch") : a2.replace(b2, "-webkit-" + b2) + a2.replace(b2, "-moz-" + b2.replace("fill-", "")) + a2;
        break;

      case 962:
        if (a2 = "-webkit-" + a2 + (102 === a2.charCodeAt(5) ? "-ms-" + a2 : "") + a2, 211 === e2 + h2 && 105 === a2.charCodeAt(13) && 0 < a2.indexOf("transform", 10)) return a2.substring(0, a2.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a2;
    }

    return a2;
  }

  function L2(d2, c2) {
    var e2 = d2.indexOf(1 === c2 ? ":" : "{"),
        h2 = d2.substring(0, 3 !== c2 ? e2 : 10);
    e2 = d2.substring(e2 + 1, d2.length - 1);
    return R2(2 !== c2 ? h2 : h2.replace(na, "$1"), e2, c2);
  }

  function ea(d2, c2) {
    var e2 = P2(c2, c2.charCodeAt(0), c2.charCodeAt(1), c2.charCodeAt(2));
    return e2 !== c2 + ";" ? e2.replace(oa, " or ($1)").substring(4) : "(" + c2 + ")";
  }

  function H2(d2, c2, e2, h2, a2, m2, b2, v2, n2, q2) {
    for (var g2 = 0, x2 = c2, w3; g2 < A2; ++g2) {
      switch (w3 = S2[g2].call(B2, d2, x2, e2, h2, a2, m2, b2, v2, n2, q2)) {
        case void 0:
        case false:
        case true:
        case null:
          break;

        default:
          x2 = w3;
      }
    }

    if (x2 !== c2) return x2;
  }

  function T2(d2) {
    switch (d2) {
      case void 0:
      case null:
        A2 = S2.length = 0;
        break;

      default:
        if ("function" === typeof d2) S2[A2++] = d2;else if ("object" === typeof d2) for (var c2 = 0, e2 = d2.length; c2 < e2; ++c2) {
          T2(d2[c2]);
        } else Y2 = !!d2 | 0;
    }

    return T2;
  }

  function U2(d2) {
    d2 = d2.prefix;
    void 0 !== d2 && (R2 = null, d2 ? "function" !== typeof d2 ? w2 = 1 : (w2 = 2, R2 = d2) : w2 = 0);
    return U2;
  }

  function B2(d2, c2) {
    var e2 = d2;
    33 > e2.charCodeAt(0) && (e2 = e2.trim());
    V2 = e2;
    e2 = [V2];

    if (0 < A2) {
      var h2 = H2(-1, c2, e2, e2, D2, z2, 0, 0, 0, 0);
      void 0 !== h2 && "string" === typeof h2 && (c2 = h2);
    }

    var a2 = M2(O2, e2, c2, 0, 0);
    0 < A2 && (h2 = H2(-2, a2, e2, e2, D2, z2, a2.length, 0, 0, 0), void 0 !== h2 && (a2 = h2));
    V2 = "";
    E2 = 0;
    z2 = D2 = 1;
    return a2;
  }

  var ca = /^\0+/g,
      N2 = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F2 = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q2 = /::(place)/g,
      ha = /:(read-only)/g,
      G2 = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z2 = 1,
      D2 = 1,
      E2 = 0,
      w2 = 1,
      O2 = [],
      S2 = [],
      A2 = 0,
      R2 = null,
      Y2 = 0,
      V2 = "";
  B2.use = T2;
  B2.set = U2;
  void 0 !== W2 && U2(W2);
  return B2;
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize$1(fn) {
  var cache = /* @__PURE__ */Object.create(null);
  return function (arg) {
    if (cache[arg] === void 0) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */memoize$1(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var reactIs$1 = {
  exports: {}
};
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b2 = "function" === typeof Symbol && Symbol.for,
      c2 = b2 ? Symbol.for("react.element") : 60103,
      d2 = b2 ? Symbol.for("react.portal") : 60106,
      e2 = b2 ? Symbol.for("react.fragment") : 60107,
      f2 = b2 ? Symbol.for("react.strict_mode") : 60108,
      g2 = b2 ? Symbol.for("react.profiler") : 60114,
      h2 = b2 ? Symbol.for("react.provider") : 60109,
      k2 = b2 ? Symbol.for("react.context") : 60110,
      l2 = b2 ? Symbol.for("react.async_mode") : 60111,
      m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111,
      n2 = b2 ? Symbol.for("react.forward_ref") : 60112,
      p2 = b2 ? Symbol.for("react.suspense") : 60113,
      q2 = b2 ? Symbol.for("react.suspense_list") : 60120,
      r2 = b2 ? Symbol.for("react.memo") : 60115,
      t2 = b2 ? Symbol.for("react.lazy") : 60116,
      v2 = b2 ? Symbol.for("react.block") : 60121,
      w2 = b2 ? Symbol.for("react.fundamental") : 60117,
      x2 = b2 ? Symbol.for("react.responder") : 60118,
      y2 = b2 ? Symbol.for("react.scope") : 60119;

  function z2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;

      switch (u2) {
        case c2:
          switch (a2 = a2.type, a2) {
            case l2:
            case m2:
            case e2:
            case g2:
            case f2:
            case p2:
              return a2;

            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h2:
                  return a2;

                default:
                  return u2;
              }

          }

        case d2:
          return u2;
      }
    }
  }

  function A2(a2) {
    return z2(a2) === m2;
  }

  reactIs_production_min.AsyncMode = l2;
  reactIs_production_min.ConcurrentMode = m2;
  reactIs_production_min.ContextConsumer = k2;
  reactIs_production_min.ContextProvider = h2;
  reactIs_production_min.Element = c2;
  reactIs_production_min.ForwardRef = n2;
  reactIs_production_min.Fragment = e2;
  reactIs_production_min.Lazy = t2;
  reactIs_production_min.Memo = r2;
  reactIs_production_min.Portal = d2;
  reactIs_production_min.Profiler = g2;
  reactIs_production_min.StrictMode = f2;
  reactIs_production_min.Suspense = p2;

  reactIs_production_min.isAsyncMode = function (a2) {
    return A2(a2) || z2(a2) === l2;
  };

  reactIs_production_min.isConcurrentMode = A2;

  reactIs_production_min.isContextConsumer = function (a2) {
    return z2(a2) === k2;
  };

  reactIs_production_min.isContextProvider = function (a2) {
    return z2(a2) === h2;
  };

  reactIs_production_min.isElement = function (a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
  };

  reactIs_production_min.isForwardRef = function (a2) {
    return z2(a2) === n2;
  };

  reactIs_production_min.isFragment = function (a2) {
    return z2(a2) === e2;
  };

  reactIs_production_min.isLazy = function (a2) {
    return z2(a2) === t2;
  };

  reactIs_production_min.isMemo = function (a2) {
    return z2(a2) === r2;
  };

  reactIs_production_min.isPortal = function (a2) {
    return z2(a2) === d2;
  };

  reactIs_production_min.isProfiler = function (a2) {
    return z2(a2) === g2;
  };

  reactIs_production_min.isStrictMode = function (a2) {
    return z2(a2) === f2;
  };

  reactIs_production_min.isSuspense = function (a2) {
    return z2(a2) === p2;
  };

  reactIs_production_min.isValidElementType = function (a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e2 || a2 === m2 || a2 === g2 || a2 === f2 || a2 === p2 || a2 === q2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h2 || a2.$$typeof === k2 || a2.$$typeof === n2 || a2.$$typeof === w2 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v2);
  };

  reactIs_production_min.typeOf = z2;
  return reactIs_production_min;
}

var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE2 = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;

      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE2:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return void 0;
      }

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE2;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE2;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }

  return reactIs_development;
}

(function (module2) {
  if (process.env.NODE_ENV === "production") {
    module2.exports = requireReactIs_production_min();
  } else {
    module2.exports = requireReactIs_development();
  }
})(reactIs$1);

var reactIs = reactIs$1.exports;
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}

var defineProperty$2 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== "string") {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys2 = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys2 = keys2.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i2 = 0; i2 < keys2.length; ++i2) {
      var key = keys2[i2];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          defineProperty$2(targetComponent, key, descriptor);
        } catch (e2) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function v$1() {
  return (v$1 = Object.assign || function (e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var n2 = arguments[t2];

      for (var r2 in n2) {
        Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
    }

    return e2;
  }).apply(this, arguments);
}

var g$1 = function g$1(e2, t2) {
  for (var n2 = [e2[0]], r2 = 0, o2 = t2.length; r2 < o2; r2 += 1) {
    n2.push(t2[r2], e2[r2 + 1]);
  }

  return n2;
},
    S$1 = function S$1(t2) {
  return null !== t2 && "object" == typeof t2 && "[object Object]" === (t2.toString ? t2.toString() : Object.prototype.toString.call(t2)) && !reactIs$2.exports.typeOf(t2);
},
    w$1 = Object.freeze([]),
    E$1 = Object.freeze({});

function b$1(e2) {
  return "function" == typeof e2;
}

function _(e2) {
  return "production" !== process.env.NODE_ENV && "string" == typeof e2 && e2 || e2.displayName || e2.name || "Component";
}

function N(e2) {
  return e2 && "string" == typeof e2.styledComponentId;
}

var A = "undefined" != typeof process && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled",
    C = "5.3.6",
    I = "undefined" != typeof window && "HTMLElement" in window,
    P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY ? "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY : "production" !== process.env.NODE_ENV),
    O$1 = {},
    R = "production" !== process.env.NODE_ENV ? {
  1: "Cannot create styled-component for component: %s.\n\n",
  2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
  8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
  9: "Missing document `<head>`\n\n",
  10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
  14: 'ThemeProvider: "theme" prop is required.\n\n',
  15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
  16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
  17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
} : {};

function D() {
  for (var e2 = arguments.length <= 0 ? void 0 : arguments[0], t2 = [], n2 = 1, r2 = arguments.length; n2 < r2; n2 += 1) {
    t2.push(n2 < 0 || arguments.length <= n2 ? void 0 : arguments[n2]);
  }

  return t2.forEach(function (t3) {
    e2 = e2.replace(/%[a-z]/, t3);
  }), e2;
}

function j$1(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++) {
    n2[r2 - 1] = arguments[r2];
  }

  throw "production" === process.env.NODE_ENV ? new Error("An error occurred. See https://git.io/JUIaE#" + e2 + " for more information." + (n2.length > 0 ? " Args: " + n2.join(", ") : "")) : new Error(D.apply(void 0, [R[e2]].concat(n2)).trim());
}

var T = function () {
  function e2(e3) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e3;
  }

  var t2 = e2.prototype;
  return t2.indexOfGroup = function (e3) {
    for (var t3 = 0, n2 = 0; n2 < e3; n2++) {
      t3 += this.groupSizes[n2];
    }

    return t3;
  }, t2.insertRules = function (e3, t3) {
    if (e3 >= this.groupSizes.length) {
      for (var n2 = this.groupSizes, r2 = n2.length, o2 = r2; e3 >= o2;) {
        (o2 <<= 1) < 0 && j$1(16, "" + e3);
      }

      this.groupSizes = new Uint32Array(o2), this.groupSizes.set(n2), this.length = o2;

      for (var s2 = r2; s2 < o2; s2++) {
        this.groupSizes[s2] = 0;
      }
    }

    for (var i2 = this.indexOfGroup(e3 + 1), a2 = 0, c2 = t3.length; a2 < c2; a2++) {
      this.tag.insertRule(i2, t3[a2]) && (this.groupSizes[e3]++, i2++);
    }
  }, t2.clearGroup = function (e3) {
    if (e3 < this.length) {
      var t3 = this.groupSizes[e3],
          n2 = this.indexOfGroup(e3),
          r2 = n2 + t3;
      this.groupSizes[e3] = 0;

      for (var o2 = n2; o2 < r2; o2++) {
        this.tag.deleteRule(n2);
      }
    }
  }, t2.getGroup = function (e3) {
    var t3 = "";
    if (e3 >= this.length || 0 === this.groupSizes[e3]) return t3;

    for (var n2 = this.groupSizes[e3], r2 = this.indexOfGroup(e3), o2 = r2 + n2, s2 = r2; s2 < o2; s2++) {
      t3 += this.tag.getRule(s2) + "/*!sc*/\n";
    }

    return t3;
  }, e2;
}(),
    x$1 = /* @__PURE__ */new Map(),
    k = /* @__PURE__ */new Map(),
    V = 1,
    B = function B(e2) {
  if (x$1.has(e2)) return x$1.get(e2);

  for (; k.has(V);) {
    V++;
  }

  var t2 = V++;
  return "production" !== process.env.NODE_ENV && ((0 | t2) < 0 || t2 > 1 << 30) && j$1(16, "" + t2), x$1.set(e2, t2), k.set(t2, e2), t2;
},
    z$1 = function z$1(e2) {
  return k.get(e2);
},
    M = function M(e2, t2) {
  t2 >= V && (V = t2 + 1), x$1.set(e2, t2), k.set(t2, e2);
},
    G = "style[" + A + '][data-styled-version="5.3.6"]',
    L = new RegExp("^" + A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
    F = function F(e2, t2, n2) {
  for (var r2, o2 = n2.split(","), s2 = 0, i2 = o2.length; s2 < i2; s2++) {
    (r2 = o2[s2]) && e2.registerName(t2, r2);
  }
},
    Y = function Y(e2, t2) {
  for (var n2 = (t2.textContent || "").split("/*!sc*/\n"), r2 = [], o2 = 0, s2 = n2.length; o2 < s2; o2++) {
    var i2 = n2[o2].trim();

    if (i2) {
      var a2 = i2.match(L);

      if (a2) {
        var c2 = 0 | parseInt(a2[1], 10),
            u2 = a2[2];
        0 !== c2 && (M(u2, c2), F(e2, u2, a2[3]), e2.getTag().insertRules(c2, r2)), r2.length = 0;
      } else r2.push(i2);
    }
  }
},
    q = function q() {
  return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
},
    H = function H(e2) {
  var t2 = document.head,
      n2 = e2 || t2,
      r2 = document.createElement("style"),
      o2 = function (e3) {
    for (var t3 = e3.childNodes, n3 = t3.length; n3 >= 0; n3--) {
      var r3 = t3[n3];
      if (r3 && 1 === r3.nodeType && r3.hasAttribute(A)) return r3;
    }
  }(n2),
      s2 = void 0 !== o2 ? o2.nextSibling : null;

  r2.setAttribute(A, "active"), r2.setAttribute("data-styled-version", "5.3.6");
  var i2 = q();
  return i2 && r2.setAttribute("nonce", i2), n2.insertBefore(r2, s2), r2;
},
    $ = function () {
  function e2(e3) {
    var t3 = this.element = H(e3);
    t3.appendChild(document.createTextNode("")), this.sheet = function (e4) {
      if (e4.sheet) return e4.sheet;

      for (var t4 = document.styleSheets, n2 = 0, r2 = t4.length; n2 < r2; n2++) {
        var o2 = t4[n2];
        if (o2.ownerNode === e4) return o2;
      }

      j$1(17);
    }(t3), this.length = 0;
  }

  var t2 = e2.prototype;
  return t2.insertRule = function (e3, t3) {
    try {
      return this.sheet.insertRule(t3, e3), this.length++, true;
    } catch (e4) {
      return false;
    }
  }, t2.deleteRule = function (e3) {
    this.sheet.deleteRule(e3), this.length--;
  }, t2.getRule = function (e3) {
    var t3 = this.sheet.cssRules[e3];
    return void 0 !== t3 && "string" == typeof t3.cssText ? t3.cssText : "";
  }, e2;
}(),
    W = function () {
  function e2(e3) {
    var t3 = this.element = H(e3);
    this.nodes = t3.childNodes, this.length = 0;
  }

  var t2 = e2.prototype;
  return t2.insertRule = function (e3, t3) {
    if (e3 <= this.length && e3 >= 0) {
      var n2 = document.createTextNode(t3),
          r2 = this.nodes[e3];
      return this.element.insertBefore(n2, r2 || null), this.length++, true;
    }

    return false;
  }, t2.deleteRule = function (e3) {
    this.element.removeChild(this.nodes[e3]), this.length--;
  }, t2.getRule = function (e3) {
    return e3 < this.length ? this.nodes[e3].textContent : "";
  }, e2;
}(),
    U = function () {
  function e2(e3) {
    this.rules = [], this.length = 0;
  }

  var t2 = e2.prototype;
  return t2.insertRule = function (e3, t3) {
    return e3 <= this.length && (this.rules.splice(e3, 0, t3), this.length++, true);
  }, t2.deleteRule = function (e3) {
    this.rules.splice(e3, 1), this.length--;
  }, t2.getRule = function (e3) {
    return e3 < this.length ? this.rules[e3] : "";
  }, e2;
}(),
    J = I,
    X = {
  isServer: !I,
  useCSSOMInjection: !P
},
    Z = function () {
  function e2(e3, t3, n2) {
    void 0 === e3 && (e3 = E$1), void 0 === t3 && (t3 = {}), this.options = v$1({}, X, {}, e3), this.gs = t3, this.names = new Map(n2), this.server = !!e3.isServer, !this.server && I && J && (J = false, function (e4) {
      for (var t4 = document.querySelectorAll(G), n3 = 0, r2 = t4.length; n3 < r2; n3++) {
        var o2 = t4[n3];
        o2 && "active" !== o2.getAttribute(A) && (Y(e4, o2), o2.parentNode && o2.parentNode.removeChild(o2));
      }
    }(this));
  }

  e2.registerId = function (e3) {
    return B(e3);
  };

  var t2 = e2.prototype;
  return t2.reconstructWithOptions = function (t3, n2) {
    return void 0 === n2 && (n2 = true), new e2(v$1({}, this.options, {}, t3), this.gs, n2 && this.names || void 0);
  }, t2.allocateGSInstance = function (e3) {
    return this.gs[e3] = (this.gs[e3] || 0) + 1;
  }, t2.getTag = function () {
    return this.tag || (this.tag = (n2 = (t3 = this.options).isServer, r2 = t3.useCSSOMInjection, o2 = t3.target, e3 = n2 ? new U(o2) : r2 ? new $(o2) : new W(o2), new T(e3)));
    var e3, t3, n2, r2, o2;
  }, t2.hasNameForId = function (e3, t3) {
    return this.names.has(e3) && this.names.get(e3).has(t3);
  }, t2.registerName = function (e3, t3) {
    if (B(e3), this.names.has(e3)) this.names.get(e3).add(t3);else {
      var n2 = /* @__PURE__ */new Set();
      n2.add(t3), this.names.set(e3, n2);
    }
  }, t2.insertRules = function (e3, t3, n2) {
    this.registerName(e3, t3), this.getTag().insertRules(B(e3), n2);
  }, t2.clearNames = function (e3) {
    this.names.has(e3) && this.names.get(e3).clear();
  }, t2.clearRules = function (e3) {
    this.getTag().clearGroup(B(e3)), this.clearNames(e3);
  }, t2.clearTag = function () {
    this.tag = void 0;
  }, t2.toString = function () {
    return function (e3) {
      for (var t3 = e3.getTag(), n2 = t3.length, r2 = "", o2 = 0; o2 < n2; o2++) {
        var s2 = z$1(o2);

        if (void 0 !== s2) {
          var i2 = e3.names.get(s2),
              a2 = t3.getGroup(o2);

          if (i2 && a2 && i2.size) {
            var c2 = A + ".g" + o2 + '[id="' + s2 + '"]',
                u2 = "";
            void 0 !== i2 && i2.forEach(function (e4) {
              e4.length > 0 && (u2 += e4 + ",");
            }), r2 += "" + a2 + c2 + '{content:"' + u2 + '"}/*!sc*/\n';
          }
        }
      }

      return r2;
    }(this);
  }, e2;
}(),
    K = /(a)(d)/gi,
    Q = function Q(e2) {
  return String.fromCharCode(e2 + (e2 > 25 ? 39 : 97));
};

function ee(e2) {
  var t2,
      n2 = "";

  for (t2 = Math.abs(e2); t2 > 52; t2 = t2 / 52 | 0) {
    n2 = Q(t2 % 52) + n2;
  }

  return (Q(t2 % 52) + n2).replace(K, "$1-$2");
}

var te = function te(e2, t2) {
  for (var n2 = t2.length; n2;) {
    e2 = 33 * e2 ^ t2.charCodeAt(--n2);
  }

  return e2;
},
    ne = function ne(e2) {
  return te(5381, e2);
};

function re(e2) {
  for (var t2 = 0; t2 < e2.length; t2 += 1) {
    var n2 = e2[t2];
    if (b$1(n2) && !N(n2)) return false;
  }

  return true;
}

var oe = ne("5.3.6"),
    se = function () {
  function e2(e3, t2, n2) {
    this.rules = e3, this.staticRulesId = "", this.isStatic = "production" === process.env.NODE_ENV && (void 0 === n2 || n2.isStatic) && re(e3), this.componentId = t2, this.baseHash = te(oe, t2), this.baseStyle = n2, Z.registerId(t2);
  }

  return e2.prototype.generateAndInjectStyles = function (e3, t2, n2) {
    var r2 = this.componentId,
        o2 = [];
    if (this.baseStyle && o2.push(this.baseStyle.generateAndInjectStyles(e3, t2, n2)), this.isStatic && !n2.hash) {
      if (this.staticRulesId && t2.hasNameForId(r2, this.staticRulesId)) o2.push(this.staticRulesId);else {
        var s2 = Ne(this.rules, e3, t2, n2).join(""),
            i2 = ee(te(this.baseHash, s2) >>> 0);

        if (!t2.hasNameForId(r2, i2)) {
          var a2 = n2(s2, "." + i2, void 0, r2);
          t2.insertRules(r2, i2, a2);
        }

        o2.push(i2), this.staticRulesId = i2;
      }
    } else {
      for (var c2 = this.rules.length, u2 = te(this.baseHash, n2.hash), l2 = "", d2 = 0; d2 < c2; d2++) {
        var h2 = this.rules[d2];
        if ("string" == typeof h2) l2 += h2, "production" !== process.env.NODE_ENV && (u2 = te(u2, h2 + d2));else if (h2) {
          var p2 = Ne(h2, e3, t2, n2),
              f2 = Array.isArray(p2) ? p2.join("") : p2;
          u2 = te(u2, f2 + d2), l2 += f2;
        }
      }

      if (l2) {
        var m2 = ee(u2 >>> 0);

        if (!t2.hasNameForId(r2, m2)) {
          var y2 = n2(l2, "." + m2, void 0, r2);
          t2.insertRules(r2, m2, y2);
        }

        o2.push(m2);
      }
    }
    return o2.join(" ");
  }, e2;
}(),
    ie = /^\s*\/\/.*$/gm,
    ae = [":", "[", ".", "#"];

function ce(e2) {
  var t2,
      n2,
      r2,
      o2,
      s2 = void 0 === e2 ? E$1 : e2,
      i2 = s2.options,
      a2 = void 0 === i2 ? E$1 : i2,
      c2 = s2.plugins,
      u2 = void 0 === c2 ? w$1 : c2,
      l2 = new stylis_min(a2),
      d2 = [],
      h2 = function (e3) {
    function t3(t4) {
      if (t4) try {
        e3(t4 + "}");
      } catch (e4) {}
    }

    return function (n3, r3, o3, s3, i3, a3, c3, u3, l3, d3) {
      switch (n3) {
        case 1:
          if (0 === l3 && 64 === r3.charCodeAt(0)) return e3(r3 + ";"), "";
          break;

        case 2:
          if (0 === u3) return r3 + "/*|*/";
          break;

        case 3:
          switch (u3) {
            case 102:
            case 112:
              return e3(o3[0] + r3), "";

            default:
              return r3 + (0 === d3 ? "/*|*/" : "");
          }

        case -2:
          r3.split("/*|*/}").forEach(t3);
      }
    };
  }(function (e3) {
    d2.push(e3);
  }),
      f2 = function f2(e3, r3, s3) {
    return 0 === r3 && -1 !== ae.indexOf(s3[n2.length]) || s3.match(o2) ? e3 : "." + t2;
  };

  function m2(e3, s3, i3, a3) {
    void 0 === a3 && (a3 = "&");
    var c3 = e3.replace(ie, ""),
        u3 = s3 && i3 ? i3 + " " + s3 + " { " + c3 + " }" : c3;
    return t2 = a3, n2 = s3, r2 = new RegExp("\\" + n2 + "\\b", "g"), o2 = new RegExp("(\\" + n2 + "\\b){2,}"), l2(i3 || !s3 ? "" : s3, u3);
  }

  return l2.use([].concat(u2, [function (e3, t3, o3) {
    2 === e3 && o3.length && o3[0].lastIndexOf(n2) > 0 && (o3[0] = o3[0].replace(r2, f2));
  }, h2, function (e3) {
    if (-2 === e3) {
      var t3 = d2;
      return d2 = [], t3;
    }
  }])), m2.hash = u2.length ? u2.reduce(function (e3, t3) {
    return t3.name || j$1(15), te(e3, t3.name);
  }, 5381).toString() : "", m2;
}

var ue = r$1.createContext(),
    le = ue.Consumer,
    de = r$1.createContext(),
    he = (de.Consumer, new Z()),
    pe = ce();

function fe() {
  return useContext(ue) || he;
}

function me() {
  return useContext(de) || pe;
}

function ye(e2) {
  var t2 = useState(e2.stylisPlugins),
      n2 = t2[0],
      s2 = t2[1],
      c2 = fe(),
      u2 = useMemo(function () {
    var t3 = c2;
    return e2.sheet ? t3 = e2.sheet : e2.target && (t3 = t3.reconstructWithOptions({
      target: e2.target
    }, false)), e2.disableCSSOMInjection && (t3 = t3.reconstructWithOptions({
      useCSSOMInjection: false
    })), t3;
  }, [e2.disableCSSOMInjection, e2.sheet, e2.target]),
      l2 = useMemo(function () {
    return ce({
      options: {
        prefix: !e2.disableVendorPrefixes
      },
      plugins: n2
    });
  }, [e2.disableVendorPrefixes, n2]);
  return useEffect(function () {
    shallowequal(n2, e2.stylisPlugins) || s2(e2.stylisPlugins);
  }, [e2.stylisPlugins]), r$1.createElement(ue.Provider, {
    value: u2
  }, r$1.createElement(de.Provider, {
    value: l2
  }, "production" !== process.env.NODE_ENV ? r$1.Children.only(e2.children) : e2.children));
}

var ve = function () {
  function e2(e3, t2) {
    var n2 = this;
    this.inject = function (e4, t3) {
      void 0 === t3 && (t3 = pe);
      var r2 = n2.name + t3.hash;
      e4.hasNameForId(n2.id, r2) || e4.insertRules(n2.id, r2, t3(n2.rules, r2, "@keyframes"));
    }, this.toString = function () {
      return j$1(12, String(n2.name));
    }, this.name = e3, this.id = "sc-keyframes-" + e3, this.rules = t2;
  }

  return e2.prototype.getName = function (e3) {
    return void 0 === e3 && (e3 = pe), this.name + e3.hash;
  }, e2;
}(),
    ge = /([A-Z])/,
    Se = /([A-Z])/g,
    we = /^ms-/,
    Ee = function Ee(e2) {
  return "-" + e2.toLowerCase();
};

function be(e2) {
  return ge.test(e2) ? e2.replace(Se, Ee).replace(we, "-ms-") : e2;
}

var _e = function _e(e2) {
  return null == e2 || false === e2 || "" === e2;
};

function Ne(e2, n2, r2, o2) {
  if (Array.isArray(e2)) {
    for (var s2, i2 = [], a2 = 0, c2 = e2.length; a2 < c2; a2 += 1) {
      "" !== (s2 = Ne(e2[a2], n2, r2, o2)) && (Array.isArray(s2) ? i2.push.apply(i2, s2) : i2.push(s2));
    }

    return i2;
  }

  if (_e(e2)) return "";
  if (N(e2)) return "." + e2.styledComponentId;

  if (b$1(e2)) {
    if ("function" != typeof (l2 = e2) || l2.prototype && l2.prototype.isReactComponent || !n2) return e2;
    var u2 = e2(n2);
    return "production" !== process.env.NODE_ENV && reactIs$2.exports.isElement(u2) && console.warn(_(e2) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Ne(u2, n2, r2, o2);
  }

  var l2;
  return e2 instanceof ve ? r2 ? (e2.inject(r2, o2), e2.getName(o2)) : e2 : S$1(e2) ? function e3(t2, n3) {
    var r3,
        o3,
        s3 = [];

    for (var i3 in t2) {
      t2.hasOwnProperty(i3) && !_e(t2[i3]) && (Array.isArray(t2[i3]) && t2[i3].isCss || b$1(t2[i3]) ? s3.push(be(i3) + ":", t2[i3], ";") : S$1(t2[i3]) ? s3.push.apply(s3, e3(t2[i3], i3)) : s3.push(be(i3) + ": " + (r3 = i3, null == (o3 = t2[i3]) || "boolean" == typeof o3 || "" === o3 ? "" : "number" != typeof o3 || 0 === o3 || r3 in unitlessKeys ? String(o3).trim() : o3 + "px") + ";"));
    }

    return n3 ? [n3 + " {"].concat(s3, ["}"]) : s3;
  }(e2) : e2.toString();
}

var Ae = function Ae(e2) {
  return Array.isArray(e2) && (e2.isCss = true), e2;
};

function Ce(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++) {
    n2[r2 - 1] = arguments[r2];
  }

  return b$1(e2) || S$1(e2) ? Ae(Ne(g$1(w$1, [e2].concat(n2)))) : 0 === n2.length && 1 === e2.length && "string" == typeof e2[0] ? e2 : Ae(Ne(g$1(e2, n2)));
}

var Ie = /invalid hook call/i,
    Pe = /* @__PURE__ */new Set(),
    Oe = function Oe(e2, t2) {
  if ("production" !== process.env.NODE_ENV) {
    var n2 = "The component " + e2 + (t2 ? ' with the id of "' + t2 + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",
        r2 = console.error;

    try {
      var o2 = true;
      console.error = function (e3) {
        if (Ie.test(e3)) o2 = false, Pe.delete(n2);else {
          for (var t3 = arguments.length, s2 = new Array(t3 > 1 ? t3 - 1 : 0), i2 = 1; i2 < t3; i2++) {
            s2[i2 - 1] = arguments[i2];
          }

          r2.apply(void 0, [e3].concat(s2));
        }
      }, useRef(), o2 && !Pe.has(n2) && (console.warn(n2), Pe.add(n2));
    } catch (e3) {
      Ie.test(e3.message) && Pe.delete(n2);
    } finally {
      console.error = r2;
    }
  }
},
    Re = function Re(e2, t2, n2) {
  return void 0 === n2 && (n2 = E$1), e2.theme !== n2.theme && e2.theme || t2 || n2.theme;
},
    De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
    je = /(^-|-$)/g;

function Te(e2) {
  return e2.replace(De, "-").replace(je, "");
}

var xe = function xe(e2) {
  return ee(ne(e2) >>> 0);
};

function ke(e2) {
  return "string" == typeof e2 && ("production" === process.env.NODE_ENV || e2.charAt(0) === e2.charAt(0).toLowerCase());
}

var Ve = function Ve(e2) {
  return "function" == typeof e2 || "object" == typeof e2 && null !== e2 && !Array.isArray(e2);
},
    Be = function Be(e2) {
  return "__proto__" !== e2 && "constructor" !== e2 && "prototype" !== e2;
};

function ze(e2, t2, n2) {
  var r2 = e2[n2];
  Ve(t2) && Ve(r2) ? Me(r2, t2) : e2[n2] = t2;
}

function Me(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++) {
    n2[r2 - 1] = arguments[r2];
  }

  for (var o2 = 0, s2 = n2; o2 < s2.length; o2++) {
    var i2 = s2[o2];
    if (Ve(i2)) for (var a2 in i2) {
      Be(a2) && ze(e2, i2[a2], a2);
    }
  }

  return e2;
}

var Ge = r$1.createContext(),
    Le = Ge.Consumer;

function Fe(e2) {
  var t2 = useContext(Ge),
      n2 = useMemo(function () {
    return function (e3, t3) {
      if (!e3) return j$1(14);

      if (b$1(e3)) {
        var n3 = e3(t3);
        return "production" === process.env.NODE_ENV || null !== n3 && !Array.isArray(n3) && "object" == typeof n3 ? n3 : j$1(7);
      }

      return Array.isArray(e3) || "object" != typeof e3 ? j$1(8) : t3 ? v$1({}, t3, {}, e3) : e3;
    }(e2.theme, t2);
  }, [e2.theme, t2]);
  return e2.children ? r$1.createElement(Ge.Provider, {
    value: n2
  }, e2.children) : null;
}

var Ye = {};

function qe(e2, t2, n2) {
  var o2 = N(e2),
      i2 = !ke(e2),
      a2 = t2.attrs,
      c2 = void 0 === a2 ? w$1 : a2,
      d2 = t2.componentId,
      h2 = void 0 === d2 ? function (e3, t3) {
    var n3 = "string" != typeof e3 ? "sc" : Te(e3);
    Ye[n3] = (Ye[n3] || 0) + 1;
    var r2 = n3 + "-" + xe("5.3.6" + n3 + Ye[n3]);
    return t3 ? t3 + "-" + r2 : r2;
  }(t2.displayName, t2.parentComponentId) : d2,
      p2 = t2.displayName,
      f2 = void 0 === p2 ? function (e3) {
    return ke(e3) ? "styled." + e3 : "Styled(" + _(e3) + ")";
  }(e2) : p2,
      g2 = t2.displayName && t2.componentId ? Te(t2.displayName) + "-" + t2.componentId : t2.componentId || h2,
      S2 = o2 && e2.attrs ? Array.prototype.concat(e2.attrs, c2).filter(Boolean) : c2,
      A2 = t2.shouldForwardProp;
  o2 && e2.shouldForwardProp && (A2 = t2.shouldForwardProp ? function (n3, r2, o3) {
    return e2.shouldForwardProp(n3, r2, o3) && t2.shouldForwardProp(n3, r2, o3);
  } : e2.shouldForwardProp);

  var C2,
      I2 = new se(n2, g2, o2 ? e2.componentStyle : void 0),
      P2 = I2.isStatic && 0 === c2.length,
      O2 = function O2(e3, t3) {
    return function (e4, t4, n3, r2) {
      var o3 = e4.attrs,
          i3 = e4.componentStyle,
          a3 = e4.defaultProps,
          c3 = e4.foldedComponentIds,
          d3 = e4.shouldForwardProp,
          h3 = e4.styledComponentId,
          p3 = e4.target;
      "production" !== process.env.NODE_ENV && useDebugValue(h3);

      var f3 = function (e5, t5, n4) {
        void 0 === e5 && (e5 = E$1);
        var r3 = v$1({}, t5, {
          theme: e5
        }),
            o4 = {};
        return n4.forEach(function (e6) {
          var t6,
              n5,
              s2,
              i4 = e6;

          for (t6 in b$1(i4) && (i4 = i4(r3)), i4) {
            r3[t6] = o4[t6] = "className" === t6 ? (n5 = o4[t6], s2 = i4[t6], n5 && s2 ? n5 + " " + s2 : n5 || s2) : i4[t6];
          }
        }), [r3, o4];
      }(Re(t4, useContext(Ge), a3) || E$1, t4, o3),
          y2 = f3[0],
          g3 = f3[1],
          S3 = function (e5, t5, n4, r3) {
        var o4 = fe(),
            s2 = me(),
            i4 = t5 ? e5.generateAndInjectStyles(E$1, o4, s2) : e5.generateAndInjectStyles(n4, o4, s2);
        return "production" !== process.env.NODE_ENV && useDebugValue(i4), "production" !== process.env.NODE_ENV && !t5 && r3 && r3(i4), i4;
      }(i3, r2, y2, "production" !== process.env.NODE_ENV ? e4.warnTooManyClasses : void 0),
          w2 = n3,
          _2 = g3.$as || t4.$as || g3.as || t4.as || p3,
          N2 = ke(_2),
          A3 = g3 !== t4 ? v$1({}, t4, {}, g3) : t4,
          C3 = {};

      for (var I3 in A3) {
        "$" !== I3[0] && "as" !== I3 && ("forwardedAs" === I3 ? C3.as = A3[I3] : (d3 ? d3(I3, isPropValid, _2) : !N2 || isPropValid(I3)) && (C3[I3] = A3[I3]));
      }

      return t4.style && g3.style !== t4.style && (C3.style = v$1({}, t4.style, {}, g3.style)), C3.className = Array.prototype.concat(c3, h3, S3 !== h3 ? S3 : null, t4.className, g3.className).filter(Boolean).join(" "), C3.ref = w2, createElement(_2, C3);
    }(C2, e3, t3, P2);
  };

  return O2.displayName = f2, (C2 = r$1.forwardRef(O2)).attrs = S2, C2.componentStyle = I2, C2.displayName = f2, C2.shouldForwardProp = A2, C2.foldedComponentIds = o2 ? Array.prototype.concat(e2.foldedComponentIds, e2.styledComponentId) : w$1, C2.styledComponentId = g2, C2.target = o2 ? e2.target : e2, C2.withComponent = function (e3) {
    var r2 = t2.componentId,
        o3 = function (e4, t3) {
      if (null == e4) return {};
      var n3,
          r3,
          o4 = {},
          s3 = Object.keys(e4);

      for (r3 = 0; r3 < s3.length; r3++) {
        n3 = s3[r3], t3.indexOf(n3) >= 0 || (o4[n3] = e4[n3]);
      }

      return o4;
    }(t2, ["componentId"]),
        s2 = r2 && r2 + "-" + (ke(e3) ? e3 : Te(_(e3)));

    return qe(e3, v$1({}, o3, {
      attrs: S2,
      componentId: s2
    }), n2);
  }, Object.defineProperty(C2, "defaultProps", {
    get: function get() {
      return this._foldedDefaultProps;
    },
    set: function set(t3) {
      this._foldedDefaultProps = o2 ? Me({}, e2.defaultProps, t3) : t3;
    }
  }), "production" !== process.env.NODE_ENV && (Oe(f2, g2), C2.warnTooManyClasses = function (e3, t3) {
    var n3 = {},
        r2 = false;
    return function (o3) {
      if (!r2 && (n3[o3] = true, Object.keys(n3).length >= 200)) {
        var s2 = t3 ? ' with the id of "' + t3 + '"' : "";
        console.warn("Over 200 classes were generated for component " + e3 + s2 + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r2 = true, n3 = {};
      }
    };
  }(f2, g2)), C2.toString = function () {
    return "." + C2.styledComponentId;
  }, i2 && hoistNonReactStatics_cjs(C2, e2, {
    attrs: true,
    componentStyle: true,
    displayName: true,
    foldedComponentIds: true,
    shouldForwardProp: true,
    styledComponentId: true,
    target: true,
    withComponent: true
  }), C2;
}

var He = function He(e2) {
  return function e3(t2, r2, o2) {
    if (void 0 === o2 && (o2 = E$1), !reactIs$2.exports.isValidElementType(r2)) return j$1(1, String(r2));

    var s2 = function s2() {
      return t2(r2, o2, Ce.apply(void 0, arguments));
    };

    return s2.withConfig = function (n2) {
      return e3(t2, r2, v$1({}, o2, {}, n2));
    }, s2.attrs = function (n2) {
      return e3(t2, r2, v$1({}, o2, {
        attrs: Array.prototype.concat(o2.attrs, n2).filter(Boolean)
      }));
    }, s2;
  }(qe, e2);
};

["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function (e2) {
  He[e2] = He(e2);
});

var $e = function () {
  function e2(e3, t3) {
    this.rules = e3, this.componentId = t3, this.isStatic = re(e3), Z.registerId(this.componentId + 1);
  }

  var t2 = e2.prototype;
  return t2.createStyles = function (e3, t3, n2, r2) {
    var o2 = r2(Ne(this.rules, t3, n2, r2).join(""), ""),
        s2 = this.componentId + e3;
    n2.insertRules(s2, s2, o2);
  }, t2.removeStyles = function (e3, t3) {
    t3.clearRules(this.componentId + e3);
  }, t2.renderStyles = function (e3, t3, n2, r2) {
    e3 > 2 && Z.registerId(this.componentId + e3), this.removeStyles(e3, n2), this.createStyles(e3, t3, n2, r2);
  }, e2;
}();

function We(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), o2 = 1; o2 < t2; o2++) {
    n2[o2 - 1] = arguments[o2];
  }

  var i2 = Ce.apply(void 0, [e2].concat(n2)),
      a2 = "sc-global-" + xe(JSON.stringify(i2)),
      u2 = new $e(i2, a2);

  function l2(e3) {
    var t3 = fe(),
        n3 = me(),
        o3 = useContext(Ge),
        l3 = useRef(t3.allocateGSInstance(a2)).current;
    return "production" !== process.env.NODE_ENV && r$1.Children.count(e3.children) && console.warn("The global style component " + a2 + " was given child JSX. createGlobalStyle does not render children."), "production" !== process.env.NODE_ENV && i2.some(function (e4) {
      return "string" == typeof e4 && -1 !== e4.indexOf("@import");
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), t3.server && h2(l3, e3, t3, o3, n3), useLayoutEffect(function () {
      if (!t3.server) return h2(l3, e3, t3, o3, n3), function () {
        return u2.removeStyles(l3, t3);
      };
    }, [l3, e3, t3, o3, n3]), null;
  }

  function h2(e3, t3, n3, r2, o3) {
    if (u2.isStatic) u2.renderStyles(e3, O$1, n3, o3);else {
      var s2 = v$1({}, t3, {
        theme: Re(t3, r2, l2.defaultProps)
      });
      u2.renderStyles(e3, s2, n3, o3);
    }
  }

  return "production" !== process.env.NODE_ENV && Oe(a2), r$1.memo(l2);
}

function Ue(e2) {
  "production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");

  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++) {
    n2[r2 - 1] = arguments[r2];
  }

  var o2 = Ce.apply(void 0, [e2].concat(n2)).join(""),
      s2 = xe(o2);
  return new ve(s2, o2);
}

var Je = function () {
  function e2() {
    var e3 = this;
    this._emitSheetCSS = function () {
      var t3 = e3.instance.toString();
      if (!t3) return "";
      var n2 = q();
      return "<style " + [n2 && 'nonce="' + n2 + '"', A + '="true"', 'data-styled-version="5.3.6"'].filter(Boolean).join(" ") + ">" + t3 + "</style>";
    }, this.getStyleTags = function () {
      return e3.sealed ? j$1(2) : e3._emitSheetCSS();
    }, this.getStyleElement = function () {
      var t3;
      if (e3.sealed) return j$1(2);
      var n2 = ((t3 = {})[A] = "", t3["data-styled-version"] = "5.3.6", t3.dangerouslySetInnerHTML = {
        __html: e3.instance.toString()
      }, t3),
          o2 = q();
      return o2 && (n2.nonce = o2), [r$1.createElement("style", v$1({}, n2, {
        key: "sc-0-0"
      }))];
    }, this.seal = function () {
      e3.sealed = true;
    }, this.instance = new Z({
      isServer: true
    }), this.sealed = false;
  }

  var t2 = e2.prototype;
  return t2.collectStyles = function (e3) {
    return this.sealed ? j$1(2) : r$1.createElement(ye, {
      sheet: this.instance
    }, e3);
  }, t2.interleaveWithNodeStream = function (e3) {
    return j$1(3);
  }, e2;
}(),
    Xe = function Xe(e2) {
  var t2 = r$1.forwardRef(function (t3, n2) {
    var o2 = useContext(Ge),
        i2 = e2.defaultProps,
        a2 = Re(t3, o2, i2);
    return "production" !== process.env.NODE_ENV && void 0 === a2 && console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + _(e2) + '"'), r$1.createElement(e2, v$1({}, t3, {
      theme: a2,
      ref: n2
    }));
  });
  return hoistNonReactStatics_cjs(t2, e2), t2.displayName = "WithTheme(" + _(e2) + ")", t2;
},
    Ze = function Ze() {
  return useContext(Ge);
},
    Ke = {
  StyleSheet: Z,
  masterSheet: he
};

"production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "production" !== process.env.NODE_ENV && "test" !== process.env.NODE_ENV && "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, 1 === window["__styled-components-init__"] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
var styledComponents_browser_esm = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  default: He,
  ServerStyleSheet: Je,
  StyleSheetConsumer: le,
  StyleSheetContext: ue,
  StyleSheetManager: ye,
  ThemeConsumer: Le,
  ThemeContext: Ge,
  ThemeProvider: Fe,
  __PRIVATE__: Ke,
  createGlobalStyle: We,
  css: Ce,
  isStyledComponent: N,
  keyframes: Ue,
  useTheme: Ze,
  version: C,
  withTheme: Xe
}, Symbol.toStringTag, {
  value: "Module"
}));
var require$$2 = /* @__PURE__ */getAugmentedNamespace(styledComponents_browser_esm);
var propTypes = {
  exports: {}
};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols2 = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      var test1 = new String("abc");
      test1[5] = "de";

      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }

      var test2 = {};

      for (var i2 = 0; i2 < 10; i2++) {
        test2["_" + String.fromCharCode(i2)] = i2;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n2) {
        return test2[n2];
      });

      if (order2.join("") !== "0123456789") {
        return false;
      }

      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }

      return true;
    } catch (err) {
      return false;
    }
  }

  objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s2 = 1; s2 < arguments.length; s2++) {
      from = Object(arguments[s2]);

      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols2) {
        symbols = getOwnPropertySymbols2(from);

        for (var i2 = 0; i2 < symbols.length; i2++) {
          if (propIsEnumerable.call(from, symbols[i2])) {
            to[symbols[i2]] = from[symbols[i2]];
          }
        }
      }
    }

    return to;
  };
  return objectAssign;
}

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;

  var printWarning = function printWarning() {};

  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();

    printWarning = function printWarning(text) {
      var message = "Warning: " + text;

      if (typeof console !== "undefined") {
        console.error(message);
      }

      try {
        throw new Error(message);
      } catch (x2) {}
    };
  }

  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;

          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              err.name = "Invariant Violation";
              throw err;
            }

            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }

          if (error && !(error instanceof Error)) {
            printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).");
          }

          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
          }
        }
      }
    }
  }

  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };

  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = reactIs$1.exports;
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();

  var printWarning = function printWarning() {};

  if (process.env.NODE_ENV !== "production") {
    printWarning = function printWarning(text) {
      var message = "Warning: " + text;

      if (typeof console !== "undefined") {
        console.error(message);
      }

      try {
        throw new Error(message);
      } catch (x2) {}
    };
  }

  function emptyFunctionThatReturnsNull() {
    return null;
  }

  factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";

    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }

    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    function is(x2, y2) {
      if (x2 === y2) {
        return x2 !== 0 || 1 / x2 === 1 / y2;
      } else {
        return x2 !== x2 && y2 !== y2;
      }
    }

    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }

    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }

      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;

            if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
              printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.");
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }

        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }

            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }

          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
            expectedType: expectedType
          });
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }

        var propValue = props[propName];

        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }

        for (var i2 = 0; i2 < propValue.length; i2++) {
          var error = typeChecker(propValue, i2, componentName, location, propFullName + "[" + i2 + "]", ReactPropTypesSecret);

          if (error instanceof Error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }

        return emptyFunctionThatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        for (var i2 = 0; i2 < expectedValues.length; i2++) {
          if (is(propValue, expectedValues[i2])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);

          if (type === "symbol") {
            return String(value);
          }

          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }

      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }

        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }

        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);

            if (error instanceof Error) {
              return error;
            }
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }

      for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
        var checker = arrayOfTypeCheckers[i2];

        if (typeof checker !== "function") {
          printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + ".");
          return emptyFunctionThatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];

        for (var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
          var checker2 = arrayOfTypeCheckers[i3];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);

          if (checkerResult == null) {
            return null;
          }

          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }

        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }

      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }

        for (var key in shapeTypes) {
          var checker = shapeTypes[key];

          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }

          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);

          if (error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }

        var allKeys = assign({}, props[propName], shapeTypes);

        for (var key in allKeys) {
          var checker = shapeTypes[key];

          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }

          if (!checker) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
          }

          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);

          if (error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;

        case "boolean":
          return !propValue;

        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }

          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);

          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;

            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;

                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;

        default:
          return false;
      }
    }

    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }

      if (!propValue) {
        return false;
      }

      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }

      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }

      return false;
    }

    function getPropType(propValue) {
      var propType = typeof propValue;

      if (Array.isArray(propValue)) {
        return "array";
      }

      if (propValue instanceof RegExp) {
        return "object";
      }

      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }

      return propType;
    }

    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }

      var propType = getPropType(propValue);

      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }

      return propType;
    }

    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);

      switch (type) {
        case "array":
        case "object":
          return "an " + type;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;

        default:
          return type;
      }
    }

    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }

      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  return factoryWithTypeCheckers;
}

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();

  function emptyFunction() {}

  function emptyFunctionWithReset() {}

  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }

      var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      err.name = "Invariant Violation";
      throw err;
    }

    shim.isRequired = shim;

    function getShim() {
      return shim;
    }

    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  return factoryWithThrowingShims;
}

if (process.env.NODE_ENV !== "production") {
  var ReactIs = reactIs$1.exports;
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var _default;

Object.defineProperty(styledComponents, "__esModule", {
  value: true
});
var e = r$1,
    t = server_browser,
    r = require$$2,
    n = require$$3,
    o = propTypes.exports;

function a(e2) {
  return e2 && "object" == typeof e2 && "default" in e2 ? e2 : {
    default: e2
  };
}

var u = a(e),
    l = a(o),
    c = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : {};

function i(e2, t2) {
  return e2(t2 = {
    exports: {}
  }, t2.exports), t2.exports;
}

var s = i(function (e2) {
  !function (t2) {
    var r2 = function r2(e3, t3, n3) {
      if (!c2(t3) || s2(t3) || f2(t3) || d2(t3) || l2(t3)) return t3;
      var o3,
          a3 = 0,
          u3 = 0;
      if (i2(t3)) for (o3 = [], u3 = t3.length; a3 < u3; a3++) {
        o3.push(r2(e3, t3[a3], n3));
      } else for (var p3 in o3 = {}, t3) {
        Object.prototype.hasOwnProperty.call(t3, p3) && (o3[e3(p3, n3)] = r2(e3, t3[p3], n3));
      }
      return o3;
    },
        n2 = function n2(e3) {
      return p2(e3) ? e3 : (e3 = e3.replace(/[\-_\s]+(.)?/g, function (e4, t3) {
        return t3 ? t3.toUpperCase() : "";
      })).substr(0, 1).toLowerCase() + e3.substr(1);
    },
        o2 = function o2(e3) {
      var t3 = n2(e3);
      return t3.substr(0, 1).toUpperCase() + t3.substr(1);
    },
        a2 = function a2(e3, t3) {
      return function (e4, t4) {
        var r3 = (t4 = t4 || {}).separator || "_",
            n3 = t4.split || /(?=[A-Z])/;
        return e4.split(n3).join(r3);
      }(e3, t3).toLowerCase();
    },
        u2 = Object.prototype.toString,
        l2 = function l2(e3) {
      return "function" == typeof e3;
    },
        c2 = function c2(e3) {
      return e3 === Object(e3);
    },
        i2 = function i2(e3) {
      return "[object Array]" == u2.call(e3);
    },
        s2 = function s2(e3) {
      return "[object Date]" == u2.call(e3);
    },
        f2 = function f2(e3) {
      return "[object RegExp]" == u2.call(e3);
    },
        d2 = function d2(e3) {
      return "[object Boolean]" == u2.call(e3);
    },
        p2 = function p2(e3) {
      return (e3 -= 0) == e3;
    },
        y2 = function y2(e3, t3) {
      var r3 = t3 && "process" in t3 ? t3.process : t3;
      return "function" != typeof r3 ? e3 : function (t4, n3) {
        return r3(t4, e3, n3);
      };
    },
        h2 = {
      camelize: n2,
      decamelize: a2,
      pascalize: o2,
      depascalize: a2,
      camelizeKeys: function camelizeKeys(e3, t3) {
        return r2(y2(n2, t3), e3);
      },
      decamelizeKeys: function decamelizeKeys(e3, t3) {
        return r2(y2(a2, t3), e3, t3);
      },
      pascalizeKeys: function pascalizeKeys(e3, t3) {
        return r2(y2(o2, t3), e3);
      },
      depascalizeKeys: function depascalizeKeys() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };

    e2.exports ? e2.exports = h2 : t2.humps = h2;
  }(c);
}).decamelize,
    f = i(function (e2) {
  function t2() {
    return e2.exports = t2 = Object.assign || function (e3) {
      for (var t3 = 1; t3 < arguments.length; t3++) {
        var r2 = arguments[t3];

        for (var n2 in r2) {
          Object.prototype.hasOwnProperty.call(r2, n2) && (e3[n2] = r2[n2]);
        }
      }

      return e3;
    }, t2.apply(this, arguments);
  }

  e2.exports = t2;
});

var d = function d(e2) {
  if (Array.isArray(e2)) return e2;
};

var p = function p(e2, t2) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e2)) {
    var r2 = [],
        n2 = true,
        o2 = false,
        a2 = void 0;

    try {
      for (var u2, l2 = e2[Symbol.iterator](); !(n2 = (u2 = l2.next()).done) && (r2.push(u2.value), !t2 || r2.length !== t2); n2 = true) {
        ;
      }
    } catch (e3) {
      o2 = true, a2 = e3;
    } finally {
      try {
        n2 || null == l2.return || l2.return();
      } finally {
        if (o2) throw a2;
      }
    }

    return r2;
  }
};

var y = function y(e2, t2) {
  (null == t2 || t2 > e2.length) && (t2 = e2.length);

  for (var r2 = 0, n2 = new Array(t2); r2 < t2; r2++) {
    n2[r2] = e2[r2];
  }

  return n2;
};

var h = function h(e2, t2) {
  if (e2) {
    if ("string" == typeof e2) return y(e2, t2);
    var r2 = Object.prototype.toString.call(e2).slice(8, -1);
    return "Object" === r2 && e2.constructor && (r2 = e2.constructor.name), "Map" === r2 || "Set" === r2 ? Array.from(e2) : "Arguments" === r2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r2) ? y(e2, t2) : void 0;
  }
};

var v = function v() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};

var m = function m(e2, t2) {
  return d(e2) || p(e2, t2) || h(e2, t2) || v();
};

var g = function g(e2, t2) {
  if (null == e2) return {};
  var r2,
      n2,
      o2 = {},
      a2 = Object.keys(e2);

  for (n2 = 0; n2 < a2.length; n2++) {
    r2 = a2[n2], t2.indexOf(r2) >= 0 || (o2[r2] = e2[r2]);
  }

  return o2;
};

var b = function b(e2, t2) {
  if (null == e2) return {};
  var r2,
      n2,
      o2 = g(e2, t2);

  if (Object.getOwnPropertySymbols) {
    var a2 = Object.getOwnPropertySymbols(e2);

    for (n2 = 0; n2 < a2.length; n2++) {
      r2 = a2[n2], t2.indexOf(r2) >= 0 || Object.prototype.propertyIsEnumerable.call(e2, r2) && (o2[r2] = e2[r2]);
    }
  }

  return o2;
};

var S = e.createContext(null);

function w(e2) {
  var t2 = e2.root,
      r2 = e2.children;
  return n.createPortal(r2, t2);
}

function O(t2) {
  var r2 = e.forwardRef(function (r3, n2) {
    var o2,
        a2,
        l2 = r3.mode,
        c2 = r3.delegatesFocus,
        i2 = r3.styleSheets,
        s2 = r3.ssr,
        d2 = r3.children,
        p2 = b(r3, ["mode", "delegatesFocus", "styleSheets", "ssr", "children"]),
        y2 = (o2 = n2, a2 = e.useRef(o2 && o2.current), e.useEffect(function () {
      o2 && (o2.current = a2.current);
    }, [o2]), a2),
        h2 = e.useState(null),
        v2 = m(h2, 2),
        g2 = v2[0],
        O2 = v2[1],
        j2 = "node_".concat(l2).concat(c2);
    return e.useEffect(function () {
      if (y2.current) try {
        if ("function" == typeof n2 && n2(y2.current), s2) {
          var e2 = y2.current.shadowRoot;
          return void O2(e2);
        }

        var t3 = y2.current.attachShadow({
          mode: l2,
          delegatesFocus: c2
        });
        i2.length > 0 && (t3.adoptedStyleSheets = i2), O2(t3);
      } catch (e3) {
        !function (e4) {
          var t4 = e4.error,
              r4 = e4.styleSheets,
              n3 = e4.root;

          switch (t4.name) {
            case "NotSupportedError":
              r4.length > 0 && (n3.adoptedStyleSheets = r4);
              break;

            default:
              throw t4;
          }
        }({
          error: e3,
          styleSheets: i2,
          root: g2
        });
      }
    }, [n2, y2, i2]), u.default.createElement(u.default.Fragment, null, u.default.createElement(t2.tag, f({
      key: j2,
      ref: y2
    }, p2), (g2 || s2) && u.default.createElement(S.Provider, {
      value: g2
    }, s2 ? u.default.createElement("template", {
      shadowroot: "open"
    }, t2.render({
      root: g2,
      ssr: s2,
      children: d2
    })) : u.default.createElement(w, {
      root: g2
    }, t2.render({
      root: g2,
      ssr: s2,
      children: d2
    })))));
  });
  return r2.propTypes = {
    mode: l.default.oneOf(["open", "closed"]),
    delegatesFocus: l.default.bool,
    styleSheets: l.default.arrayOf(l.default.instanceOf(globalThis.CSSStyleSheet)),
    ssr: l.default.bool,
    children: l.default.node
  }, r2.defaultProps = {
    mode: "open",
    delegatesFocus: false,
    styleSheets: [],
    ssr: false,
    children: null
  }, r2;
}

w.propTypes = {
  root: l.default.object.isRequired,
  children: l.default.node
}, w.defaultProps = {
  children: null
};
var j = /* @__PURE__ */new Map();

function E() {
  var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "core",
      r2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function (e3) {
    return e3.children;
  };
  return new Proxy(e2, {
    get: function get(e3, n2) {
      var o2 = s(n2, {
        separator: "-"
      }),
          a2 = "".concat(t2, "-").concat(o2);
      return j.has(a2) || j.set(a2, O({
        tag: o2,
        render: r2
      })), j.get(a2);
    }
  });
}

function x(e2) {
  var n2 = new r.ServerStyleSheet();
  return t.renderToString(u.default.createElement(r.StyleSheetManager, {
    sheet: n2.instance
  }, u.default.createElement(u.default.Fragment, null, e2))), n2.getStyleElement();
}

E();
var z = E({}, "styled-components", function (e2) {
  var t2 = e2.root,
      n2 = e2.ssr,
      o2 = e2.children;
  return n2 ? u.default.createElement(u.default.Fragment, null, x(o2), o2) : u.default.createElement(r.StyleSheetManager, {
    target: t2
  }, u.default.createElement(u.default.Fragment, null, o2));
});
_default = styledComponents.default = z, styledComponents.getStyleSheets = x;
var FETCH_DEFAULTS = {
  credentials: "include",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
};

function buildUrl(host, path) {
  return host + path;
}

function patch(_x, _x2, _x3) {
  return _patch.apply(this, arguments);
}

function _patch() {
  _patch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(host, url, body) {
    var res;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            _context16.next = 3;
            return fetch(buildUrl(host, url), _objectSpread(_objectSpread({}, FETCH_DEFAULTS), {}, {
              method: "PATCH",
              body: JSON.stringify(body)
            }));

          case 3:
            res = _context16.sent;
            return _context16.abrupt("return", processResponse(res));

          case 7:
            _context16.prev = 7;
            _context16.t0 = _context16["catch"](0);
            console.error("PATCH request error", _context16.t0);
            return _context16.abrupt("return", {
              error: _context16.t0
            });

          case 11:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 7]]);
  }));
  return _patch.apply(this, arguments);
}

function doDelete(_x4, _x5, _x6) {
  return _doDelete.apply(this, arguments);
}

function _doDelete() {
  _doDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(host, url, body) {
    var res;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            _context17.next = 3;
            return fetch(buildUrl(host, url), _objectSpread(_objectSpread({}, FETCH_DEFAULTS), {}, {
              method: "DELETE",
              body: JSON.stringify(body)
            }));

          case 3:
            res = _context17.sent;
            return _context17.abrupt("return", processResponse(res));

          case 7:
            _context17.prev = 7;
            _context17.t0 = _context17["catch"](0);
            console.error("DELETE request error", _context17.t0);
            return _context17.abrupt("return", {
              error: _context17.t0
            });

          case 11:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 7]]);
  }));
  return _doDelete.apply(this, arguments);
}

function get(_x7, _x8, _x9) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(host, url, params2) {
    var res;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            if (params2) {
              url += "?" + new URLSearchParams(params2).toString();
            }

            _context18.prev = 1;
            _context18.next = 4;
            return fetch(buildUrl(host, url), _objectSpread(_objectSpread({}, FETCH_DEFAULTS), {}, {
              method: "GET"
            }));

          case 4:
            res = _context18.sent;
            return _context18.abrupt("return", processResponse(res));

          case 8:
            _context18.prev = 8;
            _context18.t0 = _context18["catch"](1);
            console.error("GET request error", _context18.t0);
            return _context18.abrupt("return", {
              error: _context18.t0,
              data: void 0
            });

          case 12:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[1, 8]]);
  }));
  return _get.apply(this, arguments);
}

function post(_x10, _x11, _x12) {
  return _post.apply(this, arguments);
}

function _post() {
  _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(host, url, body) {
    var res;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            _context19.next = 3;
            return fetch(buildUrl(host, url), _objectSpread(_objectSpread({}, FETCH_DEFAULTS), {}, {
              method: "POST",
              body: JSON.stringify(body)
            }));

          case 3:
            res = _context19.sent;
            return _context19.abrupt("return", processResponse(res));

          case 7:
            _context19.prev = 7;
            _context19.t0 = _context19["catch"](0);
            return _context19.abrupt("return", {
              error: _context19.t0,
              data: void 0
            });

          case 10:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[0, 7]]);
  }));
  return _post.apply(this, arguments);
}

function processResponse(_x13) {
  return _processResponse.apply(this, arguments);
}

function _processResponse() {
  _processResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(res) {
    var data, _data;

    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            if (!(res.status >= 200 && res.status <= 201)) {
              _context20.next = 7;
              break;
            }

            _context20.next = 3;
            return res.json();

          case 3:
            data = _context20.sent;
            return _context20.abrupt("return", {
              data: data,
              response: res
            });

          case 7:
            if (!(res.status === 400)) {
              _context20.next = 14;
              break;
            }

            _context20.next = 10;
            return res.json();

          case 10:
            _data = _context20.sent;
            return _context20.abrupt("return", {
              error: new Error(_data == null ? void 0 : _data.error),
              response: res,
              data: void 0
            });

          case 14:
            if (!(res.status === 401)) {
              _context20.next = 18;
              break;
            }

            return _context20.abrupt("return", {
              error: new Error("Not authenticated"),
              response: res
            });

          case 18:
            if (!(res.status >= 500)) {
              _context20.next = 20;
              break;
            }

            return _context20.abrupt("return", {
              error: new Error("Unexpected error occurred"),
              response: res
            });

          case 20:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _processResponse.apply(this, arguments);
}

var jsxRuntime = {
  exports: {}
};
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f2 = r$1,
      k2 = Symbol.for("react.element"),
      l2 = Symbol.for("react.fragment"),
      m2 = Object.prototype.hasOwnProperty,
      n2 = f2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      p2 = {
    key: true,
    ref: true,
    __self: true,
    __source: true
  };

  function q2(c2, a2, g2) {
    var b2,
        d2 = {},
        e2 = null,
        h2 = null;
    void 0 !== g2 && (e2 = "" + g2);
    void 0 !== a2.key && (e2 = "" + a2.key);
    void 0 !== a2.ref && (h2 = a2.ref);

    for (b2 in a2) {
      m2.call(a2, b2) && !p2.hasOwnProperty(b2) && (d2[b2] = a2[b2]);
    }

    if (c2 && c2.defaultProps) for (b2 in a2 = c2.defaultProps, a2) {
      void 0 === d2[b2] && (d2[b2] = a2[b2]);
    }
    return {
      $$typeof: k2,
      type: c2,
      key: e2,
      ref: h2,
      props: d2,
      _owner: n2.current
    };
  }

  reactJsxRuntime_production_min.Fragment = l2;
  reactJsxRuntime_production_min.jsx = q2;
  reactJsxRuntime_production_min.jsxs = q2;
  return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var React = r$1;
      var REACT_ELEMENT_TYPE2 = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }

        return null;
      }

      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning("error", format, args);
          }
        }
      }

      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();

          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }

          var argsWithFormat = args.map(function (item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }

      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }

        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }

        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }

        return false;
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;

        if (displayName) {
          return displayName;
        }

        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }

      function getContextName(type) {
        return type.displayName || "Context";
      }

      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }

        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }

        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }

        if (typeof type === "string") {
          return type;
        }

        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";

          case REACT_PORTAL_TYPE:
            return "Portal";

          case REACT_PROFILER_TYPE:
            return "Profiler";

          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";

          case REACT_SUSPENSE_TYPE:
            return "Suspense";

          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }

        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");

            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;

              if (outerName !== null) {
                return outerName;
              }

              return getComponentNameFromType(type.type) || "Memo";

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentNameFromType(init(payload));
                } catch (x2) {
                  return null;
                }
              }
          }
        }

        return null;
      }

      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }

          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x2) {
              var match = x2.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }

          return "\n" + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          if (construct) {
            var Fake = function Fake() {
              throw Error();
            };

            Object.defineProperty(Fake.prototype, "props", {
              set: function set() {
                throw Error();
              }
            });

            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x2) {
                control = x2;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x2) {
                control = x2;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x2) {
              control = x2;
            }

            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s2 = sampleLines.length - 1;
            var c2 = controlLines.length - 1;

            while (s2 >= 1 && c2 >= 0 && sampleLines[s2] !== controlLines[c2]) {
              c2--;
            }

            for (; s2 >= 1 && c2 >= 0; s2--, c2--) {
              if (sampleLines[s2] !== controlLines[c2]) {
                if (s2 !== 1 || c2 !== 1) {
                  do {
                    s2--;
                    c2--;

                    if (c2 < 0 || sampleLines[s2] !== controlLines[c2]) {
                      var _frame = "\n" + sampleLines[s2].replace(" at new ", " at ");

                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }

                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s2 >= 1 && c2 >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }

        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component2) {
        var prototype = Component2.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }

        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }

        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x2) {}
              }
          }
        }

        return "";
      }

      var hasOwnProperty2 = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has2 = Function.call.bind(hasOwnProperty2);

          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$1 = void 0;

              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var isArrayImpl = Array.isArray;

      function isArray2(a2) {
        return isArrayImpl(a2);
      }

      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }

      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e2) {
            return true;
          }
        }
      }

      function testStringCoercion(value) {
        return "" + value;
      }

      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }

      function hasValidRef(config) {
        {
          if (hasOwnProperty2.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }

      function hasValidKey(config) {
        {
          if (hasOwnProperty2.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }

      function warnIfStringRefCannotBeAutoConverted(config, self2) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self2 && ReactCurrentOwner.current.stateNode !== self2) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }

      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function warnAboutAccessingKey() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };

          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }

      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function warnAboutAccessingRef() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };

          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }

      var ReactElement = function ReactElement(type, key, ref, self2, source, owner, props) {
        var element = {
          $$typeof: REACT_ELEMENT_TYPE2,
          type: type,
          key: key,
          ref: ref,
          props: props,
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self2
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });

          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };

      function jsxDEV(type, config, maybeKey, source, self2) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;

          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }

          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }

          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self2);
          }

          for (propName in config) {
            if (hasOwnProperty2.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }

          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;

            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }

          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;

            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }

            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }

          return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
        }
      }

      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }

      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }

      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE2;
        }
      }

      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }

          return "";
        }
      }

      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }

          return "";
        }
      }

      var ownerHasKeyUseWarning = {};

      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();

          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;

            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }

          return info;
        }
      }

      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }

          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }

          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";

          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }

          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }

      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }

          if (isArray2(node)) {
            for (var i2 = 0; i2 < node.length; i2++) {
              var child = node[i2];

              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);

            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;

                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }

      function validatePropTypes(element) {
        {
          var type = element.type;

          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }

          var propTypes2;

          if (typeof type === "function") {
            propTypes2 = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes2 = type.propTypes;
          } else {
            return;
          }

          if (propTypes2) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes2, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;

            var _name = getComponentNameFromType(type);

            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }

          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }

      function validateFragmentProps(fragment) {
        {
          var keys2 = Object.keys(fragment.props);

          for (var i2 = 0; i2 < keys2.length; i2++) {
            var key = keys2[i2];

            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }

          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }

      function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
        {
          var validType = isValidElementType(type);

          if (!validType) {
            var info = "";

            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }

            var sourceInfo = getSourceInfoErrorAddendum(source);

            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }

            var typeString;

            if (type === null) {
              typeString = "null";
            } else if (isArray2(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE2) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }

            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }

          var element = jsxDEV(type, props, key, source, self2);

          if (element == null) {
            return element;
          }

          if (validType) {
            var children = props.children;

            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray2(children)) {
                  for (var i2 = 0; i2 < children.length; i2++) {
                    validateChildKeys(children[i2], type);
                  }

                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }

          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }

          return element;
        }
      }

      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }

      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }

      var jsx2 = jsxWithValidationDynamic;
      var jsxs2 = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx2;
      reactJsxRuntime_development.jsxs = jsxs2;
    })();
  }

  return reactJsxRuntime_development;
}

(function (module2) {
  if (process.env.NODE_ENV === "production") {
    module2.exports = requireReactJsxRuntime_production_min();
  } else {
    module2.exports = requireReactJsxRuntime_development();
  }
})(jsxRuntime);

var Fragment = jsxRuntime.exports.Fragment;
var jsx = jsxRuntime.exports.jsx;
var jsxs = jsxRuntime.exports.jsxs;
var Context$2 = createContext(void 0);

var Provider$2 = function Provider$2(_ref6) {
  var _ref6$value = _ref6.value,
      apiHost = _ref6$value.apiHost,
      organizationId = _ref6$value.organizationId,
      profileLink = _ref6$value.profileLink,
      children = _ref6.children;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      config = _useState2[0],
      setConfig = _useState2[1];

  var getConfig = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref8, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return get(apiHost, "/api/config", {
                organizationId: organizationId
              });

            case 2:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 5;
                break;
              }

              _context.t0 = {};

            case 5:
              _ref8 = _context.t0;
              data = _ref8.data;
              return _context.abrupt("return", data);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getConfig() {
      return _ref7.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getConfig().then(function (config2) {
      setConfig(config2);
    });
  }, []);
  return /* @__PURE__ */jsx(Context$2.Provider, {
    value: {
      apiHost: apiHost,
      organizationId: organizationId,
      config: config,
      profileLink: profileLink
    },
    children: children
  });
};

var useOrg = function useOrg() {
  var org = useContext(Context$2);

  if (org === void 0) {
    throw Error("No org has been specified using Provider");
  }

  return org;
};

var Context$1 = createContext({
  user: null,
  setUser: function setUser() {}
});

var Provider$1 = function Provider$1(_ref9) {
  var children = _ref9.children;

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      user = _useState4[0],
      setUser = _useState4[1];

  var _useOrg = useOrg(),
      organizationId = _useOrg.organizationId,
      apiHost = _useOrg.apiHost;

  function getSession() {
    return get(apiHost, "/api/user", {
      organizationId: organizationId
    });
  }

  useEffect(function () {
    getSession().then(function (res) {
      var _a;

      if (res == null ? void 0 : res.error) {
        console.error("ERROR", res.error);
      } else if (res && "data" in res && res.data) {
        var role = (_a = res.data.profile) == null ? void 0 : _a.role;
        var isModerator = role === "admin" || role === "moderator";
        setUser(_objectSpread(_objectSpread({}, res.data), {}, {
          isModerator: isModerator
        }));
      }
    }).catch(function (err) {
      console.log("error getting session", err);
    });
  }, [user == null ? void 0 : user.id]);
  return /* @__PURE__ */jsx(Context$1.Provider, {
    value: {
      user: user,
      setUser: setUser
    },
    children: children
  });
};

var isArray$2 = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== "undefined";

function equal(a2, b2) {
  if (a2 === b2) return true;

  if (a2 && b2 && typeof a2 == "object" && typeof b2 == "object") {
    var arrA = isArray$2(a2),
        arrB = isArray$2(b2),
        i2,
        length,
        key;

    if (arrA && arrB) {
      length = a2.length;
      if (length != b2.length) return false;

      for (i2 = length; i2-- !== 0;) {
        if (!equal(a2[i2], b2[i2])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a2 instanceof Date,
        dateB = b2 instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a2.getTime() == b2.getTime();
    var regexpA = a2 instanceof RegExp,
        regexpB = b2 instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a2.toString() == b2.toString();
    var keys2 = keyList(a2);
    length = keys2.length;
    if (length !== keyList(b2).length) return false;

    for (i2 = length; i2-- !== 0;) {
      if (!hasProp.call(b2, keys2[i2])) return false;
    }

    if (hasElementType && a2 instanceof Element && b2 instanceof Element) return a2 === b2;

    for (i2 = length; i2-- !== 0;) {
      key = keys2[i2];

      if (key === "_owner" && a2.$$typeof) {
        continue;
      } else {
        if (!equal(a2[key], b2[key])) return false;
      }
    }

    return true;
  }

  return a2 !== a2 && b2 !== b2;
}

var reactFastCompare = function exportedEqual(a2, b2) {
  try {
    return equal(a2, b2);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
      console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
      return false;
    }

    throw error;
  }
};

var isMergeableObject = function isMergeableObject2(value) {
  return isNonNullObject(value) && !isSpecial(value);
};

function isNonNullObject(value) {
  return !!value && typeof value === "object";
}

function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
}

var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;

function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}

function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}

function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}

function mergeObject(target, source, options) {
  var destination = {};

  if (options.isMergeableObject(target)) {
    Object.keys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }

  Object.keys(source).forEach(function (key) {
    if (!options.isMergeableObject(source[key]) || !target[key]) {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    } else {
      destination[key] = deepmerge(target[key], source[key], options);
    }
  });
  return destination;
}

function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}

deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error("first argument should be an array");
  }

  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};

var deepmerge_1 = deepmerge;
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function("return this")();
var root$1 = root;
var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;
var objectProto$d = Object.prototype;
var hasOwnProperty$b = objectProto$d.hasOwnProperty;
var nativeObjectToString$1 = objectProto$d.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;

function getRawTag(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {}

  var result = nativeObjectToString$1.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }

  return result;
}

var objectProto$c = Object.prototype;
var nativeObjectToString = objectProto$c.toString;

function objectToString(value) {
  return nativeObjectToString.call(value);
}

var nullTag = "[object Null]",
    undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;

function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;

function isObjectLike(value) {
  return value != null && typeof value == "object";
}

var objectTag$3 = "[object Object]";
var funcProto$2 = Function.prototype,
    objectProto$b = Object.prototype;
var funcToString$2 = funcProto$2.toString;
var hasOwnProperty$a = objectProto$b.hasOwnProperty;
var objectCtorString = funcToString$2.call(Object);

function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }

  var proto2 = getPrototype$1(value);

  if (proto2 === null) {
    return true;
  }

  var Ctor = hasOwnProperty$a.call(proto2, "constructor") && proto2.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}

function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

function eq(value, other) {
  return value === other || value !== value && other !== other;
}

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var arrayProto = Array.prototype;
var splice = arrayProto.splice;

function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? void 0 : data[index][1];
}

function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

function stackDelete(key) {
  var data = this.__data__,
      result = data["delete"](key);
  this.size = data.size;
  return result;
}

function stackGet(key) {
  return this.__data__.get(key);
}

function stackHas(key) {
  return this.__data__.has(key);
}

function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}

var asyncTag = "[object AsyncFunction]",
    funcTag$2 = "[object Function]",
    genTag$1 = "[object GeneratorFunction]",
    proxyTag = "[object Proxy]";

function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false;
  }

  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var coreJsData = root$1["__core-js_shared__"];
var coreJsData$1 = coreJsData;

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();

function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;

function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e2) {}

    try {
      return func + "";
    } catch (e2) {}
  }

  return "";
}

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype,
    objectProto$a = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;
var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$9).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

function getValue(object, key) {
  return object == null ? void 0 : object[key];
}

function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}

var Map$1 = getNative(root$1, "Map");
var Map$2 = Map$1;
var nativeCreate = getNative(Object, "create");
var nativeCreate$1 = nativeCreate;

function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
var objectProto$9 = Object.prototype;
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? void 0 : result;
  }

  return hasOwnProperty$8.call(data, key) ? data[key] : void 0;
}

var objectProto$8 = Object.prototype;
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$7.call(data, key);
}

var HASH_UNDEFINED = "__lodash_hash_undefined__";

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === void 0 ? HASH_UNDEFINED : value;
  return this;
}

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$2 || ListCache)(),
    "string": new Hash()
  };
}

function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}

function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}

function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}

function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var LARGE_ARRAY_SIZE = 200;

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache) {
    var pairs = data.__data__;

    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

var defineProperty = function () {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e2) {}
}();

var defineProperty$1 = defineProperty;

function baseAssignValue(object, key, value) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}

var objectProto$7 = Object.prototype;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$6.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;

    if (newValue === void 0) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }

  return object;
}

function baseTimes(n2, iteratee) {
  var index = -1,
      result = Array(n2);

  while (++index < n2) {
    result[index] = iteratee(index);
  }

  return result;
}

var argsTag$2 = "[object Arguments]";

function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$5.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
var isArguments$1 = isArguments;
var isArray = Array.isArray;
var isArray$1 = isArray;

function stubFalse() {
  return false;
}

var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$1 = moduleExports$2 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;

function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

var MAX_SAFE_INTEGER = 9007199254740991;

function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var argsTag$1 = "[object Arguments]",
    arrayTag$1 = "[object Array]",
    boolTag$2 = "[object Boolean]",
    dateTag$2 = "[object Date]",
    errorTag$1 = "[object Error]",
    funcTag$1 = "[object Function]",
    mapTag$4 = "[object Map]",
    numberTag$2 = "[object Number]",
    objectTag$2 = "[object Object]",
    regexpTag$2 = "[object RegExp]",
    setTag$4 = "[object Set]",
    stringTag$2 = "[object String]",
    weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$2 = "[object ArrayBuffer]",
    dataViewTag$3 = "[object DataView]",
    float32Tag$2 = "[object Float32Array]",
    float64Tag$2 = "[object Float64Array]",
    int8Tag$2 = "[object Int8Array]",
    int16Tag$2 = "[object Int16Array]",
    int32Tag$2 = "[object Int32Array]",
    uint8Tag$2 = "[object Uint8Array]",
    uint8ClampedTag$2 = "[object Uint8ClampedArray]",
    uint16Tag$2 = "[object Uint16Array]",
    uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$2] = false;

function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal$1.process;

var nodeUtil = function () {
  try {
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;

    if (types) {
      return types;
    }

    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e2) {}
}();

var nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

var objectProto$4 = Object.prototype;

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto$4;
  return value === proto2;
}

var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;
var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$3.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }

  return result;
}

function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}

function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }

  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$2.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer = moduleExports ? root$1.Buffer : void 0,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;

function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }

  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

function stubArray() {
  return [];
}

var objectProto$1 = Object.prototype;
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;

function copySymbols(source, object) {
  return copyObject(source, getSymbols$1(source), object);
}

function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];

  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }

  return result;
};
var getSymbolsIn$1 = getSymbolsIn;

function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}

function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}

var DataView = getNative(root$1, "DataView");
var DataView$1 = DataView;
var Promise$1 = getNative(root$1, "Promise");
var Promise$2 = Promise$1;
var Set$1 = getNative(root$1, "Set");
var Set$2 = Set$1;
var WeakMap$1 = getNative(root$1, "WeakMap");
var WeakMap$2 = WeakMap$1;
var mapTag$3 = "[object Map]",
    objectTag$1 = "[object Object]",
    promiseTag = "[object Promise]",
    setTag$3 = "[object Set]",
    weakMapTag$1 = "[object WeakMap]";
var dataViewTag$2 = "[object DataView]";
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$2),
    promiseCtorString = toSource(Promise$2),
    setCtorString = toSource(Set$2),
    weakMapCtorString = toSource(WeakMap$2);
var getTag = baseGetTag;

if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2 || Map$2 && getTag(new Map$2()) != mapTag$3 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$3 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : void 0,
        ctorString = Ctor ? toSource(Ctor) : "";

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;

        case mapCtorString:
          return mapTag$3;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag$3;

        case weakMapCtorString:
          return weakMapTag$1;
      }
    }

    return result;
  };
}

var getTag$1 = getTag;
var objectProto = Object.prototype;
var hasOwnProperty$1 = objectProto.hasOwnProperty;

function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  if (length && typeof array[0] == "string" && hasOwnProperty$1.call(array, "index")) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}

var Uint8Array$1 = root$1.Uint8Array;
var Uint8Array$2 = Uint8Array$1;

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var reFlags = /\w*$/;

function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;

function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var boolTag$1 = "[object Boolean]",
    dateTag$1 = "[object Date]",
    mapTag$2 = "[object Map]",
    numberTag$1 = "[object Number]",
    regexpTag$1 = "[object RegExp]",
    setTag$2 = "[object Set]",
    stringTag$1 = "[object String]",
    symbolTag$2 = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]",
    dataViewTag$1 = "[object DataView]",
    float32Tag$1 = "[object Float32Array]",
    float64Tag$1 = "[object Float64Array]",
    int8Tag$1 = "[object Int8Array]",
    int16Tag$1 = "[object Int16Array]",
    int32Tag$1 = "[object Int32Array]",
    uint8Tag$1 = "[object Uint8Array]",
    uint8ClampedTag$1 = "[object Uint8ClampedArray]",
    uint16Tag$1 = "[object Uint16Array]",
    uint32Tag$1 = "[object Uint32Array]";

function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor();

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor();

    case symbolTag$2:
      return cloneSymbol(object);
  }
}

var objectCreate = Object.create;

var baseCreate = function () {
  function object() {}

  return function (proto2) {
    if (!isObject$1(proto2)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto2);
    }

    object.prototype = proto2;
    var result = new object();
    object.prototype = void 0;
    return result;
  };
}();

var baseCreate$1 = baseCreate;

function initCloneObject(object) {
  return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
}

var mapTag$1 = "[object Map]";

function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$1;
}

var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;
var setTag$1 = "[object Set]";

function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}

var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$2 = 4;
var argsTag = "[object Arguments]",
    arrayTag = "[object Array]",
    boolTag = "[object Boolean]",
    dateTag = "[object Date]",
    errorTag = "[object Error]",
    funcTag = "[object Function]",
    genTag = "[object GeneratorFunction]",
    mapTag = "[object Map]",
    numberTag = "[object Number]",
    objectTag = "[object Object]",
    regexpTag = "[object RegExp]",
    setTag = "[object Set]",
    stringTag = "[object String]",
    symbolTag$1 = "[object Symbol]",
    weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]",
    dataViewTag = "[object DataView]",
    float32Tag = "[object Float32Array]",
    float64Tag = "[object Float64Array]",
    int8Tag = "[object Int8Array]",
    int16Tag = "[object Int16Array]",
    int32Tag = "[object Int32Array]",
    uint8Tag = "[object Uint8Array]",
    uint8ClampedTag = "[object Uint8ClampedArray]",
    uint16Tag = "[object Uint16Array]",
    uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$2;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== void 0) {
    return result;
  }

  if (!isObject$1(value)) {
    return value;
  }

  var isArr = isArray$1(value);

  if (isArr) {
    result = initCloneArray(value);

    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }

    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);

      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = initCloneByTag(value, tag, isDeep);
    }
  }

  stack || (stack = new Stack());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key2) {
      result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? void 0 : keysFunc(value);
  arrayEach(props || value, function (subValue, key2) {
    if (props) {
      key2 = subValue;
      subValue = value[key2];
    }

    assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
  });
  return result;
}

var CLONE_SYMBOLS_FLAG$1 = 4;

function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG$1);
}

function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var symbolTag = "[object Symbol]";

function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

var FUNC_ERROR_TEXT = "Expected a function";

function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;

function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46) {
    result.push("");
  }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  });
  return result;
});
var stringToPath$1 = stringToPath;
var INFINITY$1 = 1 / 0;

function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }

  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}

var INFINITY = 1 / 0;
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0,
    symbolToString = symbolProto ? symbolProto.toString : void 0;

function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }

  if (isArray$1(value)) {
    return arrayMap(value, baseToString) + "";
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }

  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}

function toString(value) {
  return value == null ? "" : baseToString(value);
}

function toPath(value) {
  if (isArray$1(value)) {
    return arrayMap(value, toKey);
  }

  return isSymbol(value) ? [value] : copyArray(stringToPath$1(toString(value)));
}

var isProduction = process.env.NODE_ENV === "production";

function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== "undefined") {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x2) {}
  }
}

var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;

  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self2;
}

var isEmptyArray = function isEmptyArray2(value) {
  return Array.isArray(value) && value.length === 0;
};

var isFunction = function isFunction2(obj) {
  return typeof obj === "function";
};

var isObject = function isObject2(obj) {
  return obj !== null && typeof obj === "object";
};

var isInteger = function isInteger2(obj) {
  return String(Math.floor(Number(obj))) === obj;
};

var isString = function isString2(obj) {
  return Object.prototype.toString.call(obj) === "[object String]";
};

var isEmptyChildren = function isEmptyChildren2(children) {
  return Children.count(children) === 0;
};

var isPromise = function isPromise2(value) {
  return isObject(value) && isFunction(value.then);
};

function getActiveElement(doc) {
  doc = doc || (typeof document !== "undefined" ? document : void 0);

  if (typeof doc === "undefined") {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e2) {
    return doc.body;
  }
}

function getIn(obj, key, def, p2) {
  if (p2 === void 0) {
    p2 = 0;
  }

  var path = toPath(key);

  while (obj && p2 < path.length) {
    obj = obj[path[p2++]];
  }

  return obj === void 0 ? def : obj;
}

function setIn(obj, path, value) {
  var res = clone(obj);
  var resVal = res;
  var i2 = 0;
  var pathArray = toPath(path);

  for (; i2 < pathArray.length - 1; i2++) {
    var currentPath = pathArray[i2];
    var currentObj = getIn(obj, pathArray.slice(0, i2 + 1));

    if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone(currentObj);
    } else {
      var nextPath = pathArray[i2 + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  }

  if ((i2 === 0 ? obj : resVal)[pathArray[i2]] === value) {
    return obj;
  }

  if (value === void 0) {
    delete resVal[pathArray[i2]];
  } else {
    resVal[pathArray[i2]] = value;
  }

  if (i2 === 0 && value === void 0) {
    delete res[pathArray[i2]];
  }

  return res;
}

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = /* @__PURE__ */new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k2 = _Object$keys[_i];
    var val = object[k2];

    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true);
        response[k2] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k2]);
      }
    } else {
      response[k2] = value;
    }
  }

  return response;
}

var FormikContext = /* @__PURE__ */createContext(void 0);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
FormikContext.Consumer;

function useFormikContext() {
  var formik = useContext(FormikContext);
  !!!formik ? process.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case "SET_VALUES":
      return _extends({}, state, {
        values: msg.payload
      });

    case "SET_TOUCHED":
      return _extends({}, state, {
        touched: msg.payload
      });

    case "SET_ERRORS":
      if (reactFastCompare(state.errors, msg.payload)) {
        return state;
      }

      return _extends({}, state, {
        errors: msg.payload
      });

    case "SET_STATUS":
      return _extends({}, state, {
        status: msg.payload
      });

    case "SET_ISSUBMITTING":
      return _extends({}, state, {
        isSubmitting: msg.payload
      });

    case "SET_ISVALIDATING":
      return _extends({}, state, {
        isValidating: msg.payload
      });

    case "SET_FIELD_VALUE":
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case "SET_FIELD_TOUCHED":
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case "SET_FIELD_ERROR":
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case "RESET_FORM":
      return _extends({}, state, msg.payload);

    case "SET_FORMIK_STATE":
      return msg.payload(state);

    case "SUBMIT_ATTEMPT":
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case "SUBMIT_FAILURE":
      return _extends({}, state, {
        isSubmitting: false
      });

    case "SUBMIT_SUCCESS":
      return _extends({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
}

var emptyErrors = {};
var emptyTouched = {};

function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = useRef(props.initialValues);
  var initialErrors = useRef(props.initialErrors || emptyErrors);
  var initialTouched = useRef(props.initialTouched || emptyTouched);
  var initialStatus = useRef(props.initialStatus);
  var isMounted = useRef(false);
  var fieldRegistry = useRef({});

  if (process.env.NODE_ENV !== "production") {
    useEffect(function () {
      !(typeof isInitialValid === "undefined") ? process.env.NODE_ENV !== "production" ? warning(false, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : warning(false) : void 0;
    }, []);
  }

  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = useReducer(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = useCallback(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (process.env.NODE_ENV !== "production") {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  var runValidationSchema = useCallback(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        if (err.name === "ValidationError") {
          resolve(yupToFormErrors(err));
        } else {
          if (process.env.NODE_ENV !== "production") {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = useCallback(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = useCallback(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f2) {
      return isFunction(fieldRegistry.current[f2].validate);
    });
    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f2) {
      return runSingleFieldLevelValidation(f2, getIn(values, f2));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]);
  var runAllValidations = useCallback(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = deepmerge_1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]);
  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: "SET_ISVALIDATING",
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: "SET_ISVALIDATING",
          payload: false
        });
        dispatch({
          type: "SET_ERRORS",
          payload: combinedErrors
        });
      }

      return combinedErrors;
    });
  });
  useEffect(function () {
    if (validateOnMount && isMounted.current === true && reactFastCompare(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = useCallback(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn2() {
      dispatch({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  useEffect(function () {
    if (isMounted.current === true && !reactFastCompare(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithHighPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: "SET_ERRORS",
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: "SET_TOUCHED",
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: "SET_STATUS",
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        dispatch({
          type: "SET_ISVALIDATING",
          payload: true
        });
        return maybePromise.then(function (x2) {
          return x2;
        }).then(function (error) {
          dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: "SET_ISVALIDATING",
            payload: false
          });
        });
      } else {
        dispatch({
          type: "SET_FIELD_ERROR",
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: "SET_ISVALIDATING",
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x2) {
        return x2;
      }).then(function (error) {
        dispatch({
          type: "SET_FIELD_ERROR",
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: "SET_ISVALIDATING",
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = useCallback(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = useCallback(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: "SET_TOUCHED",
      payload: touched
    });
    var willValidate = shouldValidate === void 0 ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = useCallback(function (errors) {
    dispatch({
      type: "SET_ERRORS",
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: "SET_VALUES",
      payload: resolvedValues
    });
    var willValidate = shouldValidate === void 0 ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = useCallback(function (field, value) {
    dispatch({
      type: "SET_FIELD_ERROR",
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: "SET_FIELD_VALUE",
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === void 0 ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = useCallback(function (eventOrTextValue, maybePath) {
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed;

    if (!isString(eventOrTextValue)) {
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && process.env.NODE_ENV !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
          handlerName: "handleChange"
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple ? getSelectedValues(options) : value;
    }

    if (field) {
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === void 0 ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = useCallback(function (e2, path) {
    if (e2.persist) {
      e2.persist();
    }

    var _e$target = e2.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && process.env.NODE_ENV !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: "handleblur-e-any--void",
        handlerName: "handleBlur"
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = useCallback(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: "SET_FORMIK_STATE",
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: "SET_FORMIK_STATE",
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = useCallback(function (status) {
    dispatch({
      type: "SET_STATUS",
      payload: status
    });
  }, []);
  var setSubmitting = useCallback(function (isSubmitting) {
    dispatch({
      type: "SET_ISSUBMITTING",
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: "SUBMIT_ATTEMPT"
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit();

          if (promiseOrUndefined === void 0) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: "SUBMIT_SUCCESS"
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: "SUBMIT_FAILURE"
            });
            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        dispatch({
          type: "SUBMIT_FAILURE"
        });

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e2) {
    if (e2 && e2.preventDefault && isFunction(e2.preventDefault)) {
      e2.preventDefault();
    }

    if (e2 && e2.stopPropagation && isFunction(e2.stopPropagation)) {
      e2.stopPropagation();
    }

    if (process.env.NODE_ENV !== "production" && typeof document !== "undefined") {
      var activeElement = getActiveElement();

      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem("type")) ? process.env.NODE_ENV !== "production" ? warning(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : warning(false) : void 0;
      }
    }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e2) {
    if (e2 && e2.preventDefault && isFunction(e2.preventDefault)) {
      e2.preventDefault();
    }

    if (e2 && e2.stopPropagation && isFunction(e2.stopPropagation)) {
      e2.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = useCallback(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = useCallback(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched2(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = useCallback(function (nameOrOptions) {
    var isAnObject = isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === "checkbox") {
        if (valueProp === void 0) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === "radio") {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === "select" && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = useMemo(function () {
    return !reactFastCompare(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = useMemo(function () {
    return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}

function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef;
  useImperativeHandle(innerRef, function () {
    return formikbag;
  });

  if (process.env.NODE_ENV !== "production") {
    useEffect(function () {
      !!props.render ? process.env.NODE_ENV !== "production" ? warning(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : warning(false) : void 0;
    }, []);
  }

  return createElement(FormikProvider, {
    value: formikbag
  }, component ? createElement(component, formikbag) : render ? render(formikbag) : children ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? Children.only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}

function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? "validateSync" : "validate"](validateData, {
    abortEarly: false,
    context: context
  });
}

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k2 in values) {
    if (Object.prototype.hasOwnProperty.call(values, k2)) {
      var key = String(k2);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== "" ? value : void 0;
          }
        });
      } else if (isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== "" ? values[key] : void 0;
      }
    }
  }

  return data;
}

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e2, i2) {
    if (typeof destination[i2] === "undefined") {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e2);
      destination[i2] = shouldClone ? deepmerge_1(Array.isArray(e2) ? [] : {}, e2, options) : e2;
    } else if (options.isMergeableObject(e2)) {
      destination[i2] = deepmerge_1(target[i2], e2, options);
    } else if (target.indexOf(e2) === -1) {
      destination.push(e2);
    }
  });
  return destination;
}

function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}

function getValueForCheckbox(currentValue, checked, valueProp) {
  if (typeof currentValue === "boolean") {
    return Boolean(checked);
  }

  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    if (!valueProp || valueProp == "true" || valueProp == "false") {
      return Boolean(checked);
    }
  } else {
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  }

  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  }

  if (!isValueInArray) {
    return currentArrayOfValues;
  }

  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
}

var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? useLayoutEffect : useEffect;

function useEventCallback(fn) {
  var ref = useRef(fn);
  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

function Field(_ref) {
  var validate = _ref.validate,
      name = _ref.name,
      render = _ref.render,
      children = _ref.children,
      is = _ref.as,
      component = _ref.component,
      props = _objectWithoutPropertiesLoose(_ref, ["validate", "name", "render", "children", "as", "component"]);

  var _useFormikContext = useFormikContext(),
      formik = _objectWithoutPropertiesLoose(_useFormikContext, ["validate", "validationSchema"]);

  if (process.env.NODE_ENV !== "production") {
    useEffect(function () {
      !!render ? process.env.NODE_ENV !== "production" ? warning(false, '<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name="' + name + '" render={({field, form}) => ...} /> with <Field name="' + name + '">{({field, form, meta}) => ...}</Field>') : warning(false) : void 0;
      !!(is && children && isFunction(children)) ? process.env.NODE_ENV !== "production" ? warning(false, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.") : warning(false) : void 0;
      !!(component && children && isFunction(children)) ? process.env.NODE_ENV !== "production" ? warning(false, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.") : warning(false) : void 0;
      !!(render && children && !isEmptyChildren(children)) ? process.env.NODE_ENV !== "production" ? warning(false, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored") : warning(false) : void 0;
    }, []);
  }

  var registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  useEffect(function () {
    registerField(name, {
      validate: validate
    });
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name, validate]);
  var field = formik.getFieldProps(_extends({
    name: name
  }, props));
  var meta = formik.getFieldMeta(name);
  var legacyBag = {
    field: field,
    form: formik
  };

  if (render) {
    return render(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (isFunction(children)) {
    return children(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (component) {
    if (typeof component === "string") {
      var innerRef = props.innerRef,
          rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return createElement(component, _extends({
        ref: innerRef
      }, field, rest), children);
    }

    return createElement(component, _extends({
      field: field,
      form: formik
    }, props), children);
  }

  var asElement = is || "input";

  if (typeof asElement === "string") {
    var _innerRef = props.innerRef,
        _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

    return createElement(asElement, _extends({
      ref: _innerRef
    }, field, _rest), children);
  }

  return createElement(asElement, _extends({}, field, props), children);
}

var Form$1 = /* @__PURE__ */forwardRef(function (props, ref) {
  var action = props.action,
      rest = _objectWithoutPropertiesLoose(props, ["action"]);

  var _action = action != null ? action : "#";

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return createElement("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form$1.displayName = "Form";

var move = function move2(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};

var swap = function swap2(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a2 = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a2;
  return copy;
};

var insert = function insert2(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};

var replace = function replace2(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};

var copyArrayLike = function copyArrayLike2(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};

var FieldArrayInner = /* @__PURE__ */function (_React$Component) {
  _inheritsLoose(FieldArrayInner2, _React$Component);

  function FieldArrayInner2(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = typeof alterErrors === "function" ? alterErrors : fn;
        var updateTouched = typeof alterTouched === "function" ? alterTouched : fn;
        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : void 0;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : void 0;

        if (isEmptyArray(fieldError)) {
          fieldError = void 0;
        }

        if (isEmptyArray(fieldTouched)) {
          fieldTouched = void 0;
        }

        return _extends({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [cloneDeep(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    };

    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FieldArrayInner2.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !reactFastCompare(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };

  _proto.remove = function remove(index) {
    var result;
    this.updateArrayField(function (array) {
      var copy = array ? copyArrayLike(array) : [];

      if (!result) {
        result = copy[index];
      }

      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      }

      return copy;
    }, true, true);
    return result;
  };

  _proto.pop = function pop() {
    var result;
    this.updateArrayField(function (array) {
      var tmp = array;

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _this$props2 = this.props,
        component = _this$props2.component,
        render2 = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, ["validate", "validationSchema"]);

    var props = _extends({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? createElement(component, props) : render2 ? render2(props) : children ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? Children.only(children) : null : null;
  };

  return FieldArrayInner2;
}(Component);

FieldArrayInner.defaultProps = {
  validateOnChange: true
};

var useUser = function useUser() {
  var user = useContext(Context$1);
  return user;
};

function Approval(_ref10) {
  var handleConfirm = _ref10.handleConfirm;
  return /* @__PURE__ */jsxs("div", {
    className: "squeak-approval-required",
    children: [/* @__PURE__ */jsx("h3", {
      children: "Post submitted"
    }), /* @__PURE__ */jsx("p", {
      children: "New posts require approval from a moderator. Check back soon!"
    }), /* @__PURE__ */jsx("p", {
      children: "(You'll also receive an email when answers are posted.)"
    }), /* @__PURE__ */jsx("button", {
      onClick: handleConfirm,
      className: "squeak-post-button",
      children: "Got it"
    })]
  });
}

var Image = function Image(_ref11) {
  var src = _ref11.src;
  return src ? /* @__PURE__ */jsx("img", {
    src: src
  }) : /* @__PURE__ */jsxs("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    children: [/* @__PURE__ */jsx("path", {
      d: "M0 0h40v40H0z"
    }), /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.19 6.57c-5.384-.696-9.938 3.89-9.93 10.343.013.1.026.229.042.378.045.443.11 1.067.262 1.67.883 3.445 2.781 6.077 6.305 7.132 3.117.938 5.86.04 8.14-2.242 3.008-3.016 3.805-8.039 1.891-12.047-1.36-2.844-3.484-4.82-6.71-5.234ZM2.5 40c-.64-1.852 1.119-6.454 2.947-7.61 2.48-1.563 5.076-2.942 7.671-4.32.48-.255.96-.51 1.438-.766.313-.164.899.008 1.29.188 2.827 1.242 5.624 1.25 8.468.03.492-.21 1.242-.241 1.695-.015 2.688 1.367 5.352 2.774 7.961 4.281 2.352 1.36 4.35 6.056 3.53 8.212h-35Z",
      fill: "#fff"
    })]
  });
};

var Avatar = function Avatar(_ref12) {
  var image = _ref12.image,
      url = _ref12.url;
  return /* @__PURE__ */jsx("div", {
    className: "squeak-avatar-container",
    children: url ? /* @__PURE__ */jsx("a", {
      href: url,
      children: /* @__PURE__ */jsx(Image, {
        src: image
      })
    }) : /* @__PURE__ */jsx(Image, {
      src: image
    })
  });
};

var ForgotPassword = function ForgotPassword(_ref13) {
  var setMessage = _ref13.setMessage,
      setParentView = _ref13.setParentView,
      apiHost = _ref13.apiHost;

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      emailSent = _useState8[0],
      setEmailSent = _useState8[1];

  var _useOrg2 = useOrg(),
      organizationId = _useOrg2.organizationId;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values) {
      var _ref15, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return post(apiHost, "/api/password/forgot", {
                email: values.email,
                redirect: window.location.href,
                organizationId: organizationId
              });

            case 3:
              _context2.t0 = _context2.sent;

              if (_context2.t0) {
                _context2.next = 6;
                break;
              }

              _context2.t0 = {};

            case 6:
              _ref15 = _context2.t0;
              error = _ref15.error;

              if (error) {
                setMessage(error.message);
              } else {
                setEmailSent(true);
              }

              setLoading(false);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit(_x14) {
      return _ref14.apply(this, arguments);
    };
  }();

  var handleReturnToPost = function handleReturnToPost(e2) {
    e2.preventDefault();
    setParentView == null ? void 0 : setParentView("question-form");
  };

  return /* @__PURE__ */jsx(Formik, {
    validateOnMount: true,
    initialValues: {
      email: ""
    },
    validate: function validate(values) {
      var errors = {};

      if (!values.email) {
        errors.email = "Required";
      }

      return errors;
    },
    onSubmit: handleSubmit,
    children: function children(_ref16) {
      var isValid = _ref16.isValid;
      return /* @__PURE__ */jsxs(Form$1, {
        children: [/* @__PURE__ */jsx("label", {
          htmlFor: "email",
          children: "Email address"
        }), /* @__PURE__ */jsx(Field, {
          required: true,
          id: "email",
          name: "email",
          type: "email",
          placeholder: "Email address..."
        }), emailSent ? /* @__PURE__ */jsxs("div", {
          children: [/* @__PURE__ */jsx("p", {
            children: "Check your email for password reset instructions"
          }), /* @__PURE__ */jsxs("p", {
            children: [/* @__PURE__ */jsx("button", {
              onClick: handleReturnToPost,
              className: "squeak-return-to-post",
              children: "Click here"
            }), " ", "to return to your post"]
          })]
        }) : /* @__PURE__ */jsx("button", {
          style: loading || !isValid ? {
            opacity: ".5"
          } : {},
          type: "submit",
          children: "Send password reset instructions"
        })]
      });
    }
  });
};

var gravatar$1 = {
  exports: {}
};
var gravatar = {
  exports: {}
};
var md5$1 = {
  exports: {}
};

(function (module2) {
  (function ($2) {
    function safeAdd(x2, y2) {
      var lsw = (x2 & 65535) + (y2 & 65535);
      var msw = (x2 >> 16) + (y2 >> 16) + (lsw >> 16);
      return msw << 16 | lsw & 65535;
    }

    function bitRotateLeft(num, cnt) {
      return num << cnt | num >>> 32 - cnt;
    }

    function md5cmn(q2, a2, b2, x2, s2, t2) {
      return safeAdd(bitRotateLeft(safeAdd(safeAdd(a2, q2), safeAdd(x2, t2)), s2), b2);
    }

    function md5ff(a2, b2, c2, d2, x2, s2, t2) {
      return md5cmn(b2 & c2 | ~b2 & d2, a2, b2, x2, s2, t2);
    }

    function md5gg(a2, b2, c2, d2, x2, s2, t2) {
      return md5cmn(b2 & d2 | c2 & ~d2, a2, b2, x2, s2, t2);
    }

    function md5hh(a2, b2, c2, d2, x2, s2, t2) {
      return md5cmn(b2 ^ c2 ^ d2, a2, b2, x2, s2, t2);
    }

    function md5ii(a2, b2, c2, d2, x2, s2, t2) {
      return md5cmn(c2 ^ (b2 | ~d2), a2, b2, x2, s2, t2);
    }

    function binlMD5(x2, len) {
      x2[len >> 5] |= 128 << len % 32;
      x2[(len + 64 >>> 9 << 4) + 14] = len;
      var i2;
      var olda;
      var oldb;
      var oldc;
      var oldd;
      var a2 = 1732584193;
      var b2 = -271733879;
      var c2 = -1732584194;
      var d2 = 271733878;

      for (i2 = 0; i2 < x2.length; i2 += 16) {
        olda = a2;
        oldb = b2;
        oldc = c2;
        oldd = d2;
        a2 = md5ff(a2, b2, c2, d2, x2[i2], 7, -680876936);
        d2 = md5ff(d2, a2, b2, c2, x2[i2 + 1], 12, -389564586);
        c2 = md5ff(c2, d2, a2, b2, x2[i2 + 2], 17, 606105819);
        b2 = md5ff(b2, c2, d2, a2, x2[i2 + 3], 22, -1044525330);
        a2 = md5ff(a2, b2, c2, d2, x2[i2 + 4], 7, -176418897);
        d2 = md5ff(d2, a2, b2, c2, x2[i2 + 5], 12, 1200080426);
        c2 = md5ff(c2, d2, a2, b2, x2[i2 + 6], 17, -1473231341);
        b2 = md5ff(b2, c2, d2, a2, x2[i2 + 7], 22, -45705983);
        a2 = md5ff(a2, b2, c2, d2, x2[i2 + 8], 7, 1770035416);
        d2 = md5ff(d2, a2, b2, c2, x2[i2 + 9], 12, -1958414417);
        c2 = md5ff(c2, d2, a2, b2, x2[i2 + 10], 17, -42063);
        b2 = md5ff(b2, c2, d2, a2, x2[i2 + 11], 22, -1990404162);
        a2 = md5ff(a2, b2, c2, d2, x2[i2 + 12], 7, 1804603682);
        d2 = md5ff(d2, a2, b2, c2, x2[i2 + 13], 12, -40341101);
        c2 = md5ff(c2, d2, a2, b2, x2[i2 + 14], 17, -1502002290);
        b2 = md5ff(b2, c2, d2, a2, x2[i2 + 15], 22, 1236535329);
        a2 = md5gg(a2, b2, c2, d2, x2[i2 + 1], 5, -165796510);
        d2 = md5gg(d2, a2, b2, c2, x2[i2 + 6], 9, -1069501632);
        c2 = md5gg(c2, d2, a2, b2, x2[i2 + 11], 14, 643717713);
        b2 = md5gg(b2, c2, d2, a2, x2[i2], 20, -373897302);
        a2 = md5gg(a2, b2, c2, d2, x2[i2 + 5], 5, -701558691);
        d2 = md5gg(d2, a2, b2, c2, x2[i2 + 10], 9, 38016083);
        c2 = md5gg(c2, d2, a2, b2, x2[i2 + 15], 14, -660478335);
        b2 = md5gg(b2, c2, d2, a2, x2[i2 + 4], 20, -405537848);
        a2 = md5gg(a2, b2, c2, d2, x2[i2 + 9], 5, 568446438);
        d2 = md5gg(d2, a2, b2, c2, x2[i2 + 14], 9, -1019803690);
        c2 = md5gg(c2, d2, a2, b2, x2[i2 + 3], 14, -187363961);
        b2 = md5gg(b2, c2, d2, a2, x2[i2 + 8], 20, 1163531501);
        a2 = md5gg(a2, b2, c2, d2, x2[i2 + 13], 5, -1444681467);
        d2 = md5gg(d2, a2, b2, c2, x2[i2 + 2], 9, -51403784);
        c2 = md5gg(c2, d2, a2, b2, x2[i2 + 7], 14, 1735328473);
        b2 = md5gg(b2, c2, d2, a2, x2[i2 + 12], 20, -1926607734);
        a2 = md5hh(a2, b2, c2, d2, x2[i2 + 5], 4, -378558);
        d2 = md5hh(d2, a2, b2, c2, x2[i2 + 8], 11, -2022574463);
        c2 = md5hh(c2, d2, a2, b2, x2[i2 + 11], 16, 1839030562);
        b2 = md5hh(b2, c2, d2, a2, x2[i2 + 14], 23, -35309556);
        a2 = md5hh(a2, b2, c2, d2, x2[i2 + 1], 4, -1530992060);
        d2 = md5hh(d2, a2, b2, c2, x2[i2 + 4], 11, 1272893353);
        c2 = md5hh(c2, d2, a2, b2, x2[i2 + 7], 16, -155497632);
        b2 = md5hh(b2, c2, d2, a2, x2[i2 + 10], 23, -1094730640);
        a2 = md5hh(a2, b2, c2, d2, x2[i2 + 13], 4, 681279174);
        d2 = md5hh(d2, a2, b2, c2, x2[i2], 11, -358537222);
        c2 = md5hh(c2, d2, a2, b2, x2[i2 + 3], 16, -722521979);
        b2 = md5hh(b2, c2, d2, a2, x2[i2 + 6], 23, 76029189);
        a2 = md5hh(a2, b2, c2, d2, x2[i2 + 9], 4, -640364487);
        d2 = md5hh(d2, a2, b2, c2, x2[i2 + 12], 11, -421815835);
        c2 = md5hh(c2, d2, a2, b2, x2[i2 + 15], 16, 530742520);
        b2 = md5hh(b2, c2, d2, a2, x2[i2 + 2], 23, -995338651);
        a2 = md5ii(a2, b2, c2, d2, x2[i2], 6, -198630844);
        d2 = md5ii(d2, a2, b2, c2, x2[i2 + 7], 10, 1126891415);
        c2 = md5ii(c2, d2, a2, b2, x2[i2 + 14], 15, -1416354905);
        b2 = md5ii(b2, c2, d2, a2, x2[i2 + 5], 21, -57434055);
        a2 = md5ii(a2, b2, c2, d2, x2[i2 + 12], 6, 1700485571);
        d2 = md5ii(d2, a2, b2, c2, x2[i2 + 3], 10, -1894986606);
        c2 = md5ii(c2, d2, a2, b2, x2[i2 + 10], 15, -1051523);
        b2 = md5ii(b2, c2, d2, a2, x2[i2 + 1], 21, -2054922799);
        a2 = md5ii(a2, b2, c2, d2, x2[i2 + 8], 6, 1873313359);
        d2 = md5ii(d2, a2, b2, c2, x2[i2 + 15], 10, -30611744);
        c2 = md5ii(c2, d2, a2, b2, x2[i2 + 6], 15, -1560198380);
        b2 = md5ii(b2, c2, d2, a2, x2[i2 + 13], 21, 1309151649);
        a2 = md5ii(a2, b2, c2, d2, x2[i2 + 4], 6, -145523070);
        d2 = md5ii(d2, a2, b2, c2, x2[i2 + 11], 10, -1120210379);
        c2 = md5ii(c2, d2, a2, b2, x2[i2 + 2], 15, 718787259);
        b2 = md5ii(b2, c2, d2, a2, x2[i2 + 9], 21, -343485551);
        a2 = safeAdd(a2, olda);
        b2 = safeAdd(b2, oldb);
        c2 = safeAdd(c2, oldc);
        d2 = safeAdd(d2, oldd);
      }

      return [a2, b2, c2, d2];
    }

    function binl2rstr(input) {
      var i2;
      var output = "";
      var length32 = input.length * 32;

      for (i2 = 0; i2 < length32; i2 += 8) {
        output += String.fromCharCode(input[i2 >> 5] >>> i2 % 32 & 255);
      }

      return output;
    }

    function rstr2binl(input) {
      var i2;
      var output = [];
      output[(input.length >> 2) - 1] = void 0;

      for (i2 = 0; i2 < output.length; i2 += 1) {
        output[i2] = 0;
      }

      var length8 = input.length * 8;

      for (i2 = 0; i2 < length8; i2 += 8) {
        output[i2 >> 5] |= (input.charCodeAt(i2 / 8) & 255) << i2 % 32;
      }

      return output;
    }

    function rstrMD5(s2) {
      return binl2rstr(binlMD5(rstr2binl(s2), s2.length * 8));
    }

    function rstrHMACMD5(key, data) {
      var i2;
      var bkey = rstr2binl(key);
      var ipad = [];
      var opad = [];
      var hash;
      ipad[15] = opad[15] = void 0;

      if (bkey.length > 16) {
        bkey = binlMD5(bkey, key.length * 8);
      }

      for (i2 = 0; i2 < 16; i2 += 1) {
        ipad[i2] = bkey[i2] ^ 909522486;
        opad[i2] = bkey[i2] ^ 1549556828;
      }

      hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
      return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
    }

    function rstr2hex(input) {
      var hexTab = "0123456789abcdef";
      var output = "";
      var x2;
      var i2;

      for (i2 = 0; i2 < input.length; i2 += 1) {
        x2 = input.charCodeAt(i2);
        output += hexTab.charAt(x2 >>> 4 & 15) + hexTab.charAt(x2 & 15);
      }

      return output;
    }

    function str2rstrUTF8(input) {
      return unescape(encodeURIComponent(input));
    }

    function rawMD5(s2) {
      return rstrMD5(str2rstrUTF8(s2));
    }

    function hexMD5(s2) {
      return rstr2hex(rawMD5(s2));
    }

    function rawHMACMD5(k2, d2) {
      return rstrHMACMD5(str2rstrUTF8(k2), str2rstrUTF8(d2));
    }

    function hexHMACMD5(k2, d2) {
      return rstr2hex(rawHMACMD5(k2, d2));
    }

    function md52(string, key, raw) {
      if (!key) {
        if (!raw) {
          return hexMD5(string);
        }

        return rawMD5(string);
      }

      if (!raw) {
        return hexHMACMD5(key, string);
      }

      return rawHMACMD5(key, string);
    }

    if (module2.exports) {
      module2.exports = md52;
    } else {
      $2.md5 = md52;
    }
  })(commonjsGlobal);
})(md5$1);

var querystring$1 = {};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var decode = function decode(qs, sep, eq2, options) {
  sep = sep || "&";
  eq2 = eq2 || "=";
  var obj = {};

  if (typeof qs !== "string" || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);
  var maxKeys = 1e3;

  if (options && typeof options.maxKeys === "number") {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;

  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i2 = 0; i2 < len; ++i2) {
    var x2 = qs[i2].replace(regexp, "%20"),
        idx = x2.indexOf(eq2),
        kstr,
        vstr,
        k2,
        v2;

    if (idx >= 0) {
      kstr = x2.substr(0, idx);
      vstr = x2.substr(idx + 1);
    } else {
      kstr = x2;
      vstr = "";
    }

    k2 = decodeURIComponent(kstr);
    v2 = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k2)) {
      obj[k2] = v2;
    } else if (Array.isArray(obj[k2])) {
      obj[k2].push(v2);
    } else {
      obj[k2] = [obj[k2], v2];
    }
  }

  return obj;
};

var stringifyPrimitive = function stringifyPrimitive(v2) {
  switch (typeof v2) {
    case "string":
      return v2;

    case "boolean":
      return v2 ? "true" : "false";

    case "number":
      return isFinite(v2) ? v2 : "";

    default:
      return "";
  }
};

var encode = function encode(obj, sep, eq2, name) {
  sep = sep || "&";
  eq2 = eq2 || "=";

  if (obj === null) {
    obj = void 0;
  }

  if (typeof obj === "object") {
    return Object.keys(obj).map(function (k2) {
      var ks = encodeURIComponent(stringifyPrimitive(k2)) + eq2;

      if (Array.isArray(obj[k2])) {
        return obj[k2].map(function (v2) {
          return ks + encodeURIComponent(stringifyPrimitive(v2));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k2]));
      }
    }).join(sep);
  }

  if (!name) return "";
  return encodeURIComponent(stringifyPrimitive(name)) + eq2 + encodeURIComponent(stringifyPrimitive(obj));
};

querystring$1.decode = querystring$1.parse = decode;
querystring$1.encode = querystring$1.stringify = encode;
var md5 = md5$1.exports,
    querystring = querystring$1,
    MD5_REGEX = /^[0-9a-f]{32}$/;

function params(options) {
  var params2 = {},
      removing = {
    protocol: 1,
    format: 1
  };

  for (var key in options) {
    if (!removing[key]) params2[key] = options[key];
  }

  return params2;
}

function proto(options, protocol) {
  if (!options) return;
  if (typeof options.protocol === "boolean") return options.protocol;
  return options.protocol === "http" ? false : options.protocol === "https" ? true : void 0;
}

function getHash(email) {
  email = typeof email === "string" ? email.trim().toLowerCase() : "unspecified";
  return email.match(MD5_REGEX) ? email : md5(email);
}

function getQueryString(options) {
  var queryData = querystring.stringify(params(options));
  return queryData && "?" + queryData || "";
}

gravatar.exports = {
  url: function url(email, options, protocol) {
    var baseURL = "//www.gravatar.com/avatar/";

    if (options && options.cdn) {
      baseURL = options.cdn + "/avatar/";
      delete options.cdn;
    } else {
      if (options && options.protocol) protocol = proto(options);

      if (typeof protocol !== "undefined") {
        baseURL = protocol ? "https://s.gravatar.com/avatar/" : "http://www.gravatar.com/avatar/";
      }
    }

    var query = getQueryString(options);
    return baseURL + getHash(email) + query;
  },
  profile_url: function profile_url(email, options, https) {
    var format = options != void 0 && options.format != void 0 ? String(options.format) : "json";
    var baseURL;

    if (options && options.cdn) {
      baseURL = options.cdn + "/";
      delete options.cdn;
    } else {
      if (options && options.protocol) https = proto(options);
      var baseURL = https && "https://secure.gravatar.com/" || "http://www.gravatar.com/";
    }

    var query = getQueryString(options);
    return baseURL + getHash(email) + "." + format + query;
  }
};

(function (module2) {
  module2.exports = gravatar.exports;
})(gravatar$1);

var getGravatar = /* @__PURE__ */getDefaultExportFromCjs(gravatar$1.exports);

var SignUp = function SignUp(_ref17) {
  var setMessage = _ref17.setMessage,
      handleMessageSubmit = _ref17.handleMessageSubmit,
      formValues = _ref17.formValues,
      organizationId = _ref17.organizationId,
      apiHost = _ref17.apiHost,
      buttonText = _ref17.buttonText,
      onSignUp = _ref17.onSignUp;

  var _useUser = useUser(),
      setUser = _useUser.setUser;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(values) {
      var gravatar2, avatar, _ref19, error, data;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              gravatar2 = getGravatar.url(values.email);
              _context3.next = 3;
              return fetch("https:".concat(gravatar2, "?d=404")).then(function (res) {
                return res.ok && "https:".concat(gravatar2) || "";
              });

            case 3:
              avatar = _context3.sent;
              _context3.next = 6;
              return post(apiHost, "/api/register", {
                email: values.email,
                password: values.password,
                firstName: values.first_name,
                lastName: values.last_name,
                avatar: avatar,
                organizationId: organizationId
              });

            case 6:
              _context3.t0 = _context3.sent;

              if (_context3.t0) {
                _context3.next = 9;
                break;
              }

              _context3.t0 = {};

            case 9:
              _ref19 = _context3.t0;
              error = _ref19.error;
              data = _ref19.data;
              _context3.next = 14;
              return handleMessageSubmit(formValues || {
                email: values.email
              });

            case 14:
              onSignUp && onSignUp({
                email: values.email,
                firstName: values.first_name,
                lastName: values.last_name
              });
              setUser({
                id: data.userId
              });

              if (error) {
                setMessage(error.message);
              }

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmit(_x15) {
      return _ref18.apply(this, arguments);
    };
  }();

  return /* @__PURE__ */jsx(Formik, {
    validateOnMount: true,
    initialValues: {
      email: "",
      password: "",
      first_name: "",
      last_name: ""
    },
    validate: function validate(values) {
      var errors = {};

      if (!values.first_name) {
        errors.first_name = "Required";
      }

      if (!values.email) {
        errors.email = "Required";
      }

      if (!values.password) {
        errors.password = "Required";
      }

      return errors;
    },
    onSubmit: handleSubmit,
    children: function children(_ref20) {
      var isValid = _ref20.isValid,
          isSubmitting = _ref20.isSubmitting;
      return /* @__PURE__ */jsxs(Form$1, {
        children: [/* @__PURE__ */jsxs("div", {
          className: "squeak-authentication-form-name",
          children: [/* @__PURE__ */jsxs("span", {
            children: [/* @__PURE__ */jsx("label", {
              htmlFor: "first_name",
              children: "First name"
            }), /* @__PURE__ */jsx(Field, {
              required: true,
              id: "first_name",
              name: "first_name",
              type: "text",
              placeholder: "First name..."
            })]
          }), /* @__PURE__ */jsxs("span", {
            children: [/* @__PURE__ */jsx("label", {
              htmlFor: "last_name",
              children: "Last name"
            }), /* @__PURE__ */jsx(Field, {
              id: "last_name",
              name: "last_name",
              type: "text",
              placeholder: "Last name..."
            })]
          })]
        }), /* @__PURE__ */jsx("label", {
          htmlFor: "email",
          children: "Email address"
        }), /* @__PURE__ */jsx(Field, {
          required: true,
          id: "email",
          name: "email",
          type: "email",
          placeholder: "Email address..."
        }), /* @__PURE__ */jsx("label", {
          htmlFor: "password",
          children: "Password"
        }), /* @__PURE__ */jsx(Field, {
          required: true,
          id: "password",
          name: "password",
          type: "password",
          placeholder: "Password..."
        }), /* @__PURE__ */jsx("button", {
          style: isSubmitting || !isValid ? {
            opacity: ".5"
          } : {},
          type: "submit",
          children: buttonText
        })]
      });
    }
  });
};

var SignIn = function SignIn(_ref21) {
  var setMessage = _ref21.setMessage,
      handleMessageSubmit = _ref21.handleMessageSubmit,
      formValues = _ref21.formValues,
      apiHost = _ref21.apiHost,
      buttonText = _ref21.buttonText,
      organizationId = _ref21.organizationId;

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loading = _useState10[0],
      setLoading = _useState10[1];

  var _useUser2 = useUser(),
      setUser = _useUser2.setUser;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(values) {
      var _ref23, data, error;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setLoading(true);
              _context4.next = 3;
              return post(apiHost, "/api/login", {
                email: values.email,
                password: values.password,
                organizationId: organizationId
              });

            case 3:
              _context4.t0 = _context4.sent;

              if (_context4.t0) {
                _context4.next = 6;
                break;
              }

              _context4.t0 = {};

            case 6:
              _ref23 = _context4.t0;
              data = _ref23.data;
              error = _ref23.error;

              if (!error) {
                _context4.next = 14;
                break;
              }

              setMessage("Incorrect email/password. Please try again.");
              setLoading(false);
              _context4.next = 17;
              break;

            case 14:
              setUser({
                id: data.id
              });
              _context4.next = 17;
              return handleMessageSubmit(formValues || {
                email: values.email
              });

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSubmit(_x16) {
      return _ref22.apply(this, arguments);
    };
  }();

  return /* @__PURE__ */jsx(Formik, {
    validateOnMount: true,
    initialValues: {
      email: "",
      password: ""
    },
    validate: function validate(values) {
      var errors = {};

      if (!values.email) {
        errors.email = "Required";
      }

      if (!values.password) {
        errors.password = "Required";
      }

      return errors;
    },
    onSubmit: handleSubmit,
    children: function children(_ref24) {
      var isValid = _ref24.isValid;
      return /* @__PURE__ */jsxs(Form$1, {
        children: [/* @__PURE__ */jsx("label", {
          htmlFor: "email",
          children: "Email address"
        }), /* @__PURE__ */jsx(Field, {
          required: true,
          id: "email",
          name: "email",
          type: "email",
          placeholder: "Email address..."
        }), /* @__PURE__ */jsx("label", {
          htmlFor: "password",
          children: "Password"
        }), /* @__PURE__ */jsx(Field, {
          required: true,
          id: "password",
          name: "password",
          type: "password",
          placeholder: "Password..."
        }), /* @__PURE__ */jsx("button", {
          style: loading || !isValid ? {
            opacity: ".5"
          } : {},
          type: "submit",
          children: buttonText
        })]
      });
    }
  });
};

var ResetPassword = function ResetPassword(_ref25) {
  var setMessage = _ref25.setMessage,
      setParentView = _ref25.setParentView,
      apiHost = _ref25.apiHost;

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      loading = _useState12[0],
      setLoading = _useState12[1];

  var resetPassword = useRef(null);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(values) {
      var _ref27, error;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setLoading(true);
              _context5.next = 3;
              return post(apiHost, "/api/password/reset", {
                password: values.password
              });

            case 3:
              _context5.t0 = _context5.sent;

              if (_context5.t0) {
                _context5.next = 6;
                break;
              }

              _context5.t0 = {};

            case 6:
              _ref27 = _context5.t0;
              error = _ref27.error;

              if (error) {
                setMessage(error.message);
              } else {
                setParentView == null ? void 0 : setParentView(null);
              }

              setLoading(false);

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleSubmit(_x17) {
      return _ref26.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (resetPassword == null ? void 0 : resetPassword.current) {
      resetPassword.current.scrollIntoView();
    }
  }, [resetPassword]);
  return /* @__PURE__ */jsx("div", {
    ref: resetPassword,
    children: /* @__PURE__ */jsx(Formik, {
      validateOnMount: true,
      initialValues: {
        password: ""
      },
      validate: function validate(values) {
        var errors = {};

        if (!values.password) {
          errors.password = "Required";
        }

        return errors;
      },
      onSubmit: handleSubmit,
      children: function children(_ref28) {
        var isValid = _ref28.isValid;
        return /* @__PURE__ */jsxs(Form$1, {
          children: [/* @__PURE__ */jsx("label", {
            htmlFor: "password",
            children: "New password"
          }), /* @__PURE__ */jsx(Field, {
            required: true,
            id: "password",
            name: "password",
            type: "password",
            placeholder: "New password"
          }), /* @__PURE__ */jsx("button", {
            style: loading || !isValid ? {
              opacity: ".5"
            } : {},
            type: "submit",
            children: "Reset password"
          })]
        });
      }
    })
  });
};

var Authentication$1 = function Authentication$1(_ref29) {
  var handleMessageSubmit = _ref29.handleMessageSubmit,
      formValues = _ref29.formValues,
      setParentView = _ref29.setParentView,
      _ref29$initialView = _ref29.initialView,
      initialView = _ref29$initialView === void 0 ? "sign-in" : _ref29$initialView,
      _ref29$buttonText = _ref29.buttonText,
      buttonText = _ref29$buttonText === void 0 ? {
    login: "Login",
    signUp: "Sign up"
  } : _ref29$buttonText,
      banner = _ref29.banner,
      onSignUp = _ref29.onSignUp;

  var _useOrg3 = useOrg(),
      organizationId = _useOrg3.organizationId,
      apiHost = _useOrg3.apiHost;

  var _useState13 = useState(initialView),
      _useState14 = _slicedToArray(_useState13, 2),
      view = _useState14[0],
      setView = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      message = _useState16[0],
      setMessage = _useState16[1];

  var handleForgotPassword = function handleForgotPassword(e2) {
    e2.preventDefault();
    setView("forgot-password");
  };

  return /* @__PURE__ */jsxs("div", {
    children: [/* @__PURE__ */jsx(Avatar, {}), formValues && /* @__PURE__ */jsxs("div", {
      className: "squeak-post-preview-container",
      children: [/* @__PURE__ */jsxs("div", {
        className: "squeak-post-preview",
        children: [(formValues == null ? void 0 : formValues.subject) && /* @__PURE__ */jsx("h3", {
          children: formValues.subject
        }), formValues.question]
      }), /* @__PURE__ */jsx("div", {
        className: "squeak-button-container",
        children: /* @__PURE__ */jsx("button", {
          onClick: function onClick() {
            return setParentView == null ? void 0 : setParentView("question-form");
          },
          children: "Edit post"
        })
      })]
    }), /* @__PURE__ */jsxs("div", {
      className: "squeak-authentication-form-container",
      children: [banner && /* @__PURE__ */jsxs("div", {
        className: "squeak-authentication-form-message",
        children: [/* @__PURE__ */jsx("h4", {
          children: banner.title
        }), /* @__PURE__ */jsx("p", {
          children: banner.body
        })]
      }), /* @__PURE__ */jsxs("div", {
        className: "squeak-authentication-form",
        children: [/* @__PURE__ */jsxs("div", {
          className: "squeak-authentication-navigation",
          children: [/* @__PURE__ */jsx("button", {
            className: view === "sign-in" ? "active" : "",
            onClick: function onClick() {
              return setView("sign-in");
            },
            children: "Login"
          }), /* @__PURE__ */jsx("button", {
            className: view === "sign-up" ? "active" : "",
            onClick: function onClick() {
              return setView("sign-up");
            },
            children: "Signup"
          }), /* @__PURE__ */jsx("div", {
            style: {
              opacity: view === "forgot-password" || view === "reset-password" ? 0 : 1
            },
            className: "squeak-authentication-navigation-rail ".concat(view)
          })]
        }), /* @__PURE__ */jsxs("div", {
          className: "squeak-authentication-form-wrapper",
          children: [message && /* @__PURE__ */jsx("p", {
            className: "squeak-auth-error",
            children: message
          }), {
            "sign-in": /* @__PURE__ */jsx(SignIn, {
              buttonText: buttonText.login,
              formValues: formValues,
              handleMessageSubmit: handleMessageSubmit,
              setMessage: setMessage,
              apiHost: apiHost,
              organizationId: organizationId
            }),
            "sign-up": /* @__PURE__ */jsx(SignUp, {
              buttonText: buttonText.signUp,
              formValues: formValues,
              handleMessageSubmit: handleMessageSubmit,
              setMessage: setMessage,
              organizationId: organizationId,
              apiHost: apiHost,
              onSignUp: onSignUp
            }),
            "forgot-password": /* @__PURE__ */jsx(ForgotPassword, {
              setParentView: setParentView,
              setMessage: setMessage,
              apiHost: apiHost
            }),
            "reset-password": /* @__PURE__ */jsx(ResetPassword, {
              setParentView: setParentView,
              setMessage: setMessage,
              apiHost: apiHost
            })
          }[view], view !== "forgot-password" && view !== "reset-password" && /* @__PURE__ */jsx("button", {
            onClick: handleForgotPassword,
            className: "squeak-forgot-password",
            children: "Forgot password"
          })]
        })]
      })]
    })]
  });
};

function Logo() {
  return /* @__PURE__ */jsxs("svg", {
    width: "48",
    height: "15",
    viewBox: "0 0 48 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */jsx("path", {
      d: "M4.26318 12.8562C3.69439 12.881 3.10451 12.8507 2.49354 12.7652C1.89148 12.67 1.37131 12.5246 0.933028 12.3288C0.675977 12.2186 0.491692 12.0632 0.380171 11.8625C0.26865 11.6618 0.222196 11.4537 0.240811 11.238C0.259018 11.013 0.329731 10.8137 0.452949 10.6402C0.57576 10.4573 0.743176 10.3332 0.955198 10.2679C1.16681 10.1933 1.41047 10.2107 1.68617 10.3201C2.04823 10.4818 2.45508 10.5995 2.90672 10.6732C3.35796 10.7376 3.77939 10.7613 4.17102 10.7442C4.78643 10.7173 5.2119 10.6193 5.44742 10.4502C5.69185 10.2714 5.80878 10.0608 5.7982 9.81835C5.78884 9.60389 5.69273 9.43525 5.50987 9.31244C5.33633 9.18922 5.02841 9.09055 4.58609 9.01643L2.93439 8.73818C1.14606 8.43319 0.219745 7.54406 0.155453 6.07079C0.127376 5.42741 0.275261 4.85575 0.599106 4.35582C0.932277 3.85549 1.40553 3.46115 2.01888 3.1728C2.63182 2.87513 3.35323 2.70818 4.1831 2.67197C4.66797 2.65081 5.15995 2.68539 5.65903 2.77572C6.16703 2.85631 6.60753 2.99591 6.98054 3.1945C7.26679 3.33149 7.45291 3.52889 7.53889 3.78672C7.62448 4.03523 7.62594 4.28273 7.54327 4.52924C7.46061 4.77574 7.3005 4.96023 7.06294 5.08271C6.83471 5.20477 6.53552 5.19914 6.16535 5.06582C5.88033 4.95681 5.56876 4.88166 5.23064 4.84036C4.89211 4.78974 4.56433 4.77134 4.24729 4.78518C3.72512 4.80796 3.32824 4.91871 3.05665 5.1174C2.78464 5.30677 2.65495 5.54599 2.66756 5.83505C2.67652 6.04019 2.76776 6.20436 2.9413 6.32758C3.11483 6.4508 3.4181 6.54967 3.85109 6.6242L5.48881 6.90306C7.30511 7.20683 8.24439 8.07204 8.30665 9.49868C8.33473 10.1421 8.18664 10.7091 7.86239 11.1997C7.53813 11.6903 7.06934 12.0797 6.45599 12.3681C5.84265 12.6564 5.11171 12.8191 4.26318 12.8562Z"
    }), /* @__PURE__ */jsx("path", {
      d: "M14.797 14.8908C13.9672 14.9271 13.5339 14.5256 13.4973 13.6864L13.4003 11.4625C13.2175 11.7694 12.9436 12.0243 12.5788 12.227C12.2229 12.4201 11.8258 12.5261 11.3875 12.5453C10.8001 12.5709 10.2716 12.4492 9.80211 12.18C9.34192 11.9105 8.96949 11.511 8.6848 10.9816C8.40944 10.4518 8.25569 9.81854 8.22354 9.08191C8.19099 8.33595 8.289 7.69173 8.51756 7.14925C8.75505 6.59704 9.09127 6.16664 9.52623 5.85805C9.97051 5.54905 10.4864 5.38174 11.0738 5.3561C11.5307 5.33616 11.9499 5.41596 12.3314 5.5955C12.7219 5.76531 13.0175 6.00932 13.2182 6.32753C13.2627 5.63427 13.6532 5.27156 14.3899 5.23942C15.2104 5.20361 15.6388 5.60064 15.675 6.43052L15.9869 13.5777C16.0048 13.988 15.9112 14.305 15.7061 14.5289C15.501 14.7527 15.198 14.8733 14.797 14.8908ZM12.1048 10.6782C12.4778 10.6619 12.7794 10.5086 13.0096 10.2183C13.2399 9.92801 13.3416 9.47515 13.3147 8.85974C13.2874 8.235 13.1467 7.79271 12.8924 7.53288C12.6378 7.26373 12.324 7.13729 11.951 7.15357C11.5687 7.17025 11.2624 7.32375 11.0322 7.61406C10.8016 7.89505 10.6999 8.34791 10.7272 8.97265C10.754 9.58807 10.8948 10.0304 11.1494 10.2995C11.4041 10.5687 11.7225 10.6949 12.1048 10.6782Z"
    }), /* @__PURE__ */jsx("path", {
      d: "M19.1098 12.2083C18.2147 12.2473 17.5421 12.0338 17.092 11.5676C16.6508 11.0917 16.4083 10.3503 16.3643 9.34324L16.2361 6.40604C16.1999 5.57616 16.5968 5.14311 17.4266 5.1069C17.8276 5.0894 18.14 5.1832 18.3638 5.38831C18.5876 5.59341 18.7083 5.89644 18.7258 6.29739L18.857 9.30453C18.8863 9.97589 19.19 10.299 19.7681 10.2737C20.1038 10.2591 20.3736 10.1259 20.5775 9.87406C20.7813 9.62227 20.8745 9.29589 20.857 8.89494L20.7399 6.2095C20.7036 5.37962 21.1005 4.94657 21.9303 4.91036C22.3313 4.89286 22.6437 4.98667 22.8675 5.19177C23.0913 5.39687 23.212 5.6999 23.2295 6.10085L23.4315 10.7304C23.4681 11.5696 23.0855 12.0067 22.2836 12.0417C21.5656 12.0731 21.1453 11.7551 21.0228 11.0878C20.6053 11.7973 19.9677 12.1708 19.1098 12.2083Z"
    }), /* @__PURE__ */jsx("path", {
      d: "M27.8457 11.827C27.0065 11.8637 26.2729 11.7509 25.6449 11.4887C25.0258 11.2167 24.5412 10.8175 24.1913 10.2909C23.8413 9.76433 23.6503 9.13272 23.6181 8.39609C23.5876 7.69676 23.7144 7.06997 23.9985 6.51572C24.2919 5.96107 24.7026 5.52275 25.2303 5.20076C25.7671 4.86905 26.3851 4.68793 27.0844 4.65742C27.7744 4.6273 28.3775 4.74579 28.8936 5.01288C29.4191 5.27955 29.8288 5.6774 30.1228 6.20642C30.4258 6.72571 30.5929 7.34434 30.6242 8.06233C30.6401 8.42598 30.4336 8.61717 30.0047 8.63588L26.0184 8.80984C26.1219 9.25375 26.3224 9.56731 26.62 9.7505C26.9176 9.9337 27.3229 10.0141 27.8357 9.99173C28.0315 9.98319 28.2636 9.9497 28.532 9.89128C28.8004 9.83286 29.0535 9.74707 29.2915 9.63392C29.585 9.50901 29.8367 9.49802 30.0468 9.60097C30.2564 9.69458 30.3987 9.85186 30.4737 10.0728C30.5577 10.284 30.5581 10.5082 30.4751 10.7454C30.4009 10.9728 30.2359 11.1529 29.9801 11.2855C29.6607 11.4582 29.3159 11.5854 28.9458 11.6669C28.5854 11.7574 28.2187 11.8108 27.8457 11.827ZM27.2665 6.261C26.8935 6.27728 26.5907 6.4026 26.358 6.63697C26.1347 6.87093 25.9997 7.20379 25.9532 7.63557L28.5547 7.52204C28.5076 7.08501 28.3722 6.76394 28.1483 6.55884C27.9334 6.344 27.6395 6.24473 27.2665 6.261Z"
    }), /* @__PURE__ */jsx("path", {
      d: "M33.4081 11.5843C32.8766 11.6075 32.4014 11.5301 31.9826 11.3522C31.5731 11.1739 31.2445 10.922 30.9967 10.5965C30.7579 10.2613 30.6289 9.87451 30.6097 9.43626C30.5882 8.94207 30.7016 8.54474 30.9501 8.24429C31.1982 7.93452 31.6086 7.7064 32.1814 7.55996C32.7539 7.40419 33.5203 7.30535 34.4807 7.26343L35.0122 7.24024L35.0036 7.04443C34.989 6.70875 34.89 6.47484 34.7068 6.3427C34.5328 6.21016 34.2361 6.15304 33.8165 6.17136C33.5833 6.18153 33.3281 6.22069 33.0508 6.28885C32.7825 6.34727 32.4786 6.44928 32.1393 6.59488C31.8365 6.7202 31.5799 6.72673 31.3694 6.61446C31.159 6.50219 31.0163 6.33559 30.9412 6.11465C30.8751 5.88398 30.8885 5.65452 30.9813 5.42625C31.083 5.18826 31.2853 5.0066 31.5881 4.88128C32.0287 4.70323 32.4343 4.5781 32.8049 4.50587C33.1843 4.42392 33.5326 4.37602 33.8496 4.36219C34.9965 4.31214 35.8558 4.52221 36.4275 4.9924C37.0086 5.46218 37.3223 6.22856 37.3687 7.29155L37.492 10.1169C37.5286 10.9561 37.1646 11.3923 36.4 11.4257C35.6727 11.4575 35.2694 11.1014 35.1903 10.3574C35.0752 10.7175 34.8636 11.007 34.5555 11.2259C34.2474 11.4449 33.865 11.5644 33.4081 11.5843ZM33.8967 9.93744C34.2417 9.92238 34.5259 9.79787 34.7492 9.56391C34.9819 9.32955 35.0903 9.03054 35.0744 8.66688L35.0635 8.41512L34.532 8.43832C33.9818 8.46232 33.5789 8.54063 33.3231 8.67324C33.0762 8.79612 32.9582 8.98345 32.9692 9.23521C32.9786 9.44967 33.0609 9.62358 33.2162 9.75693C33.3808 9.88988 33.6077 9.95005 33.8967 9.93744Z"
    }), /* @__PURE__ */jsx("path", {
      d: "M39.3562 11.2967C38.9553 11.3142 38.6429 11.2204 38.419 11.0153C38.2045 10.8098 38.0883 10.5019 38.0704 10.0916L37.739 2.49685C37.7024 1.65765 38.0944 1.22014 38.9149 1.18433C39.3159 1.16684 39.6282 1.26064 39.8521 1.46574C40.0852 1.67044 40.2107 1.97793 40.2286 2.3882L40.4301 7.00381L40.458 7.00259L42.0741 4.85809C42.2946 4.55886 42.4999 4.3397 42.69 4.20062C42.8894 4.06112 43.1617 3.98385 43.5067 3.96879C43.8517 3.95374 44.1211 4.02606 44.3149 4.18576C44.5087 4.34546 44.6111 4.55119 44.6221 4.80295C44.6424 5.05431 44.5555 5.31034 44.3613 5.57105L42.9557 7.39808L44.756 9.47756C44.9636 9.73943 45.0541 9.99239 45.0274 10.2365C45.0096 10.4708 44.9016 10.6717 44.7033 10.8392C44.514 10.9969 44.2655 11.0825 43.9578 11.0959C43.5755 11.1126 43.2696 11.0605 43.0401 10.9398C42.8196 10.8093 42.5911 10.6044 42.3547 10.3251L40.5124 8.2474L40.4844 8.24863L40.5601 9.98297C40.5967 10.8222 40.1954 11.2601 39.3562 11.2967Z"
    }), /* @__PURE__ */jsx("path", {
      d: "M46.4279 7.62491C45.9337 7.64647 45.6363 7.3605 45.5357 6.76699L44.8618 2.56438C44.7754 2.08235 44.8469 1.68686 45.0763 1.3779C45.3053 1.05961 45.6576 0.89009 46.1331 0.869337C46.618 0.848178 46.9837 0.986365 47.2303 1.2839C47.4764 1.57211 47.5774 1.96008 47.5333 2.4478L47.2421 6.69253C47.1935 7.29255 46.9221 7.60334 46.4279 7.62491ZM46.5726 10.9398C46.153 10.9581 45.8118 10.8468 45.5491 10.6061C45.2952 10.3556 45.1596 10.0298 45.1421 9.62887C45.125 9.23725 45.2322 8.91026 45.4636 8.64792C45.7044 8.38518 46.0346 8.24465 46.4542 8.22634C46.8831 8.20762 47.2243 8.31885 47.4777 8.56003C47.7311 8.80121 47.8664 9.11762 47.8835 9.50924C47.901 9.91019 47.7942 10.2465 47.5632 10.5182C47.3317 10.7805 47.0015 10.921 46.5726 10.9398Z"
    })]
  });
}

function MarkdownLogo() {
  return /* @__PURE__ */jsx("div", {
    children: /* @__PURE__ */jsxs("svg", {
      width: "30",
      height: "18",
      viewBox: "0 0 30 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/* @__PURE__ */jsxs("g", {
        clipPath: "url(#clip0_398_5010)",
        children: [/* @__PURE__ */jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.74291 1.40625C2.35302 1.40625 2.03694 1.72105 2.03694 2.10938V15.8906C2.03694 16.2789 2.35302 16.5938 2.74291 16.5938H27.8755C28.2654 16.5938 28.5815 16.2789 28.5815 15.8906V2.10938C28.5815 1.72105 28.2654 1.40625 27.8755 1.40625H2.74291ZM0.625 2.10938C0.625 0.944399 1.57322 0 2.74291 0H27.8755C29.0452 0 29.9934 0.944399 29.9934 2.10938V15.8906C29.9934 17.0556 29.0452 18 27.8755 18H2.74291C1.57322 18 0.625 17.0556 0.625 15.8906V2.10938Z",
          fill: "currentColor"
        }), /* @__PURE__ */jsx("path", {
          d: "M4.85938 13.7812V4.21875H7.68326L10.5071 7.73438L13.331 4.21875H16.1549V13.7812H13.331V8.29688L10.5071 11.8125L7.68326 8.29688V13.7812H4.85938ZM22.5087 13.7812L18.2728 9.14062H21.0967V4.21875H23.9206V9.14062H26.7445L22.5087 13.7812Z",
          fill: "currentColor"
        })]
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "clip0_398_5010",
          children: /* @__PURE__ */jsx("rect", {
            width: "29.3684",
            height: "18",
            fill: "white",
            transform: "translate(0.625)"
          })
        })
      })]
    })
  });
}

var buttons = [{
  cursor: -2,
  replaceWith: function replaceWith(selectedText) {
    return "**".concat(selectedText, "**");
  },
  icon: /* @__PURE__ */jsx("svg", {
    width: "11",
    height: "13",
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */jsx("path", {
      d: "M0.394742 13H5.65074C8.31474 13 10.1867 11.632 10.1867 9.238C10.1867 7.6 9.21474 6.574 8.08074 6.124C8.80074 5.728 9.53874 4.828 9.53874 3.64C9.53874 1.534 7.79274 0.399999 5.52474 0.399999H0.394742V13ZM3.23874 10.552V7.546H5.41674C6.87474 7.546 7.50474 8.086 7.50474 9.076C7.50474 10.048 6.87474 10.552 5.41674 10.552H3.23874ZM3.23874 5.17V2.632H5.23674C6.42474 2.632 6.92874 3.118 6.92874 3.91C6.92874 4.684 6.42474 5.17 5.29074 5.17H3.23874Z",
      fill: "currentColor"
    })
  })
}, {
  cursor: -1,
  replaceWith: function replaceWith(selectedText) {
    return "*".concat(selectedText, "*");
  },
  icon: /* @__PURE__ */jsx("svg", {
    width: "4",
    height: "13",
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */jsx("path", {
      d: "M0.0360938 13H1.56609L3.00609 3.928H1.47609L0.0360938 13ZM1.63809 2.2H3.40209L3.70809 0.256H1.94409L1.63809 2.2Z",
      fill: "currentColor"
    })
  })
}, {
  cursor: -4,
  replaceWith: function replaceWith(selectedText) {
    return "\n```\n".concat(selectedText, "\n```");
  },
  icon: /* @__PURE__ */jsxs("svg", {
    width: "14",
    height: "10",
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */jsx("path", {
      d: "M5.80395 1.35631C5.80395 1.06647 5.69075 0.794129 5.48513 0.588497C5.08756 0.192017 4.34818 0.191471 3.95227 0.589044L0.31773 4.22415C0.115934 4.42594 0 4.70485 0 4.99087C0 5.27634 0.115937 5.5558 0.31773 5.75759L3.95339 9.39326C4.15792 9.59723 4.43026 9.70989 4.71957 9.70989C5.00777 9.70989 5.27957 9.59724 5.48575 9.39216C5.69082 9.18764 5.80402 8.91473 5.80402 8.62544C5.80402 8.33614 5.69082 8.06325 5.48575 7.85871L2.61855 4.99095L5.48533 2.12375C5.69096 1.91923 5.80415 1.64688 5.80415 1.35648L5.80395 1.35631Z",
      fill: "currentColor"
    }), /* @__PURE__ */jsx("path", {
      d: "M13.6821 4.22397L10.047 0.588315C9.64939 0.19129 8.91274 0.190183 8.51298 0.589409C8.30846 0.793935 8.1958 1.06684 8.1958 1.35559C8.1958 1.64597 8.309 1.91832 8.51298 2.12231L11.3813 4.99063L8.51298 7.85895C8.30846 8.06347 8.1958 8.33638 8.1958 8.62513C8.1958 8.91388 8.30846 9.18676 8.51408 9.39294C8.71915 9.59692 8.99205 9.70958 9.28025 9.70958C9.56846 9.70958 9.8408 9.59692 10.0464 9.3924L13.6815 5.7573C13.8833 5.5555 13.9993 5.27605 13.9993 4.99057C13.9993 4.70455 13.8839 4.42565 13.6821 4.22385L13.6821 4.22397Z",
      fill: "currentColor"
    })]
  })
}, {
  cursor: -1,
  replaceWith: function replaceWith(selectedText) {
    return "[".concat(selectedText, "]()");
  },
  icon: /* @__PURE__ */jsxs("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */jsxs("g", {
      clipPath: "url(#clip0_3781_82365)",
      children: [/* @__PURE__ */jsx("path", {
        d: "M12.9069 1.09374C11.449 -0.364215 9.08481 -0.364215 7.62741 1.09374L5.54435 3.17624C5.70951 3.1582 5.87576 3.15054 6.0431 3.15054C6.57028 3.15054 7.08271 3.23421 7.5684 3.39554L8.74856 2.21538C9.15379 1.80961 9.69301 1.58648 10.2667 1.58648C10.8398 1.58648 11.3791 1.80961 11.7849 2.21538C12.1901 2.62061 12.4132 3.15875 12.4132 3.73298C12.4132 4.30612 12.1901 4.84533 11.7849 5.25058L9.47544 7.56002C9.06966 7.9658 8.53044 8.18893 7.95728 8.18893C7.38305 8.18893 6.84494 7.9658 6.43912 7.56002C6.24169 7.3637 6.08803 7.13455 5.98193 6.88518C5.71889 6.89995 5.4728 7.00932 5.28466 7.19691L4.66943 7.81268C4.83787 8.12441 5.05389 8.41862 5.31693 8.68275C6.77489 10.1407 9.13907 10.1407 10.597 8.68275L12.907 6.37219C14.3644 4.91479 14.3644 2.55117 12.907 1.09377L12.9069 1.09374Z",
        fill: "currentColor"
      }), /* @__PURE__ */jsx("path", {
        d: "M7.98178 10.8489C7.4535 10.8489 6.93614 10.7636 6.43954 10.5951L5.25117 11.7835C4.84594 12.1893 4.30727 12.4124 3.73357 12.4124C3.16044 12.4124 2.62178 12.1893 2.21597 11.7835C1.8102 11.3783 1.58707 10.8396 1.58707 10.2659C1.58707 9.69275 1.8102 9.15354 2.21597 8.74772L4.52541 6.43828C4.93119 6.03305 5.46932 5.81047 6.04301 5.81047C6.61724 5.81047 7.15536 6.0336 7.56117 6.43828C7.7586 6.63571 7.91281 6.86485 8.01945 7.11421C8.28359 7.10054 8.53023 6.99007 8.71781 6.80249L9.33195 6.18726C9.16351 5.87445 8.94695 5.58078 8.68336 5.31663C7.2254 3.85867 4.86122 3.85867 3.40382 5.31663L1.09438 7.62719C-0.364142 9.08515 -0.364142 11.4482 1.09438 12.9067C2.55234 14.3647 4.9154 14.3647 6.37336 12.9067L8.45306 10.827C8.29774 10.8412 8.14133 10.8495 7.98329 10.8495L7.98178 10.8489Z",
        fill: "currentColor"
      })]
    }), /* @__PURE__ */jsx("defs", {
      children: /* @__PURE__ */jsx("clipPath", {
        id: "clip0_3781_82365",
        children: /* @__PURE__ */jsx("rect", {
          width: "14",
          height: "14",
          fill: "white"
        })
      })
    })]
  })
}];

function RichText(_ref30) {
  var _ref30$initialValue = _ref30.initialValue,
      initialValue = _ref30$initialValue === void 0 ? "" : _ref30$initialValue,
      setFieldValue = _ref30.setFieldValue;
  var textarea = useRef(null);

  var _useState17 = useState(initialValue),
      _useState18 = _slicedToArray(_useState17, 2),
      value = _useState18[0],
      setValue = _useState18[1];

  var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      cursor = _useState20[0],
      setCursor = _useState20[1];

  var replaceSelection = function replaceSelection(selectionStart, selectionEnd, text) {
    return value.substring(0, selectionStart) + text + value.substring(selectionEnd, value.length);
  };

  var handleClick = function handleClick(e2, replaceWith, cursor2) {
    e2.preventDefault();

    if (textarea.current) {
      var selectionStart = textarea.current.selectionStart;
      var selectionEnd = textarea.current.selectionEnd;
      var selectedText = textarea.current.value.slice(selectionStart, selectionEnd);
      textarea.current.focus();
      setValue(replaceSelection(selectionStart, selectionEnd, replaceWith(selectedText)));
      setCursor(cursor2);
    }
  };

  var handleChange = function handleChange(e2) {
    setValue(e2.target.value);
  };

  useEffect(function () {
    if (cursor && textarea.current) {
      textarea.current.focus();
      textarea.current.setSelectionRange(textarea.current.value.length + cursor, textarea.current.value.length + cursor);
      setCursor(null);
    }
  }, [cursor]);
  useEffect(function () {
    setFieldValue("question", value);
  }, [value]);
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("textarea", {
      name: "question",
      value: value,
      onChange: handleChange,
      ref: textarea,
      required: true,
      id: "question",
      placeholder: "Type more details...",
      maxLength: 2e3
    }), /* @__PURE__ */jsxs("div", {
      className: "squeak-form-richtext-buttons-container",
      children: [/* @__PURE__ */jsx("ul", {
        className: "squeak-form-richtext-buttons",
        children: buttons.map(function (button, index) {
          return /* @__PURE__ */jsx("li", {
            children: /* @__PURE__ */jsx("button", {
              onClick: function onClick(e2) {
                return handleClick(e2, button.replaceWith, button.cursor);
              },
              children: button.icon
            })
          }, index);
        })
      }), /* @__PURE__ */jsx("div", {
        className: "squeak-markdown-logo",
        children: /* @__PURE__ */jsx("a", {
          href: "https://www.markdownguide.org/cheat-sheet/",
          target: "_blank",
          rel: "noopener",
          title: "Supports Markdown syntax",
          children: /* @__PURE__ */jsx(MarkdownLogo, {})
        })
      })]
    })]
  });
}

function QuestionFormMain(_ref31) {
  var title = _ref31.title,
      onSubmit = _ref31.onSubmit,
      _ref31$subject = _ref31.subject,
      subject = _ref31$subject === void 0 ? true : _ref31$subject,
      loading = _ref31.loading,
      initialValues = _ref31.initialValues,
      formType = _ref31.formType;

  var _useUser3 = useUser(),
      user = _useUser3.user;

  var _useOrg4 = useOrg(),
      profileLink = _useOrg4.profileLink;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(values) {
      var _a, _b;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.t0 = onSubmit;

              if (!_context6.t0) {
                _context6.next = 4;
                break;
              }

              _context6.next = 4;
              return onSubmit(_objectSpread(_objectSpread({}, values), {}, {
                email: user == null ? void 0 : user.email,
                firstName: (_a = user == null ? void 0 : user.profile) == null ? void 0 : _a.first_name,
                lastName: (_b = user == null ? void 0 : user.profile) == null ? void 0 : _b.last_name
              }), formType);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function handleSubmit(_x18) {
      return _ref32.apply(this, arguments);
    };
  }();

  return /* @__PURE__ */jsxs("div", {
    className: "squeak-form-frame",
    children: [title && /* @__PURE__ */jsx("h2", {
      children: title
    }), /* @__PURE__ */jsx(Formik, {
      initialValues: _objectSpread({
        subject: "",
        question: ""
      }, initialValues),
      validate: function validate(values) {
        var errors = {};

        if (!values.question) {
          errors.question = "Required";
        }

        if (subject && !values.subject) {
          errors.subject = "Required";
        }

        return errors;
      },
      onSubmit: handleSubmit,
      children: function children(_ref33) {
        var setFieldValue = _ref33.setFieldValue,
            isValid = _ref33.isValid;

        var _a;

        return /* @__PURE__ */jsxs(Form$1, {
          className: "squeak-form",
          children: [/* @__PURE__ */jsx(Avatar, {
            url: (user == null ? void 0 : user.profile) && profileLink && profileLink(user == null ? void 0 : user.profile),
            image: (_a = user == null ? void 0 : user.profile) == null ? void 0 : _a.avatar
          }), /* @__PURE__ */jsxs("div", {
            className: "",
            children: [/* @__PURE__ */jsxs("div", {
              className: "squeak-inputs-wrapper",
              children: [subject && /* @__PURE__ */jsxs(Fragment, {
                children: [/* @__PURE__ */jsx(Field, {
                  required: true,
                  id: "subject",
                  name: "subject",
                  placeholder: "Title",
                  maxLength: "140"
                }), /* @__PURE__ */jsx("hr", {})]
              }), /* @__PURE__ */jsx("div", {
                className: "squeak-form-richtext",
                children: /* @__PURE__ */jsx(RichText, {
                  setFieldValue: setFieldValue,
                  initialValue: initialValues == null ? void 0 : initialValues.question
                })
              })]
            }), /* @__PURE__ */jsxs("span", {
              className: "squeak-reply-buttons-row",
              children: [/* @__PURE__ */jsx("button", {
                className: "squeak-post-button",
                style: loading || !isValid ? {
                  opacity: ".5"
                } : {},
                disabled: loading || !isValid,
                type: "submit",
                children: user ? "Post" : "Login & post"
              }), /* @__PURE__ */jsxs("div", {
                className: "squeak-by-line",
                children: ["by", /* @__PURE__ */jsx("a", {
                  href: "https://squeak.posthog.com?utm_source=post-form",
                  children: /* @__PURE__ */jsx(Logo, {})
                })]
              })]
            })]
          })]
        });
      }
    })]
  });
}

function QuestionForm(_ref34) {
  var _ref34$formType = _ref34.formType,
      formType = _ref34$formType === void 0 ? "question" : _ref34$formType,
      messageID = _ref34.messageID,
      initialView = _ref34.initialView,
      onSubmit = _ref34.onSubmit,
      onSignUp = _ref34.onSignUp;

  var _a;

  var _useOrg5 = useOrg(),
      organizationId = _useOrg5.organizationId,
      apiHost = _useOrg5.apiHost,
      profileLink = _useOrg5.profileLink;

  var _useUser4 = useUser(),
      user = _useUser4.user,
      setUser = _useUser4.setUser;

  var _useState21 = useState(null),
      _useState22 = _slicedToArray(_useState21, 2),
      formValues = _useState22[0],
      setFormValues = _useState22[1];

  var _useState23 = useState(initialView || null),
      _useState24 = _slicedToArray(_useState23, 2),
      view = _useState24[0],
      setView = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      loading = _useState26[0],
      setLoading = _useState26[1];

  var buttonText = formType === "question" ? /* @__PURE__ */jsx("span", {
    children: "Ask a question"
  }) : /* @__PURE__ */jsxs("span", {
    className: "squeak-reply-label",
    children: [/* @__PURE__ */jsx("strong", {
      children: "Reply"
    }), " to question"]
  });

  var insertReply = /*#__PURE__*/function () {
    var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref35) {
      var body, messageID2, _yield$post, data;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              body = _ref35.body, messageID2 = _ref35.messageID;
              _context7.next = 3;
              return post(apiHost, "/api/reply", {
                body: body,
                organizationId: organizationId,
                messageId: messageID2
              });

            case 3:
              _yield$post = _context7.sent;
              data = _yield$post.data;
              return _context7.abrupt("return", data);

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function insertReply(_x19) {
      return _ref36.apply(this, arguments);
    };
  }();

  var insertMessage = /*#__PURE__*/function () {
    var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref37) {
      var subject, body, userID, _yield$post2, data;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              subject = _ref37.subject, body = _ref37.body, userID = _ref37.userID;
              _context8.next = 3;
              return post(apiHost, "/api/question", {
                subject: subject,
                body: body,
                organizationId: organizationId,
                slug: window.location.pathname.replace(/\/$/, "")
              });

            case 3:
              _yield$post2 = _context8.sent;
              data = _yield$post2.data;
              return _context8.abrupt("return", data);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function insertMessage(_x20) {
      return _ref38.apply(this, arguments);
    };
  }();

  var handleMessageSubmit = /*#__PURE__*/function () {
    var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(values) {
      var userID, view2, _yield$insertMessage, messagePublished, _yield$insertReply, replyPublished;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              setLoading(true);
              userID = user == null ? void 0 : user.id;

              if (!userID) {
                _context9.next = 22;
                break;
              }

              view2 = null;

              if (!(formType === "question")) {
                _context9.next = 10;
                break;
              }

              _context9.next = 7;
              return insertMessage({
                subject: values.subject,
                body: values.question
              });

            case 7:
              _yield$insertMessage = _context9.sent;
              messagePublished = _yield$insertMessage.published;

              if (!messagePublished) {
                view2 = "approval";
              }

            case 10:
              if (!(formType === "reply" && messageID)) {
                _context9.next = 16;
                break;
              }

              _context9.next = 13;
              return insertReply({
                body: values.question,
                messageID: messageID
              });

            case 13:
              _yield$insertReply = _context9.sent;
              replyPublished = _yield$insertReply.published;

              if (!replyPublished) {
                view2 = "approval";
              }

            case 16:
              if (onSubmit) {
                onSubmit(values, formType);
              }

              setLoading(false);
              setView(view2);
              setFormValues(null);
              _context9.next = 25;
              break;

            case 22:
              setFormValues(values);
              setView("auth");
              setLoading(false);

            case 25:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function handleMessageSubmit(_x21) {
      return _ref39.apply(this, arguments);
    };
  }();

  var doLogout = /*#__PURE__*/function () {
    var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return post(apiHost, "/api/logout");

            case 2:
              setUser(null);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function doLogout() {
      return _ref40.apply(this, arguments);
    };
  }();

  return view ? {
    "question-form": /* @__PURE__ */jsx(QuestionFormMain, {
      subject: formType === "question",
      initialValues: formValues,
      loading: loading,
      onSubmit: handleMessageSubmit
    }),
    auth: /* @__PURE__ */jsx(Authentication$1, {
      banner: {
        title: "Please signup to post.",
        body: "Create an account to ask questions & help others."
      },
      buttonText: {
        login: "Login & post question",
        signUp: "Sign up & post question"
      },
      setParentView: setView,
      formValues: formValues,
      handleMessageSubmit: handleMessageSubmit,
      onSignUp: onSignUp
    }),
    login: /* @__PURE__ */jsx(Authentication$1, {
      setParentView: setView,
      formValues: formValues,
      handleMessageSubmit: function handleMessageSubmit() {
        return setView(null);
      },
      onSignUp: onSignUp
    }),
    approval: /* @__PURE__ */jsx(Approval, {
      handleConfirm: function handleConfirm() {
        return setView(null);
      }
    })
  }[view] : /* @__PURE__ */jsxs("div", {
    className: "squeak-reply-buttons",
    children: [/* @__PURE__ */jsx(Avatar, {
      url: (user == null ? void 0 : user.profile) && profileLink && profileLink(user == null ? void 0 : user.profile),
      image: (_a = user == null ? void 0 : user.profile) == null ? void 0 : _a.avatar
    }), /* @__PURE__ */jsx("button", {
      className: formType === "reply" ? "squeak-reply-skeleton" : "squeak-ask-button",
      onClick: function onClick() {
        return setView("question-form");
      },
      children: buttonText
    }), formType === "question" && /* @__PURE__ */jsx("button", {
      onClick: function onClick() {
        if (user) {
          doLogout();
        } else {
          setView("login");
        }
      },
      className: "squeak-auth-button",
      children: user ? "Logout" : "Login"
    })]
  });
}

function getBackgroundColor(el) {
  var color = window.getComputedStyle(el).backgroundColor;

  if (color !== "rgba(0, 0, 0, 0)" || el.tagName.toLowerCase() === "body") {
    return color;
  } else if (el.parentElement) {
    return getBackgroundColor(el.parentElement);
  } else {
    return "";
  }
}

function lightOrDark(color) {
  if (color === "rgba(0, 0, 0, 0)") {
    return "light";
  }

  var r2, g2, b2, hsp;
  var colorMatch = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
  if (!colorMatch) return "light";
  r2 = parseInt(colorMatch[1]);
  g2 = parseInt(colorMatch[2]);
  b2 = parseInt(colorMatch[3]);
  hsp = Math.sqrt(0.299 * (r2 * r2) + 0.587 * (g2 * g2) + 0.114 * (b2 * b2));
  return hsp > 127.5 ? "light" : "dark";
}

var Style$1 = We(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n:host {\n    --primary-color: var(--squeak-primary-color, ", "); // rgb triplets, no hex\n    --default-avatar-fill: var(--squeak-default-avatar-fill, ", "); // rgb triplets, no hex\n    --button-color: var(--squeak-button-color, 29, 74, 255); // rgb triplet, no hex\n    --button-weight: bold; // normal | bold | 600 | etc\n    --border-radius: var(--squeak-border-radius, .25rem); // adjusts all radii\n    --base-font-size: var(--squeak-base-font-size, 16px);\n    --warning-color: var(--squeak-warning-color, #FFF7E9); // hex\n    --thread-border-style: var(--squeak-thread-border-style, dashed); // css border style\n    --input-text-color: var(--squeak-input-text-color, 0, 0, 0); // rgb triplet, no hex\n    --input-background-color: var(--squeak-input-background-color, #fff); // transparent, hex, rgb, or rgba\n    --link-text-decoration: none; // none | underline | dashed | etc\n    all: initial;\n    font-family: inherit;\n}\n\n.squeak {\n    // font-family: -apple-system, BlinkMacSystemFont; // for dev use\n    color: rgba(var(--primary-color), 1);\n    font-size: var(--base-font-size);\n\n    *:not(pre *) {\n        box-sizing: border-box;\n        font-family: var(--font-family);\n    }\n\n    code, pre {\n        padding: 2px 3px;\n        background: rgba(var(--primary-color),0.05);\n        font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,Courier,monospace;\n        border-radius: 2px;\n    }\n\n    button {\n        background: transparent;\n        border: solid 1.5px rgba(var(--button-color), .85);\n        border-radius: var(--border-radius);\n        color: rgba(var(--button-color), .85);\n        cursor: pointer;\n        font-size: .933em;\n        font-weight: var(--button-weight);\n        padding: 0.6rem 1rem;\n\n        &:hover {\n            border: solid 1.5px rgba(var(--button-color), .9);\n            color: rgba(var(--button-color), .9);\n        }\n\n        &:active {\n            border: solid 1.5px rgba(var(--button-color), 1);\n            color: rgba(var(--button-color), 1);\n        }\n\n        &[disabled] {\n            background: transparent;\n            border: solid 1.5px rgba(var(--primary-color), .5);\n            color: rgba(var(--primary-color), 1);\n            cursor: not-allowed;\n        }\n    }\n\n    .squeak-authentication-form-container {\n        margin-left: 50px;\n        max-width: 600px;\n\n        .squeak-authentication-form-message {\n            background: var(--warning-color);\n            border: 1px solid rgba(var(--primary-color), .2);\n            color: #000;\n            border-bottom: none;\n            padding: 1rem;\n\n            h4, p {\n                margin: 0;\n            }\n\n            h4 {\n                font-size: 1em;\n                padding-bottom: .25em;\n            }\n\n            p {\n                font-size: .875em;\n            }\n        }\n\n        .squeak-authentication-form {\n            border: 1px solid rgba(var(--primary-color), .2);\n            border-top: none;\n            border-radius: 0 0 var(--border-radius) var(--border-radius);\n            overflow: hidden;\n            position: relative;\n\n            button {\n                transition: color 0.2s;\n                width: 100%;\n\n                &.active {\n                    color: rgba(var(--button-color), 1);\n                }\n            }\n\n            input {\n                border-radius: var(--border-radius);\n                border: 1px solid rgba(var(--primary-color), .3);\n                display: block;\n                font-size: .875em;\n                margin-bottom: 1.25rem;\n                padding: 0.75rem 1rem;\n                width: 100%;\n            }\n\n            label {\n                display: block;\n                font-size: .875em;\n                font-weight: 600;\n                margin-bottom: 0.5rem;\n                opacity: 0.6;\n            }\n\n            .squeak-authentication-form-wrapper {\n                padding: 1.5rem 1.5rem .5rem;\n            }\n        }\n    }\n\n    .squeak-authentication-form-name {\n        display: grid;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        column-gap: 0.5rem;\n    }\n\n    .squeak-authentication-navigation {\n        background: rgba(var(--primary-color),.03);\n        border-top: 1px solid rgba(var(--primary-color),.1);\n        border-bottom: 1px solid rgba(var(--primary-color),.1);\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        position: relative;\n\n        button {\n            font-size: .875em;\n            border: none;\n            border-bottom: solid 1px transparent;\n            border-radius: 0;\n            background: none;\n            padding: .75rem .25rem calc(.75rem + 1px);\n\n            &:not(.active) {\n                color: rgba(var(--primary-color),.5);\n\n                &:hover {\n                    color: rgba(var(--primary-color),.6);\n                    border-bottom: .5px solid rgba(var(--primary-color),.25);\n                }\n            }\n        }\n    }\n\n    .squeak-authentication-navigation-rail {\n        background: rgba(var(--button-color), 1);\n        border-radius: var(--border-radius);\n        bottom: -1px;\n        height: 2px;\n        left: 0;\n        position: absolute;\n        transition: all 0.2s;\n        width: 50%;\n    }\n\n    .squeak-authentication-navigation-rail.sign-up {\n        transform: translateX(100%);\n    }\n\n    .squeak-avatar-container {\n        float: left;\n        flex-shrink: 0;\n        line-height: 0;\n        margin-right: 10px;\n\n        svg {\n            background: rgba(var(--default-avatar-fill), 1);\n        }\n    }\n\n    .squeak-avatar-container svg path:first-child {\n        fill: rgba(var(--primary-color), .3);\n    }\n\n    .squeak-avatar-container img,\n    .squeak-avatar-container svg {\n        border-radius: 100px;\n        height: 40px;\n        width: 40px;\n    }\n\n    .squeak-replies .squeak-avatar-container img,\n    .squeak-replies .squeak-avatar-container svg {\n        border-radius: 100px;\n        height: 25px;\n        width: 25px;\n    }\n\n    .squeak-post-preview-container {\n        align-items: center;\n        border: 1px solid rgba(var(--primary-color), .3);\n        border-radius: var(--border-radius) var(--border-radius) 0 0;\n        border-bottom: none;\n        display: flex;\n        max-width: 600px;\n        padding: .7rem 1rem;\n\n        .squeak-post-preview {\n            align-items: baseline;\n            display: flex;\n            flex: 1;\n            min-width: 0;\n            white-space: nowrap;\n            overflow: hidden;\n        }\n\n        h3, p {\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n        }\n\n        h3 {\n            flex: 0 auto;\n            font-size: 1em;\n            font-weight: 700;\n            margin: 0 .5em 0 0;\n            flex-shrink: 0;\n        }\n\n        .squeak-post-markdown {\n            flex: 1;\n            font-size: .875em;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            p {\n                margin: 0;\n            }\n\n            img {\n                max-width: 100%;\n            }\n        }\n\n        .squeak-button-container {\n            margin-left: .25em;\n            white-space: nowrap;\n        }\n\n        button {\n            border: 1px solid transparent;\n            color: rgba(var(--button-color), 1);\n            padding: 0;\n            background: transparent;\n        }\n    }\n\n    .squeak-replies,\n    .squeak-questions {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    .squeak-questions {\n        margin-bottom: 1.5rem;\n\n        > li {\n            padding-bottom: 1rem;\n\n            &:not(:first-child) {\n                padding-top: 1em;\n            }\n        }\n\n        .squeak-reply-buttons-row {\n            margin-left: 35px;\n        }\n    }\n\n    // affects questions\n    .squeak-post {\n        display: flex;\n        flex-direction: column;\n\n        // top-level questions\n        .squeak-post-content {\n            margin-left: 20px;\n            border-left: 1px var(--thread-border-style) rgba(var(--primary-color), .4);\n            padding-left: calc(25px + 5px);\n\n            .squeak-subject {\n                color: var(--primary-color);\n\n                a {\n                    color: var(--primary-color);\n                    underline: none;\n                }\n            }\n        }\n\n        // replies to questions\n        .squeak-replies {\n            .squeak-post-content {\n                padding-left: calc(25px + 10px);\n            }\n        }\n    }\n\n    .squeak-question-container {\n        .squeak-authentication-form-container {\n            margin-left: 35px;\n        }\n    }\n\n    .squeak-post-author {\n        align-items: center;\n        display: flex;\n\n        .squeak-avatar-container {\n            margin-right: 10px;\n        }\n\n        > span:last-of-type {\n            display: flex;\n        }\n\n        strong {\n            font-weight: 600;\n        }\n\n        // add left margin to all elements that aren't the avatar\n        span {\n            margin-left: .5rem;\n        }\n    }\n\n    button.squeak-reply-skeleton {\n        background: transparent;\n        border: solid 1.5px rgba(var(--primary-color), .3);\n        padding: 15px;\n        flex: 1;\n        text-align: left;\n\n        span {\n            color: rgba(var(--primary-color), .6);\n\n            strong {\n                color: rgba(var(--primary-color), .65);\n                font-weight: bold;\n                text-decoration: underline;\n            }\n        }\n\n        &:hover {\n            border: solid 1.5px rgba(var(--primary-color), .5);\n\n            span {\n                color: rgba(var(--primary-color), .7);\n\n                strong {\n                    color: rgba(var(--primary-color), .75);\n                }\n            }\n        }\n    }\n\n    button:hover .squeak-reply-skeleton strong {\n        color: rgba(var(--primary-color), .9);\n    }\n\n    .squeak-post-timestamp {\n        color: rgba(var(--primary-color), .6);\n        font-size: .875em;\n\n        a {\n            color: inherit;\n        }\n    }\n\n    .squeak-author-badge {\n        border: 1px solid rgba(var(--primary-color), .3);\n        border-radius: calc(var(--border-radius) * .75);\n        color: rgba(var(--primary-color),0.6);\n        font-size: .75em;\n        padding: .2rem .3rem;\n    }\n\n    .squeak-post h3 {\n        font-size: 1em;\n        font-weight: 600;\n        margin: 0;\n        padding-bottom: .25rem;\n        line-height: 1.25rem;\n    }\n\n    // replies styling only\n\n    .squeak-replies {\n        margin-left: 20px;\n\n        > li {\n            padding: 0 5px 0 calc(25px + 5px);\n            position: relative;\n\n            .squeak-avatar-container {\n                margin-right: 8px;\n            }\n\n            .squeak-post {\n\n            }\n\n            .squeak-post-author {\n                padding-bottom: .25rem;\n            }\n\n            .squeak-post-content {\n                border-left: 0;\n                margin-left: calc(25px + 8px); // avatar + avatar right margin\n                padding-left: 0;\n                padding-bottom: .25rem;\n            }\n        }\n\n        // left border on replies\n        &:not(.squeak-thread-resolved) > li {\n            border-left: 1px var(--thread-border-style) rgba(var(--primary-color), .4);\n\n            // don't show left border inside, since parent has border\n            &:before {\n                border-left: none;\n            }\n        }\n    }\n\n    // left border and curved line on replies\n    .squeak-reply-form-container:before,\n    .squeak-replies li:before {\n        border-left: 1px var(--thread-border-style) rgba(var(--primary-color), .4);\n        border-bottom: 1px var(--thread-border-style) rgba(var(--primary-color), .4);\n        border-bottom-left-radius: 6px;\n        content: '';\n        height: 13px;\n        left: 0;\n        position: absolute;\n        top: 0;\n        width: 30px;\n    }\n\n    .squeak-replies.squeak-thread-resolved li:not(:last-child) {\n        border-left: 1px var(--thread-border-style) rgba(var(--primary-color), .4);\n    }\n\n    // don't show left border inside, since parent has border\n    .squeak-replies:not(.squeak-thread-resolved) li:before {\n        border-left: none;\n    }\n\n    .squeak-replies.squeak-thread-resolved li:not(:last-child):before {\n        border-left: none;\n    }\n\n    ul.squeak-thread-resolved {\n        li:not(.squeak-solution) {\n            > div:not(.squeak-other-replies-container) {\n                opacity: .6;\n            }\n        }\n    }\n\n    .squeak-reply-unpublished {\n        opacity: .5;\n    }\n\n    // post content defaults\n\n    .squeak-post-markdown {\n        font-size: .933em;\n        line-height: 1.5;\n        overflow-wrap: break-word;\n        word-break: break-word;\n        p {\n            margin-top: 0;\n        }\n\n        ol, ul {\n            padding-bottom: 1em;\n        }\n\n        a {\n            color: rgba(var(--button-color), 1);\n            text-decoration: var(--link-text-decoration);\n        }\n\n        pre {\n            border-radius: var(--border-radius);\n            font-size: .875em;\n            margin: 0.75rem 0;\n            max-height: 450px;\n            overflow: scroll;\n            padding: 1rem;\n        }\n    }\n\n    .squeak-reply-form-container {\n        margin-left: 20px;\n        padding-right: 20px;\n        padding-bottom: .25rem;\n        padding-left: calc(25px + 8px);\n        position: relative;\n        width: 100%;\n\n        .squeak-avatar-container {\n            float: left; // has to float, not use flexbox, so we can truncate the preview text before authenticating\n            margin-right: 10px;\n            width: 25px;\n        }\n\n        .squeak-avatar-container {\n            svg, img {\n                height: 25px;\n                width: 25px;\n            }\n        }\n\n        > div:nth-of-type(2) {\n            flex-grow: 1;\n        }\n    }\n\n    .squeak-reply-buttons {\n        display: flex;\n        flex: 1;\n    }\n\n    .squeak-reply-buttons-row {\n        display: flex;\n        justify-content: space-between;\n        margin-left: 50px;\n    }\n\n    .squeak-by-line {\n        align-items: center;\n        color: rgba(var(--primary-color), .5);\n        display: flex;\n        font-size: .813rem;\n\n        a {\n            color: rgba(var(--primary-color), .5);\n            display: flex;\n            margin-left: .2rem;\n\n            &:hover {\n                color: rgba(var(--primary-color), .6);\n            }\n\n            &:active {\n                color: rgba(var(--primary-color), .55);\n            }\n        }\n\n        svg {\n\n            path {\n                fill: currentColor;\n            }\n        }\n    }\n\n    .squeak-auth-button {\n        border: solid 1.5px transparent;\n        background: none;\n        margin-left: auto;\n        opacity: 0.85;\n\n        &:hover {\n            border: solid 1.5px transparent;\n            opacity: 1;\n        }\n    }\n\n    .squeak-markdown-logo {\n        line-height: 0;\n        margin: 0 .5rem 0 0;\n\n        a {\n            color: rgba(var(--primary-color), .3);\n\n            &:hover {\n                color: rgba(var(--primary-color), .4);\n            }\n        }\n    }\n\n    // applies to top-level question form only\n    .squeak > .squeak-form-frame > .squeak-form {\n        > .squeak-avatar-container {\n            width: 40px;\n        }\n    }\n\n    // UI elements\n\n    .squeak-form-frame {\n        flex: 1;\n        margin-bottom: 1rem;\n    }\n\n    .squeak-inputs-wrapper {\n        background: var(--input-background-color);\n        border: 1px solid rgba(var(--primary-color), .3);\n        border-radius: var(--border-radius);\n        overflow: hidden;\n        margin-bottom: 1rem;\n        // don't apply width: 100%\n\n        input[name=\"subject\"] {\n            font-weight: 700;\n        }\n    }\n\n    hr {\n        background: rgba(var(--input-text-color), .3);\n        border: none;\n        height: 1px;\n        margin: 0;\n    }\n\n    input {\n        background: var(--input-background-color);\n        border: none;\n        color: rgba(var(--input-text-color), 1);\n        font-size: 1em;\n        padding: 0.75rem 1rem;\n        width: 100%;\n    }\n\n    textarea {\n        background: var(--input-background-color);\n        border: none;\n        color: rgba(var(--input-text-color), 1);\n        font-size: .875em;\n        height: 150px;\n        padding: 0.75rem 1rem;\n        resize: none;\n        width: 100%;\n    }\n\n    .squeak-form-richtext {\n        line-height: 0;\n    }\n\n    .squeak-form-richtext-buttons-container {\n        align-items: center;\n        display: flex;\n        justify-content: space-between;\n        padding: 0.25rem 0;\n    }\n\n    .squeak-form-richtext-buttons {\n        display: flex;\n        align-items: center;\n        list-style: none;\n        padding: 0;\n        margin: 0 0 0 0.5rem;\n\n        button {\n            align-items: center;\n            background: none;\n            border: none;\n            border-radius: var(--border-radius);\n            color: rgba(var(--primary-color), .5);\n            cursor: pointer;\n            display: flex;\n            height: 32px;\n            justify-content: center;\n            margin: 0 1px 0 0;\n            opacity: 1;\n            padding: 0;\n            width: 32px;\n\n            &:hover {\n                background: rgba(var(--input-text-color), .15);\n                color: rgba(var(--input-text-color), .75);\n            }\n\n            &:active {\n                background: rgba(var(--input-text-color), .2);\n                color: rgba(var(--input-text-color), 1);\n            }\n        }\n    }\n\n    .squeak-forgot-password {\n        background: transparent;\n        color: rgba(var(--primary-color), .3) !important;\n        border-color: transparent;\n        margin-top: 0.5rem;\n\n        &:hover,\n        &:active {\n            border-color: transparent;\n        }\n    }\n\n    .squeak-auth-error {\n        background: var(--warning-color);\n        margin: -1.5rem -1.5rem 1.5rem;\n        padding: 1.5rem;\n    }\n\n    .squeak-return-to-post {\n        background: none;\n        border: none;\n        color: rgba(var(--button-color), 1);\n        cursor: pointer;\n        font-size: inherit;\n        font-weight: 600;\n        padding: 0;\n        width: auto !important;\n    }\n\n    .squeak-reply-action-buttons {\n        display: flex;\n        margin-bottom: 1rem;\n        position: relative;\n        top: -.5em;\n\n        &:empty {\n            display: none;\n        }\n    }\n\n    .squeak-resolve-button, .squeak-publish-button {\n        margin-right: .75rem;\n    }\n\n    .squeak-delete-button {\n        color: red;\n        background: none;\n        border: none;\n        padding: 0;\n        font-size: .875em;\n        font-weight: 600;\n        z-index: 1;\n        &:hover,\n        &:active {\n            border: none;\n            color: red;\n        }\n    }\n\n\n\n    .squeak-resolve-button,\n    .squeak-undo-resolved, .squeak-publish-button, .squeak-other-replies {\n        background: none;\n        border: none;\n        padding: 0;\n        color: rgba(var(--button-color), 1);\n        cursor: pointer;\n\n        &:hover,\n        &:active {\n            border: none;\n        }\n    }\n    .squeak-undo-resolved {\n        font-size: .875em;\n        font-weight: 600;\n        margin-left: .5rem;\n    }\n    .squeak-resolve-button, .squeak-unresolve-button, .squeak-resolve-text, .squeak-publish-button, .squeak-other-replies {\n        font-size: .875em;\n        font-weight: 600;\n        z-index: 1;\n    }\n\n    .squeak-other-replies-container {\n        padding-bottom: 2rem;\n        display: flex;\n        align-items: center;\n        .squeak-avatar-container:not(:first-of-type) {\n            margin-left: -1rem;\n            position: relative;\n        }\n    }\n\n    .squeak-resolved-badge {\n        border-radius: calc(var(--border-radius) * .75);\n        border: 1.5px solid rgba(0, 130, 0, .8);\n        color: rgba(0, 130, 0, .8);\n        font-size: .688em;\n        font-weight: 600;\n        padding: .2rem .3rem;\n        text-transform: uppercase;\n    }\n\n    .squeak-locked-message {\n        border-radius: var(--border-radius);\n        margin: -1.5rem 0 0 calc(20px + 25px + 22px);\n        padding: 0 1rem;\n\n        p {\n            color: rgba(var(--primary-color), .6);\n            font-size: .875em;\n        }\n    }\n\n    .squeak-approval-required {\n        background: rgba(var(--primary-color), .03);\n        border: 1px solid rgba(var(--primary-color), .2);\n        border-radius: var(--border-radius);\n        margin-bottom: 0;\n        padding: 0 1rem;\n\n        p {\n            color: rgba(var(--primary-color), .6);\n            font-size: .875em;\n        }\n    }\n\n    .squeak-approval-required {\n        padding-bottom: 1rem;\n\n        h3 {\n            margin-bottom: .5rem;\n        }\n        p {\n            font-size: 1em;\n            margin: .5rem 0 .25rem;\n        }\n\n        .squeak-post-button {\n            margin-top: .5rem;\n        }\n    }\n\n    .squeak-show-more-questions-button {\n        width: 100%;\n        margin-bottom: 2rem;\n    }\n    .squeak-topics-container {\n        list-style: none;\n        margin: 0 0 1.5rem;\n        padding: 0;\n        display: flex;\n        white-space: nowrap;\n        overflow: auto;\n\n        > li {\n            margin-right: .5rem;\n\n            button {\n                padding: 0 0 .2rem;\n                border: none;\n                border-radius: 0;\n                border-bottom: 1px solid rgba(var(--button-color), 0);\n                 &.squeak-active-topic {\n                    color: rgba(var(--button-color), 100);\n                    border-bottom: 1px solid rgba(var(--button-color), 100);\n                }\n            }\n        }\n    }\n    .squeak-profile-link {\n        color: inherit;\n        font-size: var(--base-font-size);\n        text-decoration: none;\n        display: flex;\n        align-items: center;\n    }\n}\n"])), function (props) {
  return props.dark ? "255, 255, 255" : "0, 0, 0";
}, function (props) {
  return props.dark ? "0, 0, 0" : "255, 255, 255";
});

var Theme = function Theme(_ref41) {
  var containerRef = _ref41.containerRef;

  var _useState27 = useState(null),
      _useState28 = _slicedToArray(_useState27, 2),
      dark = _useState28[0],
      setDark = _useState28[1];

  useEffect(function () {
    if (containerRef.current) {
      var color = getBackgroundColor(containerRef.current);
      setDark(lightOrDark(color) === "dark");
    }
  }, []);
  return /* @__PURE__ */jsx(Style$1, {
    dark: dark
  });
};

var ErrorBoundary = /*#__PURE__*/function (_r$1$Component) {
  _inherits(ErrorBoundary, _r$1$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this2;

    _classCallCheck(this, ErrorBoundary);

    _this2 = _super.call(this, props);
    _this2.state = {
      hasError: false
    };
    return _this2;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      console.error(error, errorInfo);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return null;
      } else {
        return this.props.children;
      }
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(r$1.Component);

var Form = function Form(_ref42) {
  var apiHost = _ref42.apiHost,
      organizationId = _ref42.organizationId,
      initialView = _ref42.initialView,
      onSubmit = _ref42.onSubmit;
  var containerRef = useRef(null);
  return /* @__PURE__ */jsx(ErrorBoundary, {
    children: /* @__PURE__ */jsx(_default.div, {
      ref: containerRef,
      children: /* @__PURE__ */jsx(Provider$2, {
        value: {
          organizationId: organizationId,
          apiHost: apiHost
        },
        children: /* @__PURE__ */jsxs(Provider$1, {
          children: [/* @__PURE__ */jsx(Theme, {
            containerRef: containerRef
          }), /* @__PURE__ */jsx("div", {
            className: "squeak",
            children: /* @__PURE__ */jsx(QuestionForm, {
              onSubmit: onSubmit,
              initialView: initialView
            })
          })]
        })
      })
    })
  });
};

var Context = createContext({});

var Provider = function Provider(_ref43) {
  var children = _ref43.children,
      question = _ref43.question,
      onResolve = _ref43.onResolve,
      onSubmit = _ref43.onSubmit,
      other = _objectWithoutProperties(_ref43, _excluded);

  var _a;

  var _useOrg6 = useOrg(),
      organizationId = _useOrg6.organizationId,
      apiHost = _useOrg6.apiHost;

  var _useUser5 = useUser(),
      user = _useUser5.user;

  var _useState29 = useState([]),
      _useState30 = _slicedToArray(_useState29, 2),
      replies = _useState30[0],
      setReplies = _useState30[1];

  var _useState31 = useState(question == null ? void 0 : question.resolved_reply_id),
      _useState32 = _slicedToArray(_useState31, 2),
      resolvedBy = _useState32[0],
      setResolvedBy = _useState32[1];

  var _useState33 = useState(question == null ? void 0 : question.resolved),
      _useState34 = _slicedToArray(_useState33, 2),
      resolved = _useState34[0],
      setResolved = _useState34[1];

  var _replies = _slicedToArray(replies, 1),
      firstReply = _replies[0];

  var questionAuthorId = ((_a = firstReply == null ? void 0 : firstReply.profile) == null ? void 0 : _a.id) || null;

  var handleResolve = /*#__PURE__*/function () {
    var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(resolved2) {
      var replyId,
          _args11 = arguments;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              replyId = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : null;
              _context11.next = 3;
              return post(apiHost, "/api/question/resolve", {
                messageId: question == null ? void 0 : question.id,
                replyId: replyId,
                organizationId: organizationId,
                resolved: resolved2
              });

            case 3:
              setResolved(resolved2);
              setResolvedBy(replyId);

              if (onResolve) {
                onResolve(resolved2, replyId);
              }

            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function handleResolve(_x22) {
      return _ref44.apply(this, arguments);
    };
  }();

  var handleReplyDelete = /*#__PURE__*/function () {
    var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(id) {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return doDelete(apiHost, "/api/replies/".concat(id), {
                organizationId: organizationId
              });

            case 2:
              setReplies(replies.filter(function (reply) {
                return id !== reply.id;
              }));

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function handleReplyDelete(_x23) {
      return _ref45.apply(this, arguments);
    };
  }();

  var handlePublish = /*#__PURE__*/function () {
    var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(id, published) {
      var newReplies;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return patch(apiHost, "/api/replies/".concat(id), {
                organizationId: organizationId,
                published: published
              });

            case 2:
              newReplies = _toConsumableArray(replies);
              newReplies.some(function (reply) {
                if (reply.id === id) {
                  reply.published = published;
                  return true;
                }
              });
              setReplies(newReplies);

            case 5:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function handlePublish(_x24, _x25) {
      return _ref46.apply(this, arguments);
    };
  }();

  useEffect(function () {
    setReplies(other.replies.filter(function (reply) {
      return reply.published || !reply.published && (user == null ? void 0 : user.isModerator);
    }));
  }, [other.replies, user == null ? void 0 : user.id]);
  useEffect(function () {
    setResolved(question.resolved);
  }, [question.resolved]);
  useEffect(function () {
    setResolvedBy(question.resolved_reply_id);
  }, [question.resolved_reply_id]);
  var value = {
    replies: replies,
    resolvedBy: resolvedBy,
    resolved: resolved,
    questionAuthorId: questionAuthorId,
    question: question,
    onSubmit: onSubmit,
    handleResolve: handleResolve,
    handleReplyDelete: handleReplyDelete,
    handlePublish: handlePublish
  };
  return /* @__PURE__ */jsx(Context.Provider, {
    value: value,
    children: children
  });
};

var useQuestion = function useQuestion() {
  var question = useContext(Context);
  return question;
};

var Days = function Days(_ref47) {
  var created = _ref47.created;
  var today = new Date();
  var posted = new Date(created);
  var diff = today.getTime() - posted.getTime();
  var days = Math.round(diff / (1e3 * 3600 * 24));
  return /* @__PURE__ */jsx("span", {
    className: "squeak-post-timestamp",
    children: days <= 0 ? "Today" : "".concat(days, " day").concat(days === 1 ? "" : "s", " ago")
  });
};

var Markdown = r$1.lazy(function () {
  return import("./Markdown.f8d36d6a.js");
});

function Reply(_ref48) {
  var profile = _ref48.profile,
      created_at = _ref48.created_at,
      body = _ref48.body,
      subject = _ref48.subject,
      badgeText = _ref48.badgeText,
      id = _ref48.id,
      published = _ref48.published,
      permalink = _ref48.permalink,
      other = _objectWithoutProperties(_ref48, _excluded2);

  var _a;

  var isSSR = typeof window === "undefined";
  var question = useQuestion();
  var questionAuthorId = question.questionAuthorId,
      resolved = question.resolved,
      resolvedBy = question.resolvedBy,
      handleResolve = question.handleResolve,
      handlePublish = question.handlePublish,
      handleReplyDelete = question.handleReplyDelete;

  var _useState35 = useState(false),
      _useState36 = _slicedToArray(_useState35, 2),
      confirmDelete = _useState36[0],
      setConfirmDelete = _useState36[1];

  var _useUser6 = useUser(),
      user = _useUser6.user;

  var _useOrg7 = useOrg(),
      profileLink = _useOrg7.profileLink;

  var isModerator = user == null ? void 0 : user.isModerator;
  var isAuthor = ((_a = user == null ? void 0 : user.profile) == null ? void 0 : _a.id) === questionAuthorId;

  var handleDelete = function handleDelete(e2) {
    e2.stopPropagation();

    if (confirmDelete) {
      handleReplyDelete(id);
    } else {
      setConfirmDelete(true);
    }
  };

  var handleContainerClick = function handleContainerClick() {
    setConfirmDelete(false);
  };

  return /* @__PURE__ */jsxs("div", _objectSpread(_objectSpread({}, other), {}, {
    onClick: handleContainerClick,
    children: [/* @__PURE__ */jsxs("div", {
      className: "squeak-post-author",
      children: [profileLink ? /* @__PURE__ */jsxs("a", {
        className: "squeak-profile-link",
        href: profileLink(profile),
        children: [/* @__PURE__ */jsx(Avatar, {
          image: profile == null ? void 0 : profile.avatar
        }), /* @__PURE__ */jsx("strong", {
          className: "squeak-author-name",
          children: (profile == null ? void 0 : profile.first_name) || "Anonymous"
        })]
      }) : /* @__PURE__ */jsxs(Fragment, {
        children: [/* @__PURE__ */jsx(Avatar, {
          image: profile == null ? void 0 : profile.avatar
        }), /* @__PURE__ */jsx("strong", {
          className: "squeak-author-name",
          children: (profile == null ? void 0 : profile.first_name) || "Anonymous"
        })]
      }), badgeText && /* @__PURE__ */jsx("span", {
        className: "squeak-author-badge",
        children: badgeText
      }), /* @__PURE__ */jsx(Days, {
        created: created_at
      }), resolved && resolvedBy === id && /* @__PURE__ */jsxs(Fragment, {
        children: [/* @__PURE__ */jsx("span", {
          className: "squeak-resolved-badge",
          children: "Solution"
        }), (isAuthor || isModerator) && /* @__PURE__ */jsx("button", {
          onClick: function onClick() {
            return handleResolve(false);
          },
          className: "squeak-undo-resolved",
          children: "Undo"
        })]
      })]
    }), /* @__PURE__ */jsxs("div", {
      className: "squeak-post-content",
      children: [subject && /* @__PURE__ */jsx("h3", {
        className: "squeak-subject",
        children: permalink ? /* @__PURE__ */jsx("a", {
          href: permalink,
          children: subject
        }) : subject
      }), !isSSR && /* @__PURE__ */jsx(r$1.Suspense, {
        fallback: /* @__PURE__ */jsx("div", {}),
        children: /* @__PURE__ */jsx(Markdown, {
          children: body
        })
      }), !subject && /* @__PURE__ */jsxs("div", {
        className: "squeak-reply-action-buttons",
        children: [!resolved && (isAuthor || isModerator) && /* @__PURE__ */jsx("button", {
          onClick: function onClick() {
            return handleResolve(true, id);
          },
          className: "squeak-resolve-button",
          children: "Mark as solution"
        }), isModerator && /* @__PURE__ */jsx("button", {
          onClick: function onClick() {
            return handlePublish(id, !published);
          },
          className: "squeak-publish-button",
          children: published ? "Unpublish" : "Publish"
        }), isModerator && /* @__PURE__ */jsx("button", {
          onClick: handleDelete,
          className: "squeak-delete-button",
          children: confirmDelete ? "Click again to confirm" : "Delete"
        })]
      })]
    })]
  }));
}

var getBadge$1 = function getBadge$1(questionAuthorId, replyAuthorId, replyAuthorRole) {
  if (replyAuthorRole === "admin" || replyAuthorRole === "moderator") {
    return "Moderator";
  }

  if (!questionAuthorId || !replyAuthorId) {
    return null;
  }

  return questionAuthorId === replyAuthorId ? "Author" : null;
};

var Collapsed = function Collapsed(_ref49) {
  var setExpanded = _ref49.setExpanded;

  var _a, _b, _c, _d, _e2, _f;

  var _useQuestion = useQuestion(),
      replies = _useQuestion.replies,
      resolvedBy = _useQuestion.resolvedBy,
      questionAuthorId = _useQuestion.questionAuthorId;

  var reply = replies[replies.findIndex(function (reply2) {
    return (reply2 == null ? void 0 : reply2.id) === resolvedBy;
  })] || replies[replies.length - 1];
  var replyCount = replies.length - 2;
  var maxAvatars = Math.min(replyCount, 3);
  var replyAuthorMetadata = ((_b = (_a = reply == null ? void 0 : reply.profile) == null ? void 0 : _a.profiles_readonly) == null ? void 0 : _b[0]) || ((_d = (_c = reply == null ? void 0 : reply.profile) == null ? void 0 : _c.metadata) == null ? void 0 : _d[0]);
  var badgeText = getBadge$1(questionAuthorId, (_e2 = reply == null ? void 0 : reply.profile) == null ? void 0 : _e2.id, replyAuthorMetadata == null ? void 0 : replyAuthorMetadata.role);
  var avatars = [];

  var _iterator2 = _createForOfIteratorHelper(replies.slice(1)),
      _step;

  try {
    for (_iterator2.s(); !(_step = _iterator2.n()).done;) {
      var reply2 = _step.value;
      if (avatars.length >= maxAvatars) break;
      var avatar = (_f = reply2 == null ? void 0 : reply2.profile) == null ? void 0 : _f.avatar;

      if (avatar && !avatars.includes(avatar)) {
        avatars.push(avatar);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (avatars.length < maxAvatars) {
    avatars.push.apply(avatars, _toConsumableArray(Array(maxAvatars - avatars.length)));
  }

  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("li", {
      children: /* @__PURE__ */jsxs("div", {
        className: "squeak-other-replies-container",
        children: [avatars.map(function (avatar) {
          var _a2;

          return /* @__PURE__ */jsx(Avatar, {
            image: avatar
          }, "".concat(reply == null ? void 0 : reply.message_id, "-").concat(reply == null ? void 0 : reply.id, "-").concat((_a2 = reply == null ? void 0 : reply.profile) == null ? void 0 : _a2.id, "-").concat(avatar));
        }), /* @__PURE__ */jsxs("button", {
          className: "squeak-other-replies",
          onClick: function onClick() {
            return setExpanded(true);
          },
          children: ["View ", replyCount, " other ", replyCount === 1 ? "reply" : "replies"]
        })]
      })
    }), /* @__PURE__ */jsx("li", {
      className: "".concat(resolvedBy === (reply == null ? void 0 : reply.id) ? "squeak-solution" : "", " ").concat(!(reply == null ? void 0 : reply.published) ? "squeak-reply-unpublished" : ""),
      children: /* @__PURE__ */jsx(Reply, _objectSpread(_objectSpread({
        className: "squeak-post-reply"
      }, reply), {}, {
        badgeText: badgeText
      }))
    }, reply == null ? void 0 : reply.id)]
  });
};

var Expanded = function Expanded() {
  var _a;

  var question = useQuestion();
  var replies = (_a = question.replies) == null ? void 0 : _a.slice(1);
  var resolvedBy = question.resolvedBy,
      questionAuthorId = question.questionAuthorId;
  return /* @__PURE__ */jsx(Fragment, {
    children: replies.map(function (reply) {
      var _a2, _b, _c, _d, _e2;

      var replyAuthorMetadata = ((_b = (_a2 = reply == null ? void 0 : reply.profile) == null ? void 0 : _a2.profiles_readonly) == null ? void 0 : _b[0]) || ((_d = (_c = reply == null ? void 0 : reply.profile) == null ? void 0 : _c.metadata) == null ? void 0 : _d[0]);
      var badgeText = getBadge$1(questionAuthorId, (_e2 = reply == null ? void 0 : reply.profile) == null ? void 0 : _e2.id, replyAuthorMetadata == null ? void 0 : replyAuthorMetadata.role);
      return /* @__PURE__ */jsx("li", {
        className: "".concat(resolvedBy === reply.id ? "squeak-solution" : "", " ").concat(!reply.published ? "squeak-reply-unpublished" : ""),
        children: /* @__PURE__ */jsx(Reply, _objectSpread(_objectSpread({
          className: "squeak-post-reply"
        }, reply), {}, {
          badgeText: badgeText
        }))
      }, reply.id);
    })
  });
};

var Replies$1 = function Replies$1(_ref50) {
  var expanded = _ref50.expanded,
      setExpanded = _ref50.setExpanded;

  var _useQuestion2 = useQuestion(),
      resolved = _useQuestion2.resolved,
      replies = _useQuestion2.replies,
      onSubmit = _useQuestion2.onSubmit,
      question = _useQuestion2.question;

  return /* @__PURE__ */jsxs(Fragment, {
    children: [replies && replies.length - 1 > 0 && /* @__PURE__ */jsx("ul", {
      className: "squeak-replies ".concat(resolved ? "squeak-thread-resolved" : ""),
      children: expanded || replies.length <= 2 ? /* @__PURE__ */jsx(Expanded, {}) : /* @__PURE__ */jsx(Collapsed, {
        setExpanded: setExpanded
      })
    }), resolved ? /* @__PURE__ */jsx("div", {
      className: "squeak-locked-message",
      children: /* @__PURE__ */jsx("p", {
        children: "This thread has been closed"
      })
    }) : /* @__PURE__ */jsx("div", {
      className: "squeak-reply-form-container",
      children: /* @__PURE__ */jsx(QuestionForm, {
        onSubmit: onSubmit,
        messageID: question.id,
        formType: "reply"
      })
    })]
  });
};

function Question$1(_ref51) {
  var onSubmit = _ref51.onSubmit,
      onResolve = _ref51.onResolve,
      apiHost = _ref51.apiHost,
      other = _objectWithoutProperties(_ref51, _excluded3);

  var _a;

  var _useState37 = useState(false),
      _useState38 = _slicedToArray(_useState37, 2),
      expanded = _useState38[0],
      setExpanded = _useState38[1];

  var _useState39 = useState(other == null ? void 0 : other.question),
      _useState40 = _slicedToArray(_useState39, 2),
      question = _useState40[0],
      setQuestion = _useState40[1];

  var _useState41 = useState(((_a = other == null ? void 0 : other.question) == null ? void 0 : _a.replies) || []),
      _useState42 = _slicedToArray(_useState41, 2),
      replies = _useState42[0],
      setReplies = _useState42[1];

  var _replies2 = _slicedToArray(replies, 1),
      firstReply = _replies2[0];

  var _useOrg8 = useOrg(),
      organizationId = _useOrg8.organizationId,
      _useOrg8$config = _useOrg8.config,
      permalink_base = _useOrg8$config.permalink_base,
      permalinks_enabled = _useOrg8$config.permalinks_enabled;

  return question ? /* @__PURE__ */jsxs("div", {
    className: "squeak-question-container",
    children: [/* @__PURE__ */jsx(Reply, _objectSpread({
      permalink: permalinks_enabled && (question == null ? void 0 : question.permalink) && "/".concat(permalink_base, "/").concat(question == null ? void 0 : question.permalink),
      className: "squeak-post",
      subject: question.subject
    }, firstReply)), /* @__PURE__ */jsx(Provider, {
      onSubmit: onSubmit,
      question: question,
      replies: replies,
      onResolve: onResolve,
      children: /* @__PURE__ */jsx(Replies$1, {
        expanded: expanded,
        setExpanded: setExpanded
      })
    })]
  }) : null;
}

var Question = function Question(_ref52) {
  var apiHost = _ref52.apiHost,
      organizationId = _ref52.organizationId,
      onResolve = _ref52.onResolve,
      onSubmit = _ref52.onSubmit,
      question = _ref52.question;
  var containerRef = useRef(null);
  return /* @__PURE__ */jsx(ErrorBoundary, {
    children: /* @__PURE__ */jsx(_default.div, {
      ref: containerRef,
      children: /* @__PURE__ */jsx(Provider$2, {
        value: {
          organizationId: organizationId,
          apiHost: apiHost
        },
        children: /* @__PURE__ */jsxs(Provider$1, {
          children: [/* @__PURE__ */jsx(Theme, {
            containerRef: containerRef
          }), /* @__PURE__ */jsx("div", {
            className: "squeak",
            children: /* @__PURE__ */jsx(Question$1, {
              apiHost: apiHost,
              question: question,
              onSubmit: onSubmit,
              onResolve: onResolve
            })
          })]
        })
      })
    })
  });
};

var getBadge = function getBadge(questionAuthorId, replyAuthorId, replyAuthorRole) {
  if (replyAuthorRole === "admin" || replyAuthorRole === "moderator") {
    return "Moderator";
  }

  if (!questionAuthorId || !replyAuthorId) {
    return null;
  }

  return questionAuthorId === replyAuthorId ? "Author" : null;
};

var Replies = function Replies(_ref53) {
  var question = _ref53.question;

  var _useQuestion3 = useQuestion(),
      resolved = _useQuestion3.resolved,
      onSubmit = _useQuestion3.onSubmit;

  var replies = question.replies;
  return /* @__PURE__ */jsxs(Fragment, {
    children: [replies && replies.length - 1 > 0 && /* @__PURE__ */jsx("ul", {
      className: "squeak-replies",
      children: replies.slice(1).map(function (reply) {
        var _a, _b, _c, _d, _e2, _f;

        var replyAuthorMetadata = ((_b = (_a = reply == null ? void 0 : reply.profile) == null ? void 0 : _a.profiles_readonly) == null ? void 0 : _b[0]) || ((_d = (_c = reply == null ? void 0 : reply.profile) == null ? void 0 : _c.metadata) == null ? void 0 : _d[0]);
        var badgeText = getBadge((_e2 = replies[0].profile) == null ? void 0 : _e2.id, (_f = reply == null ? void 0 : reply.profile) == null ? void 0 : _f.id, replyAuthorMetadata == null ? void 0 : replyAuthorMetadata.role);
        return /* @__PURE__ */jsx("li", {
          className: " ".concat(!reply.published ? "squeak-reply-unpublished" : ""),
          children: /* @__PURE__ */jsx(Reply, _objectSpread(_objectSpread({
            className: "squeak-post-reply"
          }, reply), {}, {
            badgeText: badgeText
          }))
        }, reply.id);
      })
    }), resolved ? /* @__PURE__ */jsx("div", {
      className: "squeak-locked-message",
      children: /* @__PURE__ */jsx("p", {
        children: "This thread has been closed"
      })
    }) : /* @__PURE__ */jsx("div", {
      className: "squeak-reply-form-container",
      children: /* @__PURE__ */jsx(QuestionForm, {
        onSubmit: onSubmit,
        messageID: question.id,
        formType: "reply"
      })
    })]
  });
};

var FullQuestion = function FullQuestion(_ref54) {
  var onSubmit = _ref54.onSubmit,
      onResolve = _ref54.onResolve,
      apiHost = _ref54.apiHost,
      organizationId = _ref54.organizationId,
      question = _ref54.question;

  var _ref55 = (question == null ? void 0 : question.replies) || [],
      _ref56 = _slicedToArray(_ref55, 1),
      firstReply = _ref56[0];

  var containerRef = useRef(null);
  return /* @__PURE__ */jsx(ErrorBoundary, {
    children: /* @__PURE__ */jsx(_default.div, {
      ref: containerRef,
      children: /* @__PURE__ */jsxs(Provider$2, {
        value: {
          organizationId: organizationId,
          apiHost: apiHost
        },
        children: [/* @__PURE__ */jsx(Theme, {
          containerRef: containerRef
        }), /* @__PURE__ */jsx(Provider$1, {
          children: /* @__PURE__ */jsx("div", {
            className: "squeak",
            children: /* @__PURE__ */jsxs("div", {
              className: "squeak-question-container",
              children: [/* @__PURE__ */jsx(Reply, _objectSpread({
                className: "squeak-post",
                subject: question.subject
              }, firstReply)), /* @__PURE__ */jsx(Provider, {
                onSubmit: onSubmit,
                question: question,
                replies: question.replies,
                onResolve: onResolve,
                children: /* @__PURE__ */jsx(Replies, {
                  question: question
                })
              })]
            })
          })
        })]
      })
    })
  });
};

var Authentication = function Authentication(_ref57) {
  var onAuth = _ref57.onAuth,
      organizationId = _ref57.organizationId,
      apiHost = _ref57.apiHost;
  var containerRef = useRef(null);
  return /* @__PURE__ */jsx(ErrorBoundary, {
    children: /* @__PURE__ */jsx(_default.div, {
      ref: containerRef,
      children: /* @__PURE__ */jsx(Provider$2, {
        value: {
          organizationId: organizationId,
          apiHost: apiHost
        },
        children: /* @__PURE__ */jsxs(Provider$1, {
          children: [/* @__PURE__ */jsx(Theme, {
            containerRef: containerRef
          }), /* @__PURE__ */jsx("div", {
            className: "squeak",
            children: /* @__PURE__ */jsx(Authentication$1, {
              banner: {
                title: "Please signup to post.",
                body: "Create an account to ask questions & help others."
              },
              buttonText: {
                login: "Login & post question",
                signUp: "Sign up & post question"
              },
              setParentView: function setParentView() {},
              handleMessageSubmit: onAuth,
              onSignUp: onAuth
            })
          })]
        })
      })
    })
  });
};

var Topics = function Topics(_ref58) {
  var handleTopicChange = _ref58.handleTopicChange,
      activeTopic = _ref58.activeTopic,
      topics = _ref58.topics;
  return topics && topics.length > 0 ? /* @__PURE__ */jsxs("ul", {
    className: "squeak-topics-container",
    children: [/* @__PURE__ */jsx("li", {
      children: /* @__PURE__ */jsx("button", {
        className: activeTopic === null ? "squeak-active-topic" : "",
        onClick: function onClick() {
          return handleTopicChange(null);
        },
        children: "All"
      })
    }), topics.map(function (topic) {
      return /* @__PURE__ */jsx("li", {
        children: /* @__PURE__ */jsx("button", {
          className: activeTopic.label === topic.label ? "squeak-active-topic" : "",
          onClick: function onClick() {
            return handleTopicChange(topic.label);
          },
          children: topic.label
        })
      }, topic.label);
    })]
  }) : null;
};

function Questions$1(_ref59) {
  var slug = _ref59.slug,
      _ref59$limit = _ref59.limit,
      limit = _ref59$limit === void 0 ? 100 : _ref59$limit,
      onSubmit = _ref59.onSubmit,
      onLoad = _ref59.onLoad,
      topics = _ref59.topics,
      onSignUp = _ref59.onSignUp,
      topic = _ref59.topic;

  var _useState43 = useState(topic),
      _useState44 = _slicedToArray(_useState43, 2),
      activeTopic = _useState44[0],
      setActiveTopic = _useState44[1];

  var _useOrg9 = useOrg(),
      organizationId = _useOrg9.organizationId,
      apiHost = _useOrg9.apiHost;

  var _useState45 = useState([]),
      _useState46 = _slicedToArray(_useState45, 2),
      questions = _useState46[0],
      setQuestions = _useState46[1];

  var _useState47 = useState(false),
      _useState48 = _slicedToArray(_useState47, 2),
      loading = _useState48[0],
      setLoading = _useState48[1];

  var _useState49 = useState([]),
      _useState50 = _slicedToArray(_useState49, 2),
      availableTopics = _useState50[0],
      setAvailableTopics = _useState50[1];

  var _useState51 = useState(0),
      _useState52 = _slicedToArray(_useState51, 2),
      count = _useState52[0],
      setCount = _useState52[1];

  var _useState53 = useState(0),
      _useState54 = _slicedToArray(_useState53, 2),
      start = _useState54[0],
      setStart = _useState54[1];

  var getQuestions = /*#__PURE__*/function () {
    var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref60) {
      var limit2, start2, topic2, _ref62, response, data;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              limit2 = _ref60.limit, start2 = _ref60.start, topic2 = _ref60.topic;
              _context14.next = 3;
              return post(apiHost, "/api/questions", {
                organizationId: organizationId,
                slug: slug,
                published: true,
                perPage: limit2,
                start: start2,
                topic: topic2
              });

            case 3:
              _context14.t0 = _context14.sent;

              if (_context14.t0) {
                _context14.next = 6;
                break;
              }

              _context14.t0 = {};

            case 6:
              _ref62 = _context14.t0;
              response = _ref62.response;
              data = _ref62.data;

              if (!(response.status !== 200)) {
                _context14.next = 11;
                break;
              }

              return _context14.abrupt("return", {
                questions: [],
                count: 0
              });

            case 11:
              return _context14.abrupt("return", data);

            case 12:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function getQuestions(_x26) {
      return _ref61.apply(this, arguments);
    };
  }();

  var getAvailableTopics = function getAvailableTopics(questions2) {
    var availableTopics2 = [];
    questions2.forEach(function (_ref63) {
      var topics2 = _ref63.question.topics;
      topics2 == null ? void 0 : topics2.forEach(function (topic2) {
        if (!availableTopics2.includes(topic2)) availableTopics2.push(topic2);
      });
    });
    return availableTopics2;
  };

  useEffect(function () {
    getQuestions({
      limit: limit,
      start: start,
      topic: activeTopic
    }).then(function (data) {
      setQuestions([].concat(_toConsumableArray(questions), _toConsumableArray(data.questions)));
      setCount(data.count);
      setAvailableTopics(getAvailableTopics([].concat(_toConsumableArray(questions), _toConsumableArray(data.questions))));
      onLoad == null ? void 0 : onLoad();
    });
  }, []);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(values, formType) {
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              getQuestions({
                limit: 1,
                start: 0
              }).then(function (data) {
                setQuestions([].concat(_toConsumableArray(data.questions), _toConsumableArray(questions)));
                setCount(data.count);
                setStart(start + 1);
                setAvailableTopics(getAvailableTopics([].concat(_toConsumableArray(questions), _toConsumableArray(data.questions))));
                onSubmit == null ? void 0 : onSubmit(values, formType);
              });

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function handleSubmit(_x27, _x28) {
      return _ref64.apply(this, arguments);
    };
  }();

  var handleShowMore = function handleShowMore() {
    getQuestions({
      limit: limit,
      start: start + limit,
      topic: activeTopic
    }).then(function (data) {
      setQuestions([].concat(_toConsumableArray(questions), _toConsumableArray(data.questions)));
      setCount(data.count);
      setStart(start + limit);
      setAvailableTopics(getAvailableTopics([].concat(_toConsumableArray(questions), _toConsumableArray(data.questions))));
    });
  };

  var handleTopicChange = function handleTopicChange(topic2) {
    if (topic2 === activeTopic) return;
    getQuestions({
      limit: limit,
      start: 0,
      topic: topic2
    }).then(function (data) {
      setStart(0);
      setQuestions(data.questions);
      setCount(data.count);
      setActiveTopic(topic2);
    });
  };

  return /* @__PURE__ */jsxs(Fragment, {
    children: [topics && /* @__PURE__ */jsx(Topics, {
      topics: availableTopics,
      handleTopicChange: handleTopicChange,
      activeTopic: activeTopic
    }), questions && questions.length > 0 && /* @__PURE__ */jsx(Fragment, {
      children: /* @__PURE__ */jsx("ul", {
        className: "squeak-questions",
        children: questions.map(function (question) {
          return /* @__PURE__ */jsx("li", {
            children: /* @__PURE__ */jsx(Question$1, _objectSpread({
              onSubmit: handleSubmit
            }, question))
          }, question.question.id);
        })
      })
    }), start + limit < count && /* @__PURE__ */jsx("button", {
      disabled: loading,
      className: "squeak-show-more-questions-button",
      onClick: handleShowMore,
      children: "Show more"
    }), /* @__PURE__ */jsx(QuestionForm, {
      onSignUp: onSignUp,
      onSubmit: handleSubmit,
      formType: "question"
    })]
  });
}

var Squeak = function Squeak(_ref65) {
  var apiHost = _ref65.apiHost,
      organizationId = _ref65.organizationId,
      slug = _ref65.slug,
      limit = _ref65.limit,
      onSubmit = _ref65.onSubmit,
      onLoad = _ref65.onLoad,
      _ref65$topics = _ref65.topics,
      topics = _ref65$topics === void 0 ? true : _ref65$topics,
      onSignUp = _ref65.onSignUp,
      topic = _ref65.topic,
      profileLink = _ref65.profileLink;
  var containerRef = useRef(null);
  var currentSlug = topic ? void 0 : slug || typeof window !== "undefined" ? window.location.pathname : void 0;
  return /* @__PURE__ */jsx(ErrorBoundary, {
    children: /* @__PURE__ */jsx(_default.div, {
      ref: containerRef,
      children: /* @__PURE__ */jsx(Provider$2, {
        value: {
          organizationId: organizationId,
          apiHost: apiHost,
          profileLink: profileLink
        },
        children: /* @__PURE__ */jsxs(Provider$1, {
          children: [/* @__PURE__ */jsx(Theme, {
            containerRef: containerRef
          }), /* @__PURE__ */jsx("div", {
            className: "squeak",
            children: /* @__PURE__ */jsx(Questions$1, {
              onSignUp: onSignUp,
              onLoad: onLoad,
              topics: topics,
              onSubmit: onSubmit,
              limit: limit,
              slug: currentSlug,
              topic: topic
            })
          })]
        })
      })
    })
  });
};

var Style = We(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    .squeak {\n        .squeak-avatar-container {\n            display: none;\n        }\n        .squeak-authentication-form-container {\n            margin-left: 0;\n        }\n    }\n"])));

var Login = function Login(_ref66) {
  var onSubmit = _ref66.onSubmit,
      buttonText = _ref66.buttonText;
  var containerRef = useRef(null);
  return /* @__PURE__ */jsx(Fragment, {
    children: /* @__PURE__ */jsxs(_default.div, {
      ref: containerRef,
      children: [/* @__PURE__ */jsx(Theme, {
        containerRef: containerRef
      }), /* @__PURE__ */jsx(Style, {}), /* @__PURE__ */jsx("div", {
        className: "squeak",
        children: /* @__PURE__ */jsx(Authentication$1, {
          buttonText: buttonText,
          handleMessageSubmit: onSubmit
        })
      })]
    })
  });
};

var Questions = function Questions(_ref67) {
  var apiHost = _ref67.apiHost,
      organizationId = _ref67.organizationId,
      limit = _ref67.limit,
      onSubmit = _ref67.onSubmit,
      onLoad = _ref67.onLoad,
      _ref67$topics = _ref67.topics,
      topics = _ref67$topics === void 0 ? true : _ref67$topics,
      onSignUp = _ref67.onSignUp,
      topic = _ref67.topic,
      profileLink = _ref67.profileLink;
  var containerRef = useRef(null);
  return /* @__PURE__ */jsx(ErrorBoundary, {
    children: /* @__PURE__ */jsx(_default.div, {
      ref: containerRef,
      children: /* @__PURE__ */jsx(Provider$2, {
        value: {
          organizationId: organizationId,
          apiHost: apiHost,
          profileLink: profileLink
        },
        children: /* @__PURE__ */jsxs(Provider$1, {
          children: [/* @__PURE__ */jsx(Theme, {
            containerRef: containerRef
          }), /* @__PURE__ */jsx("div", {
            className: "squeak",
            children: /* @__PURE__ */jsx(Questions$1, {
              onSignUp: onSignUp,
              onLoad: onLoad,
              topics: topics,
              onSubmit: onSubmit,
              limit: limit,
              topic: topic
            })
          })]
        })
      })
    })
  });
};

export { Authentication as A, Days as D, Fragment as F, Login as L, Provider$2 as P, Questions as Q, ReactIs$1 as R, Squeak as S, FullQuestion as a, Question as b, Form as c, Avatar as d, Provider$1 as e, useUser as f, useQuestion as g, jsx as j, propTypes as p, useOrg as u };